<template>
  <div
    v-loading="isUpdatingTask || isOutputCheck || isBatchBujianLoading"
    :element-loading-text="
      isOutputCheck
        ? translateLang('arrangedPage.checkData')
        : translateLang(loadingPrompts)
    "
    :class="['draw-parts', isForbidUserSelect ? 'forbid-select' : '']"
  >
    <loading
      :loading="isDownloadingNc"
      :isTimeOut="isTimeOut"
      type="2"
      :text="loadingText"
      :isWebToQt="isWebToQt"
      :task-list="taskList"
      :finish_percent="finishPercent"
      :loadingTitle="progressTitle"
    ></loading>
    <loading
      :loading="isRefresh"
      :isTimeOut="isTimeOut"
      type="1"
      :text="loadingText"
      :isWebToQt="isWebToQt"
      :loadingTitle="translateLang('common.startArrange')"
    >
      <template slot="text">
        <span> {{ $t('materialPage.arrangeLoading') }}</span>
        <span class="fs18 ml5 mr5" style="color: #18a8c7">{{
          recordDrawPlankDataLength
        }}</span>
        {{ $t('materialPage.arrangeLoading2') }}
      </template></loading
    >
    <div class="loading-box" v-if="showLoading && !isRefresh">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 60px" spin />
      </a-spin>
    </div>
    <div class="draw-parts-main">
      <div class="left-operation" ref="leftOperationZoneRef">
        <div
          class="flex paiban-top-container flex-main--justify pb13"
          :style="{ minHeight: '160px' }"
        >
          <!-- :class="{
              'normal-top': !isShowConflictPrompts && !isDepthError,
              'oneErr-top':
                (!isShowConflictPrompts && isDepthError) ||
                (isShowConflictPrompts && !isDepthError),
            }" -->
          <div class="paiban-top w100">
            <!-- <a-tooltip
              placement="topLeft"
              :title="orderInfo.order_address"
              overlayClassName="more-title"
            >
              <div class="order-title">
                {{ orderInfo.order_address }}
              </div>
            </a-tooltip> -->

            <!-- <div class="paiban-info">
              <span class="paiban-info-label"
                >整体优化率：<span class="paiban-info-value">{{
                  totalUsedRate
                    ? totalUsedRate >= 1
                      ? `${(100).toFixed(2)}%`
                      : `${(totalUsedRate * 100).toFixed(2)}%`
                    : '0%'
                }}</span></span
              >
              <span class="paiban-info-label"
                >大板数量：<span class="paiban-info-value">{{
                  totalBigpartCounts
                }}</span></span
              >
              <span class="paiban-info-label"
                >翻板次数：<span class="paiban-info-value">{{
                  totalBigpartFanban
                }}</span></span
              >
              <span class="paiban-info-label"
                >生产线：<span class="paiban-info-value">{{
                  $store.state.recodrProductionLineChoose ?? ''
                }}</span></span
              >
            </div> -->
            <!-- 头部信息位置调整 -->
            <div class="paiban-info">
              <a-tooltip
                placement="bottomLeft"
                :title="orderAddress"
                overlayClassName="more-title"
                :overlayStyle="{
                  maxWidth: '600px !important',
                }"
              >
                <div class="flex flex-cross--center">
                  <span class="order-title">{{ orderAddress }}</span>

                  <m-deep-badge-aurora
                    v-if="isUseDeepSearchPlan"
                    :text="$translateLang('深度计算')"
                  >
                  </m-deep-badge-aurora>
                </div>
              </a-tooltip>

              <div class="flex flex-main--justify flex-cross--center">
                <div>
                  <span class="paiban-info-label"
                    >{{ $t('arrangedPage.totalRate') }}：<span
                      class="paiban-info-value"
                      >{{
                        totalUsedRate
                          ? totalUsedRate >= 1
                            ? `${(100).toFixed(2)}%`
                            : `${(totalUsedRate * 100).toFixed(2)}%`
                          : '0%'
                      }}</span
                    >
                    <a-tooltip
                      placement="bottomLeft"
                      overlayClassName="influence-tip-card"
                      :getPopupContainer="getContainer"
                    >
                      <template slot="title">
                        <m-layout-influence-tip
                          :isLessReverse="isLessReverse"
                          :isSpecialShape="isSpecialShape"
                          :selectedPaibanWay="selectedPaibanWay"
                          :activePaibanWay="activePaibanWay"
                          :currentLine="currentLine"
                          :snapshot="historyInfluenceOptions"
                        />
                      </template>
                      <i
                        id="paiban_influence_tip_icon"
                        class="iconfont icon-wenhao paiban-influence-icon cursor-pointer ml4"
                      ></i>
                    </a-tooltip>
                  </span>

                  <span class="paiban-info-label"
                    >{{ $t('arrangedPage.useArea') }}：<span
                      class="paiban-info-value"
                      >{{
                        totalUsedArea
                          ? (
                              Number(totalUsedArea.toString()) / 1000000
                            ).toFixed(2)
                          : '0'
                      }}m²</span
                    ></span
                  >
                  <a-tooltip
                    :getPopupContainer="getContainer"
                    overlayClassName="useMaterial-tooltip-card"
                    placement="bottom"
                  >
                    <template slot="title">
                      <div class="tip">
                        {{ materialData && materialData[0] }}
                      </div>
                      <a-button type="link" @click="handleCopyData"
                        >复制大板用量为文本</a-button
                      >
                    </template>
                    <span class="paiban-info-label cursor"
                      >{{ $t('arrangedPage.plankCount') }}：<span
                        class="paiban-info-value"
                        >{{ totalBigpartCounts }}</span
                      ></span
                    >
                  </a-tooltip>
                  <span class="paiban-info-label"
                    >{{ $t('arrangedPage.rollCount') }}：<span
                      class="paiban-info-value"
                      >{{ totalBigpartFanban }}</span
                    ></span
                  >
                  <span class="paiban-info-label"
                    ><span id="paiban_production_line_label">{{
                      $t('common.productionLine')
                    }}</span
                    >：
                    <div class="inline-block" style="color: rgba(0, 0, 0, 0.9)">
                      {{
                        $store.state.ncSetting.isPreLayout
                          ? $t('preLayoutSetting.preWayEmpty')
                          : $store.state.recodrProductionLineChoose ===
                            '默认生产线'
                          ? $t('common.defaultProduction')
                          : $store.state.recodrProductionLineChoose
                      }}
                      <a-tooltip
                        :title="
                          isShuntSetting
                            ? $translateLang(
                                '当前生产线因开启【孔槽分流中设置的特殊孔槽优先排在大板正面】或【启用孔槽分流后按照实际在雕刻机加工的反面孔槽计算翻板次数】功能，不支持切换生产线'
                              )
                            : currentLine?.data?.is_des_material_no_cut
                            ? $translateLang(
                                '当前生产线已开启指定小板材质不下料，暂不支持直接切换生产线'
                              )
                            : $store.state.ncSetting.isPreLayout
                            ? $translateLang('选择生产线')
                            : $translateLang('切换生产线')
                        "
                      >
                        <!-- <a-button
                          v-if="
                            $store.state.ncSetting.cuttingEquipment ==
                            'engraving'
                          "
                          @click="handleSelectProLine"
                          size="small"
                          :disabled="
                            hasEmtryPlank ||
                            isShuntSetting ||
                            isSawPaiban ||
                            currentLine?.data?.is_des_material_no_cut
                          "
                          id="paiban_select_proline_btn"
                        >

                          <span
                            class="fs14"
                            :class="[hasEmtryPlank ? 'color-c' : 'color-3']"
                            >{{
                              $store.state.ncSetting.isPreLayout
                                ? $translateLang('选择生产线')
                                : $translateLang('切换生产线')
                            }}</span
                          >
                        </a-button> -->
                        <i
                          v-if="
                            $store.state.ncSetting.cuttingEquipment ==
                            'engraving'
                          "
                          :class="[
                            'iconfont',
                            'icon-qiehuan',
                            isProLineSwitchIconDisabled
                              ? 'paiban-proline-icon--disabled'
                              : 'cursor-pointer',
                          ]"
                          @click="handleProLineSwitchIconClick"
                          id="paiban_select_proline_icon"
                        >
                        </i>
                      </a-tooltip>
                    </div>
                    <span v-if="false" class="paiban-info-value">{{
                      $store.state.recodrProductionLineChoose ?? ''
                    }}</span>
                  </span>
                </div>
                <div style="margin-left: 10px">
                  <div
                    class="display flex flex-main--justify"
                    v-if="isShowConflictPrompts"
                  >
                    <span class="prompts"
                      >{{ $t('arrangedPage.holeSlotConflict') }}!</span
                    ><a-button
                      id="modal_see_conflict_detail_btn"
                      class="see-details bg-white flex flex flex-cross--center flex-main--center ml10"
                      @click="handleSeeDetails"
                      :disabled="isOnlyShowSurplus"
                      type="link"
                      :style="{ opacity: isOnlyShowSurplus ? 0.3 : 1 }"
                    >
                      {{ $t('arrangedPage.checkDetail') }}
                    </a-button>
                  </div>
                  <div
                    class="display flex flex-main--justify"
                    v-if="isDepthError()"
                  >
                    <span class="prompts">{{
                      $t('arrangedPage.holeSlotErr')
                    }}</span
                    ><a-button
                      id="modal_see_depthError_detail_btn"
                      class="see-details bg-white flex flex flex-cross--center flex-main--center ml10"
                      @click="handleSeeDepthError"
                      :disabled="isOnlyShowSurplus"
                      type="link"
                      :style="{ opacity: isOnlyShowSurplus ? 0.3 : 1 }"
                    >
                      {{ $t('arrangedPage.checkDetail') }}
                    </a-button>
                  </div>
                  <div
                    class="display flex flex-main--justify flex-across--center"
                    v-if="
                      allKnivesErrInfos.length && showNotFoundKnivesErrInfoBtn
                    "
                  >
                    <span class="prompts">{{
                      $t('arrangedPage.knivesErr')
                    }}</span
                    ><a-button
                      id="modal_see_depthError_detail_btn"
                      class="see-details bg-white flex flex flex-cross--center flex-main--center ml10"
                      @click="handleOpenErrDetailInfoDrawer"
                      :disabled="isOnlyShowSurplus"
                      type="link"
                      :style="{ opacity: isOnlyShowSurplus ? 0.3 : 1 }"
                    >
                      {{ $t('arrangedPage.checkDetail') }}
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="paiban-actions">
              <div class="tag-nc flex-cross--center w100" v-if="hasLblAuth">
                <a-button
                  class="down-nc"
                  @click="handleDownloadNC(false)"
                  :loading="isNCBtnLoading"
                  id="paiban_downloadNC_btn"
                  :disabled="hasEmtryPlank && ncSetting.isPreLayout"
                  :class="{
                    'disable-btn': hasEmtryPlank && ncSetting.isPreLayout,
                  }"
                  :style="{
                    border:
                      hasEmtryPlank && ncSetting.isPreLayout
                        ? '1px solid #ddd'
                        : 'none',
                  }"
                  >{{ $t('arrangedPage.downloadNC') }}</a-button
                >
                <a-dropdown
                  class="more-setting ml8"
                  v-if="!isWebToQt"
                  :visible="isMoreSetting"
                  id="paiban_export_setting_dropdown"
                >
                  <template #overlay>
                    <a-menu id="paiban_export_setting_menu">
                      <a-menu-item key="3"
                        ><a-button
                          class="action-btn ml8"
                          style="
                            height: unset;
                            padding: 5px 15px;
                            text-align: left;
                          "
                          v-if="!isWebToQt"
                        >
                          <div
                            class="follow-export flex flex-dir--top flex-main--justify"
                          >
                            <a-checkbox
                              v-model="isFollowExportTag"
                              @change="handleChangeTopOption"
                              id="paiban_downloadNC_follow_export_tag_checkbox"
                              >{{
                                $t('arrangedPage.followExportTag')
                              }}</a-checkbox
                            >
                            <a-checkbox-group
                              v-model="currentTagType"
                              name="radioGroup"
                              :disabled="!isFollowExportTag"
                              @change="handleChangeTopOption"
                              class="mt5"
                              style="margin-left: 25px"
                            >
                              <a-checkbox
                                v-for="option in tagTypeOptions"
                                :value="option.value"
                                :key="option.value"
                                :id="`paiban_tag_type_option_${option.value}`"
                                :disabled="
                                  option.value == 'picture' &&
                                  print_color_tag &&
                                  ncSetting.labelImageFormatNew == 'bmp' &&
                                  ncSetting.bmp_color_style == 1
                                "
                              >
                                <span
                                  :id="`paiban_tag_type_option_${option.value}_label`"
                                  >{{ translateLang(option.label) }}</span
                                >
                                <a-tooltip placement="top">
                                  <template slot="title">
                                    <span>{{
                                      translateLang('common.hoverTip')
                                    }}</span>
                                  </template>
                                  <img
                                    src="@/assets/labelColor/error-circle.png"
                                    alt=""
                                    style="height: 16px; width: 16px"
                                    class="ml2"
                                    v-if="
                                      option.value == 'picture' &&
                                      print_color_tag &&
                                      ncSetting.labelImageFormatNew == 'bmp' &&
                                      ncSetting.bmp_color_style == 1
                                    "
                                  />
                                </a-tooltip>
                              </a-checkbox>
                            </a-checkbox-group>
                            <!-- 顺带导出模板选择 -->
                            <div
                              class="tag-template-select mt5"
                              style="margin-left: 25px"
                            >
                              <span
                                class="temp-label"
                                :class="{
                                  'temp-label_disabel': !isFollowExportTag,
                                }"
                                >{{
                                  $t('arrangedPage.tagTemplateSelect')
                                }}</span
                              >
                              <a-select
                                ref="select"
                                v-model="currentTagTempID"
                                style="width: 145px; height: 25px"
                                :disabled="!isFollowExportTag"
                                @change="handleChangeTopOption('tagTemplate')"
                                id="paiban_tag_template_select"
                              >
                                <a-select-option
                                  v-for="(tagTemp, index) in tagTempList"
                                  :value="tagTemp.id"
                                  :key="tagTemp.id"
                                  :id="`paiban_tag_template_select${index}`"
                                  :title="tagTemp.name"
                                  >{{ tagTemp.name }}
                                </a-select-option>
                              </a-select>
                            </div>
                            <div v-if="!isWebToQt && isFollowExportTag">
                              <a-checkbox
                                v-model="isSendToEzSort"
                                class="send-to-ezsort-head-checkbox mt15"
                                :id="`send_to_ezsort_head_checkbox`"
                                :value="true"
                                @change="handleChangeTopOption('sendToEzSort')"
                                ><span>{{ $translateLang('发送至彩标') }}</span>
                                <a-tooltip
                                  :title="
                                    $translateLang(
                                      '顺带导出标签PDF、图片同时勾选时，默认选择PDF进行发送'
                                    )
                                  "
                                >
                                  <a-icon
                                    class="ml5"
                                    style="color: #999"
                                    type="question-circle"
                                  /> </a-tooltip
                              ></a-checkbox>
                            </div>
                            <div
                              v-show="
                                $store.state.preferencesSetting.setting
                                  ?.isCustomPaibanImg
                              "
                              class="mt10"
                            >
                              <div class="mb5">
                                <a-checkbox
                                  v-model="isFollowExportPaibanImg"
                                  @change="handleChangeTopOption"
                                  id="paiban_downloadNC_follow_export_paibanImg_checkbox"
                                  >{{
                                    $translateLang('下载NC顺带导出排版图文件')
                                  }}</a-checkbox
                                >
                              </div>
                              <a-checkbox-group
                                v-model="currentPaibanImgType"
                                name="radioGroup"
                                @change="handleChangeTopOption"
                                :disabled="!isFollowExportPaibanImg"
                                style="margin-left: 25px"
                              >
                                <a-checkbox
                                  v-for="option in tagTypeOptions"
                                  :value="option.value"
                                  :key="option.value"
                                >
                                  <span
                                    :id="`paiban_paibanImg_type_option_${option.value}_label`"
                                    >{{ translateLang(option.label) }}</span
                                  >
                                </a-checkbox>
                              </a-checkbox-group>
                            </div>
                            <div class="mt10">
                              <a-checkbox
                                v-model="isFollowExportWorkerShop"
                                @change="handleChangeTopOption"
                                id="paiban_downloadNC_follow_export_workerShop_checkbox"
                                >{{
                                  $translateLang('下载NC顺带导出采购单')
                                }}</a-checkbox
                              >
                            </div>
                          </div>
                        </a-button>
                      </a-menu-item>
                    </a-menu>
                  </template>
                  <a-button
                    v-show="!isWebToQt"
                    @click="handleClickMoreSetting"
                    id="paiban_more_setting_btn"
                    class="action-btn"
                  >
                    <!-- 更多设置 -->
                    {{ $t('arrangedPage.exportSetting') }}
                    <a-icon
                      type="down"
                      :class="{ 'is-active': isMoreSetting }"
                    />
                  </a-button>
                </a-dropdown>
                <a-button
                  class="action-btn ml8"
                  @click="gotoTagLabel(null, false, true)"
                  id="paiban_print_tag_btn"
                  :disabled="hasEmtryPlank && ncSetting.isPreLayout"
                  :class="{
                    'disable-btn': hasEmtryPlank && ncSetting.isPreLayout,
                  }"
                  >{{ $t('main.sideBar.printTag') }}</a-button
                >
                <a-button
                  class="action-btn ml8"
                  :disabled="dataFrom == 'ggpc' || !hasLblAuth"
                  @click="showSavePaiban()"
                  id="paiban_save_history_btn"
                  >{{ $t('main.sideBar.history') }}</a-button
                >
                <!-- 更多结果：始终同一按钮，避免 v-if 切换导致 tip 定位偏移 -->
                <a-tooltip
                  placement="top"
                  :visible="!!hasDeepSearchPlan && moreResultTipVisible"
                  :auto-adjust-overflow="false"
                  :getPopupContainer="getMoreResultTipPopupContainer"
                  @visibleChange="handleMoreResultTipVisibleChange"
                >
                  <template #title>
                    <div class="more-result-tip flex flex-cross--top">
                      <div class="more-result-tip__content flex-box--1">
                        {{ $translateLang('深度计算给出更省板方案') }}~
                      </div>
                      <i
                        class="iconfont icon-close more-result-tip__close ml8 cursor-pointer"
                        @click.stop="handleCloseMoreResultTip"
                      />
                    </div>
                  </template>
                  <a-button
                    class="action-btn ml8 mr5"
                    :class="{
                      'disable-btn': isLockedRePaiban || isHistoryStatus,
                    }"
                    :disabled="isLockedRePaiban || isHistoryStatus"
                    @click="handleShowMoreResult"
                    id="paiban_more_paiban_result_btn"
                    >{{ $t('arrangedPage.moreResult') }}</a-button
                  >
                </a-tooltip>
                <!-- <a-button
                  :disabled="hasSaveSurplus"
                  class="action-btn ml15 mr5"
                  :class="{ 'disable-btn': hasSaveSurplus }"
                  @click="handleSurplusSave"
                  id="paiban_surplus_all_btn"
                >
                  余料入库</a-button
                > -->

                <a-dropdown
                  class="more-setting mr8"
                  id="paiban_batch_operation_dropdown"
                >
                  <template #overlay>
                    <a-menu id="paiban_batch_operation_menu">
                      <a-menu-item class="pt2 pb2" key="1">
                        <a-button
                          type="link"
                          :show="!showSubtle"
                          class="p0"
                          id="paiban_batch_bujian_btn"
                          @click="handleBatchBujian"
                          style="color: rgba(0, 0, 0, 0.65)"
                          :disabled="isBatchBujian || isBatchTagging"
                          >{{ $t('arrangedPage.batchBujian') }}</a-button
                        >
                      </a-menu-item>
                      <a-menu-item class="pt2 pb2" key="2">
                        <a-button
                          type="link"
                          @click="handleBatchTagging"
                          id="paiban_plank_batch_tagging_btn"
                          class="p0"
                          style="color: rgba(0, 0, 0, 0.65)"
                          :disabled="isBatchBujian || isBatchTagging"
                        >
                          {{ $translateLang('批量补标签') }}
                        </a-button>
                      </a-menu-item>
                      <a-menu-item class="pt2 pb2" key="3">
                        <a-button
                          type="link"
                          :show="!showSubtle"
                          class="p0"
                          id="paiban_batch_edit_size_btn"
                          style="color: rgba(0, 0, 0, 0.65)"
                          @click="handleBatchEditSize"
                          :disabled="isBatchBujian || isBatchTagging"
                          >{{ $translateLang('批量修改大板尺寸') }}</a-button
                        >
                      </a-menu-item>
                      <a-menu-item class="pt2 pb2" key="4">
                        <!-- 批量设置下刀点 -->
                        <a-button
                          type="link"
                          :show="!showSubtle"
                          class="p0"
                          style="color: rgba(0, 0, 0, 0.65)"
                          @click="showPositionChange = true"
                          id="paiban_origin_btn"
                          >{{ $t('arrangedPage.batchSetCut') }}</a-button
                        >
                      </a-menu-item>
                    </a-menu>
                  </template>
                  <a-button
                    :show="!showSubtle"
                    class="action-btn"
                    id="paiban_batch_operation_btn"
                    >{{ $translateLang('批量操作') }}
                    <a-icon type="down" />
                  </a-button>
                </a-dropdown>

                <!-- <new-content class="mr8"> -->
                <a-dropdown
                  class="more-setting mr8"
                  id="paiban_more_setting_dropdown"
                >
                  <template #overlay>
                    <a-menu id="paiban_more_setting_menu">
                      <a-menu-item class="pt2 pb2" key="1">
                        <!-- 余料入库 点击余料入库，按钮置灰，文案变成已入库-->
                        <div
                          class="surplus-in-storages"
                          @click="handleSurplusSave"
                        >
                          <a-button
                            class="p0 color-0"
                            type="link"
                            id="paiban_surplus_all_btn"
                            :disabled="hasSaveSurplus"
                            :class="{ 'disable-class': hasSaveSurplus }"
                            style="color: rgba(0, 0, 0, 0.65)"
                            ><i class="iconfont icon-warehousing1 mr2"></i
                            >{{
                              surplusAutoTailor
                                ? hasSaveSurplus
                                  ? translateLang('arrangedPage.stored')
                                  : translateLang('arrangedPage.saveSurplus')
                                : hasCut && hasSaveSurplus
                                ? translateLang('arrangedPage.stored')
                                : translateLang('arrangedPage.saveSurplus')
                            }}</a-button
                          >
                        </div>
                      </a-menu-item>
                      <a-menu-item class="pt2 pb2" key="2"
                        ><!-- 采购单 -->
                        <div
                          class="purchase-order"
                          @click="handlePlankShopinglist"
                        >
                          <a-button
                            type="link"
                            id="paiban_plank_shop_list_btn"
                            class="p0"
                            style="color: rgba(0, 0, 0, 0.65)"
                          >
                            <i class="iconfont icon-purchaseorder mr2"></i
                            >{{ $t('arrangedPage.workeShop') }}
                          </a-button>
                          <el-tooltip
                            v-if="false"
                            class="item"
                            effect="dark"
                            content="敬请期待!"
                            placement="top-start"
                          >
                            <a-button class="disable-btn ml15 p0"
                              ><i class="iconfont icon-purchaseorder mr2"></i
                              >{{ $t('arrangedPage.workeShop') }}</a-button
                            >
                          </el-tooltip>
                        </div></a-menu-item
                      >

                      <a-menu-item
                        class="pt2 pb2"
                        key="4"
                        @click="handleToMaterialList"
                      >
                        <a-button
                          type="link"
                          class="p0"
                          style="color: rgba(0, 0, 0, 0.65)"
                          id="paiban_material_list_btn"
                        >
                          <i class="iconfont icon-materiallist mr3"></i
                          >{{ $t('taskPage.record.materialList') }}</a-button
                        >
                      </a-menu-item>
                      <a-menu-item
                        class="pt2 pb2"
                        key="5"
                        @click="handleSendToFactory"
                        ><a-button
                          type="link"
                          class="p0"
                          style="color: rgba(0, 0, 0, 0.65)"
                          :loading="isSendToFactoryLoading"
                          id="paiban_send_workShop_btn"
                          :disabled="hasEmtryPlank && ncSetting.isPreLayout"
                          :class="{
                            'disable-class':
                              hasEmtryPlank && ncSetting.isPreLayout,
                          }"
                          ><i class="iconfont icon-workshop mr2"></i
                          >{{
                            $t('arrangedPage.sendToFactory.title')
                          }}</a-button
                        ></a-menu-item
                      >
                      <a-menu-item key="6">
                        <a-tooltip
                          placement="right"
                          overlayClassName="paiban-export-hole-slot-tooltip-card"
                        >
                          <template #title>
                            <a-button
                              class="w100"
                              @click="handleExportHoleSlotPdf"
                            >
                              {{ $translateLang('PDF格式') }}
                            </a-button>
                            <g-paid-feature
                              block
                              :iconStyle="{ right: '-5px' }"
                              :permission-keys="[
                                USER_PERMISSION_KEY.EXPORT_THE_STYLE_TWO_HOLE_SLOT_DIAGRAM_DXF,
                              ]"
                            >
                              <a-button
                                class="w100"
                                @click="handleExportHoleSlotDxf"
                              >
                                {{ $translateLang('DXF格式') }}
                              </a-button>
                            </g-paid-feature>
                          </template>
                          <div
                            class="flex flex-cross--center"
                            style="height: 36px"
                            id="paiban_export_hole_slot_pdf_btn"
                          >
                            <a-icon class="mr2" type="file-pdf" />
                            {{ $translateLang('导出孔槽图') }}
                          </div>
                        </a-tooltip>
                      </a-menu-item>
                      <a-menu-item class="pt2 pb2" key="7">
                        <div
                          class="flex flex-cross--center"
                          style="height: 36px"
                        >
                          <a-checkbox
                            v-model="isUsePlankAdsorption"
                            @change="handleUsePlankAdsorption"
                            id="paiban_send_usePlankAdsorption_checkbox"
                            >{{
                              $t('arrangedPage.usePlankAdsorption')
                            }}</a-checkbox
                          >
                        </div>
                      </a-menu-item>
                      <!-- 目录按照存在的大板数量排序 -->
                      <a-menu-item class="pt2 pb2" key="100">
                        <div
                          class="flex flex-cross--center"
                          style="height: 36px"
                        >
                          <newContent :is-new-content="false">
                            <a-checkbox
                              class="p0"
                              v-model="
                                $store.state.preferencesSetting.setting
                                  .isSortByPlankCountDesc
                              "
                              v-bp="`layout:according_plank_count_order`"
                              style="color: rgba(0, 0, 0, 0.65)"
                              @change="
                                handleSortByPlankNum(
                                  $store.state.preferencesSetting.setting
                                    .isSortByPlankCountDesc
                                )
                              "
                              id="paiban_send_SortByPlankNum_checkbox2"
                              ><span
                                id="paiban_show_cuttingOrder_checkbox_label2"
                                >{{
                                  $translateLang('按照大板数量由高到低排序')
                                }}</span
                              ></a-checkbox
                            >
                          </newContent>
                        </div>
                      </a-menu-item>
                      <a-menu-item class="pt2 pb2" key="8">
                        <div
                          class="flex flex-cross--center"
                          style="height: 36px"
                        >
                          <a-checkbox
                            v-model="isCuttingOrder"
                            @change="handleChangeTopOption"
                            id="paiban_show_cuttingOrder_checkbox"
                            ><span
                              id="paiban_show_cuttingOrder_checkbox_label2"
                              >{{
                                $t('arrangedPage.showCuttingSequence')
                              }}</span
                            ></a-checkbox
                          >
                        </div>
                      </a-menu-item>
                      <a-menu-item class="pt2 pb2" key="9">
                        <div
                          class="flex flex-cross--center"
                          style="height: 36px"
                        >
                          <a-checkbox
                            v-model="isShowPartSize"
                            @change="handleChangeTopOption"
                            id="paiban_show_plankSize_checkbox2"
                            ><span id="paiban_show_plankSize_checkbox_label">{{
                              $t('arrangedPage.showPlankSize')
                            }}</span></a-checkbox
                          >
                        </div>
                      </a-menu-item>
                      <a-menu-item class="pt2 pb2" key="10">
                        <div
                          class="flex flex-cross--center"
                          style="height: 36px"
                        >
                          <a-checkbox
                            v-model="isUnuseSurplus"
                            @change="handleUnuseSurplus"
                            id="paiban_send_isUnuseSurplus_checkbox2"
                            >{{ $t('arrangedPage.UnuseSurplus') }}</a-checkbox
                          >
                        </div>
                      </a-menu-item>
                      <!-- 排版页 数据默认收起 -->
                      <a-menu-item class="pt2 pb2" key="11">
                        <div
                          class="flex flex-cross--center"
                          style="height: 36px"
                        >
                          <a-checkbox
                            v-model="isDataDefaultCollapsed"
                            @change="handleDataDefaultCollapsed"
                            id="paiban_send_dataDefaultCollapsed_checkbox"
                            >{{
                              $t('arrangedPage.dataDefaultCollapsed')
                            }}</a-checkbox
                          >
                        </div>
                      </a-menu-item>
                      <a-menu-item class="pt2 pb2" key="12">
                        <div
                          class="flex flex-cross--center"
                          style="height: 36px"
                        >
                          <a-checkbox
                            v-model="isMarkModifiedSmallBoards"
                            @change="handleMarkModifiedSmallBoards"
                            id="paiban_send_markModifiedSmallBoards_checkbox"
                            >{{
                              $translateLang('标识修改过的小板')
                            }}</a-checkbox
                          >
                        </div>
                      </a-menu-item>
                      <a-menu-item class="pt2 pb2" key="13">
                        <div
                          class="flex flex-cross--center"
                          style="height: 36px"
                        >
                          <a-checkbox
                            v-model="isShowMoveStep"
                            @change="handleShowMoveStep"
                            id="paiban__show_move_step_checkbox"
                            >{{
                              $translateLang('自定义键盘移动步长')
                            }}</a-checkbox
                          >
                        </div>
                      </a-menu-item>
                    </a-menu>
                  </template>
                  <a-button id="paiban_more_setting_btn" class="action-btn">
                    <!-- 更多设置 -->
                    {{ $t('arrangedPage.moreSetting') }}
                    <a-icon type="down" />
                  </a-button>
                </a-dropdown>

                <!-- 重新排版 -->
                <a-tooltip
                  v-if="isWebToQt && isExpressVip"
                  :title="
                    $translateLang(
                      checkUserPermissions([USER_PERMISSION_KEY.DEEP_SEARCH]) ==
                        true
                        ? `${$translateLang(
                            '专属功能，可通过重新排版增加计算深度，以获取更优排版结果'
                          )}~`
                        : `${$translateLang(
                            '升级深度计算后，可通过重新排版增加计算深度，以获取更优排版结果，当前可试用'
                          )}~`
                    )
                  "
                >
                  <a-button
                    class="action-btn"
                    style="padding: 0 4px; min-width: 32px; margin-left: -1px"
                    :class="[
                      hasEmtryPlank || isBanRelayout ? 'disable-btn' : '',
                    ]"
                    :disabled="hasEmtryPlank || isBanRelayout"
                    @click="
                      handleChangePaibanWay(activePaibanWay[0], true, true)
                    "
                    id="paiban_plank_reLayout_btn"
                  >
                    <a-icon type="redo" />
                  </a-button>
                </a-tooltip>
                <a-tooltip v-else :title="$translateLang('重新排版')">
                  <a-button
                    class="action-btn"
                    style="padding: 0 4px; min-width: 32px; margin-left: -1px"
                    :class="[
                      hasEmtryPlank || isBanRelayout ? 'disable-btn' : '',
                    ]"
                    :disabled="hasEmtryPlank || isBanRelayout"
                    @click="
                      handleChangePaibanWay(activePaibanWay[0], true, true)
                    "
                    id="paiban_plank_reLayout_btn"
                  >
                    <a-icon type="redo" />
                  </a-button>
                </a-tooltip>

                <!-- 按材质重新排版 -->
                <a-tooltip :title="$translateLang('指定板件组重新排版')">
                  <a-button
                    class="action-btn ml5"
                    id="paiban_material_relayout_btn"
                    style="padding: 0 4px; min-width: 32px; margin-left: -1px"
                    :disabled="hasEmtryPlank || isBanRelayout"
                    @click="isShowMaterialRelayoutModal = true"
                  >
                    <a-icon type="down" style="font-size: 10px" />
                  </a-button>
                </a-tooltip>
                <!-- </new-content> -->
                <!-- 新增开料清单按钮 -->
                <div class="material-list-btn"></div>

                <div class="layout-loc">
                  <div class="only-surplus-box">
                    <a-checkbox
                      v-model="isOnlyShowSurplus"
                      @change="
                        () => {
                          handleShowSurplus(), handleBury()
                        }
                      "
                      >{{ $t('arrangedPage.onlySurplus') }}</a-checkbox
                    ><span class="only-show-surplus"
                      >{{ surplusCount }}{{ $t('common.unit') }}</span
                    >
                  </div>

                  <!-- 排版方案选择部分 -->
                  <div
                    class="paiban-program-box"
                    ref="paibanProgramRef"
                    v-show="false"
                  >
                    <a-dropdown
                      id="paiban_program_setting_dropdown"
                      :visible="isShowProgram"
                    >
                      <template #overlay>
                        <!-- <a-menu id="paiban_program_setting_menu">
                        <a-menu-item key="1">
                          <paibanSetting
                            :showProLineDialog="isShowProgram"
                          ></paibanSetting>
                        </a-menu-item>
                      </a-menu> -->
                        <paibanSetting
                          :clickFlag="clickFlag"
                          :isLessReverse="isLessReverse"
                          :isSpecialShape="isSpecialShape"
                          :selectedPaibanWay="selectedPaibanWay"
                          :showProLineDialog="isShowProgram"
                          :isFromDrawAllParts="true"
                          @onCancel="handleChangeSetting"
                          @getInitData="handleGetInitData"
                          @getFinalData="handleGetFinalData"
                          @getInitTableData="handleGetInitTableData"
                          @getFinalTableData="handleGetFinalTableData"
                          @getInitSurplusSelectData="
                            handleGetInitSurplusSelectData
                          "
                          @getFinalSurplusSelectData="
                            handleGetFinalSurplusSelectData
                          "
                        ></paibanSetting>
                      </template>
                      <div
                        class="flex flex-cross--center"
                        @click.stop="handleToggleSettings"
                      >
                        <span class="paiban-program-title"
                          >{{ $t('main.sideBar.paibanResult') }}：</span
                        >
                        <!-- <div class="paiban-program-choose"> -->
                        <div class="paiban-program-choose flex">
                          <a-tooltip
                            :title="
                              (selectedPaibanWay?.indexOf('v2') !== -1
                                ? translateLang('common.directArrange')
                                : translateLang('common.sawArrange')) +
                              (isLessReverse
                                ? `,${translateLang(
                                    'materialPage.paibanSetting.lessRoll'
                                  )}`
                                : '') +
                              (isSpecialShape
                                ? `,${translateLang(
                                    'materialPage.paibanSetting.computedSpecial'
                                  )}`
                                : '') +
                              (surplusAutoTailor
                                ? `,${translateLang('arrangedPage.cutSurplus')}`
                                : '')
                            "
                          >
                            <span class="span-box inline-block">
                              {{
                                (selectedPaibanWay?.indexOf('v2') !== -1
                                  ? translateLang('common.directArrange')
                                  : translateLang('common.sawArrange')) +
                                (isLessReverse
                                  ? `,${translateLang(
                                      'materialPage.paibanSetting.lessRoll'
                                    )}`
                                  : '') +
                                (isSpecialShape
                                  ? `,${translateLang(
                                      'materialPage.paibanSetting.computedSpecial'
                                    )}`
                                  : '') +
                                (surplusAutoTailor
                                  ? `,${translateLang(
                                      'arrangedPage.cutSurplus'
                                    )}`
                                  : '')
                              }}
                            </span>
                          </a-tooltip>
                          <a-icon slot="addonAfter" type="down" />
                        </div>
                        <!-- </div> -->
                      </div>
                    </a-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-show="isFollowExportTag && !isWebToQt && isChangeTagTemp"
              class="current-tag-name"
            >
              <span class="fs12">
                {{ $translateLang('当前标签模板') }}：{{
                  tagTempList.find((temp) => temp.id === currentTagTempID)?.name
                }}
              </span>
              <i
                class="iconfont icon-close cursor-pointer"
                @click="handleCloseTagTemp"
              ></i>
            </div>
          </div>
        </div>
        <a-alert
          type="warning"
          show-icon
          closable
          class="mh16 mt16"
          v-if="hasHighGlossPlank && !isOnlyProcessHoleSlot"
        >
          <template #message>
            <div class="highgloss-tips">
              <div v-show="showHighGlossTipType === 'back'">
                <div v-html="$t('arrangedPage.warningTip')"></div>
              </div>
              <div v-show="showHighGlossTipType === 'front'">
                <div v-html="$t('arrangedPage.frontWarningTip')"></div>
              </div>
            </div>
          </template>
        </a-alert>
        <div
          class="batch-bujian relative flex flex-main--justify flex-cross--center ml16 mr16 pl15 pr16"
          v-if="isBatchBujian"
        >
          <span class="bold">{{
            batchBujianList.length
              ? `${$t('workShopPage.selected')}${batchBujianList.length}`
              : $t('arrangedPage.selectTip')
          }}</span>
          <div class="flex flex-main--center flex-cross--center">
            <a-button
              id="paiban_cancel_batch_bujian_btn"
              class="mr10"
              @click="handleCloseBatchBujian"
              >{{ $t('common.cancel') }}</a-button
            >
            <a-button
              id="paiban_confirm_batch_bujian_btn"
              :disabled="!batchBujianList.length"
              :type="batchBujianList.length ? 'primary' : ''"
              @click="handleConfirmBatchBujian"
              >{{ $t('workShopPage.suplement') }}</a-button
            >
          </div>
        </div>
        <!-- 批量补标签 -->
        <div
          class="batch-tagging relative flex flex-main--justify flex-cross--center ml16 mr16 pl15 pr16"
          v-if="isBatchTagging"
        >
          <span class="bold">{{
            currentBatchTaggingList.length
              ? `${$t('workShopPage.selected')}${
                  currentBatchTaggingList.length
                }`
              : $t('arrangedPage.batchTaggingTip')
          }}</span>
          <div class="flex flex-main--center flex-cross--center">
            <a-button
              id="paiban_cancel_batch_tagging_btn"
              class="mr10"
              @click="handleCloseBatchTagging"
              >{{ $t('common.cancel') }}</a-button
            >
            <a-button
              id="paiban_confirm_batch_tagging_btn"
              :disabled="!currentBatchTaggingList.length"
              :type="currentBatchTaggingList.length ? 'primary' : ''"
              @click="handleConfirmBatchTagging"
              >{{ $translateLang('打印标签') }}</a-button
            >
          </div>
        </div>
        <div class="all-parts" ref="allParts" @scroll="scrollCanvas">
          <div v-show="drawData.length">
            <template v-for="(item, index) in drawData">
              <drawPart
                v-show="!item.isDesMaterialNoCut"
                :key="`drawpart${index}`"
                :isOnlyShowSurplus="isOnlyShowSurplus"
                :isShowPartSize="isShowPartSize"
                :order="index"
                :drawData="item"
                :ref="`drawpart${index}`"
                :isNonTexture="isNonTexture"
                :canvasKey="index"
                :startNum="getStartNum(index)"
                :canvasMaxHeight="canvasMaxHeight"
                :canvasMaxWidth="canvasMaxWidth"
                :isCuttingOrder="isCuttingOrder"
                :isMarkModifiedSmallBoards="isMarkModifiedSmallBoards"
                :activePlankID="activePlankID"
                :activePlankIndex="activePlankIndex"
                :currentStoreType="storeType"
                :clearConflict="clearConflict"
                :isBatchBujian="isBatchBujian"
                :batchBujianList="batchBujianList"
                :isBatchActive="isBatchActive"
                :batchActiveIdList="batchActiveIdList"
                :isBatchTagging="isBatchTagging"
                :batchTaggingList="currentBatchTaggingList"
                :calcFanbanCount="calcFanbanCount"
                :calcCutPositionOrder="calcCutPositionOrder"
                :isShowDelete="totalBigpartCounts > 1"
                :isUnuseSurplus="isUnuseSurplus"
                :isUsePlankAdsorption="isUsePlankAdsorption"
                :isDrawPartCollapsed="isDrawPartCollapsed"
                :onPartChange="onPartChange"
                :isMatchedLayeredForPartThick="isMatchedLayeredForPartThick"
                :isShowMoveStep="isShowMoveStep"
                :moveStep="lastValidMoveStep"
                @setHasSavedSurplus="setHasSavedSurplus"
                @onEditPlankSize="handleUpdateEditSize"
                @recordActivePlank="recordActivePlank"
                @clearAllActive="clearAllActive"
                @clearAllStyle="handleClearAllStyle"
                @forbidUserSelect="forbidUserSelect"
                @handleChangeRemarksAble="handleChangeRemarksAble"
                @gotoSubtle="gotoSubtle"
                @useSurplus="useSurplus"
                @closeSurplusDialog="closeSurplusDialog"
                @addNewBigpart="addNewBigpart"
                @deleteBigpart="deleteBigpart"
                @copyBigpart="copyBigpart"
                @getBigPlankH="setBigPlankH"
                @handleChangeImageTempMousedownFlag="
                  handleChangeImageTempMousedownFlag
                "
                @handleChangePage="handleChangePage"
                @onConflictPart="handleConflictPart"
                @handleChangePerPage="handleChangePerPage"
                @recordPlankMove="handleRecordPlankMove"
                @handleClickLock="handleClickLock"
                @scaleChange="handlePartScaleChange"
                @setActiveBigPart="handleSetActiveBigpart"
                @onGotoSubtleErr="onGotoSubtleErr"
                @onAddDataToOperateArr="addDataToOperateArr"
                @rightClick="handleClickRight"
                @leftClick="handleClickLeft"
                @autoScrollRightOperationZone="
                  handleAutoScrollRightOperationZone
                "
                @onLayoutReuse="handleLayoutReuse"
                @clearReuseGroup="clearReuseGroup"
                @clearSingleReuseChild="clearSingleReuseChild"
              ></drawPart>
            </template>
          </div>
          <div v-show="isAllDesMaterialNoCutTip" class="no-cut-tag-tip">
            <span>{{
              $translateLang('当前小板均为不下料板件，不参与排版')
            }}</span>
            <span>{{
              $translateLang('您仍可继续导出孔槽加工文件，或打印标签')
            }}</span>
          </div>
        </div>
        <div
          class="move-step-box"
          v-show="
            isShowMoveStep &&
            (activePlank || (showSubtle && subtleHasActivePlank))
          "
        >
          <span>{{ $translateLang('键盘移动步长') }}：</span>
          <a-input
            v-model="moveStep"
            suffix="mm"
            style="width: 100px"
            @input="handleInputMoveStep"
            @keydown.enter="handleUpdateMoveStep"
            @blur="handleBlurMoveStep"
          />
        </div>
        <div class="operate-menu">
          <div>
            <a-popover placement="top" overlayClassName="paiban-operate-menu">
              <template slot="content">
                <div class="operate-item paiban-intro">
                  <div class="rect-example"></div>
                  <span>{{ $t('arrangedPage.funished') }}</span>
                </div>
                <div class="operate-item paiban-intro">
                  <div class="holeslot-merge-example"></div>
                  <span>{{ $t('arrangedPage.holeSlotConflict1') }}</span>
                </div>
                <div class="operate-item paiban-intro">
                  <div class="rect-merge-example"></div>
                  <span>{{ $t('arrangedPage.plankErr') }}</span>
                </div>
                <div class="operate-item paiban-intro">
                  <div class="slot-example face-slot"></div>
                  <span>{{ $t('arrangedPage.frontSlot') }}</span>
                </div>
                <div class="operate-item paiban-intro">
                  <div class="slot-example back-slot"></div>
                  <span>{{ $t('arrangedPage.backSlot') }}</span>
                </div>
                <div class="operate-item paiban-intro">
                  <div class="hole-example face-hole"></div>
                  <span>{{ $t('arrangedPage.frontHole') }}</span>
                </div>
                <div class="operate-item paiban-intro">
                  <div class="hole-example back-hole"></div>
                  <span>{{ $t('arrangedPage.backHole') }}</span>
                </div>
                <div class="operate-item paiban-intro">
                  <div class="rect-step-cutting"></div>
                  <span>{{ $t('cuttingDock.cuttingParams.stepCutting') }}</span>
                </div>
                <div class="operate-item paiban-intro">
                  <div class="ml12"><span class="fs16">*</span></div>
                  <span>{{ $translateLang('存在变更的小板') }}</span>
                </div>
                <div class="operate-item paiban-intro">
                  <div class="rect-cross-material"></div>
                  <span>{{ $translateLang('跨材质颜色小板') }}</span>
                </div>
              </template>
              <template slot="title">
                <span>{{ $t('arrangedPage.picSymble') }}</span>
              </template>
              <span class="icon_btn"
                ><i class="operate-icon iconfont icon-hint01"></i
              ></span>
            </a-popover>
            <a-popover placement="top" overlayClassName="paiban-operate-menu">
              <template slot="title">
                <span>{{ $t('arrangedPage.shortCut') }}</span>
              </template>
              <template slot="content">
                <div class="operate-item">
                  <span>{{ $t('arrangedPage.updownRoll') }}</span>
                  <div>
                    <span>{{ $t('arrangedPage.mouseRoll') }}</span>
                  </div>
                </div>
                <div class="operate-item">
                  <span>{{ $t('arrangedPage.leftRightRoll') }}</span>
                  <div>
                    <span>shift</span>
                    <span>+{{ $t('arrangedPage.mouseRoll') }}</span>
                  </div>
                </div>
                <div class="operate-item">
                  <span>{{ $t('arrangedPage.zoomScale') }}</span>
                  <div class="operate-item-more">
                    <div>
                      <span>ctrl</span>
                      <span>+{{ $t('arrangedPage.mouseRoll') }}</span>
                    </div>
                  </div>
                </div>
                <div class="operate-item">
                  <span>{{ $t('arrangedPage.dragCanvas') }}</span>
                  <div class="operate-item-more">
                    <div>
                      <span>{{ $t('arrangedPage.mouseRight') }}</span>
                    </div>
                  </div>
                </div>
                <div class="operate-item">
                  <span>{{ $translateLang('精细排版') }}</span>
                  <span>{{ $translateLang('双击大板') }}</span>
                </div>
                <div class="operate-item">
                  <span>{{ $translateLang('删除板件') }}</span>
                  <span>{{ $translateLang('键盘') }}delete</span>
                </div>
                <div class="operate-item">
                  <span>{{ $translateLang('多选板件') }}</span>
                  <span>ctrl + {{ $translateLang('鼠标左键') }}</span>
                </div>
              </template>
              <span class="icon_btn"
                ><i class="operate-icon iconfont icon-keyboard01"></i
              ></span>
            </a-popover>
          </div>
          <div class="zoom-percent-box">
            <span
              class="iconfont icon-reduce01 operate-icon"
              @mousedown="changeZoomPercent(-0.1)"
              @mouseup="clearAllTimer"
              id="paiban_sub_scale_btn"
            ></span>
            <span class="zoom-percent">{{
              showSubtle ? subtleZoomPercent : zoomPercent
            }}</span>
            <span
              class="iconfont icon-add_03 operate-icon"
              @mousedown="changeZoomPercent(0.1)"
              @mouseup="clearAllTimer"
              id="paiban_add_scale_btn"
            ></span>
          </div>
          <div class="mr1" style="border-left: solid #ccc 1px">
            <a-popover placement="top">
              <template slot="content">{{
                $t('arrangedPage.resetScale')
              }}</template>
              <i
                class="iconfont icon-reset-icon operate-icon ml3"
                @click="handleResetScale"
                id="paiban_reset_scale_btn"
              ></i>
            </a-popover>
          </div>
        </div>
      </div>

      <div class="right-operation">
        <a-input-search
          v-model="plankKeyWord"
          :placeholder="translateLang('arrangedPage.plankKeyWordPlaceholder')"
          @search="searchPlank"
          :class="{ 'empty-input': isEmptyInput }"
          id="paiban_search_plank_input"
          :disabled="isBatchBujian"
        >
          <template #suffix>
            <div>
              {{
                searchPlankList.length
                  ? `${searchPlankIndex + 1}/${searchPlankList.length}`
                  : ''
              }}
            </div>
          </template>
        </a-input-search>
        <div class="change-plank">
          <el-button
            class="presious-plank"
            :disabled="searchPlankList.length <= 1"
            @click="handlePresiousPlank"
            id="paiban_search_plank_pre_btn"
            >{{ $t('common.previous') }}</el-button
          >
          <el-button
            class="next-plank"
            :disabled="searchPlankList.length <= 1"
            @click="handleNextPlank"
            id="paiban_search_plank_next_btn"
            >{{ $t('common.next') }}</el-button
          >
        </div>
        <div class="active-plank-box">
          <div v-if="activePlank" class="active-plank-info">
            <div class="left-info">
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{
                    activePlank._isBujian
                      ? activePlank._bujianOrderNo
                        ? activePlank._bujianOrderNo
                        : activePlank.orderNo
                      : activePlank.orderNo
                  }}</span>
                </template>
                <span
                  class="info-eliplise"
                  ref="activePlankAddr"
                  id="paiban_plank_info_orderNo_text"
                  >{{ $t('common.orderNo') }}：{{
                    activePlank._isBujian
                      ? activePlank._bujianOrderNo
                        ? activePlank._bujianOrderNo
                        : activePlank.orderNo
                      : activePlank.orderNo
                  }}</span
                >
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{
                    activePlank._isBujian
                      ? activePlank._bujianAddress
                        ? activePlank._bujianAddress
                        : activePlank.address
                      : activePlank.address
                  }}</span>
                </template>
                <span
                  class="info-eliplise"
                  ref="activePlankAddr"
                  id="paiban_plank_info_address_text"
                  >{{ $t('taskPage.search.orderName') }}：{{
                    activePlank._isBujian
                      ? activePlank._bujianAddress
                        ? activePlank._bujianAddress
                        : activePlank.address
                      : activePlank.address
                  }}</span
                >
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>
                    {{ $t('common.plankName') }}：
                    {{ activePlank.partName }}
                  </span>
                </template>
                <span id="paiban_plank_info_address_text">
                  {{ $t('common.plankName') }}：
                  {{ activePlank.partName }}
                </span>
              </a-tooltip>

              <div class="plank-matCode-container">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span
                      >{{ $t('common.matCode') }}{{ $t('common.color') }}：{{
                        activePlank.thick
                      }}{{
                        dealHighlightMatCode(
                          activePlank._oriMatCode || activePlank.matCode
                        )
                      }}（{{
                        activePlank._oriTexture ||
                        activePlank.oriTexture ||
                        activePlank.texture
                      }}）
                    </span>
                  </template>
                  <span
                    class="info-eliplise"
                    style="max-with: 210px; width: 210px"
                    ref="activePlankAddr"
                    id="paiban_plank_info_matcode_text"
                    >{{ $t('common.matCode') }}{{ $t('common.color') }}：{{
                      activePlank.thick
                    }}{{
                      dealHighlightMatCode(
                        activePlank._oriMatCode || activePlank.matCode
                      )
                    }}（{{
                      activePlank._oriTexture ||
                      activePlank.oriTexture ||
                      activePlank.texture
                    }}）</span
                  >
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span
                      >{{ $t('common.plankNo') }}：{{
                        activePlank.plankID
                      }}</span
                    >
                  </template>
                  <span
                    class="info-eliplise"
                    style="max-width: 100px; margin-left: 10px"
                    id="paiban_plank_info_plankID_text"
                    >{{ $t('common.plankNo') }}：{{ activePlank.plankID }}
                  </span>
                </a-tooltip>
              </div>
              <span class="info-eliplise" ref="activePlankAddr"
                >{{ $t('common.edge.info') }}：{{ newEdgeInfo }}</span
              >

              <a-tooltip placement="top">
                <template slot="title">
                  <span
                    >{{ computedRealRectFopEdge('width') }}*{{
                      computedRealRectFopEdge('height')
                    }}</span
                  >
                </template>
                <span id="paiban_plank_info_cuttingSize_text"
                  >{{ $t('common.cuttingSize') }}：{{
                    computedRealRectFopEdge('width')
                  }}*{{ computedRealRectFopEdge('height') }}</span
                >
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span
                    >{{
                      activePlank.srcTexDir !== 'reverse'
                        ? showPartSize('oRect', 'width')
                        : showPartSize('oRect', 'height')
                    }}*{{
                      activePlank.srcTexDir !== 'reverse'
                        ? showPartSize('oRect', 'height')
                        : showPartSize('oRect', 'width')
                    }}</span
                  >
                </template>
                <span id="paiban_plank_info_oSize_text"
                  >{{ $t('common.finishedSize') }}：{{
                    activePlank.srcTexDir !== 'reverse'
                      ? showPartSize('oRect', 'width')
                      : showPartSize('oRect', 'height')
                  }}*{{
                    activePlank.srcTexDir !== 'reverse'
                      ? showPartSize('oRect', 'height')
                      : showPartSize('oRect', 'width')
                  }}</span
                >
              </a-tooltip>
              <span>{{ $t('common.plankNum') }}：{{ showPlankNum }}</span>
              <a-tooltip placement="top">
                <template slot="title">
                  <span
                    >{{ $t('common.plankRemark') }}：{{
                      activePlank.plank_remarks
                    }}</span
                  >
                </template>
                <span
                  class="info-eliplise"
                  style="max-width: 190px"
                  id="paiban_plank_remarks_plankID_text"
                >
                  <span
                    >{{ $t('common.plankRemark') }}：{{
                      activePlank.plank_remarks
                    }}</span
                  >
                </span>
              </a-tooltip>
              <a-tooltip
                v-if="activePlank.textureGrainInfo?.groupName"
                placement="top"
              >
                <template slot="title">
                  <span
                    >{{ $translateLang('对纹组') }}：{{
                      activePlank.textureGrainInfo.groupName
                    }}</span
                  >
                </template>
                <span class="info-eliplise" style="max-width: 190px">
                  {{ $translateLang('对纹组') }}：{{
                    activePlank.textureGrainInfo.groupName
                  }}
                </span>
              </a-tooltip>
            </div>
            <div
              class="right-qrcode"
              style="display: none"
              id="paiban-qrcode"
              ref="paibanQRcode"
            ></div>
            <div class="right-qrcode" ref="plankQRcode"></div>
            <div
              class="absolute t1 r5"
              v-show="
                activePlank.specialFlag && activePlank.specialFlag !== 'default'
              "
            >
              <img :src="specialIcon[activePlank.specialFlag]" alt="无法显示" />
            </div>
          </div>
          <div class="no-active-plank" v-else>
            <div>
              <div>{{ $t('arrangedPage.showDetail.tip1') }}</div>
              <div>{{ $t('arrangedPage.showDetail.tip2') }}</div>
            </div>
          </div>
        </div>
        <div class="paiban-way">
          <div class="title-box">
            <span class="circle"></span>
            <span class="title"
              >{{ $t('main.sideBar.paibanResult') }}
              <span style="font-size: 12px">{{
                $t('arrangedPage.arrangeTip')
              }}</span>
            </span>
          </div>
          <a-tooltip :title="false">
            <div class="select-paiban">
              <a-select
                ref="select"
                v-model="selectedPaibanWay"
                style="width: 50%"
                :disabled="
                  isHistoryStatus || hasEmtryPlank || isHbsHistoryStatus
                "
                @change="handleChangePaibanWay(selectedPaibanWay)"
              >
                <a-select-option
                  v-for="(item, index) in paibanWayList"
                  :key="index"
                  :value="item.interface"
                  :id="`paiban_paibanWay_select_option${index}`"
                  :disabled="
                    hasSelectSpecialShapeSurplus && item.interface == 'paiban'
                  "
                >
                  <a-tooltip
                    :title="translateLang('异形余料不能使用锯切排版')"
                    v-if="
                      hasSelectSpecialShapeSurplus && item.interface == 'paiban'
                    "
                  >
                    <span>{{
                      item.name !== 'AI智能排版限时试用'
                        ? translateLang(item.name)
                        : null
                    }}</span>
                  </a-tooltip>
                  <span v-else>{{
                    item.name !== 'AI智能排版限时试用'
                      ? translateLang(item.name)
                      : null
                  }}</span>
                </a-select-option>
              </a-select>
              <span
                style="margin-left: 10px; color: #2babcc"
                id="paiban_paibanWay_suit_text"
              >
                <!-- 适用于: }} -->
                {{ translateLang('arrangedPage.applyTo') }}
                {{ translateLang(suitText) }}
              </span>
            </div>
            <a-checkbox
              v-model="isLessReverse"
              :disabled="isHistoryStatus || isHbsHistoryStatus"
              @change="
                () => {
                  handleChangePaibanWay('_roll'), handleBury()
                }
              "
              id="paiban_paibanWay_setting_lessRoll_checkbox"
              ><span id="paiban_paibanWay_setting_lessRoll_checkbox_label">{{
                $t('materialPage.paibanSetting.lessRoll')
              }}</span></a-checkbox
            >
            <br />
            <a-checkbox
              v-model="isSpecialShape"
              :disabled="isHistoryStatus || isHbsHistoryStatus"
              @change="handleSpecial"
              id="paiban_paibanWay_setting_comSpecial_checkbox"
              style="margin-top: 2px"
              ><span id="paiban_paibanWay_setting_comSpecial_checkbox_label"
                >{{ $t('materialPage.paibanSetting.computedSpecial') }}（{{
                  $t('materialPage.paibanSetting.specialTip')
                }}）</span
              ></a-checkbox
            >
            <a-radio-group
              v-model="nestWay"
              name="radioGroup"
              class="factory relative"
              style="margin-top: 5px"
              v-if="isSpecialShape"
              :disabled="isHistoryStatus || isHbsHistoryStatus"
              @change="handlerRadioOption($event.target)"
            >
              <a-radio
                value="PRIMARY"
                style="width: 120px"
                id="paiban_paibanWay_setting_primary_radio"
                ><g-t-view
                  :text="$t('materialPage.paibanSetting.primaryNesting')"
                  id="paiban_paibanWay_setting_primary_radio_label"
                  width="80px"
              /></a-radio>

              <a-radio
                value="SENIOR"
                style="width: 120px"
                id="paiban_paibanWay_setting_senior_radio"
                :disabled="!hasAdvancedNestPermission"
              >
                <g-paid-feature
                  :iconStyle="{ right: '-15px' }"
                  :permission-keys="[
                    USER_PERMISSION_KEY.ADVANCED_IRREGULAR_NESTING,
                  ]"
                  ><g-t-view
                    :text="$t('materialPage.paibanSetting.seniorShape')"
                    id="paiban_paibanWay_setting_senior_radio_label"
                    width="80px"
                /></g-paid-feature>
              </a-radio>

              <div
                style="
                  width: 200px;
                  margin-left: 8px;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <span class="radioGroup"
                  ><g-t-view
                    :text="
                      '(' +
                      $t('materialPage.paibanSetting.specialShapedPanel') +
                      ')'
                    "
                    width="80px"
                /></span>
                <span class="radioGroup"
                  ><g-t-view
                    :text="
                      '(' +
                      $t('materialPage.paibanSetting.heteromorphicInlay') +
                      ')'
                    "
                    width="80px"
                /></span>
              </div>
              <div
                class="factory-tip absolute pv1 ph5 br5"
                style="line-height: 12px; top: -0.6em; right: -0.5em"
              ></div>
            </a-radio-group>
          </a-tooltip>
        </div>
        <div class="plank-operation">
          <div class="title-box">
            <span class="circle"></span>
            <span class="title">{{ $t('arrangedPage.plankOpration') }}</span>
          </div>
          <div class="plank-operation-btns">
            <a-button
              class="plank-control-rotate"
              @click="rotatePlank(90)"
              :disabled="
                (!activePlank && !batchActiveIdList.length) ||
                !hasLblAuth ||
                handleIslocked ||
                isBatchBujian ||
                hasExpandedPlank ||
                hasBatchActiveInvalid
              "
              id="paiban_rotatePlank_btn"
              >{{ $t('arrangedPage.rotate') }}</a-button
            >
            <a-button
              class="plank-control-rotate"
              :class="
                activePlank && activePlank.is_high_gloss_plank
                  ? 'highGlossDisabled'
                  : 'plank-control-rotate'
              "
              @click="reversePlank"
              :disabled="
                (!activePlank && !batchActiveIdList.length) ||
                !hasLblAuth ||
                handleIslocked ||
                isBatchBujian ||
                hasExpandedPlank ||
                hasBatchActiveInvalid
              "
              id="paiban_reversePlank_btn"
              >{{ $t('common.roll') }}</a-button
            >
            <el-tooltip
              v-if="false"
              class="item"
              effect="dark"
              :content="translateLang('sideHoleMachine.please')"
              placement="top-start"
            >
              <a-button
                class="plank-control-rotate disable-btn ml15"
                id="paiban_reversePlank_btn_disable"
                >{{ $t('common.roll') }}</a-button
              >
            </el-tooltip>
            <a-button
              class="plank-control-del"
              @click="deletePlank"
              :disabled="
                (!activePlank && !batchActiveIdList.length) ||
                handleIslocked ||
                isBatchBujian ||
                hasBatchActiveLocked
              "
              id="paiban_deletePlank_btn"
              >{{ $t('materialPage.deletePlank') }}</a-button
            >
            <a-button
              class="plank-control-del ml8"
              :disabled="
                (!activePlank && !batchActiveIdList.length) ||
                handleIslocked ||
                isBatchBujian ||
                hasBatchActiveLocked
              "
            >
              <a-checkbox
                :checked="nonTextureChecked"
                :indeterminate="isNonTextureIndeterminate"
                @change="handleNonTexture"
                :disabled="
                  (!activePlank && !batchActiveIdList.length) ||
                  handleIslocked ||
                  isBatchBujian ||
                  hasBatchActiveLocked ||
                  isNonTextureDisabled
                "
                id="paiban_plankNonTexture_checkbox"
                ><span id="paiban_plankNonTexture_checkbox_label">{{
                  $t('arrangedPage.notCare')
                }}</span></a-checkbox
              >
            </a-button>
            <!-- !!this.activePlank.surplusPath || -->
            <a-button
              class="plank-control-del"
              :disabled="
                (!activePlank && !batchActiveIdList.length) ||
                !hasLblAuth ||
                handleIslocked ||
                isBatchBujian ||
                hasBatchActiveLocked
              "
              id="paiban_calcCutPositionOrder_btn"
              v-if="
                !ableRewriteRemarks ||
                (!activePlank && !batchActiveIdList.length)
              "
              @click="handleRewriteRemarks"
              >{{ $t('arrangedPage.editRemark') }}</a-button
            >
            <div
              v-if="
                ableRewriteRemarks && (activePlank || batchActiveIdList.length)
              "
              class="w100"
            >
              <div class="w100">
                <a-textarea
                  :maxLength="50"
                  v-model="plankRemarks"
                  :placeholder="translateLang('arrangedPage.editRemark')"
                ></a-textarea>
                <div class="flex flex-main--justify mt8 mb8">
                  <a-button @click="plankRemarks = ''">{{
                    $t('arrangedPage.clearRemark')
                  }}</a-button>
                  <a-button @click="handleChangeRemarks">{{
                    $t('common.confirm')
                  }}</a-button>
                </div>
              </div>
            </div>

            <a-button
              class="plank-control-del"
              id="paiban_special_shap_cut_btn"
            >
              <a-checkbox
                :checked="layerCutChecked"
                :indeterminate="isLayerCutIndeterminate"
                :disabled="
                  isBatchBujian ||
                  (!activePlank && !batchActiveIdList.length) ||
                  isMatchedLayeredForPartThick ||
                  hasBatchActiveLocked
                "
                id="paiban_special_shape_cut_checkbox"
                @change="handleLayerCut"
                ><span id="paiban_special_shape_cut_checkbox_label">{{
                  $t('cuttingDock.cuttingParams.stepCutting')
                }}</span></a-checkbox
              >
            </a-button>
            <div
              v-if="showPositionChange"
              @click="showPositionChange = false"
              id="paiban_origin_mask"
              class="origin-dialog-mask"
            >
              <div class="origin-dialog" @click.stop>
                <div class="origin-dialog-title">
                  <span>{{ $t('arrangedPage.setCutPoint') }}</span>
                  <span
                    class="iconfont icon-close"
                    id="paiban_origin_cancel_icon_btn"
                    @click="showPositionChange = false"
                  ></span>
                </div>
                <div class="origin-btn">
                  <a-button
                    :class="selectedCutorigin == 'leftTop' ? 'active' : ''"
                    @click="changeCutOrigin('leftTop')"
                    id="paiban_origin_leftTop_btn"
                    >{{ $t('cuttingDock.cuttingParams.topLeftD') }}</a-button
                  >
                  <a-button
                    :class="selectedCutorigin == 'rightTop' ? 'active' : ''"
                    id="paiban_origin_rightTop_btn"
                    @click="changeCutOrigin('rightTop')"
                    >{{ $t('cuttingDock.cuttingParams.topRightD') }}</a-button
                  >
                  <a-button
                    :class="selectedCutorigin == 'leftBottom' ? 'active' : ''"
                    @click="changeCutOrigin('leftBottom')"
                    id="paiban_origin_leftBottom_btn"
                    >{{ $t('cuttingDock.cuttingParams.bottomLeftD') }}</a-button
                  >
                  <a-button
                    :class="selectedCutorigin == 'rightBottom' ? 'active' : ''"
                    id="paiban_origin_rightBottom_btn"
                    @click="changeCutOrigin('rightBottom')"
                    >{{
                      $t('cuttingDock.cuttingParams.bottomRightD')
                    }}</a-button
                  >
                </div>
                <div class="origin-dialog-btns">
                  <div>
                    <a-button
                      @click="showPositionChange = false"
                      id="paiban_origin_cancel_btn"
                      class="mr8"
                      >{{ $t('common.cancel') }}</a-button
                    >
                    <a-button
                      @click="handleConfirmChangeCutOrigin"
                      id="paiban_origin_confirm_btn"
                      >{{ $t('common.confirm') }}</a-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <a-button
              class="plank-control-calc"
              @click="() => calcCutPositionOrder(false)"
              :disabled="!hasLblAuth || handleIslocked"
              id="paiban_calcCutPositionOrder_btn"
              >{{ $t('arrangedPage.recalcIndex') }}</a-button
            >
          </div>
        </div>

        <!-- 右下角区域：补件/待排版库 -->
        <div>
          <!-- 板件待排板库 -->
          <a-radio-group
            style="margin: 8px"
            v-model="storeType"
            @change="handleStoreTypeChange"
          >
            <a-radio-button value="bujianStore">
              {{ $translateLang('补件库') }}
            </a-radio-button>
            <a-radio-button value="awaitStore">
              {{ $translateLang('待排版库') }}
            </a-radio-button>
          </a-radio-group>
          <component
            :is="
              storeType === 'bujianStore' ? 'm-bujian-store' : 'm-plank-store'
            "
            ref="storeRef"
            :data="bujianStoreData"
            :loading="bujianStoreLoading"
            :defaultScale="defaultScale"
            :scale="scalePercent"
            :activeBigpart="activeBigpart"
            :activeTempStorage="activeTempStorage"
            :keyword="bujianKeyword"
            @onSearch="handleGetBujianStoreData"
          />
        </div>
      </div>
    </div>
    <newSubtle
      ref="subtleRef"
      :visible.sync="showSubtle"
      :subtleData="subtleData"
      :isNCBtnLoading="isNCBtnLoading"
      :standardPlank="standardPlank"
      :baseMaterialData="baseMaterialData"
      :isSpecialShape="isSpecialShape"
      :isUsePlankAdsorption="isUsePlankAdsorption"
      :nestWay="this.nestWay == 'PRIMARY' ? 1 : 2"
      :isUnuseSurplus="isUnuseSurplus"
      :isShowSubtleInspectCutOrder.sync="isShowSubtleInspectCutOrder"
      :errorBigPlankCutOrders="errorBigPlankCutOrders"
      :errorCutOrders="errorCutOrders"
      :currentSubtleCutOrderName.sync="currentSubtleCutOrderName"
      :currentSubtleCutOrderIndex.sync="currentSubtleCutOrderIndex"
      :onPartChange="onPartChange"
      :checkBigPlankIsRotate="checkBigPlankIsRotate"
      :setDrawData="setDrawData"
      :renderAllByMain="renderAll"
      :isShowPartSize="isShowPartSize"
      :isShowMoveStep="isShowMoveStep"
      :moveStep="lastValidMoveStep"
      :isMarkModifiedSmallBoards="isMarkModifiedSmallBoards"
      v-if="subtleData && showSubtle"
      @subtle-active-plank-change="onSubtleActivePlankChange"
      @getBigPart="getBigPart"
      @downloadNC="subtleDownloadNC"
      @printTag="subtlePrintTag"
      @wheelScale="wheelScale"
      @changeBigpart="changeBigpart"
      @savePlan="savePlan"
      @updatePaibanData="updatePaibanData"
      @recordRotatePlank="handleRecordRotatePlank"
      @recordPlankMove="handleRecordPlankMove"
      @recordChangeCutOrigin="handleRecordChangeCutOrigin"
      @recordUpdatePriority="handleRecordUpdatePriority"
      @recordDeletePlank="handleRecordDeletePlank"
      @changeLockedStatus="changeLockedStatus"
      @judgeAbleFanban="handleJudgeAbleFanban"
      @judgeCutOrder="judgeCutOrder"
      @onClose="dealJinxiEnterPath(false)"
      @onAddDataToOperateArr="addDataToOperateArr"
    ></newSubtle>
    <div class="surplus-dialog" v-if="showSurplusDialog">
      <div class="content">
        <div class="title-box">
          <span class="title">{{ $t('arrangedPage.useSurplus.title') }}</span>
          <span class="iconfont icon-close" @click="closeSurplusDialog"></span>
        </div>
        <div class="match-surplus-box">
          <div class="top-operation">
            <a-button
              @click="confirmUseSurplus"
              :disabled="isSelectedSurplus"
              :class="isSelectedSurplus ? 'disable-use' : ''"
              >{{ $t('common.confirm') }}</a-button
            >
            <a-input-search
              v-model="surplusKeyword"
              :placeholder="translateLang('common.inputPlaceholder')"
              @search="searchSurplusList()"
            >
              <a-select
                slot="addonBefore"
                v-model="searchType"
                style="width: 90px"
              >
                <a-select-option value="name">{{
                  $t('surplusPage.surplusName')
                }}</a-select-option>
                <a-select-option value="remark">{{
                  $t('materialPage.surplusHead.remark')
                }}</a-select-option>
              </a-select>
              <a-button slot="enterButton" class="search-btn">
                <span class="iconfont icon-search"></span>
                <span>{{ $t('common.check') }}</span>
              </a-button>
            </a-input-search>
          </div>
          <div
            class="surplus-list"
            ref="surplusList"
            @scroll="scrollSurplusList"
          >
            <div v-if="surplusList.length > 0">
              <div
                v-for="(item, index) in surplusList"
                :key="index"
                class="surplus-item"
                @click="changeselectedSurplus(item)"
              >
                <a-radio :checked="item.isSelected"></a-radio>
                <div class="surplus-info">
                  <div class="surplus-info-item surplus-name">
                    <span class="title"
                      >{{ item.name ? item.name + '_' : ''
                      }}{{
                        item.shape == 0
                          ? translateLang('common.rect')
                          : translateLang('common.Ltype')
                      }}_{{ dealHighlightMatCode(item.type) }}_{{
                        item.color
                      }}</span
                    >
                    <span
                      >{{ $t('materialPage.surplusHead.remark') }}：{{
                        item.remark
                      }}</span
                    >
                  </div>
                  <div class="surplus-info-item surplus-amount">
                    <span>{{ $t('common.count') }}</span>
                    <span class="info">{{ item.amount ?? 1 }}</span>
                  </div>
                  <div class="surplus-info-item surplus-thick">
                    <span>{{ $t('common.thick') }}(mm)</span>
                    <span class="info">{{ item.thick }}</span>
                  </div>
                  <div class="surplus-info-item surplus-long">
                    <span>{{ $t('common.long') }}(mm)</span>
                    <span class="info">{{ item.long }}</span>
                  </div>
                  <div class="surplus-info-item surplus-width">
                    <span>{{ $t('common.width') }}(mm)</span>
                    <span class="info">{{ item.width }}</span>
                  </div>
                  <div class="surplus-info-item surplus-width">
                    <span>修边</span>
                    <span class="info">{{
                      item.surplus_trim_edge ? item.surplus_trim_edge : '/'
                    }}</span>
                  </div>
                  <div class="surplus-info-item surplus-width">
                    <span>余料仓</span>
                    <a-tooltip
                      v-if="item.branch_name && item.branch_name.length > 3"
                    >
                      <template #title>
                        {{ item.branch_name }}
                      </template>
                      <span style="color: #333; font-size: 16px">{{
                        item.branch_name.slice(0, 3) + '...'
                      }}</span>
                    </a-tooltip>
                    <span class="info" v-else>{{
                      item.branch_name || '-'
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="no-match-list" v-else>
              <div>
                <img
                  :src="require('../../assets/image/noMatchSurplus.png')"
                  alt=""
                />
                <div class="no-match-text">
                  <span>{{ $t('materialPage.surplusTip') }}</span
                  ><span class="add-new-surplus" @click="gotoSurplusStorage">{{
                    $t('materialPage.creatSurplus')
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!showSubtle" class="user-info fs12">
      <span>{{ userInfo.id }}</span>
    </div>
    <a-modal
      v-model="showAITipDialog"
      :title="translateLang('common.tip')"
      centered
      @ok="handleCloseAITip"
    >
      <p>AI智能排版限时试用，<span style="color: red">谨慎生产</span>。</p>
      <template #footer>
        <a-button key="back" @click="handleCloseAITip">{{
          $t('common.confirm')
        }}</a-button>
      </template>
    </a-modal>
    <a-modal
      v-model="alignedPlanDialog"
      centered
      :maskClosable="false"
      :width="isExpressVip ? '1000px' : ''"
      :footer="null"
      :closable="false"
      :forceRender="true"
    >
      <div
        class="flex flex-main--justify 100w pb15 mb20"
        style="border-bottom: solid 1px rgba(0, 0, 0, 0.35)"
      >
        <div class="fs16 bold">
          {{ translateLang('arrangedPage.moreResult') }}
        </div>
        <i
          style="fontsize: 12px; color: rgba(0, 0, 0, 0.45)"
          class="iconfont icon-close cursor-pointer"
          @click="closeAlignedPlanDialog"
          id="arrangedPage_close_more_result_btn"
        ></i>
      </div>
      <moreAlignedPlan
        ref="moreAlignedPlanRef"
        @useApply="useApply"
        @setAlignedPlanDialog="setAlignedPlanDialog"
        @onChangeShowDeepTabTip="onChangeShowDeepTabTip"
        :alignedPlanDialog="alignedPlanDialog"
        :current-fanban-count="totalBigpartFanban"
        v-if="isShowAlignedPlan"
      />
      <a-empty v-else />
    </a-modal>
    <sendModal
      :visible="sendToFactoryDialog"
      :is-loading="false"
      :title="translateLang('arrangedPage.sendToFactory.title')"
      :proLineName="$store.state.recodrProductionLineChoose"
      :print_color_tag="print_color_tag"
      @onClose="handleCloseSend"
      @onConfirm="handleConfirmSend"
    >
    </sendModal>
    <!-- 避免拖动图片造成canvas滚动 -->
    <div class="drop-mask" v-if="imageTempMousedownFlag"></div>
    <!-- 试生产模态框 -->
    <MTryProductionDialog
      ref="trialRef"
      @onConfirm="handleTrialProductConfirm"
      @onCancel="handleTrialProductCancel"
    />
    <lack-knives-dialog
      v-if="isShowLackKnivesDialog"
      :lackKnivesValueString="lackKnivesValueString"
      :lackKnivesKeysList="lackKnivesKeysList"
      @handleCancle="handleCancle"
      @search="searchPlank"
    >
    </lack-knives-dialog>
    <g-base-modal
      :visible="isVisible"
      v-if="isVisible"
      :contain="deleteConfirmTip"
      @ok="handleConfirmDeletePlank"
      @cancel="isVisible = false"
      preffix="paiban_delete"
    >
    </g-base-modal>
    <!--  保存至历史 -->
    <g-base-modal
      :visible="showSaveDialog"
      v-if="showSaveDialog"
      :showIcon="false"
      :ok-text="translateLang('common.save')"
      :title="translateLang('materialPage.save.title')"
      :subtitle="translateLang('materialPage.save.subTitle')"
      @ok="savePaiban"
      :isLoading="isSavePaiBanLoading"
      @cancel="showSaveDialog = false"
      preffix="paiban_save"
    >
      <div class="flex flex-main--center flex-cross--center">
        <span class="flex-box--1">{{ $t('materialPage.save.name') }}</span>
        <div class="flex-box--3">
          <a-input v-model="paibanWayName"></a-input>
        </div>
      </div>
    </g-base-modal>
    <g-base-modal
      :visible="isShowInspectCutOrder"
      v-if="isShowInspectCutOrder"
      :ok-text="translateLang('common.autoAdjust')"
      contain=""
      :cancel-text="translateLang('arrangedPage.checkDetail')"
      :disabledOkBtn="cutOrderOkDisable"
      @ok="handleAutoAdjust"
      @cancel="handleShowConflictDetail"
    >
      <div>
        <p>
          {{
            translateLang('common.cutOrderTip', {
              errorCutOrdersString: errorBigPlankCutOrders.join('、'),
            })
          }}
        </p>
        <p v-if="errorBigPlankLockedCutOrders.length">
          {{
            translateLang('common.lockedCutOrderTip', {
              errorCutOrdersString: errorBigPlankLockedCutOrders.join('、'),
            })
          }}
        </p>
      </div>
    </g-base-modal>
    <!-- 查看详情弹窗 -->
    <g-detail-pop
      :isShowPlateDetails="isShowConflictDetail"
      :fullName="currentCutOrderName"
      :currentIndex="currentCutOrderIndex"
      :sourceList="errorCutOrders"
      title="materialPage.overSize.conflictWorkInfo"
      idPrefix="drawAllParts_cutOreder"
      :popStyle="popStyle"
      @clickOperate="handleOperate"
      @clickGoBack="handleGoBack"
    >
    </g-detail-pop>
    <g-warning-modal
      :visible.sync="isShowWarningModal"
      :repeatNameList="repeatNameList"
      :repeatFileNameList="repeatFileNameList"
      :repeatFolderNameList="repeatFolderNameList"
    >
    </g-warning-modal>
    <MConflictTip
      :part="conflictPart"
      :conflictIndex="conflictIndex"
      :isExistsActivePlank="isExistsActivePlank"
      @searchConflictingPlates="searchPlank"
      v-if="isShowConflictDiagram"
      @closeConflictDiagram="handleCloseConflictDiagram"
    ></MConflictTip>
    <MDepthTip
      :isShow="isShowDepthTip"
      @onClose="isShowDepthTip = false"
      :depthErrorData="depthErrorData"
      :allDepthErrorData="allDepthErrorData"
      :depthErrorIndex="depthErrorIndex"
      :depthErrorNum="depthErrorNum"
      @onDepthErrorBtn="handleDepthTipBtnClick"
      @onSearch="searchPlank"
    ></MDepthTip>
    <!-- 订单生产标记窗 -->
    <!-- <a-modal
      v-model="isShowOrderMark"
      :title="translateLang('common.warning')"
      :okText="translateLang('common.export')"
      @ok="handleOrderMarkOk"
      @cancel="handleOrderMarkCancel"
      id="allPartsOrderMark"
    >
      <div class="order-mark-body">
        <p style="margin-left: 80px" v-if="proucePopupState.is_produced_orders">
          {{ $t('materialPage.sameOrder') }}
        </p>
        <p
          class="flex"
          style="margin-left: 80px"
          v-if="proucePopupState.is_display_mark"
        >
          <span class="mr10">{{ $t('materialPage.markOrder') }}</span>
          <a-radio-group
            :options="orderMarkOptions"
            :default-value="proucePopupState.mark_action"
            v-model="proucePopupState.mark_action"
          />
        </p>
      </div>
    </a-modal> -->

    <!-- 订单生产标记弹窗替换组件 -->
    <g-order-production-marking
      :isShowOrderMark.sync="isShowOrderMark"
      :proucePopupState.sync="proucePopupState"
      @handleOrderMarkOk="handleOrderMarkOk"
      @handleOrderMarkCancel="handleOrderMarkCancel"
    >
    </g-order-production-marking>
    <!-- 大板用料清单弹窗 -->
    <!-- 暂时注释 不太确定这个做不做 -->
    <!-- <a-modal
      v-model="showMaterialList"
      title="大板用料清单"
      width="891px"
      wrapClassName="material-list-modal"
      centered
      :footer="null"
    >
      <a-table
        :columns="materialListColumns"
        :data-source="materialList"
        :scroll="{ y: 200 }"
        class="material-list-table"
      />
      <div class="flex flex-main--justify pv16">
        <div class="flex flex-cross--center">
          <img src="../../assets/upload.png" />
          <span class="ml5">导出</span>
        </div>
        <span>总计：26 张大板</span>
      </div>
    </a-modal> -->
    <!-- 余料库容量不足弹窗 -->
    <a-modal
      v-model="showSurStoreTip"
      title="提示"
      centered
      okText="存入余料清单"
      class="sur-store-modal"
      width="450px"
      @ok="handleSaveSurStorage"
    >
      <span>余料库容量不足，余料无法存入仓库</span>
    </a-modal>
    <!-- 余料 补件 待排版库 扣减弹窗 -->
    <g-base-modal
      v-if="isShowDeduction"
      :visible="isShowDeduction"
      :title="translateLang('arrangedPage.deductionModalTitle')"
      :okText="translateLang('common.confirm')"
      contain=""
      @ok="handleDeductionPlank"
      @cancel="
        () => {
          closeDeductionModal()
          handleContinueDownloadNc()
        }
      "
      class="deduction-modal"
    >
      <template #title-icon>
        <i class="iconfont icon-warn mt1 mr6"></i>
      </template>
      <template>
        <div v-loading="$store.state.preferencesSetting.isLoading">
          <div
            style="margin-bottom: 29px"
            v-if="deductionShowState.isShowBujianDeduction"
          >
            <!-- 扣减补件小板 -->
            <g-t-view
              :text="$t('arrangedPage.bujianDeduction') + '：'"
              style="width: 112px; margin-right: 8px; text-align: right"
            ></g-t-view>
            <a-radio-group
              v-model="
                $store.state.preferencesSetting.setting.isDeductionBujian
              "
            >
              <a-radio :value="true"> {{ $t('common.is') }} </a-radio>
              <a-radio :value="false"> {{ $t('common.not') }} </a-radio>
            </a-radio-group>
          </div>
          <div
            style="margin-bottom: 29px"
            v-if="deductionShowState.isShowAwaitDeduction"
          >
            <!-- 扣减暂存区小板 -->
            <g-t-view
              :text="$t('arrangedPage.paibanDeduction') + '：'"
              style="width: 112px; margin-right: 8px; text-align: right"
            ></g-t-view>
            <a-radio-group
              v-model="
                $store.state.preferencesSetting.setting.isDeductionPaibanStore
              "
            >
              <a-radio :value="true"> {{ $t('common.is') }} </a-radio>
              <a-radio :value="false"> {{ $t('common.not') }} </a-radio>
            </a-radio-group>
          </div>
          <div v-if="deductionShowState.isShowSurplusDeduction">
            <!-- 扣减余料大板 -->
            <g-t-view
              :text="$t('arrangedPage.surplusDeduction') + '：'"
              style="width: 112px; margin-right: 8px; text-align: right"
            ></g-t-view>
            <a-radio-group
              v-model="
                $store.state.preferencesSetting.setting.isDeductionSurplus
              "
            >
              <a-radio :value="true"> {{ $t('common.is') }} </a-radio>
              <a-radio :value="false"> {{ $t('common.not') }} </a-radio>
            </a-radio-group>
            <div
              v-show="
                !$store.state.preferencesSetting.setting.isDeductionSurplus &&
                $store.state.preferencesSetting.setting.surplus_lock
              "
              class="mt11"
              style="margin-left: 120px; margin-bottom: 20px"
            >
              <a-radio-group
                v-model="
                  $store.state.preferencesSetting.setting
                    .maintain_paiban_plank_lock
                "
                style="display: flex; flex-direction: column"
              >
                <a-radio :value="false" style="margin-bottom: 9px">
                  <!-- 解除参与排版余料的锁定 -->
                  <g-t-view
                    :text="$t('arrangedPage.unlockPaiban')"
                    width="300px"
                  ></g-t-view>
                </a-radio>
                <a-radio :value="true">
                  <!-- 维持参与排版余料的锁定 -->
                  <g-t-view
                    :text="$t('arrangedPage.maintain')"
                    width="300px"
                  ></g-t-view>
                </a-radio>
              </a-radio-group>
            </div>
          </div>
        </div>
      </template>
    </g-base-modal>
    <!-- 本地直接下载nc文件所使用的目录被删除提示的弹窗 -->
    <g-folder-choose-modal
      :cb="ncDownloadCallBack"
      ref="folderChooseModalRef"
    ></g-folder-choose-modal>
    <MNotFoundKnivesInfoDialog
      :visible.sync="isShowNotFoundKnivesInfoModal"
      :data="allKnivesErrInfos"
      :showViewBtn="!showSubtle"
      @viewDetailInfo="handleOpenErrDetailInfoDrawer"
    />
    <MNotFoundKnivesInfoDrawer
      :visible.sync="isShowNotFoundKnivesInfoDrawer"
      :data="notFoundKnivesInfo"
      @searchPart="searchPlank"
    />
    <!-- 孔槽冲突弹窗 -->
    <g-base-modal
      v-if="isShowConflictModal"
      :visible="isShowConflictModal"
      :okText="translateLang('common.toCheck')"
      :cancelText="translateLang('common.continueExport')"
      :contain="translateLang('common.pleaseCheck')"
      @ok="handleCloseConflictModal"
      @cancel="handleIgnoreConflict"
    >
    </g-base-modal>
    <m-line-select-modal
      :visible="isSelectProLine"
      :lineList="proLineList"
      :proLineId="ncSetting.process_setting_id || 0"
      :isExpandedArranged="isExpandedArranged"
      @onVisibleChange="handleChangeVisible"
      @onClose="handleChangeVisible"
      @onCancel="handleChangeVisible"
      @onConfirm="handleConfirmLineSelect"
    ></m-line-select-modal>
    <!-- 需要扣减的内容的弹窗 -->
    <!-- <MDeductModal
      v-if="isShowDeduction"
      :showDeductItem="deductionShowState"
      :visible.sync="isShowDeduction"
      @success="handleDeductionPlank"
      @cancel="handleContinueDownloadNc"
    /> -->
    <!-- 彩色标签确认弹窗 需要展示超过限制的具体数据-->
    <g-base-modal
      v-if="isShowConfirmColorTag"
      :visible="isShowConfirmColorTag"
      :contain="`${translateLang('common.exist')}${limitTwelveList
        .map((item) =>
          item == 'orderNo'
            ? translateLang('common.order')
            : item == 'roomName'
            ? translateLang('common.roomName')
            : translateLang('common.loc')
        )
        .join('/')}${translateLang('common.limitNotEffect')}，${translateLang(
        'common.bw'
      )}`"
      :okText="$t('common.yes')"
      :cancelText="$t('common.no')"
      @ok="handleConfirmContinue"
      @cancel="handleCancelDownloadNC"
    >
    </g-base-modal>
    <g-base-modal
      v-if="showConfirmModal"
      :visible="showConfirmModal"
      :contain="confirmTip"
      :okText="$t('common.confirm')"
      :isShowCancelBtn="false"
      @ok="handleExportImg"
      @cancel="
        () => {
          isShowConfirmNoSmallTag = false
          isShowConfirmForSurFolder = false
        }
      "
    >
    </g-base-modal>
    <!-- 下载NC 余料未被本订单全部锁定 提示弹窗 -->
    <g-base-modal
      :visible="isShowSurplusLock"
      v-if="isShowSurplusLock"
      :contain="translateLang('arrangedPage.lockModalText') + '？'"
      :cancelText="translateLang('common.not')"
      :ok-text="translateLang('common.is')"
      @cancel="
        () => {
          handleCloseSurLock()
          const isSendToFactory = currentOperate == 'nc' ? false : true
          handleDownloadNC(isSendToFactory, true)
        }
      "
      @ok="
        () => {
          handleCloseSurLock()
          handleChangePaibanWay(activePaibanWay[0], false, false)
        }
      "
    >
    </g-base-modal>
    <!-- 精细排版 下载NC 锁定判断 -->
    <g-base-modal
      :visible="isShowSurplusLockNewSub"
      v-if="isShowSurplusLockNewSub"
      :contain="translateLang('arrangedPage.lockNewSModalText') + '？'"
      :cancelText="translateLang('common.not')"
      :ok-text="translateLang('common.is')"
      @cancel="handleCloseSurLockNewSub"
      @ok="
        () => {
          handleCloseSurLockNewSub()
          subtleDownloadNC(subtleBigPart, true)
        }
      "
    >
    </g-base-modal>
    <!-- 小板分散排版 -->
    <g-base-modal
      :visible="isShowDisPaiabnConfirm"
      :contain="translateLang('common.dispersePaibanTip')"
      :cancelText="translateLang('common.ok')"
      :ok-text="translateLang('common.moreResult')"
      @ok="handleOpenMoreResult"
      @cancel="handleCloseDisPaibanConfirm"
    >
      <a @click="handleSeePlankDetail">查看问题大板</a>
    </g-base-modal>
    <m-select-plank
      v-if="isShowSlectPlank"
      :allPlankList="neecActivePlank"
      @handlePre="selectActivePlank"
      @handleNext="selectActivePlank"
      @handleCancle="() => (isShowSlectPlank = false)"
      @handleBack="
        () => {
          isShowSlectPlank = false
          setIsShowDisPaiabnConfirm(true)
        }
      "
    >
    </m-select-plank>
    <!-- 夹手位置处存在孔槽弹窗 -->
    <g-base-modal
      v-if="isShowHoleSlotOnClampHandModal"
      :visible="isShowHoleSlotOnClampHandModal"
      :okText="$translateLang('查看详情')"
      :cancelText="$translateLang('确认')"
      :contain="
        $translateLang('检测到您部分板件的孔槽无法避让夹手位置，请您手动调整')
      "
      @ok="handleViewDetail"
      @cancel="handleCloseClamHandConfictModal"
    >
    </g-base-modal>
    <!-- 夹手位置处存在孔槽弹窗(下载nc时的弹窗) -->
    <g-base-modal
      v-if="isShowHoleSlotOnClampHandModalForDownloadNC"
      :visible="isShowHoleSlotOnClampHandModalForDownloadNC"
      :okText="$translateLang('查看详情')"
      :isShowOkBtn="isShowClampHandModalOkTextBtn"
      :cancelText="$translateLang('忽略，继续输出文件')"
      :contain="
        $translateLang('检测到您部分板件的孔槽无法避让夹手位置，请您手动调整')
      "
      @ok="handleViewDetail"
      @cancel="handleCloseClamHandConfictModalForDownloadNC"
    >
    </g-base-modal>
    <GConflictPartModal
      v-if="showConflictPartDetail"
      :visiable.sync="showConflictPartDetail"
      :conflictParts="conflictParts"
      :showCancelBtn="false"
      @toggleConflictPart="handleSearchClampHandPart"
    />
    <g-base-modal
      :visible="isShowExPaibanConfirm"
      :ok-text="translateLang('确认')"
      :contain="
        $translateLang(
          '【高级嵌套】限免体验已到期，当前可预览高级嵌套排版结果（也可切换普通嵌套进行正常排产），如需导出高级嵌套排产文件，请联系销售人员购买~'
        )
      "
      :title="translateLang('温馨提示')"
      @ok="
        () => {
          this.hasCheckedClampHand = true
          this.handleCheckClampHandPosition()
          this.isShowExPaibanConfirm = false
        }
      "
      @cancel="
        () => {
          this.isShowExPaibanConfirm = false
        }
      "
      preffix="sync_guigui_base_m"
    >
    </g-base-modal>

    <!-- 生产线变化对比 -->
    <m-paiban-task-conflict-modal
      :visible="hasConflict"
      :data="confilict"
      :production-line-name="productionLineName"
      @cancel="handleConflictModalOk"
      @ok="handleConflictModalOk"
    />

    <!-- 开启异形嵌套时需要判断 -->
    <g-base-modal
      :visible="isShowSpecialAndFiveSix"
      v-if="isShowSpecialAndFiveSix"
      :okText="$translateLang('继续排版')"
      :cancelText="$translateLang('调整设置')"
      :contain="
        $translateLang(
          '五/六面钻加工板件异形时，开启异形嵌套可能会导致切到板件，请确认是否继续排版？'
        )
      "
      :btn-type="true"
      @ok="handleConfirmContinuePaiban"
      @cancel="handleCancelContinuePaiban"
    ></g-base-modal>
    <g-base-modal
      v-if="isVisiblExpire"
      :visible="isVisiblExpire"
      :okText="$t('common.ok')"
      :cancelText="$t('common.cancel')"
      :contain="expirseMsg"
      @ok="() => (isVisiblExpire = false)"
      @cancel="() => (isVisiblExpire = false)"
    >
    </g-base-modal>

    <!-- 余料入库二次确认弹窗 -->
    <MSurplusSecondConfirm
      :visible="isShowSecondConfirm"
      :surplusConfirmList="surplusConfirmList"
      @delSecCon="handleDelSecCon"
      @cancel="handleCloseSecCon"
      @ok="handleOKSecCon"
    ></MSurplusSecondConfirm>

    <!-- 异形分层切割深度 -->
    <g-base-modal
      v-if="isShowLayerCutDepthModal"
      :visible="isShowLayerCutDepthModal"
      :showIcon="false"
      :title="translateLang('cuttingDock.cuttingParams.stepCutting')"
      :ok-text="translateLang('common.ok')"
      @ok="handleConfirmLayerCutDepth"
      @cancel="handleCancelLayerCutDepth"
      preffix="paiban_save"
    >
      <div class="flex flex-main--center flex-cross--center">
        <span class="" style="width: fit-content; margin-right: 5px"
          >{{ $t('cuttingDock.cuttingParams.secondDeep') }}:</span
        >
        <div class="flex-box--1">
          <a-input
            id="batch_edit_size_layer_cut_depth_input"
            v-model="layerCutDepth"
            @input="handleLayerCutDepthInput"
          ></a-input>
        </div>
      </div>
    </g-base-modal>

    <!-- 批量修改大板尺寸 -->
    <m-batch-edit-size
      :isShow="isBatchEditSize"
      @update:isShow="handleUpdateBatchEditSize"
      @onPaibanDataUpdate="handlePaibanDataUpdate"
    ></m-batch-edit-size>

    <m-edit-size
      :visible="isShowEditSize"
      :plank="activeBigpart"
      @update:visible="handleUpdateEditSize"
      @onPaibanDataUpdate="handlePaibanDataUpdate"
    >
    </m-edit-size>
    <m-menu
      ref="mMenuRef"
      :position="pointPosition"
      :data="menuList"
      @selectMenuItem="handleSelectMenuItem"
      :isUseSaw="activePlank && activePlank.isUseSaw"
    />

    <m-surplus-size-err-modal
      :visible="isShowSurplusSizeErrModal"
      :prolineId="ncSetting.process_setting_id || 0"
      :prolineName="
        ncSetting.process_setting_name
          ? ncSetting.process_setting_name
          : $store.state.recodrProductionLineChoose
      "
      @close="isShowSurplusSizeErrModal = false"
    ></m-surplus-size-err-modal>
    <!-- 骨骼门加工提示弹窗 -->
    <g-base-modal
      v-if="isShowFrameDoorModal"
      :visible="isShowFrameDoorModal"
      :okText="$translateLang('确认')"
      :contain="
        $translateLang(
          '检测到本次排版有合并的骨骼门，注意骨骼门二次加工前需要先封边再上雕刻机切割！'
        )
      "
      @ok="handleConfirmFrameDoor"
      @cancel="handleConfirmFrameDoor"
    >
      <div class="prompt flex flex-dir--top flex-main--center">
        <div>
          <label>
            <a-checkbox
              v-model="isFrameDoorTip"
              @change="handleChangeFrameDoorTip"
            ></a-checkbox
            ><span class="ml6">{{ $translateLang('不再提示') }}</span>
          </label>
        </div>
      </div>
    </g-base-modal>
    <!-- 按材质重新排版弹窗 -->
    <m-material-relayout-modal
      :visible.sync="isShowMaterialRelayoutModal"
      :drawData="drawData"
      :selectStandardPlank="selectStandardPlank"
      :xyReverse="ncSetting.xyReverse"
      @onConfirm="handleReLayoutByMaterial"
      @onCancel="isShowMaterialRelayoutModal = false"
    ></m-material-relayout-modal>
  </div>
</template>

<script>
import {
  getRawMaterialPlankInfo,
  loadFullPlankManageData,
} from '@/apis/baseMaterial'
import { deleteStoreData, fetchStoreData } from '@/apis/bujianStore'
import { LibraryType } from '@/apis/bujianStore/types'
import { LibraryTypeJS } from '@/apis/bujianStore/types'
import { buryPoint } from '@/apis/common/buryPoint'
import { addFeedback } from '@/apis/common/feedback'
import { saveHistory } from '@/apis/common/saveHistory'
import { getLoadDoorWallAioModel } from '@/apis/doorWallAioSetting'
import { getJsonUrlData } from '@/apis/equipment'
import {
  fetchGetProductionNcSetting,
  getLoadDock56FModel,
} from '@/apis/materialList'
import { getPreferencesSetting } from '@/apis/materialList'
import { getPaibanBatch } from '@/apis/paiban/index'
import {
  dealHoleSlotShunt,
  fetchDeductBaseMaterial,
  fetchSendPurchaseData,
  fetchSendUseMaterialData,
  getExcelData,
  getProucePopupState,
  saveOrderInfoToLbl,
  updateProduceStatus,
  useSurplus as useSurplusApi,
} from '@/apis/paiban/index'
import { fetchModelData, fetchModelList } from '@/apis/paibanImg'
import {
  comparePreLayoutSetting,
  getPrelayoutSetting,
} from '@/apis/preLayoutSetting'
import { httpRequest } from '@/apis/request'
import { getSurplusList, surplusLock } from '@/apis/surplusManage'
import { fetchTagTemplate, getSpecialRemarks } from '@/apis/tag/index'
import { updateToHasPaiban } from '@/apis/taskList/index'
import { batchBujian } from '@/apis/work-shop'
import circleShape from '@/assets/icon/circle_shape.svg'
import halfCircleShape from '@/assets/icon/half_circle_shape.svg'
import hexagonShape from '@/assets/icon/hexagon_shape.svg'
import squareShape from '@/assets/icon/square_shape.svg'
import triangleShapea from '@/assets/icon/triangle_shape.svg'
import {
  checkUserPermissionWithToast,
  checkUserPermissions,
} from '@/auth/user_function'
import loading from '@/components/common/loading'
import GBaseModal from '@/components/g-base-modal.vue'
import gConflictPartModal from '@/components/g-conflict-part-modal.vue'
import GDetailPop from '@/components/g-detail-pop.vue'
import GFolderChooseModal from '@/components/g-folder-choose-modal.vue'
import GOrderProductionMarking from '@/components/g-order-production-marking'
import GPaidFeature from '@/components/g-paid-feature.vue'
import GTaskLoading from '@/components/g-task-loading.vue'
import GWarningModal from '@/components/g-warning-modal.vue'
import newContent from '@/components/newContent.vue'
import GAntButton from '@/components/translateComp/g-ant-button.vue'
import GTView from '@/components/translateComp/g-t-view.vue'
import { sampleCabinets } from '@/constants'
import { USER_PERMISSION_KEY } from '@/data/auth'
import { initProductionNcSetting } from '@/data/init'
import store from '@/store'
import { updateLocalPreference } from '@/store/modules/preferencesSetting'
import { TaskStatus, createTask } from '@/store/modules/progressNotice'
import {
  appendPreMillingToEdgeInfoDisplay,
  dealUnionPathSlots,
  deepCopy,
  getCutKnifeDiameterList,
  getSawKnife,
  judgeIsMergeFrameDoor,
} from '@/util/LayoutFuncs'
import { caclPartArea } from '@/util/LayoutFuncs'
import { rotateFrontEdge } from '@/util/LayoutFuncs'
import { isSawPaiban } from '@/util/LayoutFuncs'
import { rolloverPlank } from '@/util/LayoutFuncs.js'
import {
  checkIsOnlyProcessHoleSlotByPaibanData,
  exterPathEdgeForPart,
  matchLayeredCutForPalnkThick,
} from '@/util/LayoutTool'
import {
  dealExpandSlotForPaiban,
  matchOriginalPlankknife,
  rotatePart,
} from '@/util/LayoutTool'
import {
  changeDataStartPoint,
  dealStockPlankRoll,
  viewDataToNCData,
} from '@/util/NCGenerator.js'
import { pickNcPartFields, sendTrialRecord } from '@/util/NcFileRelated'
import { buryPointFunc } from '@/util/buryPointDeal'
import { EventBusKey } from '@/util/bus'
import EventBus from '@/util/bus'
import ClipperLib from '@/util/clipper_unminified.js'
import { copyText } from '@/util/common'
import {
  chunkArray,
  dealHighlightMatCode,
  genColorRes,
  getSurplusMatchTypes,
  isHighBigPlank,
  judgeRectangle,
  labelSources,
  restoreOriginalMatcode,
  translate,
} from '@/util/commonFun'
import {
  buryPointApi,
  checkPlankDataIsCorrect,
  convertBlobToBase64,
  dataClustering,
  fourTrimEdge,
  generateSimplePlankNum,
  getOriginRect,
  modalMsg,
  toDecimal,
  uniquePlankNum,
} from '@/util/commonFuncs'
import { isSamePart } from '@/util/commonFuncs'
import { genFinalRecord } from '@/util/commonFuncs.js'
import { fileNameSetObj } from '@/util/configure'
import { initNcLifeObj } from '@/util/createLifeFunc'
import { getEdgeTypeWithRect } from '@/util/createTag'
import { isLongPlateProcessing } from '@/util/createTag'
import { dealGuiguiJson } from '@/util/dealGuiguiJson.js'
import {
  checkDesMaterialNoCut,
  checkOnePlank,
  checkPlankEdgeHasChanged,
  checkPlankHoleSlot,
  compShapeData,
  dealAllParts,
  dealLshapeTurnPoints,
  dealPaibanData,
  dealPlankListLabelID,
  dealPlankPoly,
  dealPreLayoutDataLabelID,
  genPaibanRequestParams,
  genSurplusParams,
  getPlateKnifeDiameter,
  setSurplusObj,
} from '@/util/dealPaibanData'
import { defaultPaibanImgTemplate } from '@/util/defaultTagData'
import { DrawPartView } from '@/util/drawPlank'
import {
  applyLastCutPoint,
  calcBigpartArea,
  calcPartsArea,
  calcStartPositionBySurplus,
  calcSurplusPosition,
  calcSurplusPositionByStartPosition,
  dealPlankType,
} from '@/util/drawPlankFuncs.js'
import { exportThreeViewDxf } from '@/util/dxf/holeSlotDxf'
import { convertJpegToBmp } from '@/util/file/convert'
import { collector } from '@/util/file/customFolderGenerate'
import { getZipJson } from '@/util/getZipJson.js'
import { compareNumbers } from '@/util/graphCalc'
import { compressGzip, getGzipData } from '@/util/gzipCompress'
import {
  compositeTexturePlanks,
  decompositeTexturePlanks,
  forEachTextureChild,
  getSameGroupParts,
  isTextureAlignmentPlank,
  isVirtualCompositePlank,
  showTextureConfirmModal,
} from '@/util/plankAlignTexture'
import {
  addNewBigPlank,
  checkBigPlankIsRotate,
  clearObjAttr,
  dealGuimenFGNo,
  exportExcel,
  getOriPartByLayout,
  getPathMinMaxPoint,
  getSlotBasicInfo,
} from '@/util/plankCommonFuncs'
import {
  createTagImageZip,
  generateTagFile,
  validateSubTagPerForExport,
} from '@/util/productionDataGenerate/tagDataGenerate'
import { regReplaceCuttingParamsInputDepth } from '@/util/regReplace'
import {
  appendIpToJsonBlob,
  fetchUserIp,
  genMergeSubFolderData,
  promiseToZip,
  removeTagImageZip,
  saveDataJsonToOssForRecord,
  saveDataToOSS,
} from '@/util/saveFile'
import { showCardDetail } from '@/util/showCardDetail'
import {
  applySpecialShapeMinZeroForUpload,
  assignSequentialSurplusNames,
  buildCutSurplusDepotPayloadItems,
  genSurplusStockKey,
  postProcessSurplusPayloadItems,
} from '@/util/surplusWarehousing'
import {
  genFirstLevelFileName,
  getGraghEdge,
  handleGenFileNameStr,
} from '@/util/tag'
import { jsPdfTool } from '@/util/tag/pdfFont'
import { tailorSurplus } from '@/util/tailorSurplus'
import { cutBlueSurplus, updateBlueAreaSurplusPart } from '@/util/tailorSurplus'
import {
  dealLblApartPackageCount,
  needApartPackUser,
} from '@/util/thirdPartyDealFunc/lblDealFuncs'
import paibanSetting from '@/views/materialsList/components/paibanSetting'
import MSelectPlank from '@/views/newPaiban/component/m-select-plank'
import { MDeepBadgeAurora } from '@/views/newPaiban/component/moreAlignedPlan/iconComponents/index'
import MPaibanTaskConflictModal from '@/views/paibanTask/components/m-paiban-task-conflict-modal.vue'
import OSS from 'ali-oss'
import { message } from 'ant-design-vue'
import axios from 'axios'
import { Loading } from 'element-ui'
import lodash from 'lodash'
import { nanoid } from 'nanoid'
import QRCode from 'qrcodejs2'
import Vue from 'vue'
import { mapMutations, mapState } from 'vuex'

import {
  checkPrelayoutSettingChanged,
  dealPreLayoutSetting,
  dealPreLayoutSettingFromNCSetting,
} from '../materialsList/util/preLayoutDeal'
import { createPaibanImg } from '../paibanImg/util/createPaibanImg'
import { getDate } from '../taskList/util/batchDataDeal'
import { sendDataToWorkShop } from '../workShopProduction/utils'
import mBatchEditSize from './component/m-batch-edit-size.vue'
import MBujianStore from './component/m-bujian-store/index.vue'
import MConflictTip from './component/m-conflict-tip'
import MDepthTip from './component/m-depth-tip'
import mEditSize from './component/m-edit-size.vue'
import LackKnivesDialog from './component/m-lack-knives-dialog.vue'
import MLayoutInfluenceTip from './component/m-layout-influence-tip/index.vue'
import { buildInfluenceSnapshot } from './component/m-layout-influence-tip/useInfluenceInfo'
import mLineSelectModal from './component/m-line-select-modal.vue'
import mMaterialRelayoutModal from './component/m-material-relayout-modal.vue'
import mMenu from './component/m-menu/index.vue'
import MNotFoundKnivesInfoDialog from './component/m-notFound-knives-info-dialog/m-notFound-knives-info-dialog.vue'
import MNotFoundKnivesInfoDrawer from './component/m-notFound-knives-info-drawer/index.vue'
import MPlankStore from './component/m-paiban-store/index.vue'
import {
  genAwaitStoreData,
  getPlankImage,
  parseAwaitStoreRenderUrl,
  plankAddAwaitStoreFeature,
  plankAddBujianStoreFeature,
} from './component/m-paiban-store/utlis'
import sendModal from './component/m-sendModal.vue'
import MSurplusSecondConfirm from './component/m-surplus-second-confirm.vue'
import mSurplusSizeErrModal from './component/m-surplus-size-err-modal.vue'
import MTryProductionDialog from './component/m-try-production-dialog'
import moreAlignedPlan from './component/moreAlignedPlan'
import {
  bigPlankMenuList,
  otherMenuList,
  partMenuList,
} from './config/menuList'
import drawPart from './drawPart.vue'
import newSubtle from './newSubtle.vue'
import {
  buildBujianQueryKey,
  dealBatchBujian,
  getBujianParticipationIdsFromPaibanData,
} from './util/bujianData'
import { dealClampHandHasPart } from './util/checkClampHand'
import {
  downloadFile as downloadNCFile,
  genNcZipByCustomFolder,
  getChildrenFolderFileSize,
} from './util/downLoadNC'
import { filterNestedParts } from './util/judgePartInOtherPart'
import {
  calcBaseMaterial,
  changeFinalDataByPlankNum,
  clearReuseInfo,
  dealDataForPaiban,
  dealStandardPlank,
  filterSurplusByNoCutPlanks,
  genBaseMaterialsForNotCutParts,
  genBeforeTitleSorts,
  genFinalDataOrder,
  isBrandBigPlank,
  isNormalPlankPart,
  isPaibanLock,
  isReuseChild,
  isReuseParent,
  isSpecialBigPlank,
  isSurplusBigPlank,
  isSurplusPlank,
} from './util/layoutDataDeal'
import { dealPlankDataForLbl } from './util/lblPlankData'
import { uploadCompressedFile, uploadFiles } from './util/uploadFiles'

const defaultScale = 6
const orderMarkOptions = [
  { label: '标记', value: 1 },
  { label: '不标记', value: 0 },
]
// 翻译映射
const languageMap = new Map([])
export default {
  components: {
    MPaibanTaskConflictModal,
    GTView,
    mLineSelectModal,
    drawPart,
    newSubtle,
    loading,
    moreAlignedPlan,
    sendModal,
    GTaskLoading,
    newContent,
    MTryProductionDialog,
    LackKnivesDialog,
    GBaseModal,
    GDetailPop,
    MConflictTip,
    GWarningModal,
    MDepthTip,
    MLayoutInfluenceTip,
    paibanSetting,
    MPlankStore,
    MBujianStore,
    GAntButton,
    GFolderChooseModal,
    GPaidFeature,
    MNotFoundKnivesInfoDialog,
    MNotFoundKnivesInfoDrawer,
    GTView,
    MSelectPlank,
    GConflictPartModal: gConflictPartModal,
    GOrderProductionMarking,
    MSurplusSecondConfirm,
    mMenu,
    mSurplusSizeErrModal,
    mBatchEditSize,
    mEditSize,
    mMaterialRelayoutModal,
    MDeepBadgeAurora,
  },
  data() {
    return {
      hasConflict: false,
      confilict: null,
      productionLineName: '',
      USER_PERMISSION_KEY,
      isShowNotFoundKnivesInfoModal: false,
      clickFlag: false,
      isTextureConfirming: false,
      initState: {},
      finalState: {},
      initTableList: [],
      finalTableList: [],
      initSurplusSelectList: [],
      finalSurplusSelectList: [],
      isShowProgram: false, //控制排版方案选择弹窗
      isOnlyShowSurplus: false, //只看余料大板
      isUnuseSurplus: false, //余料不参与利用率计算
      isUsePlankAdsorption: false, // 板件吸附功能
      isDataDefaultCollapsed: false, //数据默认收起
      isMarkModifiedSmallBoards: false, //标识修改过的小板
      isShowMoveStep: false, //显示键盘移动步长
      moveStep: 20, // 键盘移动步长（输入框展示）
      lastValidMoveStep: 20, // 已生效的步长，供键盘移动与子组件使用
      /** 精细排版页内是否选中了小板（用于与主排版 activePlank 区分） */
      subtleHasActivePlank: false,
      isDrawPartCollapsed: true, // 控制drawpart的画布展开或者收起，默认给收起，减少获取数据的过程对用户体验产生的影响
      surplusCount: 0, // 只看余料大板计数
      // isCancontinue: false,
      proucePopupState: {
        mark_action: 1,
        is_produced_orders: true,
        is_display_mark: true,
      },
      /** 此数据一般来说是直接对应 paibandata 的两个数据相同,部分情况下如精细排版页面下载 NC，其数据只会指向精细排版页面对应的那个大板 */
      drawDataArr: [],
      orderMarkOptions,
      isSubtle: false,
      // 发送生产车间加载loading
      isSendToFactoryLoading: false,
      // 加载loading的提示词
      loadingPrompts: 'arrangedPage.dataLoading',
      // 控制重名弹窗显示
      isShowWarningModal: false,
      repeatFileNameList: [],
      repeatFolderNameList: [],
      // 重名数组
      repeatNameList: [],
      // 记录绘制的显示宽度和高度
      canvasMaxWidth: 0,
      canvasMaxHeight: 0,
      // 记录窗口可视区域的变化
      resizeEvent: null,
      // 记录键盘抬起事件
      keyUpEvent: null,
      // 记录键盘按下事件
      keyDownEvent: null,
      // 是否显示加载
      showLoading: false,
      // 记录非空大板排版数据长度
      oriPlankLen: 0,
      // 记录整体优化率
      totalUsedRate: 0,
      // 记录整体优化面积
      totalUsedArea: 0,
      // 记录整体的翻板次数
      totalBigpartFanban: 0,
      // 记录所有大板数量
      totalBigpartCounts: 0,
      // 记录绘制数组
      drawData: [],
      // 记录整体的缩放比例
      zoomNum: 1,
      // 记录搜索的值
      plankKeyWord: '',
      // 记录选中的板件
      activePlank: null,
      // 排版方式
      paibanWayList: [
        {
          name: 'common.sawArrange',
          interface: 'paiban',
          desc: 'materialPage.paibanSetting.suitEquipmentSpecial',
        },
        {
          name: 'common.directArrange',
          interface: 'paiban_v2',
          desc: 'materialPage.paibanSetting.suitEquipmentNormal',
        },
        // {
        //   name: 'AI智能排版(试用)',
        //   interface: 'blue_ai/paiban',
        //   desc: '常规雕刻机',
        // },
      ],
      // 记录保存排版时输入的名字
      paibanWayName: '',
      // 记录当前点击的是第几个分类
      canvasKey: -1,
      // 记录是否显示保存弹窗
      showSaveDialog: false,
      // 记录搜索到的板件列表
      searchPlankList: [],
      // 记录搜索之后, 当前板件列表的选中板件的下标
      searchPlankIndex: -1,
      // 是否禁止选中文字
      isForbidUserSelect: false,
      // 记录点击暂存区时生成的图片
      tempImg: null,
      // 记录鼠标按下时图片的真实宽高
      imgRealSize: null,
      // 记录鼠标按下时, 鼠标位置相对于图片的位置
      imgPostion: null,
      // 记录鼠标移动事件
      mouseMoveEvent: null,
      // 是否显示精细排版
      showSubtle: false,
      // 记录显示精细排版时的数据
      subtleData: null,
      // 记录是否显示余料匹配的弹窗
      showSurplusDialog: false,
      // 记录搜索余料时选择的字段
      searchType: 'name',
      // 记录匹配到的余料数据
      surplusList: [],
      // 记录搜索的余料关键词
      surplusKeyword: '',
      // 记录当前选中大板的最大宽度和最大高度
      maxSurplusWidth: 0,
      maxSurplusHeight: 0,
      // 记录获取的余料页码
      surplusPage: 1,
      // 记录当前选中的大板
      activeBigpart: null,
      // 记录选中的余料
      selectedSurplus: null,
      // 记录替换余料时, 板件的最小x值和最大y值
      minSurplusX: 0,
      maxSurplusY: 0,
      // 记录是否正在下载NC
      isDownloadingNc: false,
      // 自动贴标确认继续后，本次导出跳过副标签
      skipSubTagOnNcExport: false,
      // 暂存区是否显示
      isShowzancun: false,
      // 下载NC文件时是否自动传保存记录
      isAutoPassData: false,
      // 板件是否显示切割顺序
      isCuttingOrder: true,
      // 记录点击的排版方式
      selectedPaibanWay: null,
      // 板件是否选择无纹理
      isNonTexture: false,
      // 异形板件是否分层切割
      isLayerCut: false,
      // 分层切割的深度
      layerCutDepth: 2,
      // 分层切割深度弹窗
      isShowLayerCutDepthModal: false,
      // 记录操作无纹理选项后的板件信息
      plankArr: [],
      // 记录当前激活板件ID
      activePlankID: 0,
      // 记录当前激活板件Index
      activePlankIndex: 0,
      nestWay: 'PRIMARY',
      // 是否选中异形嵌套排版
      isSpecialShape: false,
      // 记录排版方案是否是AI排版
      isAIpaiban: false,
      // 是否选中少翻版
      isLessReverse: false,
      // 选中排版使用范围
      suitText: '',
      // AI排版后的提示框
      showAITipDialog: false,
      // 记录是否空输入
      isEmptyInput: false,
      // 记录是否为AI智能排版
      isAIPaiban: false,
      // 多排版方案是否显示
      alignedPlanDialog: false,
      // 更多结果按钮深度计算 tip，默认打开，可手动关闭
      moreResultTipVisible: true,
      // 生成图片的点击标记
      imageTempMousedownFlag: false,
      // 记录激活大板的startY
      bigPlankH: 0,
      // 记录余料是否已经入库
      hasSaveSurplus: false,
      hasCut: false,
      // 记录当前大板序号
      currentIndex: 1,
      // 记录当前精细排版大板
      surplusBigpart: null,
      // 缩放timeOut
      scaleTimer: null,
      scaleInterv: null,
      // 精细排版缩放
      subtleZoomNum: 1,
      specialIcon: {
        circle_shape: circleShape,
        half_circle_shape: halfCircleShape,
        triangle_shape: triangleShapea,
        hexagon_shape: hexagonShape,
        square_shape: squareShape,
      },
      sendToFactoryDialog: false,
      taskList: [],
      isShowTask: false,
      // 保存NC文件的ossurl
      NCUrls: [],
      // 是否确认发送
      confirmSendToFactory: false,
      // 保存标签文件的ossUrl
      ossUrl: { data: '', type: '' },
      loadingText: this.$t('materialPage.dealing'),
      // 是否显示小板尺寸
      isShowPartSize: false,
      //是否显示下载NC时，缺失刀具的提示框
      isShowLackKnivesDialog: false,
      //下载nc，没有相应刀的数据
      lackKnivesList: [],
      //下载nc，没有相应刀的数据的键组成数组
      lackKnivesKeysList: [],
      //下载nc，没有相应刀的数据的值组成数组,拼接的字符串
      lackKnivesValueString: '',
      // 用于保存每页多少张大板
      countPerPage: 20,
      // 用于保存当前页数
      currentPape: 1,
      // 是否顺带导出标签
      isFollowExportTag: false,

      // 标签文件输出方式
      tagTypeOptions: [
        {
          label: 'common.exportPDF',
          value: 'pdf',
        },
        {
          label: 'common.exportPic',
          value: 'picture',
        },
      ],
      // 标签模板项
      tagTemplateOptions: [],
      // 是否点击了更多设置
      isMoreSetting: false,
      // 当前选中的标签模板
      currentTagTempID: undefined,
      // 当前导出标签的类型
      currentTagType: ['picture'],
      // 异形排版提示设置
      isShowExPaibanConfirm: false,
      exNextTip: true,
      // 压缩图片时候的zip对象
      imgZip: null,
      // 贴标信息
      labelInfoList: [],
      // 精细排版数据
      subtleBigPart: null,
      // 显示删除小板弹窗
      isVisible: false,
      // 冲突显示的板件
      conflictPart: null,
      // 是否存在活跃板件
      isExistsActivePlank: false,
      //记录此次排版是否存在板件冲突
      isShowConflictPrompts: false,
      //孔槽冲突图是否显示
      isShowConflictDiagram: false,
      isShowDepthTip: false,
      //孔槽冲突图第一次显示的索引
      conflictIndex: 0,
      //孔槽冲突图冲突板件列表
      conflictPlankList: [],
      isTimeOut: false,
      // 是否在更新任务
      isUpdatingTask: false,
      // 收集贴标图文件数据
      labelImgList: [[]],
      // 操作记录
      operateArr: [],
      // 操作过的板子
      operateMarkBoards: [],
      bigPart: null,
      // 全部锁定禁止重新排版
      isBanRelayout: false,
      // 材质分组重新排版弹窗
      isShowMaterialRelayoutModal: false,
      isSavePaiBanLoading: false,
      // 下载NC的任务生命周期函数对象
      ncLifeFuncObj: {},
      // 好帮手历史跳转
      isHbsHistoryStatus: false,
      allDepthErrorData: [],
      depthErrorIndex: 0,
      // 是否展示订单标记模态框
      isShowOrderMark: false,
      // 是否加载下载NC按钮
      isNCBtnLoading: false,
      // 扣减的余料数组
      surplusUseArr: [],
      isOutputCheck: false,
      // 板件备注
      plankRemarks: '',
      // 是否能够修改板件备注
      ableRewriteRemarks: false,
      // 是否在批量补件
      isBatchBujian: false,
      // 批量补件列表
      batchBujianList: [],
      //是否在批量选中板件
      isBatchActive: false,
      // 批量选中板件的partUniqueId列表
      batchActiveIdList: [],
      // 批量补件的加载状态
      isBatchBujianLoading: false,
      // 真正使用的标准板
      standardPlank: {},
      // 原片管理的标准板
      defaultPlankList: [],
      baseMaterialData: {},
      // 原片管理数据请求竞态保护（避免慢请求回写导致闪烁）
      rawMaterialReqId: 0,
      isComponentDestroyed: false,
      // 记录选择的下刀点
      selectedCutorigin: '',
      // 显示下刀点修改弹窗
      showPositionChange: false,
      cutOriginObj: {
        leftTop: '左上角',
        rightTop: '右上角',
        leftBottom: '左下角',
        rightBottom: '右下角',
      },
      // 大板用料清单弹窗显示
      showMaterialList: false,
      materialListColumns: Object.freeze([
        {
          title: '大板类型',
          dataIndex: 'plankType',
          filters: [
            { text: '标准板材', value: '标准板材' },
            { text: '特殊板材', value: '特殊板材' },
            { text: '余料板材', value: '余料板材' },
            { text: '全选', value: '全选' },
          ],
          width: 110,
        },
        {
          title: '材质',
          dataIndex: 'matCode',
        },
        {
          title: '颜色',
          dataIndex: 'texture',
        },
        {
          title: '厚度(mm)',
          dataIndex: 'thick',
          width: 100,
        },
        {
          title: '长度(mm)',
          dataIndex: 'plankHeight',
          width: 100,
        },
        {
          title: '宽度(mm)',
          dataIndex: 'plankWidth',
          width: 100,
        },
        {
          title: '余料仓库',
          dataIndex: 'branch_name',
          width: 100,
        },
        {
          title: '余料名称',
          dataIndex: 'name',
          width: 100,
        },
        {
          title: '数量',
          dataIndex: 'num',
        },
      ]),
      materialList: [],
      // 余料库容量不足弹窗显示
      showSurStoreTip: false,
      storeRef: null,
      // 子画布默认缩放
      defaultScale: 6,
      // 子画布动态缩放
      scalePercent: 1,
      /** 扣减弹窗 */
      isShowDeduction: false,
      // 扣减对应选择框是否显示
      deductionShowState: {
        // 补件扣减
        isShowBujianDeduction: true,
        // 余料扣减
        isShowSurplusDeduction: true,
        // 待排版库扣减
        isShowAwaitDeduction: true,
        // 余料状态勾选
        isDisarm: false,
        // 扣减原片
        isShowBaseMaterialDeduction: true,
      },
      // 扣减对应选择框选中状态
      deductionStatus: {
        bujian: true,
        surplus: true,
        awaitStore: true,
      },
      /** 扣减需要扣减的数据 */
      deductionData: {
        // 补件扣减
        bujian: [],
        // 余料扣减
        surplus: [],
        // 待排版库扣减
        awaitStore: [],
      },

      // 当前执行的下载nc方式 paiban  jingxi
      currentDownloadType: 'paiban',
      // 有关小板上找不到刀的错误信息
      notFoundKnivesInfo: [{}],
      // 所有的刀错误信息
      allKnivesErrInfos: [],
      // 在精细排版下，排版后不展示查看找不到刀的错误信息按钮
      showNotFoundKnivesErrInfoBtn: true,
      isShowNotFoundKnivesInfoDrawer: false,
      // 异形选刀提示展示弹窗
      isShowSpecialShapeKnivesInfoDialog: false,
      // 异形选刀提示展示弹窗数据
      specialShapeKnivesInfo: [],
      // 当前排版的小板数量
      recordDrawPlankDataLength: 0,
      // 是否为重新排版
      isRefresh: false,
      // 孔槽冲突的弹窗
      isShowConflictModal: false,
      // 忽略错误，继续下载文件的标识
      isContinue: false,
      // 当前生产线
      isSelectProLine: false,
      oriNcSetting: null,
      oriKnifes: null,
      orderIds: [],
      isShowDeductModal: false, // 扣减内容弹窗
      useMaterialData: {},
      label_image_folder: '', // 贴标图片文件夹
      // 标签文件按打大板分文件夹 没开启小板标签 提示
      isShowConfirmNoSmallTag: false,
      // 标签文件按大板分文件夹 余料大板文件夹 提示
      isShowConfirmForSurFolder: false,
      // 是否生成彩色标签
      print_color_tag: false,
      // 彩色标签生成警告
      isShowConfirmColorTag: false,
      // 彩色标签无法生效时选择继续下载NC
      continueDownloadFlag: false,
      // 超过限制的数组
      limitTwelveList: [],
      // 当前操作对象
      currentOperate: 'nc',
      // 当前排版使用余料id
      useSurplusId: [],
      // 当前排版使用余料列表
      useSurplusList: [],
      // 余料是否被当前订单全部锁定弹窗
      isShowSurplusLock: false,
      // 精细排版 下载NC 锁定弹窗
      isShowSurplusLockNewSub: false,
      // 删除的余料大板 id
      delSurplusId: [],
      taskFn: null,
      isShowSlectPlank: false,
      neecActivePlank: [],
      // 切割顺序检测错误弹窗
      isShowInspectCutOrder: false,
      // 冲突的板件详情弹窗
      isShowConflictDetail: false,
      // 切割顺序不正确的小板数组
      errorCutOrders: [],
      // 当前展示的板件名称
      currentCutOrderName: '',
      // 当前展示的板件index(默认展示第一个)
      currentCutOrderIndex: 1,
      // 切割顺序不正确的大板数组
      errorBigPlankCutOrders: [],
      // 切割顺序不正确的锁定大板数组
      errorBigPlankLockedCutOrders: [],
      cutOrderOkDisable: false,
      // 弹窗展示位置调整
      popStyle: {
        top: '70px',
        left: '55%',
      },
      // 控制精细排版切割顺序弹窗
      isShowSubtleInspectCutOrder: false,
      currentSubtleCutOrderName: '',
      currentSubtleCutOrderIndex: 1,
      // 当前操作对象 下载NC，发送生产车间
      isShowHoleSlotOnClampHandModal: false, // 夹手处存在孔槽时的提示弹窗
      showConflictPartDetail: false, // 展示冲突板件详情
      conflictParts: [], // 存在冲突的板件
      isShowHoleSlotOnClampHandModalForDownloadNC: false,
      notIgnore: true,
      isShowSpecialAndFiveSix: false,
      currentLineId: null,
      currentSpecailType: null,
      preSaveNcSetting: null,
      isVisiblExpire: false,
      expirseMsg: '',
      // 余料入库二次确认弹窗
      isShowSecondConfirm: false,
      surplusConfirmList: [],
      otherSurplusData: {},
      isNeedOpenModal: false,
      isNeedOpenModalForSurFolder: false,
      isFactoryFlag: false,
      isSendToEzSort: false,
      pointPosition: {
        x: 0,
        y: 0,
      },
      mMenuRef: null,
      menuList: [],
      // 是否在批量补标签
      isBatchTagging: false,
      // 批量补件列表
      currentBatchTaggingList: [],
      // 拖动板件是否激活暂存区
      activeTempStorage: false,
      fromWhtchBtn: 'saveHistory', // 记录点击的是下载NC/保存历史
      hasDownloadedNC: true, // 记录是否已经下载过NC
      // 记录是否需要重新更新排版批次
      isNeedUpdateBatch: false,
      // 当前导出排版图的类型
      currentPaibanImgType: ['picture'],
      isFollowExportPaibanImg: true,
      // 是否改变了标签模板
      isChangeTagTemp: false,
      // 余料尺寸过小提示弹窗
      isShowSurplusSizeErrModal: false,
      // 排版批次（历史记录跳过来才有此值）
      layout_batch: '',
      // 是否在批量改大板尺寸
      isBatchEditSize: false,
      // 是否单独修改大板尺寸
      isShowEditSize: false,
      isFollowExportWorkerShop: false,
      currentLine: null,
      noCutErroroNotShow: false,
      // 库类型：补件库、待排版库
      storeType: 'awaitStore',
      // 当前普通排版页补件查询条件
      currentDrawPlankKeyStr: '',
      hasForceFetchedBujianOnEnter: false,
      // 补件库搜索关键字
      bujianKeyword: '',
      // 骨骼门加工提示弹窗
      isShowFrameDoorModal: false,
      // 骨骼门提示已确认，继续下载时不再重复弹窗
      isFrameDoorConfirmed: false,
      isFrameDoorTip: false,
      /** 进度提示标题 */
      progressTitle: '',
      /** 发送车间标签设置参数 */
      tagSetting: {},
      /** 是否有深度计算排版方案 */
      hasDeepSearchPlan: false,
    }
  },
  computed: {
    ...mapState([
      'proLineList',
      'surplusAutoTailor',
      'userInfo',
      'paibanData',
      'codeIds',
      'paibanExtraInfo',
      'isHistoryStatus',
      'ncSetting',
      'preLayoutData',
      'orderInfo',
      'bigPartsInfo',
      'dataFrom',
      'hasLblAuth',
      'tempStorage',
      'supplusIndex',
      'isDragingPlank',
      'finalDrawData',
      'surplusParams',
      'activePaibanWay',
      'specialPlankParams',
      'surplusTailorWay',
      'surplusCommonSize',
      'paibanInfo',
      'recodeIsTailor',
      'paibanKey',
      'newTags',
      'sampleTableData',
      'isShowSample',
      'factoryId',
      'prePaibanData',
      'availableBujianList',
      'filterMaterialList',
      'filterObject',
      'beforeSearchMaterialList',
      'beforeSizeFilterList',
      'isTrialProduct',
      'tagTempList',
      'historyOrder',
      'highgloss_direction',
      'hasRollPoly',
      'isPrintTag',
      'labeling_folder',
      'isSurplusNoRoll',
      'materialTask',
      'produceTime',
      'isBatch',
      'isNewPaiban',
      'historyPlankEdgeOff',
      'historySecondTrimValue',
      'hasHistoryChangePaiban',
      'selectStandardPlank',
      'customPlankOrder',
      'plankOrderList',
      'onlyLayoutTooBig',
      'oriLayoutSetting',
      'paibanParams',
      'preLayoutSetting',
      'surplusObj',
      'userInfo',
      'selectSurplusList',
      'isShowDisPaiabnConfirm',
      'isLockedRePaiban',
      'batchTaggingList',
      'beforeTitleSorts',
      'paibanTaskObj',
    ]),
    historyInfluenceOptions() {
      const isImportJson =
        window.sessionStorage.getItem('isImportOrder') === 'true'
      if (this.isHistoryStatus || this.isHbsHistoryStatus) {
        return this.paibanInfo?.influenceOptions || { groups: [] }
      }
      const hasImportInfluenceOptions = Object.prototype.hasOwnProperty.call(
        this.paibanInfo || {},
        'influenceOptions'
      )
      if (!isImportJson || !hasImportInfluenceOptions) {
        return null
      }
      return this.paibanInfo?.influenceOptions || { groups: [] }
    },
    // 是否拥有高级异形嵌套权限；无权限时高级嵌套置灰并自动回退到普通嵌套
    hasAdvancedNestPermission() {
      return (
        checkUserPermissions([
          USER_PERMISSION_KEY.ADVANCED_IRREGULAR_NESTING,
        ]) === true
      )
    },
    isNewTagDraw() {
      const ggver = sessionStorage.getItem('guigui_version') ?? ''

      const GGV = Number(
        (window.webToQt?.ggVersion ?? ggver).split('-')[0].split('.').join('')
      )
      return window.webToQt && GGV >= 5003
    },
    bujianQueryKey() {
      return buildBujianQueryKey({
        colorTextureThickStr: this.currentDrawPlankKeyStr,
        filterWord: this.bujianKeyword,
        pageScope: 'paiban',
      })
    },
    bujianStoreData() {
      // 让补件删除/回退后 participation 变化能够稳定触发列表重算
      const participationVersion =
        this.$store.state.bujianStore?.participationVersion ?? 0
      return participationVersion >= 0
        ? this.$store.getters['bujianStore/getVisibleBujianList'](
            this.bujianQueryKey
          )
        : []
    },
    bujianStoreLoading() {
      return this.$store.getters['bujianStore/getLoadingByQueryKey'](
        this.bujianQueryKey
      )
    },
    // 是否有异形余料参与排版
    hasSelectSpecialShapeSurplus() {
      const stockData = this.drawData.map((d) => d.data).flat(1)
      return stockData.some(
        (item) =>
          item.surplusInfo &&
          [2, 'specialShape'].includes(item.surplusInfo.shape) &&
          item.surplusInfo.path &&
          item.surplusInfo.path.length > 7
      )
    },
    checkboxexNextTip: {
      get() {
        return !this.exNextTip
      },
      set(val) {
        this.exNextTip = !val
        updateLocalPreference({
          exNextTip: this.exNextTip,
        })
      },
    },
    isShuntSetting() {
      return (
        this.ncSetting.cal_turn_num_aft_shunt ||
        this.ncSetting.hs_on_front_aft_shunt
      )
    },
    isSawPaiban() {
      return (
        ['paiban', 'paiban_roll'].filter((way) =>
          this.$store.state.activePaibanWay.includes(way)
        ).length > 0 &&
        this.ncSetting.sawSetting.mentaoji_enable &&
        this.ncSetting.sawSetting.sawToLayout &&
        this.ncSetting.sawSetting.processType === 'weldingPlank'
      )
    },
    // 是否是只剩余空大板
    isEmptyData() {
      return this.finalDrawData.some(
        (item) =>
          !item.data.length ||
          (item.data.length === 1 &&
            item.data.some((plank) => !plank.parts.length))
      )
    },
    // 当前仍有小板，且均为不下料材质时展示提示（删光小板后不展示）
    isAllDesMaterialNoCutTip() {
      if (!this.drawData.length) return false
      const hasParts = this.drawData.some((item) =>
        item.data?.some((plank) => plank.parts?.length > 0)
      )
      if (!hasParts) return false
      return this.drawData.every((item) => item.isDesMaterialNoCut)
    },
    isExpandedArranged() {
      return this.finalDrawData.some((item) => {
        return (
          item.data.length &&
          item.data.some((plank) => plank.parts.some((part) => part.isExpanded))
        )
      })
    },
    // 检测是否有深度异常板件
    isDepthError() {
      return (drawDataArr = this.paibanData) => {
        const flag = drawDataArr.some((dataEle) =>
          dataEle.parts.some((part) => part.depthError)
        )
        return flag
      }
    },
    depthErrorData() {
      return this.allDepthErrorData[this.depthErrorIndex]
    },
    depthErrorNum() {
      if (this.allDepthErrorData && this.allDepthErrorData.length) {
        const currentDepthError = this.allDepthErrorData[this.depthErrorIndex]
        const holeDepthErrorArr = currentDepthError.holes.filter(
          (hole) => hole.depthError
        )
        const slotDepthErrorArr = currentDepthError.slots.filter(
          (slot) => slot.depthError
        )
        return slotDepthErrorArr.length + holeDepthErrorArr.length
      }
      return 0
    },
    handleIslocked() {
      let isLocked = false
      this.paibanData.forEach((item) => {
        if (this.activePlank && item.stockKey == this.activePlank.stockKey) {
          isLocked = item.isLocked
        }
      })
      return isLocked
    },
    hasHighGlossPlank() {
      const combinedParts = this.paibanData.reduce((acc, currentItem) => {
        if (currentItem.parts) {
          acc.push(...currentItem.parts)
        }
        return acc
      }, [])
      const hasHighGlossPlank = combinedParts.some(
        (item) => item.is_high_gloss_plank
      )
      return hasHighGlossPlank
    },
    showHighGlossTipType() {
      let flag
      if (this.isHistoryStatus) {
        flag = this.historyOrder.plank_info.highgloss_direction
          ? this.historyOrder.plank_info.highgloss_direction
          : 'back'
      } else if (!this.isHistoryStatus) {
        flag = this.ncSetting.highgloss_direction
      }
      return flag
    },
    getHighgloss_direction() {
      let highgloss_direction
      if (this.isHistoryStatus) {
        highgloss_direction = this.historyOrder.plank_info.highgloss_direction
          ? this.historyOrder.plank_info.highgloss_direction
          : 'back'
      } else {
        highgloss_direction = this.highgloss_direction
      }
      return highgloss_direction
    },
    newPaibanTags() {
      return this.newTags['newPaiban']
    },

    zoomPercent() {
      return ((this.zoomNum / 1) * 100).toFixed() + '%'
    },
    subtleZoomPercent() {
      return `${(this.subtleZoomNum * 100).toFixed()}%`
    },
    // 文件夹设置
    folderSetting() {
      return this.ncSetting.customizeFolder
    },
    isSelectedSurplus() {
      let flag = false
      for (let i = 0; i < this.surplusList.length; ++i) {
        if (this.surplusList[i].isSelected) {
          this.selectedSurplus = this.surplusList[i]
          flag = true
          break
        }
      }
      if (!flag) {
        this.selectedSurplus = null
      }
      return !flag
    },
    isGlass() {
      return !!this.ncSetting.glass_setting
    },
    isShowAlignedPlan() {
      // 尊享：分材质 resultPlansObj；非尊享：组合方案 paibanDataCollect
      if (this.isExpressVip) {
        const collect = this.$store.state.paibanStore.resultPlansObj
        return !!(
          collect &&
          typeof collect === 'object' &&
          Object.keys(collect).length
        )
      }
      return !!this.$store.state.paibanStore.paibanDataCollect?.length
    },
    isShowDisplaySetting() {
      return this.ncSetting.movePlankSetting?.scattered_layout
    },
    isWebToQt() {
      return Boolean(window.webToQt)
    },
    isExpressVip() {
      return Boolean(window.webToQt?.expressVip)
    },

    hasEmtryPlank() {
      let flag = false
      // 如果数据中都是空白大板也不允许排序
      let hasSmallParts = false // 是否有小板存在
      for (let i = 0; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].data.length; j++) {
          if (this.drawData[i].data[j].parts.length > 0) {
            hasSmallParts = true
          }
        }
      }
      if (!hasSmallParts) {
        flag = true
      }
      return flag
    },
    isProLineSwitchIconDisabled() {
      return (
        this.hasEmtryPlank ||
        this.isShuntSetting ||
        this.isSawPaiban ||
        this.currentLine?.data?.is_des_material_no_cut
      )
    },
    showPlankNum() {
      let str = this.activePlank.oriPlankNum
      if (this.ncSetting.genSimpleLabelBarcode) {
        str = this.activePlank.simplePlankNum ?? ''
      }
      return str
    },
    showPlankRemark() {
      return this.plankRemarks
        ? this.plankRemarks
        : this.activePlank.plank_remarks
    },
    finishPercent() {
      let percent =
        (this.taskList.filter((item) => item.endDone).length /
          this.taskList.length) *
        100
      return parseInt(percent)
    },
    // 根据每个小板上的错误信息获取到所有的错误信息
    allErrInfos() {
      return this.notFoundKnivesInfo
        .map((errObj) => {
          return errObj.errorInfo
        })
        .flat(1)
    },
    // 处理处排版用料数据
    materialData() {
      // 处理drawdata数据  满足仅打孔 不下料的数据 就过滤掉
      const drawData = this.drawData.filter((data) => !data.isDesMaterialNoCut)
      return this.dealUseMaterialData(this.dealDrawDataToTargetData(drawData))
    },
    // 有拉直器等特殊工艺 或者 使用锯切工艺
    hasExpandedPlank() {
      return (
        (this.activePlank && this.activePlank.isExpanded) ||
        (this.activePlank && this.activePlank.isUseSaw)
      )
    },
    // 复选的小板中是否有被锁定的大板（锁定大板上的小板不支持批量操作）
    hasBatchActiveLocked() {
      return this.getBatchActiveTargets().some((item) => item.bigpart.isLocked)
    },
    // 复选的小板中存在被锁定的大板或拉直器等特殊工艺板件时，不支持批量旋转、翻面
    hasBatchActiveInvalid() {
      return (
        this.hasBatchActiveLocked ||
        this.getBatchActiveTargets().some((item) => item.part.isExpanded)
      )
    },
    // 删除确认弹窗文案（复选时提示删除的小板数量）
    deleteConfirmTip() {
      if (this.batchActiveIdList.length) {
        return this.$translateLang(
          `确定删除选中的 ${this.batchActiveIdList.length} 块小板吗？`
        )
      }
      return this.$t(
        this.activePlank?._isBujian
          ? 'common.confirmDeleteBujianTip'
          : 'common.confirmDeleteTip'
      )
    },
    // 无纹理操作是否不可用（单板看激活板件，复选看是否全部为无需处理纹理的小板）
    isNonTextureDisabled() {
      if (this.batchActiveIdList.length) {
        return this.getBatchActiveTargets().every(
          (item) => item.part.srcTexDir === 'notcare'
        )
      }
      return this.activePlank?.srcTexDir === 'notcare'
    },
    /** 复选的小板无纹理勾选状态：all=全部无纹理，part=部分无纹理（非全选），none=都非无纹理 */
    batchNonTextureState() {
      if (!this.batchActiveIdList.length) return 'none'
      const targets = this.getBatchActiveTargets()
      if (!targets.length) return 'none'
      const checkedCount = targets.filter((item) =>
        this.isPartNonTexture(item.part)
      ).length
      if (!checkedCount) return 'none'
      return checkedCount === targets.length ? 'all' : 'part'
    },
    /** 无纹理复选框回显：单板取激活板件，复选取全部选中小板是否都为无纹理 */
    nonTextureChecked() {
      if (this.batchActiveIdList.length) {
        return this.batchNonTextureState === 'all'
      }
      return this.isNonTexture
    },
    /** 无纹理复选框是否处于非全选（半选）状态 */
    isNonTextureIndeterminate() {
      return (
        this.batchActiveIdList.length > 0 &&
        this.batchNonTextureState === 'part'
      )
    },
    /** 复选的小板分层切割勾选状态：all=全部开启，part=部分开启（非全选），none=都未开启 */
    batchLayerCutState() {
      if (!this.batchActiveIdList.length) return 'none'
      const targets = this.getBatchActiveTargets()
      if (!targets.length) return 'none'
      const checkedCount = targets.filter((item) =>
        this.isPartLayerCut(item.part)
      ).length
      if (!checkedCount) return 'none'
      return checkedCount === targets.length ? 'all' : 'part'
    },
    /** 分层切割复选框回显：单板取激活板件，复选取全部选中小板是否都开启 */
    layerCutChecked() {
      if (this.batchActiveIdList.length) {
        return this.batchLayerCutState === 'all'
      }
      return this.isLayerCut
    },
    /** 分层切割复选框是否处于非全选（半选）状态 */
    isLayerCutIndeterminate() {
      return (
        this.batchActiveIdList.length > 0 && this.batchLayerCutState === 'part'
      )
    },
    // 夹手位置检测结果弹窗确认按钮的展示与隐藏（下载nc）
    isShowClampHandModalOkTextBtn() {
      return !this.showSubtle
    },
    // 当前小板所在大板是否满足不同板厚分层切割（复选时按选中的全部小板判断）
    isMatchedLayeredForPartThick() {
      if (this.batchActiveIdList.length) {
        return this.getBatchActiveTargets().some((item) =>
          matchLayeredCutForPalnkThick(item.part)
        )
      }
      return matchLayeredCutForPalnkThick(this.activePlank)
    },
    // 弹窗文案
    confirmTip() {
      if (this.isShowConfirmForSurFolder) {
        return this.translateLang('common.downNcErrTipForSurFolder')
      }
      return this.translateLang('common.downImageErrTip')
    },
    showConfirmModal() {
      return this.isShowConfirmNoSmallTag || this.isShowConfirmForSurFolder
    },
    newEdgeInfo() {
      if (!this.activePlank?.edgeInfo) {
        return ''
      }
      return appendPreMillingToEdgeInfoDisplay(
        this.activePlank.edgeInfo,
        this.activePlank.edgePreMillingInfo
      )
    },
    orderAddress() {
      let address = this.orderInfo?.order_address
      if (address) {
        address = address.replace(
          /\(.*?\)|历史记录/g,
          `${this.layout_batch ? `(${this.layout_batch})` : ''}`
        )
      }
      return address
    },
    /** 是否禁止重新排版 */
    isDisableReArrange() {
      let flag = false
      return flag
    },
    /** 是否有只加工孔槽的板件 */
    isOnlyProcessHoleSlot() {
      return checkIsOnlyProcessHoleSlotByPaibanData(this.paibanData)
    },
    /** 是否来自料单页（较为离谱的判断） */
    isFromMaterial() {
      const { from, isSpecialShape } = this.$route.query ?? {}
      return (
        from === 'material_paiban' ||
        from === 'lbl' ||
        isSpecialShape === 'true'
      )
    },
    isUseDeepSearchPlan() {
      if (this.isExpressVip) {
        const usingMap =
          this.$store.state.paibanStore?.currentUsingSpecialIdMap || {}
        const resultPlansObj =
          this.$store.state.paibanStore?.resultPlansObj || {}
        return Object.keys(usingMap).some((matKey) => {
          const plans = resultPlansObj[matKey] || []
          const activeId = usingMap[matKey]
          const plan = plans.find(
            (item) => String(item.specialId) === String(activeId)
          )
          return !!(plan?.isDeepSearch || plan?.data?.isDeepSearch)
        })
      }
      const specialId = this.$store.state.paibanStore?.currentUsingSpecialId
      const plan = this.$store.state.paibanStore?.paibanDataCollect?.find(
        (item) => String(item.specialId) === String(specialId)
      )
      return !!(plan?.isDeepSearch || plan?.data?.isDeepSearch)
    },
  },
  watch: {
    hasDeepSearchPlan(val) {
      // 新排版出现深度计算方案时，等按钮布局稳定后再打开 tip，避免箭头错位
      if (val) {
        this.moreResultTipVisible = false
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.moreResultTipVisible = true
          })
        })
      }
    },
    plankKeyWord(val) {
      if (val) {
        this.isEmptyInput = false
      } else {
        this.searchPlankList = []
        this.searchPlankIndex = -1
        this.isEmptyInput = true
      }
    },
    showSubtle(val) {
      if (!val) {
        this.subtleHasActivePlank = false
      }
      // 精细排版的显隐，分别控制排版页事件的重新监听和移除
      for (let i = 0; i < this.drawData.length; i++) {
        if (val) {
          this.isShowzancun = false
          this.exitBatchSelectMode()
          window.removeEventListener('keydown', this.keyDownEvent)
          window.removeEventListener('keyup', this.keyUpEvent)
          window.removeEventListener('blur', this.onWindowBlurExitBatchSelect)
          window.removeEventListener(
            'contextmenu',
            this.preventCtrlContextMenu,
            true
          )
          if (this.$refs[`drawpart${i}`])
            this.$refs[`drawpart${i}`][0].clearEvent()
        } else {
          window.addEventListener('keydown', this.keyDownEvent)
          window.addEventListener('keyup', this.keyUpEvent)
          window.addEventListener('blur', this.onWindowBlurExitBatchSelect)
          window.addEventListener(
            'contextmenu',
            this.preventCtrlContextMenu,
            true
          )
          if (this.$refs[`drawpart${i}`])
            this.$refs[`drawpart${i}`][0].addEvent()
          this.dealOptimizeArea(this.drawData)
        }
      }
    },
    tagTempList: {
      immediate: true,
      deep: true,
      handler() {
        this.currentTagTempID = undefined
        this.currentTagTempID = this.initTagTempID()
      },
    },
    activePlank(val) {
      this.handleCollectConflicts()
      if (val?.holeSlotMerge) {
        store.commit('setrecordCurrentConflictBoard', {
          ...val,
        })
        const index = this.conflictPlankList.findIndex(
          (i) => i.partUniqueId === val.partUniqueId
        )
        this.conflictIndex = index > -1 ? index : 0
        this.conflictPart = val
      }
    },
    activeBigpart: {
      async handler() {
        const isQueryKeyChanged = this.updateCurrentDrawPlankKeyStr()
        if (
          isQueryKeyChanged &&
          this.currentDrawPlankKeyStr &&
          this.storeType === 'bujianStore'
        ) {
          await this.handleGetBujianStoreData(this.bujianKeyword)
        }
      },
    },
    currentTagType: {
      immediate: true,
      deep: true,
      handler() {
        this.updateNcLifeObj()
      },
    },
    'tagSetting.tagDocType': {
      deep: true,
      handler() {
        this.updateNcLifeObj()
      },
    },

    'drawData.length': {
      async handler() {
        const isQueryKeyChanged = this.updateCurrentDrawPlankKeyStr()
        const shouldForceFetchOnEnter =
          !this.hasForceFetchedBujianOnEnter && this.currentDrawPlankKeyStr
        if (isQueryKeyChanged || shouldForceFetchOnEnter) {
          await this.handleGetBujianStoreData(
            this.bujianKeyword,
            shouldForceFetchOnEnter
          )
          if (shouldForceFetchOnEnter) {
            this.hasForceFetchedBujianOnEnter = true
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    checkUserPermissions(vals) {
      return checkUserPermissions(vals)
    },
    onChangeShowDeepTabTip(val) {
      this.hasDeepSearchPlan = val
    },
    handleConflictModalOk() {
      this.hasConflict = false
      this.productionLineName = ''
    },

    async handleStoreTypeChange(e) {
      const nextStoreType = e?.target?.value ?? this.storeType
      if (!['awaitStore', 'bujianStore'].includes(nextStoreType)) return
      this.storeType = nextStoreType
      updateLocalPreference({
        layoutStoreType: nextStoreType,
      })
      if (nextStoreType === 'bujianStore') {
        this.updateCurrentDrawPlankKeyStr()
        await this.handleGetBujianStoreData(this.bujianKeyword)
      }
    },
    ...mapMutations([
      'setSurplusAutoTailor',
      'setLongSideRect',
      'setShortSideRect',
      'setPaibanExtraInfo',
      'setPreLayoutData',
      'setOrderInfo',
      'setCodeIds',
      'setPaibanData',
      'setNcSetting',
      'setBigPartsInfo',
      'changeHistoryStatus',
      'changeDataFrom',
      'changeLblAuth',
      'addTempStorage',
      'changeDragingPlank',
      'recordBeDraggedPlank',
      'setSupplusIndex',
      'deleteTempStorage',
      'changeTempStorage',
      'resetTempStorage',
      'setFinalDrawData',
      'setTempImgPos',
      'setActivePaibanWay',
      'deleteSurplusParams',
      'setPaibanTime',
      'setSurplusTailorWay',
      'setHasPrintTag',
      'setRecodeIsTailor',
      'setOffsetPointbetweenCacheImage',
      'setIsResetPaibanAllocation',
      'setPaibanKey',
      'setFactoryId',
      'setTempList',
      'setOpenSingleFile',
      'setHighglossDirection',
      'setHasRollPoly',
      'setIsSubPrintTag',
      'setIsPrintTag',
      'setSurplusNoRoll',
      'setProduceTime',
      'setBatchPaiban',
      'setIsNewPaiban',
      'setHistorySecondTrimValue',
      'setHistoryPlankEdgeOff',
      'setNewNCRes',
      'setPaibanInfo',
      'setFilterMaterialList',
      'setFilterObject',
      'setBeforeSearchMaterialList',
      'setBeforeSizeFilterList',
      'setIsTrialProduct',
      'setHistoryOrder',
      'setHasSendToTask',
      'setRecodeSelectPart',
      'setRecodeSelectSurplus',
      'setIsShowSample',
      'setThinkerxMaterialKeys',
      'setSampleTableData',
      'setSurplusParams',
      'setIsCanPrintTag',
      'setPreLayoutSetting',
      'setSelectSurplusList',
      'setIsShowDisPaiabnConfirm',
      'setIsLockedRePaiban',
      'setBatchTaggingList',
      'setBeforeTitleSorts',
    ]),
    updateCurrentDrawPlankKeyStr() {
      const sourceBigPlanks = this.activeBigpart
        ? [this.activeBigpart]
        : this.drawData
      const keys = sourceBigPlanks.flatMap((item) => {
        const { allColors = [], matCode, thick, texture } = item
        const currentKeys = allColors.flatMap(
          (color) => `${color}*${matCode}*${thick}`
        )
        return Array.from(
          new Set([...currentKeys, `${texture}*${matCode}*${thick}`])
        )
      })
      const nextKeyStr = Array.from(new Set(keys)).sort().join(',')
      if (nextKeyStr === this.currentDrawPlankKeyStr) return false
      this.currentDrawPlankKeyStr = nextKeyStr
      return true
    },
    handleBatchEditSize() {
      this.isBatchEditSize = true
    },
    handleUpdateBatchEditSize(isShow) {
      this.isBatchEditSize = isShow
    },
    handlePaibanDataUpdate(recordDataArr, editPlankList) {
      this.isBatchEditSize = false
      this.isShowEditSize = false
      this.$message.success(this.$translateLang('修改成功'))
      this.dealAllDrawData()
      if (
        this.ncSetting.sawSetting.firstCutSurplus &&
        this.ncSetting.sawSetting.surplusStoreAndLabeling &&
        this.selectedPaibanWay == 'paiban' &&
        this.ncSetting.sawSetting.mentaoji_enable &&
        this.ncSetting.sawSetting.processType === 'weldingPlank'
      ) {
        cutBlueSurplus(this.drawData, true)
      }
      editPlankList.forEach((board) => {
        this.clearReuseIfNeeded(board)
      })
      this.renderAll()
      recordDataArr.forEach((item) => {
        this.addDataToOperateArr(item)
      })
    },
    handleUpdateEditSize(isShow) {
      this.isShowEditSize = isShow
    },
    closeAlignedPlanDialog() {
      this.alignedPlanDialog = false
    },
    handleOpenMoreResult() {
      this.alignedPlanDialog = true
      this.setIsShowDisPaiabnConfirm(false)
    },
    handleCloseDisPaibanConfirm() {
      this.setIsShowDisPaiabnConfirm(false)
    },
    handleSeePlankDetail() {
      this.setIsShowDisPaiabnConfirm(false)
      // 根据条件筛选出满足条件的大板
      this.noMinSizePlank()
      this.isShowSlectPlank = true
      // 这个时候已经有问题大板了，需要默认选中第一个
      this.selectActivePlank(this.neecActivePlank[0])
    },
    handleExportImg() {
      this.isShowConfirmNoSmallTag = false
      this.isShowConfirmForSurFolder = false
    },
    // 批量补件
    handleBatchBujian() {
      this.isBatchBujian = true
      this.batchBujianList = []
      this.plankKeyWord = ''
      this.searchPlank('')
      this.clearAllActive()
    },
    // 关闭批量补件
    handleCloseBatchBujian() {
      this.isBatchBujian = false
      this.batchBujianList = []
      this.clearAllActive()
      this.renderAll()
    },
    computedRealRectFopEdge(type = 'width') {
      const appliedSides = this.activePlank.edgePreMillingInfo
        ?.appliedSides || {
        right: 0,
        left: 0,
        top: 0,
        bottom: 0,
      }
      const edgeInfo = {
        width: Number(appliedSides.right || 0) + Number(appliedSides.left || 0),
        height:
          Number(appliedSides.top || 0) + Number(appliedSides.bottom || 0),
      }

      const needReverse = this.activePlank.srcTexDir === 'reverse'
      if (needReverse) {
        type = type === 'width' ? 'height' : 'width'
      }
      const size = this.showPartSize('realRect', type)
      const decimal = this.ncSetting.decimal ?? 2
      const result = toDecimal(size - edgeInfo[type], decimal)
      return result
    },
    // 确认批量补件
    async handleConfirmBatchBujian() {
      try {
        if (this.batchBujianList.length) {
          this.loadingPrompts = 'arrangedPage.addToBujianStore'
          this.isBatchBujianLoading = true
          // 合并后的骨骼门在排版页是 1 块，补件需按原始 5 块单板提交
          const expandedBatchBujianList = []
          this.batchBujianList.forEach((part) => {
            if (judgeIsMergeFrameDoor(part)) {
              expandedBatchBujianList.push(...part.frame_door_children)
            } else {
              expandedBatchBujianList.push(part)
            }
          })
          const plankFileData = expandedBatchBujianList
            .map((part) => {
              const rePart = this.preLayoutData.find(
                (p) =>
                  p.partUniqueId == part.partUniqueId ||
                  p.partUniqueId == part.oriPartUniqueId ||
                  // 第三种情况纯属意外出现
                  (p.oriPartUniqueId &&
                    part.oriPartUniqueId &&
                    p.oriPartUniqueId === part.oriPartUniqueId)
              )
              if (!rePart) {
                return undefined
              }
              return {
                ...rePart,
                partUniqueId: nanoid(),
                plankNum: part.plankNum,
                amount: 1,
              }
            })
            .filter((it) => it)

          const result = {
            supplements_info: [],
            reason: '',
            duty: '',
            library_type: LibraryTypeJS.bujianStore,
          }
          for (const it of plankFileData) {
            const url = await new Promise((resolve) => {
              uploadFiles(
                {
                  plank: [it],
                },
                (re) => {
                  resolve(re)
                }
              )
            })
            const payload = await dealBatchBujian(it, url)
            result.supplements_info.push(payload)
          }
          const res = await batchBujian(result)

          buryPointApi('layout', 'batchSuplement')
          if (!res.status) {
            this.$message.error(res.msg)
          } else {
            await this.handleGetBujianStoreData(this.bujianKeyword, true)
            this.$message.success(translate('arrangedPage.storedSuccess'))
            this.handleCloseBatchBujian()
          }
        } else {
          this.$message.error(translate('arrangedPage.selectTip'))
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isBatchBujianLoading = false
      }
    },
    // 获取大板信息并更改激活状态
    getBigPart(bigPart) {
      this.drawData.forEach((item) => {
        item.data.forEach((plank) => {
          plank.isActive = plank.stockKey == bigPart.stockKey
        })
      })
    },
    changeLockedStatus(drawPart) {
      this.drawData.forEach((item) => {
        item.data.forEach((item) => {
          if (item.stockKey == drawPart.stockKey) {
            item.isLocked = drawPart.isLocked
          }
        })
      })
      let lockedPlank = []
      this.drawData.forEach((planks) => {
        planks.data.forEach((item) => {
          if (item.isLocked) {
            lockedPlank.push(item)
          }
        })
      })
      this.isBanRelayout = lockedPlank.length == this.paibanData.length
    },
    handleCancle() {
      this.isShowLackKnivesDialog = false
    },
    handleSeeDetails() {
      this.handleCollectConflicts()
      this.isShowConflictDiagram = true
    },
    handleCloseConflictDiagram() {
      this.isShowConflictDiagram = false
      this.conflictIndex = 0
    },

    /**
     * 处理大板序号
     * @param {*} currentPape 当前页
     * @param {*} countPerPage 每页有多少张大板
     */
    handleBigPartIndex(currentPape, countPerPage) {
      let index = 0
      this.drawData.forEach((item) => {
        item.data.forEach((dataItem) => {
          index++
          dataItem.canvasIndex = index
        })
      })
    },
    handleChangePage(val) {
      this.currentPape = val
    },
    handleChangePerPage(item) {
      this.countPerPage = item
      this.handleBigPartIndex(this.currentPape, this.countPerPage)
    },
    handleRecordPlankMove(val) {
      this.isNeedUpdateBatch = true
      this.addDataToOperateArr(val)
    },
    getStartNum(index) {
      let count = 0
      for (let i = 0; i < index; i++) {
        count += this.drawData[i].counts
      }
      this.drawData[index].startNum = count
      this.handleBigPartIndex(this.currentPape, this.countPerPage)
      return count
    },
    setBigPlankH(height) {
      if (this.isOnlyShowSurplus) {
        this.isOnlyShowSurplus = false
        this.handleShowSurplus()
      }
      if (height) {
        this.bigPlankH = height
      }
    },

    // 记录顶部设置
    async handleChangeTopOption(changeType) {
      this.isSendToEzSort = this.isFollowExportTag ? this.isSendToEzSort : false
      updateLocalPreference({
        isAutoPassData: this.isAutoPassData,
        isCuttingOrder: this.isCuttingOrder,
        isShowPartSize: this.isShowPartSize,
        isUnuseSurplus: this.isUnuseSurplus,
        isFollowExportTag: this.isFollowExportTag,
        currentTagType: this.currentTagType,
        exNextTip: this.exNextTip,
        isDataDefaultCollapsed: this.isDataDefaultCollapsed,
        isMarkModifiedSmallBoards: this.isMarkModifiedSmallBoards,
        isSendToEzSort: this.isSendToEzSort,
        currentPaibanImgType: this.currentPaibanImgType,
        isFollowExportPaibanImg: this.isFollowExportPaibanImg,
        isFollowExportWorkerShop: this.isFollowExportWorkerShop,
      })
      if (this.isFollowExportTag) {
        buryPointFunc('下载NC顺带导出标签文件')
        if (this.isCanExportPic()) {
          buryPointFunc('顺带导出图片')
        }
        if (this.isCanExportPdf()) {
          buryPointFunc('顺带导出PDF')
        }
        // 标签选择后立即更新标签模板
        if (changeType === 'tagTemplate') {
          const res = await fetchTagTemplate({
            id: this.currentTagTempID,
            process_line_id: this.ncSetting.process_setting_id,
          })

          if (res.status) {
            this.setNcSetting({
              ...this.ncSetting,
              tag_template_id: this.currentTagTempID,
            })
          }
        }
      }
      this.setTempList(
        this.tagTempList.map((temp) => ({
          ...temp,
          is_default: temp.id == this.currentTagTempID ? 1 : 0,
        }))
      )
      this.$store.commit('setIsFollowExportTag', this.isFollowExportTag)
      if (this.isCuttingOrder) {
        buryPointApi('layout', 'show_cutting_order')
      }
      if (this.isShowPartSize) {
        buryPointApi('layout', 'show_part_size')
      }
      if (this.isUnuseSurplus) {
        buryPointApi('layout', 'un_use_surplus')
      }
      if (changeType === 'sendToEzSort' && this.isSendToEzSort) {
        buryPointApi('layout', 'sendToEzSort')
      }
      if (this.isFollowExportWorkerShop) {
        buryPointApi('layout', 'followExportWorkerShop')
      }
    },
    // 板件翻面
    async reversePlank() {
      // 复选（Ctrl 多选）选中多块小板时，翻面操作同样应用到全部选中小板
      if (this.batchActiveIdList.length) {
        return this.batchReversePlank()
      }
      if (isTextureAlignmentPlank(this.activePlank)) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          getSameGroupParts(this.activePlank, this.activeBigpart.parts)
        )
        if (!confirmed) return
      }
      if (
        this.activePlank.isUseSaw &&
        this.activePlank.path &&
        this.activePlank.path.length &&
        !judgeRectangle(this.activePlank.path[0])
      ) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang(
            '当前操作会影响板件间隙，导致加工问题，请确认是否继续？'
          ),
          getSameGroupParts(this.activePlank, this.activeBigpart.parts)
        )
        if (!confirmed) return
      }
      this.$refs[`drawpart${this.canvasKey}`][0].reverePlank()
      buryPointApi('layout', 'plate_flip')
      this.isNeedUpdateBatch = true
      this.setBatchTaggingList([])
    },
    /**
     * @description 获取复选（Ctrl 多选）选中的小板及其所在大板、画布下标
     * @returns {Array} [{ part, bigpart, canvasKey }]
     */
    getBatchActiveTargets() {
      if (!this.batchActiveIdList.length) return []
      const idSet = new Set(this.batchActiveIdList.map((id) => String(id)))
      const targets = []
      this.drawData.forEach((group, canvasKey) => {
        group.data?.forEach((bigpart) => {
          bigpart.parts?.forEach((part) => {
            if (idSet.has(String(part.partUniqueId))) {
              targets.push({ part, bigpart, canvasKey })
            }
          })
        })
      })
      return targets
    },
    /**
     * @description 判断小板当前是否为"无纹理"，取值口径与单板回显一致（优先 plankArr，其次余料板件看 texDir）
     * @param {Object} part - 小板
     * @returns {boolean}
     */
    isPartNonTexture(part) {
      const partInPlankArr = this.plankArr.find(
        (item) => item.partUniqueId === part.partUniqueId
      )
      if (partInPlankArr) return !!partInPlankArr.isNonTexture
      return part.name == '余料板件' && part.texDir == 'notcare'
    },
    /**
     * @description 判断小板当前是否开启分层切割，优先 plankArr，其次看排版数据
     * @param {Object} part - 小板
     * @returns {boolean}
     */
    isPartLayerCut(part) {
      const partInPlankArr = this.plankArr.find(
        (item) => item.partUniqueId === part.partUniqueId
      )
      if (partInPlankArr) {
        return !!partInPlankArr.curve_layered_cutting
      }
      return !!part.curve_layered_cutting
    },
    /**
     * @description 取出复选的小板中符合条件（含同对纹组）的板件，用于统一弹窗确认
     * @param {Array} targets - getBatchActiveTargets 的结果
     * @param {Function} match - 判断小板是否符合条件
     * @returns {Array} 去重后的板件数组
     */
    getBatchMatchParts(targets, match) {
      const partMap = new Map()
      targets.forEach((item) => {
        if (!match(item.part)) return
        getSameGroupParts(item.part, item.bigpart.parts).forEach((part) => {
          partMap.set(String(part.partUniqueId), part)
        })
      })
      return [...partMap.values()]
    },
    /**
     * @description 复选批量操作前获取有效的小板列表，无选中或存在锁定大板时提示并返回空数组
     * @param {string} actionName - 操作名称，用于提示文案
     * @returns {Array} [{ part, bigpart, canvasKey }]
     */
    getBatchActiveTargetsForAction(actionName) {
      const targets = this.getBatchActiveTargets()
      if (!targets.length) {
        this.$message({
          message: '请先选中板件再进行此操作!',
          type: 'info',
        })
        return []
      }
      if (targets.some((item) => item.bigpart.isLocked)) {
        this.$message.error(`选中的小板中存在被锁定的大板，无法${actionName}!`)
        return []
      }
      return targets
    },
    /**
     * @description 复选（Ctrl 多选）批量旋转小板，与单板旋转保持同样的确认和限制
     * @param {number} angle - 旋转角度，支持 90、180、270
     * @returns {Promise<void>}
     */
    async batchRotatePlank(angle = 90) {
      const targets = this.getBatchActiveTargetsForAction('旋转')
      if (!targets.length) return
      // 与单板一致：对纹板件统一确认一次
      const textureParts = this.getBatchMatchParts(
        targets,
        isTextureAlignmentPlank
      )
      if (textureParts.length) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          textureParts
        )
        if (!confirmed) return
      }
      // 与单板一致：锯切异形板件旋转后会影响板件间隙
      const sawParts = this.getBatchMatchParts(
        targets,
        (part) =>
          part.isUseSaw &&
          part.path &&
          part.path.length &&
          !judgeRectangle(part.path[0])
      )
      if (sawParts.length) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang(
            '当前操作会影响板件间隙，导致加工问题，请确认是否继续？'
          ),
          sawParts
        )
        if (!confirmed) return
      }
      // 操作记录使用旋转前的数据
      const oriList = targets.map((item) => ({
        part: item.part,
        partName: item.part.partName,
        canvasIndex: item.bigpart.canvasIndex,
        oriRectWidth: item.part.oRect?.width,
      }))
      const renderCanvasKeys = new Set()
      for (const item of targets) {
        const drawPartRef = this.$refs[`drawpart${item.canvasKey}`]?.[0]
        if (!drawPartRef) continue
        await drawPartRef.rotatePlank(angle, {
          part: item.part,
          bigpart: item.bigpart,
          skipRender: true,
        })
        renderCanvasKeys.add(item.canvasKey)
      }
      // 批量旋转后统一重绘涉及的画布
      renderCanvasKeys.forEach((canvasKey) => {
        this.$refs[`drawpart${canvasKey}`]?.[0]?.renderAll()
      })
      buryPointApi('layout', `rotate_${angle}`)
      this.isNeedUpdateBatch = true
      this.addDataToOperateArr({
        key: '旋转小板',
        dataArr: oriList.map((item) => ({
          type: 'form',
          current: {
            oRectWidth: item.part.oRect?.width,
            angle,
          }, // 当前表单数据
          ori: {
            oRectWidth: item.oriRectWidth,
            angle: 0,
          }, // 原始表单数据
          compareMsg: [
            {
              title: `${item.partName}-大板序号: ${item.canvasIndex}`,
              keys: ['oRectWidth'],
            },
            {
              title: `${item.partName}-大板序号: ${item.canvasIndex}`,
              keys: ['angle'],
            },
          ], // 要比较的内容
          formTextObj: {
            oRectWidth: '成品宽度',
            angle: '小板旋转角度',
          }, // key对应的意思
          formValueObj: {}, // value对应的意思
        })),
      })
      this.setBatchTaggingList([])
    },
    /**
     * @description 复选（Ctrl 多选）批量翻面小板，与单板翻面保持同样的确认和限制
     * @returns {Promise<void>}
     */
    async batchReversePlank() {
      const targets = this.getBatchActiveTargetsForAction('翻面')
      if (!targets.length) return
      // 与单板一致：对纹板件统一确认一次
      const textureParts = this.getBatchMatchParts(
        targets,
        isTextureAlignmentPlank
      )
      if (textureParts.length) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          textureParts
        )
        if (!confirmed) return
      }
      // 与单板一致：锯切异形板件翻面后会影响板件间隙
      const sawParts = this.getBatchMatchParts(
        targets,
        (part) =>
          part.isUseSaw &&
          part.path &&
          part.path.length &&
          !judgeRectangle(part.path[0])
      )
      if (sawParts.length) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang(
            '当前操作会影响板件间隙，导致加工问题，请确认是否继续？'
          ),
          sawParts
        )
        if (!confirmed) return
      }
      const renderCanvasKeys = new Set()
      for (const item of targets) {
        const drawPartRef = this.$refs[`drawpart${item.canvasKey}`]?.[0]
        if (!drawPartRef) continue
        await drawPartRef.reverePlank({
          part: item.part,
          bigpart: item.bigpart,
          skipRender: true,
          skipCalcFanban: true,
        })
        renderCanvasKeys.add(item.canvasKey)
      }
      // 批量翻面后统一重绘涉及的画布
      renderCanvasKeys.forEach((canvasKey) => {
        this.$refs[`drawpart${canvasKey}`]?.[0]?.renderAll()
      })
      buryPointApi('layout', 'plate_flip')
      this.isNeedUpdateBatch = true
      // 批量翻面后统一重新计算翻板数
      this.calcFanbanCount()
      this.setBatchTaggingList([])
    },
    // 选择异形嵌套
    handleSpecial() {
      // 需要判断异形嵌套是否弹出提示
      if (this.isSpecialShape && this.ncSetting?.process_setting_id) {
        const lineId = this.ncSetting.process_setting_id
        const currentLine = this.proLineList.find((item) => item.id === lineId)
        if (currentLine) {
          try {
            if (
              currentLine.data.dock56FDrill &&
              !currentLine.data.hole_slot_engraving_process
                .engraving_process_setting.non_hole_slot_of_special_shape &&
              currentLine.data.ncHoleSlot !== 'doubleHoleSlot'
            ) {
              this.currentSpecailType = 'special'
              this.isShowSpecialAndFiveSix = true
              this.currentLineId = lineId
              return
            }
          } catch (error) {
            console.log('检测异形嵌套且开启五六面钻设置失败', error)
          }
        }
      }
      this.handleChangePaibanWay('specialShape')
    },

    // 上一块板件
    handlePresiousPlank() {
      if (this.searchPlankList.length) {
        if (this.searchPlankIndex - 1 >= 0) {
          this.searchPlankIndex -= 1
        } else {
          this.searchPlankIndex = this.searchPlankList.length - 1
        }
        this.activePlankID = this.searchPlankList[this.searchPlankIndex].plankID
        this.activePlankIndex =
          this.searchPlankList[this.searchPlankIndex].index
        this.setActivePlank(this.searchPlankIndex)
      } else {
        const preIndex =
          this.plankArr.findIndex(
            (plank) =>
              plank.plankID === this.activePlank.plankID &&
              plank.index === this.activePlank.index
          ) - 1
        if (preIndex >= 0) {
          this.activePlankID = this.plankArr[preIndex].plankID
          this.activePlankIndex = this.plankArr[preIndex].index
        }
      }
    },
    // 下一块板件
    handleNextPlank() {
      if (this.searchPlankList.length) {
        if (this.searchPlankIndex + 1 < this.searchPlankList.length) {
          this.searchPlankIndex += 1
        } else {
          this.searchPlankIndex = 0
        }
        this.activePlankID = this.searchPlankList[this.searchPlankIndex].plankID
        this.activePlankIndex =
          this.searchPlankList[this.searchPlankIndex].index
        this.setActivePlank(this.searchPlankIndex)
      } else {
        const nextIndex =
          this.plankArr.findIndex(
            (plank) =>
              plank.plankID === this.activePlank.plankID &&
              plank.index === this.activePlank.index
          ) + 1
        if (nextIndex < this.plankArr.length) {
          this.activePlankID = this.plankArr[nextIndex].plankID
          this.activePlankIndex = this.plankArr[nextIndex].index
        }
      }
    },

    /**
     * 切换大板
     * @param bigPlank 大板数据 实际需要的是大板的stockKey
     */
    selectActivePlank(bigPlank) {
      const { stockKey = '' } = bigPlank
      for (let i = 0; i < this.drawData.length; i++) {
        const drawDataItem = this.drawData[i]
        for (let j = 0; j < drawDataItem.data.length; j++) {
          if (drawDataItem.data[j].stockKey === stockKey) {
            this.activeBigpart = bigPlank
            this.$refs[`drawpart${i}`][0].setNewActiveBigpart(bigPlank)
            this.scrollToCanvasHeight(i)
          }
        }
      }
    },
    // 关闭AI排版的提示框
    handleCloseAITip() {
      this.showAITipDialog = false
    },
    // 显示精细排版
    gotoSubtle(data) {
      buryPointApi('layout', 'goto_subtle')
      this.showSubtle = true
      this.dealJinxiEnterPath()
      this.isShowDepthTip = false
      this.subtleData = data
      this.$set(this.subtleData, 'zoomNum', 1)
      // 关闭冲突弹窗
      this.isShowConflictDiagram = false
      // 关闭冲突板件弹窗
      this.$nextTick(() => {
        this.showConflictPartDetail = false
      })
    },
    // 关闭使用余料弹窗
    closeSurplusDialog() {
      this.surplusList = []
      this.showSurplusDialog = false
    },
    // 前往余料仓
    gotoSurplusStorage() {
      this.$router.push({
        path: '/supplusStorage',
        query: {
          addNew: 1,
        },
      })
    },
    // 显示余料匹配项
    useSurplus(data, canvasKey) {
      this.showSurplusDialog = true
      this.activeBigpart = data
      this.canvasKey = canvasKey
      // 找到所有板件中最大的横坐标和纵坐标
      let minX = 999999
      let minY = 999999
      let maxX = 0
      let maxY = 0
      const allParts = data.parts.filter((p) => !p.blueAreaSurplus)
      for (let i = 0; i < allParts.length; ++i) {
        let plank = allParts[i]
        let top = plank.startY
        let left = plank.startX
        let right = plank.startX + plank.rect.width
        let bottom = plank.startY + plank.rect.height
        if (right > maxX) {
          maxX = right
        }
        if (bottom > maxY) {
          maxY = bottom
        }
        if (left < minX) {
          minX = left
        }
        if (top < minY) {
          minY = top
        }
      }
      // 如果是xy互换情况下, 则需要将用于匹配的数据进行互换
      // 拿到当前
      // const diameter = this.ncSetting.knife.diameter
      const sawToLayout =
        this.ncSetting.sawSetting.mentaoji_enable &&
        this.ncSetting.sawSetting.sawToLayout &&
        this.ncSetting.sawSetting.processType === 'weldingPlank' &&
        isSawPaiban(store)
      const sawCutOnlyWeld =
        this.$store.state.ncSetting.sawSetting.sawCutOnlyWeld &&
        this.$store.state.ncSetting.sawSetting.processType === 'weldingPlank'
      const [texture, matCode, thick] = this.activeBigpart.stockKey.split(':')
      const stockKey = `${texture}:${matCode}:${thick}`
      const cutKnife = getPlateKnifeDiameter(stockKey, this.ncSetting)
      let useKnife = cutKnife
      if (
        sawToLayout &&
        ((sawCutOnlyWeld && this.activeBigpart.isWeldingPlank) ||
          !sawCutOnlyWeld)
      ) {
        useKnife = getSawKnife(this.ncSetting)
      } else {
        useKnife = cutKnife
      }

      if (this.ncSetting.xyReverse) {
        this.maxSurplusHeight = maxX - minX - useKnife
        this.maxSurplusWidth = maxY - minY - useKnife
        this.minSurplusX = maxY
        this.maxSurplusY = minX
      } else {
        this.maxSurplusWidth = maxX - minX - useKnife
        this.maxSurplusHeight = maxY - minY - useKnife
        this.minSurplusX = minX
        this.maxSurplusY = maxY
      }

      this.getSurplusList()
    },
    // 确定使用余料
    confirmUseSurplus() {
      buryPointApi('layout', 'use_surplus')
      const { color, type, thick } = this.selectedSurplus
      const stockKey = `${color}:${type}:${thick}`
      this.setSurplusParams({
        [stockKey]: [this.selectedSurplus],
      })
      this.$nextTick(() => {
        this.selectedSurplus.isUseSaw = this.activeBigpart.isUseSaw
        this.selectedSurplus.isWeldingPlank = this.activeBigpart.isWeldingPlank
        this.$refs[`drawpart${this.canvasKey}`][0].changeBigpart(
          this.selectedSurplus,
          this.minSurplusX,
          this.maxSurplusY
        )
        this.activeBigpart.parts = this.activeBigpart.parts.filter(
          (p) => !p.blueAreaSurplus
        )
        if (
          this.ncSetting.sawSetting.firstCutSurplus &&
          this.ncSetting.sawSetting.surplusStoreAndLabeling &&
          this.selectedPaibanWay == 'paiban' &&
          this.ncSetting.sawSetting.mentaoji_enable &&
          this.ncSetting.sawSetting.processType === 'weldingPlank'
        ) {
          cutBlueSurplus(this.drawData)
        }
      })
      if (this.$store.state.preferencesSetting.setting.surplus_lock) {
        // 锁定使用的余料
        const lockParams = {
          surplus: this.surplusList
            .filter((item) => item.id == this.selectedSurplus.id)
            .map((item) => ({
              ...item,
              lock_status: 1,
              lock_num: 1,
              lock_order: this.orderInfo?.order_address?.replace(
                /\(.*?\)|历史记录/g,
                ''
              ),
            })),
          release_all: false,
        }
        surplusLock(lockParams)
      }
    },
    // 搜索余料
    searchSurplusList() {
      this.surplusList = []
      this.surplusPage = 1
      this.getSurplusList()
    },
    // 获取匹配的余料数据
    getSurplusList() {
      const matCodes = getSurplusMatchTypes(
        isHighBigPlank(this.activeBigpart),
        restoreOriginalMatcode(this.activeBigpart.matCode)
      )
      let params = {
        page: this.surplusPage,
        limit: 10,
        shape: 0,
        match_list: matCodes.map((matCode) => ({
          thick: Number(this.activeBigpart.thick),
          type: matCode,
          color: this.activeBigpart.texture,
          width: this.maxSurplusWidth,
          long: this.maxSurplusHeight,
          color_id: isBrandBigPlank(this.activeBigpart)
            ? Number(this.activeBigpart.colorId) || null
            : null,
        })),
      }
      if (this.surplusKeyword) {
        params.search_type = this.searchType
        params.search_value = this.surplusKeyword
      }
      this.$token('/search_surplus_depot', params, (res) => {
        if (res.status == 1) {
          if (res.data.data.length == 0 && this.surplusPage > 1) {
            this.surplusPage--
          }
          for (let i = 0; i < res.data.data.length; ++i) {
            res.data.data[i].isSelected = false
          }
          if (res.data.data.length > 0) {
            this.surplusList = [...this.surplusList, ...res.data.data]
            // 开启余料锁定 使用余料值展示未锁定
            if (this.$store.state.preferencesSetting.setting.surplus_lock) {
              this.surplusList = this.surplusList.filter(
                (item) => item.lock_status == 0
              )
            }
          } else {
            this.$message({
              type: 'info',
              message: translate('arrangedPage.noSurplus'),
            })
          }
        }
      })
    },
    // 滚动获取更多余料
    scrollSurplusList(e) {
      let scrollHeight = this.$refs.surplusList.scrollHeight
      let scrollTop = this.$refs.surplusList.scrollTop
      let clientHeight = this.$refs.surplusList.clientHeight
      if (scrollHeight - scrollTop == clientHeight) {
        this.surplusPage++
        this.getSurplusList()
      }
    },
    // 选中匹配到的余料
    changeselectedSurplus(item) {
      for (let i = 0; i < this.surplusList.length; ++i) {
        this.surplusList[i].isSelected = false
      }
      item.isSelected = true
      this.$forceUpdate()
    },
    // 添加大板
    addNewBigpart(bigpart, canvasKey) {
      buryPointApi('layout', 'add_bigpart')
      let addIndex = 0
      let stockNum = 0
      // 找出现在所有大板中的最大的stockNum, 作为下一和新的大板的stockNum
      // 需要寻找所有的大板，因为在出现特殊大板和普通大板颜色材质厚度相同时会分开排，如果添加大板重新计算切割顺序会有误
      const {
        matCode,
        texture,
        thick,
        allColors,
        oriTextures,
        stockKeys,
        oriBigTexture,
        highlight,
      } = bigpart
      this.drawData.forEach((series) => {
        series.data.forEach((item, idx) => {
          if (
            item.matCode === matCode &&
            item.texture === texture &&
            item.thick === thick
          ) {
            stockNum = Math.max(stockNum, item.stockNum)
          }
          if (item.stockKey === bigpart.stockKey) {
            addIndex = idx
          }
        })
      })
      stockNum += 1
      let plankWidth = 0
      let plankHeight = 0
      let isOtherPlate = false
      let textureTemp = texture
      let oriBigTextureTemp = texture
      if (bigpart.otherPlate && Object.keys(bigpart.otherPlate).length > 0) {
        plankWidth = bigpart.otherPlate.width
        plankHeight = bigpart.otherPlate.height
        if (this.ncSetting.xyReverse) {
          plankWidth = bigpart.otherPlate.height
          plankHeight = bigpart.otherPlate.width
        }
        // 特殊大版使用它自身的颜色
        oriBigTextureTemp = oriBigTexture
        isOtherPlate = true
      } else {
        plankWidth = this.ncSetting.drawPlankWidth
        plankHeight = this.ncSetting.drawPlankHeight
      }
      const obj = addNewBigPlank({
        ableToggle: false,
        matCode: bigpart.matCode,
        parts: [],
        plankWidth: plankWidth,
        plankHeight: plankHeight,
        sideType: 1,
        stockKey:
          `${bigpart.texture}:${bigpart.matCode}:${bigpart.thick}:` + stockNum,
        stockNum: stockNum,
        surplusInfo: isOtherPlate ? bigpart.surplusInfo : null,
        texture: textureTemp,
        thick: bigpart.thick,
        usedRate: 0,
        usedArea: 0,
        otherPlate: isOtherPlate ? bigpart.otherPlate : null,
        isWeldingPlank: bigpart.isWeldingPlank,
        isUseSaw: bigpart.isUseSaw,
        highlight,
        margin:
          bigpart.surplusInfo && !bigpart.surplusInfo.isNotSurplus
            ? this.ncSetting.panelSize.plankEdgeOff
            : bigpart.margin,
        standardPlankId: bigpart.standardPlankId,
        oriTextures,
        allColors,
        stockKeys,
        oriBigTexture: oriBigTextureTemp,
        brandName: bigpart.brandName || '',
        supplierName: bigpart.supplierName || '',
        colorId: bigpart.colorId || '',
      })
      this.drawData[canvasKey].data.splice(addIndex + 1, 0, obj)
      this.drawData[canvasKey].counts += 1
      this.totalBigpartCounts += 1

      for (let i = 0; i < this.drawData[canvasKey].data.length; ++i) {
        this.drawData[canvasKey].data[i].canvasIndex = i + 1
      }

      const oriPaibanData = JSON.parse(JSON.stringify(this.paibanData))
      let paibanArr = []
      for (let i = 0; i < this.drawData.length; ++i) {
        paibanArr = [...paibanArr, ...this.drawData[i].data]
      }
      this.setPaibanData(paibanArr)
      // TODO 考虑是否进行数据的重新处理  WC
      this.dealAllDrawData()
      if (this.isUnuseSurplus) {
        this.oriPlankLen = this.paibanData.filter(
          (e) => e.parts.length > 0 && !e.parts.every((e) => e.surplusPath)
        ).length
      } else {
        this.oriPlankLen = this.paibanData.filter(
          (e) => e.parts.length > 0
        ).length
      }
      this.$refs[`drawpart${canvasKey}`][0].dealNewBigpart()
      this.addDataToOperateArr({
        key: `大板${bigpart.canvasIndex}-添加大板${
          this.paibanData[this.paibanData.length - 1].canvasIndex
        }`,
        dataArr: [
          {
            type: 'form',
            current: {
              bigpartNum: this.paibanData.length,
            }, // 当前表单数据
            ori: {
              bigpartNum: oriPaibanData.length,
            }, // 原始表单数据
            compareMsg: [
              {
                title: '',
                keys: ['bigpartNum'],
              },
            ], // 要比较的内容
            formTextObj: {
              bigpartNum: '大板数量',
            }, // key对应的意思
            formValueObj: {}, // value对应的意思
          },
        ],
      })
      this.onPartChange('add', { partType: 'bigPlank', data: obj })
    },
    /**
     * @description 复制大板时的条码处理方式
     * unique：板件条码唯一，重新生成全新条码
     * pack：板件条码唯一(打包专用)，在原始条码后追加序号
     * 兼容预排版 barCodeSetting.uniqueBarCode，以及 ncSetting 上的平铺字段
     * 打包专用优先，与排版去重 uniquePlankNum 的分支一致
     */
    getUniqueBarCodeCopyMode() {
      const { uniqueBarCode, uniqueBarCodeForPack, barCodeSetting } =
        this.ncSetting ?? {}
      const isUniqueBarCode = barCodeSetting
        ? barCodeSetting.uniqueBarCode
        : uniqueBarCode
      if (uniqueBarCodeForPack) return 'pack'
      if (isUniqueBarCode) return 'unique'
      return ''
    },
    /**
     * @description 获取打包专用条码的原始条码前缀
     * 优先 _plankNum(排版时记录的原始条码)，历史数据可能没有该字段，
     * 依次回退到 oriPlankNum、plankNum，避免拼接出 undefined 开头的条码
     */
    getPackPlankNumBase(part) {
      const candidates = [part?._plankNum, part?.oriPlankNum, part?.plankNum]
      for (const item of candidates) {
        if (item === undefined || item === null) continue
        const base = String(item).trim()
        if (base) return base
      }
      return ''
    },
    /**
     * @description 统计每个原始条码已经用过的最大打包序号，以及当前已占用的条码
     * 打包专用条码是 `${原始条码}${序号}`，第一张不带序号，从第二张开始序号为 1
     */
    collectPackPlankNumSuffix() {
      const suffixMap = {}
      const usedPlankNums = new Set()
      this.drawData.forEach((series) => {
        series.data.forEach((bigpart) => {
          bigpart.parts?.forEach((part) => {
            const plankNum = String(part.plankNum ?? '')
            if (plankNum) usedPlankNums.add(plankNum)
            const oriPlankNum = String(part.oriPlankNum ?? '')
            if (oriPlankNum) usedPlankNums.add(oriPlankNum)
            const base = this.getPackPlankNumBase(part)
            if (!base) return
            let suffix = 0
            if (plankNum.startsWith(base) && plankNum.length > base.length) {
              const rest = plankNum.slice(base.length)
              if (/^\d+$/.test(rest)) suffix = Number(rest)
            }
            suffixMap[base] = Math.max(suffixMap[base] ?? 0, suffix)
          })
        })
      })
      return { suffixMap, usedPlankNums }
    },
    /**
     * @description 复制大板：在当前大板后面插入 count 张排版完全相同的大板，并同步 paibanData
     * @param bigpart 被复制的大板
     * @param count 复制数量(正整数)
     * @param canvasKey 当前大板所在的绘制分类下标
     */
    copyBigpart(bigpart, count, canvasKey) {
      const copyCount = Number(count)
      if (!bigpart || !Number.isInteger(copyCount) || copyCount < 1) {
        return this.$message.warning(
          this.$translateLang('复制大板数量只能输入正整数')
        )
      }
      const { matCode, texture, thick } = bigpart
      // 复制的大板插入到当前大板后面(此处下标为当前分类下的下标)
      let addIndex = 0
      // 记录被复制大板的大板序号，用于操作记录
      const sourceCanvasIndex = bigpart.canvasIndex
      // 同一材质颜色厚度下需要保证 stockNum 唯一，否则 stockKey 会重复
      let stockNum = bigpart.stockNum ?? 0
      this.drawData.forEach((series) => {
        series.data.forEach((item, idx) => {
          if (
            item.matCode === matCode &&
            item.texture === texture &&
            item.thick === thick
          ) {
            stockNum = Math.max(stockNum, item.stockNum ?? 0)
          }
          if (item.stockKey === bigpart.stockKey) {
            addIndex = idx
          }
        })
      })
      // 板件条码唯一：复制板重新生成条码；打包专用：在原始条码后追加序号
      const barCodeMode = this.getUniqueBarCodeCopyMode()
      const packInfo =
        barCodeMode === 'pack' ? this.collectPackPlankNumSuffix() : null
      const copyBoards = []
      for (let i = 0; i < copyCount; ++i) {
        stockNum += 1
        const newBigpart = JSON.parse(JSON.stringify(bigpart))
        newBigpart.stockNum = stockNum
        newBigpart.stockKey = `${texture}:${matCode}:${thick}:${stockNum}`
        // 复制出来的大板是独立数据，需要新的唯一ID，且不继承复用关系与锁定状态
        newBigpart.bigPlankUniqueId = nanoid()
        newBigpart.isActive = false
        newBigpart.isLocked = false
        delete newBigpart._isReused
        delete newBigpart._reuseParentId
        // 复制出来的每块小板都加上复制的标识字段
        // 注意：板件的唯一ID保持和被复制板件一致，复制板件依然指向同一块拆单板件
        newBigpart.parts.forEach((part) => {
          part._isCopy = true
          part.hasSaved = false
          part.partUniqueId = nanoid()
          // 如果是余料小板，直接重新生成条码
          const isSurplusPart = part.surplusPath && part.surplusPath.length
          // 未开启条码唯一时，复制板沿用原条码
          if (barCodeMode === 'unique' || isSurplusPart) {
            const plankNum = uniquePlankNum.createUniquePlankNum()
            part.plankNum = plankNum
            part.oriPlankNum = plankNum
            part._plankNum = plankNum
          } else if (barCodeMode === 'pack') {
            const base = this.getPackPlankNumBase(part)
            let plankNum = ''
            if (base) {
              let nextSuffix = (packInfo.suffixMap[base] ?? 0) + 1
              plankNum = `${base}${nextSuffix}`
              // 兜底：与已有条码撞号时继续累加序号，保证条码唯一
              while (packInfo.usedPlankNums.has(plankNum)) {
                nextSuffix += 1
                plankNum = `${base}${nextSuffix}`
              }
              packInfo.suffixMap[base] = nextSuffix
              packInfo.usedPlankNums.add(plankNum)
              // 复制板记录原始条码，后续再次复制时继续以它为前缀追加序号
              part._plankNum = base
            } else {
              // 极端情况：板件没有任何条码信息，重新生成一条唯一条码
              plankNum = uniquePlankNum.createUniquePlankNum()
              part._plankNum = plankNum
            }
            part.plankNum = plankNum
            part.oriPlankNum = plankNum
          }
        })
        // 将大板的 stockNum/stockKey 同步到所有小板
        checkPlankDataIsCorrect(newBigpart)
        copyBoards.push(newBigpart)
      }
      this.drawData[canvasKey].data.splice(addIndex + 1, 0, ...copyBoards)
      this.drawData[canvasKey].counts += copyCount
      this.totalBigpartCounts += copyCount
      const oriPaibanData = JSON.parse(JSON.stringify(this.paibanData))
      let paibanArr = []
      for (let i = 0; i < this.drawData.length; ++i) {
        paibanArr = [...paibanArr, ...this.drawData[i].data]
      }
      // 同步 paibanData
      this.setPaibanData(paibanArr)
      this.dealAllDrawData()
      // 重新计算大板序号
      this.handleBigPartIndex(this.currentPape, this.countPerPage)
      if (this.isUnuseSurplus) {
        this.oriPlankLen = this.paibanData.filter(
          (e) => e.parts.length > 0 && !e.parts.every((e) => e.surplusPath)
        ).length
      } else {
        this.oriPlankLen = this.paibanData.filter(
          (e) => e.parts.length > 0
        ).length
      }
      // 大板数量变化后需要重新绘制画布(包含分页与大板序号)
      this.renderAll()
      buryPointApi('layout', 'bigPlankCopy')
      this.addDataToOperateArr({
        key: `复制大板${sourceCanvasIndex}`,
        dataArr: [
          {
            type: 'form',
            current: {
              bigpartNum: this.paibanData.length,
              copyCount,
            }, // 当前表单数据
            ori: {
              bigpartNum: oriPaibanData.length,
              copyCount: 0,
            }, // 原始表单数据
            compareMsg: [
              {
                title: '',
                keys: ['bigpartNum', 'copyCount'],
              },
            ], // 要比较的内容
            formTextObj: {
              bigpartNum: '大板数量',
              copyCount: '复制数量',
            }, // key对应的意思
            formValueObj: {}, // value对应的意思
          },
        ],
      })
      this.onPartChange('add', { partType: 'bigPlank', data: copyBoards[0] })
      // 更新余料入库相关状态
      this.setHasSavedSurplus()
    },
    /**
     * @description 删除大板
     * @params flag 是否是当前分类下的最后一块大板
     */
    async deleteBigpart(bigpart, canvasKey, preLayoutData, flag) {
      // 如果是最后一块空大板
      const matchKey = `${bigpart.texture}:${bigpart.matCode}:${bigpart.thick}`
      let emptyFlag = false
      if (flag) {
        // 找到drawData里面能匹配上matchKey的大板，超过一张不需要再走后续的逻辑
        const count = this.drawData.reduce((acc, plank) => {
          return matchKey === `${plank.texture}:${plank.matCode}:${plank.thick}`
            ? acc + 1
            : acc
        }, 0)
        if (count <= 1) {
          // TODO: 查找待排版库-未入库中是否有能匹配的小板
          const localPlankStore =
            this.$store.state.awaitPaibanStore.localPlankStore
          const hasMatchPart = localPlankStore.find((item) => {
            return matchKey === `${item.color}:${item.matCode}:${item.thick}`
          })
          if (hasMatchPart) {
            emptyFlag = true
          }
        }
      }
      if (bigpart.parts?.some((p) => isTextureAlignmentPlank(p))) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          bigpart.parts.filter((p) => isTextureAlignmentPlank(p))
        )
        if (!confirmed) return
      }
      this.$confirm(
        bigpart && bigpart.parts.length > 0
          ? translate('common.confirmDeleteTip')
          : emptyFlag
          ? translate('common.confirmSureDeleteTip')
          : translate('common.deleteEmptyTip'),
        emptyFlag
          ? translate('common.importantTip')
          : translate('common.warmTip'),
        {
          confirmButtonText: translate('common.confirm'),
          cancelButtonText: translate('common.cancel'),
          customClass: 'customConfirm',
          type: 'warning',
        }
      )
        .then(async () => {
          // 拿到当前大板的所有数据
          if (bigpart && bigpart.parts.length > 0) {
            // 删除整张大板时，只有普通待排版库板件才回收到待排版库，补件不回收。
            bigpart.parts.forEach(async (item) => {
              if (item?._isBujian) return
              const imgUrl = getPlankImage(item, false, {
                defaultScale,
                scale: 3,
                plankLineWidth: 1,
              })
              const data = await genAwaitStoreData(item, preLayoutData, imgUrl)
              this.$store.commit('awaitPaibanStore/setPlankToStore', data)
            })
          }
          bigpart.parts = []
          // 获取到没有排序前的大板标题信息(用来和排序后的对比减少不必要更新)
          const noShortPlankList = [...this.drawData].map((item) => item.title)
          for (let i = 0; i < this.drawData[canvasKey].data.length; ++i) {
            let _bigpart = this.drawData[canvasKey].data[i]
            if (_bigpart.stockKey === bigpart.stockKey) {
              // 如果删除的是余料大板, 则去掉记录的使用的余料大板参数
              try {
                if (
                  _bigpart.surplusInfo &&
                  Object.keys(_bigpart.surplusInfo).length > 0 &&
                  !_bigpart.surplusInfo.isNotSurplus
                ) {
                  this.deleteSurplusParams({
                    title: `${_bigpart.texture}:${_bigpart.matCode}:${_bigpart.thick}`,
                    ggid: _bigpart.surplusInfo.ggid,
                    id: _bigpart.surplusInfo.id,
                  })
                  if (
                    this.$store.state.preferencesSetting.setting.surplus_lock
                  ) {
                    this.delSurplusId.push(_bigpart.surplusInfo.id)
                    const surRes = await getSurplusList({ page: 1, limit: 999 })
                    const allSurplusList = surRes.status ? surRes.data.data : []
                    // 解锁删除的余料大板
                    const lockParams = {
                      surplus: allSurplusList
                        .filter((item) => item.id == _bigpart.surplusInfo.id)
                        .map((item) => ({
                          ...item,
                          lock_status: 0,
                          lock_num: 1,
                        })),
                      release_all: false,
                    }
                    await surplusLock(lockParams)
                  }
                }
              } catch (error) {
                console.error(error)
              }
              this.drawData[canvasKey].data.splice(i, 1)
              break
            }
          }
          for (let i = 0; i < this.drawData[canvasKey].data.length; ++i) {
            this.drawData[canvasKey].data[i].canvasIndex = i + 1
          }

          this.drawData[canvasKey].counts -= 1
          this.totalBigpartCounts -= 1

          const oriPaibanData = JSON.parse(JSON.stringify(this.paibanData))
          let paibanArr = []
          for (let i = 0; i < this.drawData.length; ++i) {
            paibanArr = [...paibanArr, ...this.drawData[i].data]
          }
          this.setPaibanData(paibanArr)
          this.dealAllDrawData()
          if (this.isUnuseSurplus) {
            this.oriPlankLen = this.paibanData.filter(
              (e) => e.parts.length > 0 && !e.parts.every((e) => e.surplusPath)
            ).length
          } else {
            this.oriPlankLen = this.paibanData.filter(
              (e) => e.parts.length > 0
            ).length
          }
          this.$refs[`drawpart${canvasKey}`][0].dealDeleteBigpart()
          // 这个地方有问题，只考虑到更新当前canvasKey的位置的板件，但是没考虑单面板排序位置会换了，互换位置的板件还是以前的排列
          this.$refs[`drawpart${canvasKey}`][0].startDraw()
          this.finalDrawData.forEach((item, index) => {
            // 加判断的目的是为了减少不必要的更新
            if (item.title !== noShortPlankList[index]) {
              this.$refs[`drawpart${index}`][0].startDraw()
            }
          })
          this.addDataToOperateArr({
            key: `删除大板${bigpart.canvasIndex}`,
            dataArr: [
              {
                type: 'form',
                current: {
                  bigpartNum: this.paibanData.length,
                }, // 当前表单数据
                ori: {
                  bigpartNum: oriPaibanData.length,
                }, // 原始表单数据
                compareMsg: [
                  {
                    title: '',
                    keys: ['bigpartNum'],
                  },
                ], // 要比较的内容
                formTextObj: {
                  bigpartNum: '大板数量',
                }, // key对应的意思
                formValueObj: {}, // value对应的意思
              },
            ],
          })
          this.onPartChange('delete', { partType: 'bigPlank', data: bigpart })
          buryPointApi('layout', 'del_bigpart')
        })
        .catch((e) => {
          console.error(e)
        })
    },
    // 保存精细排版方案
    savePlan() {
      if (this.isUnuseSurplus) {
        this.oriPlankLen = this.paibanData.filter(
          (e) => e.parts.length > 0 && !e.parts.every((e) => e.surplusPath)
        ).length
      } else {
        this.oriPlankLen = this.paibanData.filter(
          (e) => e.parts.length > 0
        ).length
      }
      this.setHasSavedSurplus()
      this.onPartChange('update', {
        partType: 'bigPlank',
        data: this.paibanData,
      })
      this.renderAll()
    },
    // 在精细排版中更新排版数据
    updatePaibanData() {
      if (this.isUnuseSurplus) {
        this.oriPlankLen = this.paibanData.filter(
          (e) => e.parts.length > 0 && !e.parts.every((e) => e.surplusPath)
        ).length
      } else {
        this.oriPlankLen = this.paibanData.filter(
          (e) => e.parts.length > 0
        ).length
      }
      this.renderAll()
    },
    // 记录精细排版旋转小板 体验优化
    handleRecordRotatePlank(data) {
      this.addDataToOperateArr(data)
    },
    handleRecordChangeCutOrigin(data) {
      this.addDataToOperateArr(data)
    },
    handleRecordUpdatePriority(data) {
      this.addDataToOperateArr(data)
    },
    handleRecordDeletePlank(data) {
      this.addDataToOperateArr(data)
    },
    /** 添加一份操作记录数据到operateArr中，但数据冻结不允许添加响应式 */
    addDataToOperateArr(data) {
      this.operateArr.push(Object.freeze(data))
    },
    // 处理移动时有冲突板件
    handleConflictPart(part) {
      this.conflictPart = part
      this.isExistsActivePlank = !!this.getAllActive().filter((it) => it).length
    },

    // 返回开料清单
    goBackMaterial() {
      this.$router.push('/materialList')
    },
    // 更新当前方案优化率
    // updateAlignedRate(obj) {
    //   const specialId = this.$store.state.paibanStore?.currentUsingSpecialId
    //   const alignedPlanResult =
    //     this.$store.state.paibanStore?.alreadyDealDrawData.get(specialId)
    //   if (alignedPlanResult) {
    //     alignedPlanResult.paibanExtraInfo = obj
    //   }
    // },
    // 将所有排版数据中, 按照特殊板材和正常板材分开进行处理
    dealAllDrawData(isClear = false) {
      if (isClear) {
        this.$store.commit('addLockedPlankInAll')
      }
      let paibanArr = this.paibanData
      // 记录大板张数
      if (this.isUnuseSurplus) {
        this.oriPlankLen = paibanArr.filter(
          (e) =>
            e.parts.length > 0 &&
            !e.parts.every((e) => e.surplusPath) &&
            !e.parts.some((e) => e.isDesMaterialNoCut)
        ).length
      } else {
        this.oriPlankLen = paibanArr.filter(
          (e) =>
            e.parts.length > 0 && !e.parts.some((e) => e.isDesMaterialNoCut)
        ).length
      }

      // 记录大板的数量和翻板次数
      this.totalBigpartCounts = 0
      this.totalBigpartFanban = 0
      let {
        data: drawData,
        totalUsedArea,
        totalUsedRate,
      } = genFinalDataOrder(
        paibanArr,
        this.ncSetting,
        {
          isSurplusNoRoll: this.isUnuseSurplus,
          isSortByPlankCountDesc:
            this.$store.state.preferencesSetting.setting.isSortByPlankCountDesc,
        },
        false,
        {
          beforeTitleSorts: this.beforeTitleSorts,
        }
      )
      for (const item of drawData) {
        if (this.isUnuseSurplus) {
          item.usedRate /= item.data.filter(
            (e) => e.parts.length > 0 && !e.parts.every((e) => e.surplusPath)
          ).length
        } else {
          item.usedRate /= item.data.filter((e) => e.parts.length > 0).length
        }
      }
      // 记录顺序便于之后重新将 drawdata 数据排序 目前此排序是最后一道排序
      this.setBeforeTitleSorts(genBeforeTitleSorts(drawData))
      this.totalUsedRate = totalUsedRate / this.oriPlankLen
      this.totalUsedArea = totalUsedArea
      this.processInitDrawData(drawData)
      this.setPaibanExtraInfo({
        total_used_rate: this.totalUsedRate,
        total_used_area: this.totalUsedArea,
        total_fanban: this.totalBigpartFanban,
        total_big_planks: this.totalBigpartCounts,
      })
      this.onPartChange('update', { partType: 'bigPlank' })
    },
    /** @description 处理部分数据在drawData 排序发生改变时的初始化(就是将 dealAllDrawData 部分处理抽离成单独函数) */
    processInitDrawData(drawData) {
      this.totalBigpartCounts = 0
      this.totalBigpartFanban = 0
      let newPaibanArr = []
      // 记录使用到的大板类型
      let bigPlankList = []
      for (let i = 0; i < drawData.length; ++i) {
        // 记录一个订单和房间的映射列表
        let orderIdToRoomMap = new Map()
        drawData[i].data.forEach((i) => {
          i.parts.forEach((part) => {
            if (!orderIdToRoomMap.has(part.orderId)) {
              orderIdToRoomMap.set(part.orderId, new Set())
            }
            orderIdToRoomMap.get(part.orderId).add(part.roomID)
          })
        })
        // 将映射转换为所需的结构
        let result = []
        orderIdToRoomMap.forEach((roomSet, orderId) => {
          result.push({ roomID: Array.from(roomSet), orderId: orderId })
        })
        // 合并具有相同 orderId 的对象
        let finalResult = []
        result.forEach((group) => {
          let existingGroup = finalResult.find(
            (item) => item.orderId === group.orderId
          )
          if (existingGroup) {
            existingGroup.roomID.push(...group.roomID)
            existingGroup.roomID = Array.from(new Set(existingGroup.roomID)) // 去重
          } else {
            finalResult.push(group)
          }
        })
        if (!drawData[i].isDesMaterialNoCut) {
          this.totalBigpartCounts += drawData[i].counts
          this.totalBigpartFanban += drawData[i].fanbanCount
        }
        newPaibanArr = [...newPaibanArr, ...drawData[i].data]
        if (drawData[i].otherPlate) {
          bigPlankList.push({
            plankInOrderRoom: finalResult,
            matCode: drawData[i].matCode,
            thick: drawData[i].thick,
            texture: drawData[i].texture,
            num: drawData[i].data.length,
            plankSize: `${drawData[i].otherPlate.height}*${drawData[i].otherPlate.width}`,
            otherPlankFlag: drawData[i].isManual ? 1 : 0,
            doorPlankFlag: drawData[i].hasDoor ? 1 : 0,
            toggleCount: drawData[i].data.filter((e) => e.ableToggle).length,
            type: drawData[i].type,
            is_des_material_no_cut: !!drawData[i].isDesMaterialNoCut,
            isSpecialBigPlank: 1,
          })
        } else {
          const size = drawData[i].plankHeight
            ? `${drawData[i].plankHeight}*${drawData[i].plankWidth}`
            : `${drawData[i].data[0].plankHeight}*${drawData[i].data[0].plankWidth}`
          bigPlankList.push({
            plankInOrderRoom: finalResult,
            matCode: drawData[i].matCode,
            thick: drawData[i].thick,
            texture: drawData[i].texture,
            num: drawData[i].data.length,
            toggleCount: drawData[i].data.filter((e) => e.ableToggle).length,
            plankSize: size,
            otherPlankFlag: drawData[i].isManual ? 1 : 0,
            doorPlankFlag: drawData[i].hasDoor ? 1 : 0,
            type: drawData[i].type,
            is_des_material_no_cut: !!drawData[i].isDesMaterialNoCut,
          })
        }
      }
      this.setBigPartsInfo(bigPlankList)
      this.setPaibanData(newPaibanArr)
      this.setFinalDrawData(drawData)

      this.drawData = this.finalDrawData
      // 给所有板件数据添加是否锁定字段
      this.drawData.forEach((item) => {
        item.data.forEach((subItem) => {
          if (!subItem.isLocked) {
            subItem.isLocked = subItem.isActive = false
          }
          // 无标示
          subItem.parts.forEach((part) => {
            part.oriPlankNumNoMark = JSON.parse(JSON.stringify(part.plankNum))
          })
        })
      })
      // 记录一个用于查询的数组，查询板件的纹理状态 (2025-07-09 修改: 只使用部分数据，减少内存占用，如果需要新的值需要自行添加，如果过多建议独立成函数)
      this.setPlankArr(
        this.paibanData
          .map((e) => e.parts)
          .flat(1)
          .map((e) => ({
            isNonTexture: e.texDir === 'notcare',
            partUniqueId: e.partUniqueId,
            curve_layered_cutting: e.curve_layered_cutting,
            curve_layered_cutting_deep: e.curve_layered_cutting_deep,
            plankID: e.plankID,
            index: e.index,
          }))
      )
    },
    /**
     * 根据优先级排序板件
     * @param { object[] } oriPlank 需要排序的板件数组
     * @param { string | number [] } priorityRule 排序应用的优先级规则
     */
    resetPlankOrder(oriPlank, priorityRule) {
      const d = {}
      let result = []
      for (const plank of oriPlank) {
        const plankType = this.backPlankType(plank)
        if (!d[plankType]) {
          d[plankType] = [plank]
        } else {
          d[plankType].push(plank)
        }
      }
      for (const k of priorityRule) {
        if (d[k]) {
          result = result.concat(d[k])
        }
      }
      return result
    },
    backPlankType(plank) {
      let type
      const part = plank.parts[0] ?? {}
      if (part.is_high_gloss_plank && part.otherPlate) {
        type = 'big_highligh'
      } else if (part.is_high_gloss_plank) {
        type = 'highligh'
      } else if (plank.surplusInfo) {
        type = 'surplus'
      } else if (part.otherPlate) {
        type = 'big_normal'
      } else {
        type = 'normal'
      }
      return type
    },
    // 记录选中的板件
    async recordActivePlank(plank, canvasKey, bigPart) {
      if (bigPart) {
        this.bigPart = bigPart
      }
      if (plank) {
        // 同时判断当前板件是否存在料单原始数据中，不存在则不让添加
        if (this.isBatchBujian) {
          const flag = getOriPartByLayout(plank.oriPartUniqueId)
          if (!flag) {
            message.error(translate('arrangedPage.batchBujianErrTip'))
          } else if (plank.specialType && plank.specialType === 'supplus') {
            this.$message({
              message: translate('arrangedPage.selectErrTip'),
              type: 'error',
            })
          } else {
            if (
              this.batchBujianList.every(
                (part) => part.partUniqueId !== plank.partUniqueId
              )
            ) {
              this.batchBujianList = [
                ...this.batchBujianList,
                { ...plank, texture: plank.oriTexture },
              ]
              this.activePlank = plank
            } else {
              this.batchBujianList = this.batchBujianList.filter(
                (part) => part.partUniqueId !== plank.partUniqueId
              )
              this.activePlank = this.batchBujianList.length
                ? this.batchBujianList[this.batchBujianList.length - 1]
                : null
              return
            }
          }
          // 批量补标签 记录选中的板
        } else if (this.isBatchTagging) {
          if (
            this.currentBatchTaggingList.every(
              (part) => part.partUniqueId !== plank.partUniqueId
            )
          ) {
            this.currentBatchTaggingList = [
              ...this.currentBatchTaggingList,
              plank,
            ]
            this.activePlank = plank
          } else {
            this.currentBatchTaggingList = this.currentBatchTaggingList.filter(
              (part) => part.partUniqueId !== plank.partUniqueId
            )
            this.activePlank = this.currentBatchTaggingList.length
              ? this.currentBatchTaggingList[
                  this.currentBatchTaggingList.length - 1
                ]
              : null
            return
          }
        } else if (this.isBatchActive) {
          const plankId = plank.partUniqueId
          // 第一次多选时，把当前已经激活的小板带进列表，避免只剩新点的那一块
          if (
            !this.batchActiveIdList.length &&
            this.activePlank?.partUniqueId
          ) {
            const activeId = this.activePlank.partUniqueId
            if (String(activeId) !== String(plankId)) {
              this.batchActiveIdList.push(activeId)
            }
          }
          const isSelected = this.batchActiveIdList.some(
            (id) => String(id) === String(plankId)
          )
          if (isSelected) {
            this.batchActiveIdList = this.batchActiveIdList.filter(
              (id) => String(id) !== String(plankId)
            )
            this.activePlank = null
            this.syncBatchActiveHighlight()
            return
          }
          this.batchActiveIdList.push(plankId)
          this.activePlank = plank
          this.syncBatchActiveHighlight()
        } else {
          this.batchActiveIdList = []
          this.activePlank = plank
        }

        const part = this.plankArr.find(
          (e) => e.partUniqueId === plank.partUniqueId
        )

        this.isLayerCut = plank.curve_layered_cutting
        this.layerCutDepth = plank.curve_layered_cutting_deep
        if (part) {
          this.isNonTexture = part.isNonTexture
        } else {
          this.isNonTexture = false
          // 手动裁剪余料 勾选上板件无纹理
          if (plank.name == '余料板件') {
            this.isNonTexture = plank.texDir == 'notcare'
          }
        }
      } else {
        this.isNonTexture = false
        this.isLayerCut = false
        this.layerCutDepth = '2'
      }
      if (plank) {
        this.activePlank = plank
        this.canvasKey = canvasKey
        this.$nextTick(() => {
          if (this.$refs.paibanQRcode) {
            this.$refs.paibanQRcode.innerHTML = ''
            let paibanQRcode = new QRCode(
              document.getElementById('paiban-qrcode'),
              {
                width: 80,
                height: 80,
                colorDark: '#000000', //前景色
                colorLight: '#ffffff', //背景色
                typeNumber: 4,
                correctLevel: QRCode.CorrectLevel.H,
                text: plank.ggid,
              }
            )
            const canvas = paibanQRcode._oDrawing._elCanvas
            this.$refs.plankQRcode.innerHTML = ''
            this.$refs.plankQRcode.appendChild(canvas)
          }
        })
      } else {
        this.activePlank = null
        this.canvasKey = -1
      }
      // this.renderAll()
    },
    // 拖动板件时, 禁止选中文字
    forbidUserSelect(val) {
      this.isForbidUserSelect = val
    },
    // 清除所有的选中状态
    clearAllActive() {
      // 已空时勿再赋 []，避免无意义触发 batchActiveIdList watcher 重绘
      if (this.batchActiveIdList.length) {
        this.batchActiveIdList = []
      }
      for (let i = 0; i < this.drawData.length; ++i) {
        this.$refs[`drawpart${i}`][0].clearLastActive()
      }
    },
    /** 多选列表变更后，同步子组件高亮并立即重绘（不依赖异步 watcher） */
    syncBatchActiveHighlight() {
      const idList = [...this.batchActiveIdList]
      for (let i = 0; i < this.drawData.length; i++) {
        const drawPartRef = this.$refs[`drawpart${i}`]?.[0]
        if (!drawPartRef) continue
        drawPartRef.activeIdList = idList
        if (
          drawPartRef.activePlank &&
          !idList.some(
            (id) => String(id) === String(drawPartRef.activePlank.partUniqueId)
          )
        ) {
          drawPartRef.activePlank = null
        }
        drawPartRef.renderAll?.()
      }
    },
    // 清除所有选中颜色
    handleClearAllStyle(activePlank) {
      for (let i = 0; i < this.drawData.length; ++i) {
        this.$refs[`drawpart${i}`][0].clearLastStyle(activePlank)
      }
    },
    // 获取活跃板件
    getAllActive() {
      let arr = []
      for (let i = 0; i < this.drawData.length; ++i) {
        arr.push(this.$refs[`drawpart${i}`][0].getActivePlank())
      }
      return arr
    },

    // 整体缩放
    changeZoomPercent(value) {
      this.canvasScale(value)
      clearTimeout(this.scaleTimer)
      this.scaleTimer = setTimeout(() => {
        this.scaleInterv = setInterval(() => {
          this.canvasScale(value)
        }, 100)
      }, 300)
    },
    // 缩放方法
    canvasScale(value, isReset) {
      this.$nextTick(() => {
        if (!this.showSubtle) {
          if (this.zoomNum - 0.5 > 0.0001 || value !== -0.1) {
            this.zoomNum += value
          } else {
            return
          }

          for (let i = 0; i < this.drawData.length; ++i) {
            let elInfo =
              this.$refs[`drawpart${i}`][0].$el.getBoundingClientRect()
            let event = {
              wheelDelta: value > 0 ? 20 : -20,
              clientX: elInfo.height / 2,
              clientY: elInfo.width / 2,
            }
            this.$refs[`drawpart${i}`][0].scaleCanvas(event, value, isReset)
          }
        } else {
          if (this.subtleZoomNum - 0.5 > 0.0001 || value !== -0.1) {
            this.subtleZoomNum += value
          } else {
            this.subtleData.zoomNum = this.subtleZoomNum
            this.$set(this.subtleData, 'zoomNum', this.subtleZoomNum)
            return
          }

          this.subtleData.zoomNum = this.subtleZoomNum
          this.$set(this.subtleData, 'zoomNum', this.subtleZoomNum)
          this.finalDrawData.forEach((drawData) => {
            drawData.data.forEach((bigPart) => {
              if (bigPart.stockNum == this.subtleData.stockNum) {
                bigPart.zoomNum = this.subtleData.zoomNum
              }
            })
          })
          let elInfo =
            this.$refs['subtleRef'].$refs[
              'subtleCanvas'
            ].getBoundingClientRect()
          let event = {
            wheelDelta: value > 0 ? 20 : -20,
            clientX: elInfo.height / 2,
            clientY: elInfo.width / 2,
          }
          this.$refs['subtleRef'].scaleCanvas(event, value, isReset)
        }
      })
    },
    handleResetScale() {
      this.zoomNum = 1
      if (this.subtleData) this.subtleData.zoomNum = 1
      this.canvasScale(0, true)
    },
    // 余料缩放倍率处理
    wheelScale(value) {
      this.subtleZoomNum = value
      this.$set(this.subtleData, 'zoomNum', this.subtleZoomNum)
    },
    // 精细排版切换大板时
    changeBigpart(bigPart) {
      this.subtleZoomNum = bigPart.zoomNum ? bigPart.zoomNum : 1
    },
    // 滚轮事件
    scrollCanvas() {
      this.$nextTick(() => {
        for (let i = 0; i < this.drawData.length; ++i) {
          let elInfo = this.$refs[`drawpart${i}`][0].$el.getBoundingClientRect()
          this.$refs[`drawpart${i}`][0].scrollCanvas(elInfo)
        }
      })
    },
    // 处理数据
    dealPaibanData() {
      this.dealAllDrawData()
      // 如果是从老板良&&好帮手跳转过来的则自动保存一次
      if (this.$route.query.from) {
        if (this.$route.query.from == 'lbl') {
          this.paibanWayName = this.orderInfo.order_address || ''
          this.savePaiban()
        }
      }
      // 监听可视区域变化
      this.resizeEvent = this.calcCanvasWidth()
      window.addEventListener('resize', this.resizeEvent)
    },
    // 计算可视区域的宽高
    calcCanvasWidth() {
      return (e) => {
        let windowWidth = document.body.offsetWidth
        let windowHeight = document.body.offsetHeight
        this.canvasMaxWidth = windowWidth - 650 < 988 ? 988 : windowWidth - 650
        this.canvasMaxHeight = windowHeight - 80
      }
    },
    // 搜索板件 (这里的index 是打开详情点击上一个和下一个传过来的)
    searchPlank(value, index = this.conflictIndex, type = '') {
      this.searchPlankList = []
      this.searchPlankIndex = -1
      this.isEmptyInput = true
      if (!this.plankKeyWord && !value) {
        this.recordActivePlank(null)
        this.clearAllActive()
      } else {
        this.isEmptyInput = false
        if (this.searchPlankList.length == 0) {
          this.clearAllActive()
          // 将符合条件的板件记录下来
          for (let i = 0; i < this.paibanData.length; ++i) {
            for (let k = 0; k < this.paibanData[i].parts.length; ++k) {
              let plank = this.paibanData[i].parts[k]
              if (plank.specialType || plank.isDesMaterialNoCut) {
                continue
              }
              if (
                plank.plankID == this.plankKeyWord ||
                plank.partName.includes(this.plankKeyWord || value) ||
                plank.oriPlankNum == (this.plankKeyWord || value) ||
                plank.partUniqueId === value
              ) {
                this.searchPlankList.push(plank)
              }
            }
          }
          if (this.searchPlankList.length == 0) {
            this.recordActivePlank(null)
            this.$message({
              type: 'info',
              message: translate('arrangedPage.noPlank'),
            })
            return
          }
          this.searchPlankIndex = 0
          if (type === 'knivesErr') {
            this.setActivePlank(index)
          } else if (type === 'depthError') {
            this.setActivePlank(index, this.depthErrorData, true)
          } else if (type == 'conflictPart') {
            this.setActivePlank(index)
          } else {
            // 收集冲突数组
            if (typeof index === 'number') {
              this.setActivePlank(index, this.conflictPlankList)
              store.commit('setrecordCurrentConflictBoard', {
                ...this.conflictPlankList[index],
              })
            } else {
              // 默认激活第一个板件
              this.setActivePlank(0)
              store.commit('setrecordCurrentConflictBoard', {
                ...this.searchPlankList[0],
              })
            }
          }
        } else {
          if (type === 'depthError') {
            this.setActivePlank(index, this.depthErrorData, true)
          } else {
            this.searchPlankIndex++
            if (this.searchPlankIndex == this.searchPlankList.length) {
              this.searchPlankIndex = 0
            }
            this.setActivePlank(this.searchPlankIndex)
          }
        }
      }
    },
    // 选中板件
    setActivePlank(index, list, onlyOne = false) {
      // 先清除所有板件
      this.clearAllActive()
      let plank = list?.length ? list[index] : this.searchPlankList[index]
      if (onlyOne) {
        plank = list
      } else {
        plank = list?.length ? list[index] : this.searchPlankList[index]
      }
      this.activePlankID = 0
      this.activePlankIndex = 0
      this.activePlankID = plank.plankID
      this.activePlankIndex = plank.index
      const brandStr =
        plank.brandName && plank.supplierName
          ? `:${plank.brandName}:${plank.supplierName}`
          : ''
      const str = `${plank.texture}:${plank.matCode}:${plank.thick}${brandStr}`
      let title = plank.otherPlate
        ? str + `:${plank.otherPlate.width}:${plank.otherPlate.height}`
        : str
      for (let i = 0; i < this.drawData.length; ++i) {
        if (this.drawData[i].title == title) {
          this.activePlank = plank
          this.recordActivePlank(plank)
          this.$refs[`drawpart${i}`][0].setNewActivePlank(plank)
          this.scrollToCanvasHeight(i)
          break
        }
      }
    },
    // 没有满足最小可吸住尺寸的板子或余料的大板
    noMinSizePlank() {
      const isPreLayout = this.$store.state.ncSetting.isPreLayout
      const { safe_length = [] } = isPreLayout
        ? this.$store.state.preLayoutSetting.setting_value.movePlankSetting
        : this.$store.state.ncSetting.movePlankSetting
      const knive = isPreLayout
        ? this.$store.state.preLayoutSetting.setting_value.knife.diameter
        : this.$store.state.ncSetting.knife.diameter
      this.searchPlankList = []
      const xyReverse = this.$store.state.ncSetting.xyReverse
      let minWidth, minHeight
      ;[minWidth, minHeight] = safe_length
      const minSize = Math.min(minWidth, minHeight)
      const maxSize = Math.max(minWidth, minHeight)
      for (let i = 0; i < this.paibanData.length; i++) {
        const item = this.paibanData[i]
        // 找出该大板下的所有小于 分散的尺寸
        const smallParts = item.parts.filter((part) => {
          const { rotate } = part
          let width, height
          // 不能酱汁做，要个根据stockNum和材质找到原始数据的尺寸
          // TODO后面记得改
          // let isSwapped =
          //   (xyReverse && (rotate === 0 || rotate === 180)) ||
          //   (!xyReverse && (rotate === 90 || rotate === 270))

          // ;[width, height] = isSwapped
          //   ? [part.rect.height - knive, part.rect.width - knive]
          //   : [part.rect.width - knive, part.rect.height - knive]
          const min = Math.min(
            part.rect.width - knive,
            part.rect.height - knive
          )
          const max = Math.max(
            part.rect.width - knive,
            part.rect.height - knive
          )
          return min < minSize || max < maxSize
        })
        // 如果该大板下有小尺寸的板件，且该大板虽有的小板都小于给定的尺寸
        if (smallParts.length > 0 && smallParts.length === item.parts.length) {
          this.searchPlankList.push(...smallParts)
        }
        // 根据小板的stockKey找到对应的大板
        // 对应大板的stockKey
        const activePlankKey = [
          ...new Set(
            this.searchPlankList.map((item) => {
              return item.stockKey
            })
          ),
        ]
        this.neecActivePlank = this.paibanData.filter((p) => {
          return activePlankKey.includes(p.stockKey)
        })
      }
    },
    // 滚动到激活板件的画布
    scrollToCanvasHeight(index) {
      const allPartRef = this.$refs.allParts
      let scrollH = 0
      for (let i = 0; i < index; i++) {
        const drawpartH =
          this.$refs[`drawpart${i}`][0].$refs.drawPartRef.offsetHeight + 10
        const drawpartDisplay = this.$refs[`drawpart${i}`][0].isShowPaiban
        if (drawpartDisplay) {
          scrollH += drawpartH
        } else {
          scrollH += 50
        }
      }
      this.$nextTick(() => {
        if (this.bigPlankH > 100) {
          scrollH += this.bigPlankH
        }
        // allPartRef.scrollTop(scrollH)
        allPartRef.scrollTo({
          top: scrollH,
          behavior: 'smooth',
        })
      })
    },
    /**
     * 选择普通或高级嵌套时调用的回调函数
     * @param {RadioEventTarget} target 事件对象
     * @return
     * @author zhouchi 2024-07-17 7-23由于test分支问题重新提交
     * */
    handlerRadioOption(target) {
      this.handleChangePaibanWay('specialShape')
      if (this.nestWay == 'PRIMARY') {
        buryPointApi('layout', 'primary_nesting')
      } else {
        buryPointApi('layout', 'irregular_nesting')
      }
    },
    /** @description 排版页重新排版 生成 layoutRectMap 单条参数 */
    buildPlankParamForRePaiban(part, layoutCtx, options = {}) {
      const { sawToLayout, sawCutOnlyWeld, realSurNotLayout, plankNames } =
        layoutCtx
      const expandedX = part.finalExtendDisMap
        ? part.finalExtendDisMap.left + part.finalExtendDisMap.right
        : 0
      const expandedY = part.finalExtendDisMap
        ? part.finalExtendDisMap.top + part.finalExtendDisMap.bottom
        : 0
      const { usedArea } = caclPartArea(part)
      let rect
      if (
        sawToLayout &&
        ((sawCutOnlyWeld && part.isWeldingPlank) || !sawCutOnlyWeld)
      ) {
        rect = {
          x1: part.rect.x,
          y1: part.rect.y,
          x2: part.realRect.width + expandedX,
          y2: part.realRect.height + expandedY,
        }
      } else {
        rect = {
          x1: part.rect.x,
          y1: part.rect.y,
          x2: part.rect.width + expandedX,
          y2: part.rect.height + expandedY,
        }
      }
      let plankParam = {
        id: part.partUniqueId,
        isWeldingPlank: !!part.isWeldingPlank,
        pathEdge: part.pathEdge,
        usedArea,
        rect,
        needRoll: part.needRoll,
        rotate: sawToLayout ? false : part.texDir == 'notcare' ? true : false,
        brandName: part.brandName,
        supplierName: part.supplierName,
        colorId: part.colorId || '',
      }
      const partName = part.partName || part.name || ''
      if (
        realSurNotLayout &&
        plankNames.some((name) => partName.includes(name))
      ) {
        plankParam.isSurNotLayoutMat = true
      }
      if (sawToLayout) {
        plankParam.rotate = false
      }
      if (isVirtualCompositePlank(part)) {
        plankParam.rotate = false
        plankParam.needRoll = false
      }
      // 合并骨骼门即使无纹理也不允许旋转
      if (judgeIsMergeFrameDoor(part)) {
        plankParam.rotate = false
      }
      if (this.isSpecialShape) {
        plankParam.cutCurve = []
        if (part.path && part.path.length) {
          let paths = part.path
          if (part.slots?.length) {
            paths = dealUnionPathSlots(paths, part.slots, this.ncSetting)
          }
          plankParam.cutCurve = plankParam.cutCurve.concat(paths)
        }
        if (part.curveHoles && part.curveHoles.length) {
          const curvePath = part.curveHoles
            ?.filter((it) => compareNumbers(it.deep, part.thick))
            .map((hole) => hole.path)
          plankParam.cutCurve = plankParam.cutCurve.concat(curvePath)
        }
      }
      forEachTextureChild(part, (child) => {
        const targetPoint = part._virtualCompositePlanksPos?.find(
          (it) => it.partUniqueId === child.partUniqueId
        )
        const childParam = this.buildPlankParamForRePaiban(child, layoutCtx, {
          rotate: false,
          needRoll: false,
          startX: targetPoint?.x ?? 0,
          startY: targetPoint?.y ?? 0,
        })
        if (!plankParam.children) {
          plankParam.children = []
        }
        plankParam.children.push(childParam)
      })
      return Object.assign(plankParam, options)
    },
    /** @description 将板件添加到 layoutRectMap 中 */
    appendRePaibanPartToLayoutMaps(part, obj, allPart, layoutCtx) {
      const title = `${part.texture}:${part.matCode}:${part.thick}`
      const plankParam = this.buildPlankParamForRePaiban(part, layoutCtx)
      if (obj[title]) {
        obj[title] = [...obj[title], plankParam]
      } else {
        obj[title] = [plankParam]
      }
      if (isVirtualCompositePlank(part)) {
        const childParts = decompositeTexturePlanks([part]) ?? []
        if (allPart[title]) {
          allPart[title] = [...allPart[title], ...childParts]
        } else {
          allPart[title] = [...childParts]
        }
      } else if (allPart[title]) {
        allPart[title] = [...allPart[title], part]
      } else {
        allPart[title] = [part]
      }
    },
    // 切换排版方式
    // activePaibanWay true true
    async handleChangePaibanWay(
      item,
      isRefresh = false,
      isClear = false,
      ortherOps = null,
      isFromReuse = false
    ) {
      if (this.checkBigPlankIsRotate(this.paibanData)) {
        return
      }
      // 如果不是来自复用按钮的调用，清除复用标记
      if (!isFromReuse) {
        if (ortherOps?.reuseMaterialKeySet) {
          this.clearReuseMarksByMaterial(ortherOps.reuseMaterialKeySet)
        } else {
          this.clearAllReuseMarks()
        }
      }
      if (isRefresh) {
        this.isRefresh = true
      }
      this.showLoading = true
      this.handleCloseBatchBujian()
      // 切换排版方式重新排版 就将批量补标签数据置为空
      this.setBatchTaggingList([])

      const allParts = this.paibanData.map((b) => b.parts).flat(2)
      const hasBlueSurplus = allParts.some(
        (p) => p.blueAreaSurplus && !p.hasSaved
      )
      if (this.surplusAutoTailor) {
        this.hasSaveSurplus = false
      } else {
        if (hasBlueSurplus) {
          this.hasSaveSurplus = false
        } else {
          this.hasSaveSurplus = true
          this.hasCut = false
        }
      }
      if (item) {
        this.clickFlag = true
      } else {
        this.clickFlag = false
      }
      // TODO wc 待定
      const res = await checkPlankEdgeHasChanged(this.baseMaterialData)
      const desMaterialNoCutRes = await checkDesMaterialNoCut()
      if (!res || !desMaterialNoCutRes) {
        this.isShowTask = false
        this.isDownloadingNc = false
        this.showLoading = false
        this.isRefresh = false
        if (item == '_roll') {
          this.isLessReverse = !this.isLessReverse
        } else if (item == 'specialShape') {
          this.isSpecialShape = !this.isSpecialShape
        } else if (item == 'paiban') {
          this.selectedPaibanWay = 'paiban_v2'
        } else {
          this.selectedPaibanWay = 'paiban'
        }
        return
      }

      EventBus.$emit('handleChangePaibanWay')
      localStorage.setItem('isChange', 'isChange')
      this.searchPlankList = []
      this.plankKeyWord = ''
      let activePaibanWay = this.activePaibanWay
      this.setHistoryPlankEdgeOff(this.historyPlankEdgeOff)
      this.setHistorySecondTrimValue(this.ncSetting.secondTrimValue)
      if (!isRefresh) {
        if (item != 'specialShape' && !item.includes('_roll')) {
          this.selectedPaibanWay = item // 记录选择的排版方式
          if (this.isLessReverse) {
            activePaibanWay = item.includes('v2')
              ? [item.replace('v2', 'roll_v2')]
              : [item + '_roll']
          } else {
            activePaibanWay = [item]
          }
          this.isAIpaiban = item === 'blue_ai/paiban'
          this.suitText = this.paibanWayList.find(
            (e) => e.interface === item
          ).desc
        } else {
          this.selectedPaibanWay = this.activePaibanWay[0].replace('_roll', '')
          if (item === 'specialShape') {
            if (this.isSpecialShape) {
              if (!activePaibanWay.includes('specialShape'))
                activePaibanWay.push('specialShape')
            } else {
              activePaibanWay = activePaibanWay.filter(
                (e) => e !== 'specialShape'
              )
            }
          } else {
            const rollWay = this.selectedPaibanWay.includes('v2')
              ? this.selectedPaibanWay.replace('_v2', item + '_v2')
              : this.selectedPaibanWay + item

            if (this.isLessReverse) {
              if (!activePaibanWay.includes(rollWay))
                activePaibanWay[0] = rollWay
            } else {
              activePaibanWay[0] = rollWay.replace('_roll', '')
            }
          }
        }
      }
      _hmt.push(['_trackEvent', '切换排版方案', 'click', activePaibanWay])
      if (isRefresh) {
        // 关闭孔槽冲突图
        this.isShowConflictDiagram = false
        buryPointApi('layout', 'reload_layout')
      } else {
        switch (item) {
          case 'paiban':
            buryPointApi('layout', 'paiban')
            break
          case 'paiban_v2':
            buryPointApi('layout', 'paiban_v2')
            break
        }
      }
      this.isNeedUpdateBatch = true
      const previousActivePaibanWay = [...this.activePaibanWay]
      const previousSelectedPaibanWay = this.selectedPaibanWay
      this.setActivePaibanWay(activePaibanWay)
      let obj = {}
      let allPart = {}
      let arr = JSON.parse(JSON.stringify(this.paibanData))
      arr.forEach((stockData) => {
        if (stockData.hasAutoRollOver) {
          dealStockPlankRoll(stockData)
        }
      })
      // 点击重新排版按钮(isClear 为true) 且生产线修改了影响排版结果的设置或者是历史记录 或非重新排版 则锁定大板解锁
      const oriSetting = dealPreLayoutSettingFromNCSetting(
        this.preSaveNcSetting
      )
      const compareRes = await comparePreLayoutSetting({
        setting_value: oriSetting,
        process_setting_id: this.ncSetting.process_setting_id,
      })
      if (compareRes.status > 0) {
        if (
          (isClear && (compareRes.data.total || this.isHistoryStatus)) ||
          !isClear
        ) {
          arr = arr.map((item) => ({ ...item, isLocked: false }))
        }
      }
      // 有锁定大板，并重新排版之后，禁用更多排版方案
      if (isRefresh && isClear && arr.some((item) => isPaibanLock(item))) {
        this.setIsLockedRePaiban(true)
      } else {
        this.setIsLockedRePaiban(false)
      }
      // TODO wc 扩板槽板子问题
      // .map((plank) => ({
      //   ...plank,
      //   isLocked: checkHasExtendSlot(plank),
      // }))

      // if (arr.every((plank) => plank.isLocked)) {
      //   this.activePlank = null
      //   this.showLoading = false
      //   this.isRefresh = false
      //   this.dealAllDrawData()
      //   return
      // }
      const ncSetting = this.$store.state.ncSetting
      const isDoorFrame =
        ncSetting.sawSetting?.mentaoji_enable &&
        ncSetting.sawSetting?.processType === 'doorFrame' &&
        isSawPaiban(this.$store)
      if (isDoorFrame) {
        const layoutData = arr.flatMap((stock) => stock.parts || [])
        const sawKnife = getSawKnife(ncSetting)
        const knifeDiameters = getCutKnifeDiameterList(ncSetting, layoutData)
        const hasKnifeRadiusGT = knifeDiameters.some(
          (diameter) => diameter / 2 > sawKnife
        )
        if (hasKnifeRadiusGT) {
          this.setActivePaibanWay(previousActivePaibanWay)
          this.selectedPaibanWay = previousSelectedPaibanWay
          this.showLoading = false
          this.isRefresh = false
          if (!isRefresh) {
            if (item == '_roll') {
              this.isLessReverse = !this.isLessReverse
            } else if (item == 'specialShape') {
              this.isSpecialShape = !this.isSpecialShape
            } else if (item == 'paiban') {
              this.selectedPaibanWay = 'paiban_v2'
            } else if (item) {
              this.selectedPaibanWay = 'paiban'
            }
          }
          this.$message.error(
            this.$translateLang(
              '您已开启"锯切雕刻机-门套切割"功能，下料刀半径大于了锯片厚度，无法进行排版！'
            )
          )
          return
        }
      }
      if (this.ncSetting.xyReverse) {
        // 第三个参数为true 代表锁定的大板跳过相关处理
        arr = viewDataToNCData(arr, 'toView', true)
      }
      const sawToLayout =
        this.$store.state.ncSetting.sawSetting.mentaoji_enable &&
        this.$store.state.ncSetting.sawSetting.sawToLayout &&
        this.$store.state.ncSetting.sawSetting.processType === 'weldingPlank' &&
        isSawPaiban(this.$store)
      const sawCutOnlyWeld =
        this.$store.state.ncSetting.sawSetting.sawCutOnlyWeld &&
        this.$store.state.ncSetting.sawSetting.processType === 'weldingPlank'

      const isSurNotLayoutMat =
        this.$store.state.preferencesSetting?.setting?.isSurNotLayoutMat
      const isSurNotLayout =
        this.$store.state.preferencesSetting?.setting?.isSurNotLayout
      const realSurNotLayout = isSurNotLayout && isSurNotLayoutMat
      const plankNames =
        this.$store.state.preferencesSetting?.setting?.plankNames
      const layoutCtx = {
        sawToLayout,
        sawCutOnlyWeld,
        realSurNotLayout,
        plankNames,
      }
      const partsForLayout = []
      // 排版页：边预处理边孔槽扩板（无料单 calcExpandRectMap 等逻辑）
      for (let i = 0; i < this.paibanData.length; ++i) {
        for (let k = 0; k < arr[i].parts.length; ++k) {
          rotateFrontEdge(arr[i].parts)
          let part = arr[i].parts[k]
          exterPathEdgeForPart(part)
          let partInPlankarr = this.plankArr.find(
            (plank) => part.partUniqueId === plank.partUniqueId
          )
          if (partInPlankarr && partInPlankarr.isNonTexture) {
            part.texDir = 'notcare'
          } else {
            part.texDir = part.srcTexDir ?? part.texDir
          }
          part._curve_layered_cutting = part.curve_layered_cutting
          part._curve_layered_cutting_deep = part.curve_layered_cutting_deep

          if (part.specialType == 'supplus') continue

          // 排版期间跳过锁定（含虚拟锁定）大板的板件收集
          if (isPaibanLock(arr[i]) && isClear) continue
          let title = `${part.texture}:${part.matCode}:${part.thick}`
          if (part.brandName && part.supplierName) {
            title += `:${part.brandName}:${part.supplierName}`
          }
          const { usedArea } = caclPartArea(part)
          // 处理拉直器扩版逻辑 余料在上方已经被调过处理了，这里不用考虑
          const cutD = part.isUseSaw
            ? getSawKnife(this.ncSetting)
            : getPlateKnifeDiameter(title, this.ncSetting)
          try {
            part.finalExtendDisMap = dealExpandSlotForPaiban(
              part,
              this.ncSetting,
              Number(cutD) / 2
            )
          } catch (error) {
            this.$message.error(
              error.message || '槽扩板计算失败，请在开料清单页面重新排版'
            )
            this.showLoading = false
            this.isRefresh = false
            return
          }
          const expandedX = part.finalExtendDisMap
            ? part.finalExtendDisMap.left + part.finalExtendDisMap.right
            : 0
          const expandedY = part.finalExtendDisMap
            ? part.finalExtendDisMap.top + part.finalExtendDisMap.bottom
            : 0
          if (expandedX || expandedY) {
            part.expandRect = {
              x: part.rect.x,
              y: part.rect.y,
              width: part.rect.width + expandedX,
              height: part.rect.height + expandedY,
            }
          }
          partsForLayout.push(part)
        }
      }
      const layoutGap = this.ncSetting.panelSize?.layoutGap ?? 0
      // 先合并对纹板再进行后续的数据组装
      compositeTexturePlanks(
        partsForLayout,
        layoutGap,
        true,
        true,
        this.ncSetting?.decimal ?? 2,
        true
      ).forEach((part) => {
        this.appendRePaibanPartToLayoutMaps(part, obj, allPart, layoutCtx)
      })
      let preData = []
      for (let key in allPart) {
        let num = 1
        for (let k = 0; k < allPart[key].length; ++k) {
          allPart[key][k].rectInd = num
          allPart[key][k].index = num
          num++
          preData.push(allPart[key][k])
        }
      }
      // let preData = JSON.parse(JSON.stringify(this.prePaibanData))
      /** TODO wc 特殊孔槽分流的逻辑暂存 */
      // const newAllPart = dealAllParts(preData)
      // // 获取孔槽分流相关设置 更新板件数据
      // const shuntPreData = await dealHoleSlotShunt({
      //   process_line_id:
      //     this.ncSetting.process_line_id ?? this.ncSetting.process_setting_id,
      //   planks: newAllPart,
      // })
      // if (shuntPreData.status) {
      //   const newParts = compShapeData(shuntPreData.data.planks, preData)
      //   preData.forEach((part) => {
      //     const newPart = newParts.find(
      //       (p) => p.partUniqueId == part.partUniqueId
      //     )
      //     if (newPart) {
      //       Object.assign(part, newPart)
      //     }
      //   })
      // }

      const objMap = new Map()
      const objKeys = Object.keys(obj)
      // 按不同刀径分开
      objKeys.forEach((key) => {
        const k = +getPlateKnifeDiameter(key, this.ncSetting)
        if (objMap.has(k)) {
          const target = objMap.get(k)
          Object.assign(target.data, { [key]: obj[key] })
        } else {
          objMap.set(k, { data: { [key]: obj[key] }, diameter: k })
        }
      })

      const paramObjList = []
      let oldUseSurplusId = JSON.parse(JSON.stringify(this.useSurplusId))
      const surplusPlank = this.paibanData.find(
        (item) =>
          item.surplusInfo &&
          Object.keys(item.surplusInfo).length &&
          !item.surplusInfo.isNotSurplus
      )
      // 获取使用余料
      const surplusRes = await getSurplusList({ page: 1, limit: 999 })
      const allSurplusList = surplusRes.status ? surplusRes.data.data : []
      this.useSurplusList = allSurplusList.filter((item) =>
        this.useSurplusId.includes(item.id)
      )
      let filterSurList = allSurplusList
      const materialPlankRes = await getRawMaterialPlankInfo({
        uid: this.$store.state.userInfo.id,
      })
      if (materialPlankRes.status !== 1) {
        return this.$message.error(materialPlankRes.msg)
      }
      // 超尺大板只排超尺小板信息
      let only_layout_too_big = materialPlankRes.data.only_layout_too_big
      objMap.forEach((it) => {
        let ncConfig = {
          stationWidth: this.ncSetting.counter_width,
          stationLimitable: this.ncSetting.counter_limit_able,
          changeKnifePosition: this.ncSetting.xyReverse ? true : false,
          decimal: this.ncSetting.decimal,
          gap: isDoorFrame ? 0 : this.ncSetting.panelSize.layoutGap,
          knifeR: it.diameter / 2,
          sawKnifeR: getSawKnife(this.ncSetting) / 2,
          outHeight: this.standardPlank.plankHeight,
          outWidth: this.standardPlank.plankWidth,
          startPosition: this.ncSetting.startPosition,
          margin: this.standardPlank.plankEdgeOff,
          xyReverse: this.ncSetting.xyReverse ? 1 : 0,
          surplus_position: this.ncSetting.surplusPosition,
          trim_side: this.ncSetting.trimSide,
          surplus_no_roll: this.isSurplusNoRoll,
          onlyLayoutTooBig: only_layout_too_big,
          new_cut_sequence: !!this.ncSetting.movePlankSetting
            ?.strong_suction_zones.length
            ? Boolean(this.ncSetting.movePlankSetting?.newCutSequence)
            : false,
          strong_suction_zones:
            this.ncSetting.movePlankSetting?.strong_suction_zones,
          safe_length: this.ncSetting.movePlankSetting?.safe_length,
          scattered_layout: this.ncSetting.movePlankSetting?.scattered_layout,
          sameWidthPlank:
            this.ncSetting.sawSetting.sameWidthPlank &&
            this.ncSetting.sawSetting.mentaoji_enable &&
            this.ncSetting.sawSetting.sawToLayout &&
            this.ncSetting.sawSetting.processType === 'weldingPlank',
          sawToLayout:
            this.ncSetting.sawSetting.mentaoji_enable &&
            this.ncSetting.sawSetting.sawToLayout &&
            this.ncSetting.sawSetting.processType === 'weldingPlank',
          mentaoji_enable: this.ncSetting.sawSetting.mentaoji_enabl,
          // TODO: 焊接板才使用锯片加工
          sawCutOnlyWeld:
            this.ncSetting.sawSetting.sawCutOnlyWeld &&
            this.ncSetting.sawSetting.processType === 'weldingPlank',
          sortByHeight: this.ncSetting.sawSetting.sortByHeight,
          processType: this.ncSetting.sawSetting.processType,

          // 混排的方案中特殊大板的颜色的映射
          colorMap: Object.keys(this.$store.state.materialListStore.colorMap)
            .length
            ? this.$store.state.materialListStore.colorMap
            : null,
          isSurNotLayoutMat: realSurNotLayout,
          stacking_method:
            this.$store.state?.preferencesSetting?.setting?.stacking_method ??
            'short',
        }
        // 最小余料匹配宽度差
        if (
          this.ncSetting.sawSetting.mentaoji_enable &&
          this.ncSetting.sawSetting.sawToLayout &&
          this.ncSetting.sawSetting.processType === 'weldingPlank'
        ) {
          ncConfig.minSurplusWidthDiff =
            this.ncSetting.sawSetting.minSurplusWidthDiff
        }
        if (this.isSpecialShape) {
          ncConfig.nesting_version = { SENIOR: 2, PRIMARY: 1 }[this.nestWay]
        }
        // 没有开启自定义大板排版顺序 重新排版还是原来的传参
        if (!this.customPlankOrder) {
          if (Object.keys(this.specialPlankParams).length > 0) {
            ncConfig.otherPlateSize = this.specialPlankParams
            let outSizeMap = {}
            this.specialPlankParams.forEach((item) => {
              if (item.isPicked) {
                let key = `${item.color}:${item.matCode}:${item.thick}`
                outSizeMap[key] = {
                  width: item.width,
                  height: item.height,
                  trim_edge: item.trim_edge,
                }
              }
            })
            ncConfig.outSizeMap = outSizeMap
            // 只要开启了特殊大板上只排超尺小板，需要重新处理otherPlateSize并恢复outSizeMap
            if (only_layout_too_big) {
              ncConfig.outSizeMap = {}
              const newGroup = ncConfig.otherPlateSize.reduce((acc, cur) => {
                // 这里不用cur中的symbol的原因就是因为这里的symbol可能是重复的：：：false/true，即使他们的颜色、材质、厚度不一样
                const symbol = `${cur.color}:${cur.matCode}:${cur.thick}`
                if (!acc[symbol]) {
                  acc[symbol] = []
                }
                acc[symbol].push(cur)
                return acc
              }, {})
              const largestPerGroup = Object.keys(newGroup).map((k) => {
                newGroup[k].sort((a, b) => {
                  const aMax = Math.max(a.width, a.height)
                  const bMax = Math.max(b.width, b.height)
                  return bMax - aMax
                })
                return newGroup[k][0]
              })
              ncConfig.otherPlateSize = largestPerGroup
              // 判断使用的特殊大板是不是默认勾选的，如果是，就需要给outSizeMap赋值
              const pickedPlate = largestPerGroup.find(
                (plate) => plate.isPicked
              )
              if (pickedPlate) {
                ncConfig.outSizeMap = outSizeMap
              }
            }
          }
        } else {
          // 开启自定义大板排版顺序
          only_layout_too_big = false
          ncConfig.customPlankOrder = this.customPlankOrder
          const standardPlank = this.plankOrderList.find(
            (item) => item.plankType == '标准大板'
          )
          if (standardPlank) {
            ncConfig.order = standardPlank.plankOrder
            ncConfig.amount = Number(standardPlank.amount)
          } else {
            ncConfig.amount = 0
          }
          // 有特殊板且数量不为0
          const plateList = this.plankOrderList.filter(
            (item) => item.plankType != '标准大板' && item.amount != '0'
          )
          if (plateList.length) {
            ncConfig.otherPlateSize = plateList.map((item) => ({
              color: item.texture,
              height: Number(item.plankSize.split('x')[1]),
              matCode: item.isHighPlank.includes('非')
                ? item.matCode
                : `高光_${item.matCode}`,
              symbol: `${item.matCode}:${item.thick}:${item.thick}`,
              thick: item.thick,
              trim_edge: item.plankEdgeOff,
              width: Number(item.plankSize.split('x')[0]),
              order: item.plankOrder,
              amount: Number(item.amount),
              brandName: item.brandName,
              supplierName: item.supplierName,
              colorId: item.colorId || '',
            }))
          }
        }
        let paibanParam = {
          layoutConfig: ncConfig,
          layoutHoleMap: {},
          layoutRectMap: it.data,
        }
        let surplusParams
        let notOrderLockList = []
        // 开启余料锁定 且使用了余料时 处理重新排版的余料参数
        if (
          this.$store.state.preferencesSetting.setting.surplus_lock &&
          surplusPlank
        ) {
          // 获取被其它订单锁定的余料id
          notOrderLockList = this.useSurplusList
            .filter(
              (item) =>
                item.lock_status == 1 &&
                item.lock_order !=
                  this.orderInfo?.order_address?.replace(
                    /\(.*?\)|历史记录/g,
                    ''
                  )
            )
            .map((item) => item.id)
        }
        const virtualLockSurplusIds = new Set(
          arr
            .filter(
              (item) =>
                item._isVirtualLock &&
                item.surplusInfo &&
                Object.keys(item.surplusInfo).length &&
                !item.surplusInfo.isNotSurplus &&
                item.surplusInfo.id
            )
            .map((item) => item.surplusInfo.id)
        )
        if (notOrderLockList.length && this.isHistoryStatus) {
          // 历史记录 直接剔除被其它订单锁定的余料
          surplusParams = setSurplusObj(
            arr.filter(
              (item) =>
                !isPaibanLock(item) &&
                !item.customSurplus &&
                !notOrderLockList.includes(item?.surplusInfo?.id)
            ),
            this.selectedPaibanWay
          )
        } else if (notOrderLockList.length) {
          let selectSurplusList = []
          if (this.selectSurplusList.length) {
            selectSurplusList = this.selectSurplusList
          } else {
            selectSurplusList = allSurplusList
              .filter((item) => this.useSurplusId.includes(item.id))
              .map((item) => ({ ...item, isSelected: true }))
          }
          // 开料清单 从所选余料中剔除被其它订单锁定的余料 及 虚拟锁定大板已占用的余料
          filterSurList = selectSurplusList.filter(
            (item) =>
              !notOrderLockList.includes(item.id) &&
              !this.delSurplusId.includes(item.id) &&
              !virtualLockSurplusIds.has(item.id)
          )
          // 更新所选余料 （拆分的情况）
          filterSurList = filterSurList.map((item) => ({
            ...item,
            amount: allSurplusList.find((useItem) => useItem.id == item.id)
              ?.amount,
          }))
          this.setSelectSurplusList(filterSurList)
          // 过滤掉与仅加工孔槽板件匹配的余料
          filterSurList = filterSurplusByNoCutPlanks(
            filterSurList,
            this.paibanData.flatMap((b) => b.parts),
            this.currentLine
          )
          surplusParams = genSurplusParams(filterSurList)
        } else {
          // 虚拟锁定（含真实锁定）的余料大板不参与排版传参
          surplusParams = setSurplusObj(
            arr.filter((item) => !isPaibanLock(item) && !item.customSurplus),
            this.selectedPaibanWay
          )
          if (!isRefresh) {
            surplusParams = setSurplusObj(
              arr.filter((item) => !item.customSurplus),
              this.selectedPaibanWay
            )
          }
        }
        const paramObj = genPaibanRequestParams(
          this.$store,
          surplusParams,
          {
            data: paibanParam,
          },
          undefined
        )
        paramObjList.push(paramObj)
      })

      this.showLoading = true
      // 清空收集的多排版方案
      // this.$store.commit('paibanStore/setPaibanDataCollect', [])
      this.$store.commit('paibanStore/clearAlreadyDealDrawData')
      // TODO wc 预排版处理
      // await this.reLayout(this.ncSetting.process_setting_id)
      // this.activePlank = null
      // this.showLoading = false

      dealPaibanData(paramObjList, preData, this.activePaibanWay[0], true).then(
        async (paibanRes) => {
          this.activePlank = null
          this.showLoading = false
          this.isRefresh = false
          const isPaibanErr = !paibanRes || paibanRes?.isPaibanErr
          // 排版错误
          if (isPaibanErr) {
            this.clearVirtualLock()
            return
          }
          // 开启自定义大板顺序 剔除被其它订单锁定的余料后 排版失败的处理
          if (
            this.customPlankOrder &&
            paibanRes?.text == '大板数量不够或超尺'
          ) {
            // '余料大板被其他订单占用，可用大板不足，请到开料清单重新排版'
            this.$message.warning(translate('arrangedPage.rePaibanWarn'))
            this.clearVirtualLock()
            return
          }
          // 排版结果超尺
          if (paibanRes.isOverSize) {
            this.clearVirtualLock()
            return
          }
          // 上方报错会基本优先这里，但是判断条件太容易出问题，写这个是为了确认不会放过错误
          if (paibanRes.isErr) {
            this.clearVirtualLock()
            return
          }
          if (isClear) {
            this.$store.commit('setLockedPlank', arr)
            this.dealAllDrawData(true)
          } else {
            this.dealAllDrawData()
          }
          // 排版完成后清理虚拟锁定标记
          this.clearVirtualLock()
          this.showAITipDialog = item.includes('blue_ai')
          // 调用余料自动裁剪
          await this.startTailorSurplus(false)
          this.handleResetPlankArea(true)
          const str = this.activePaibanWay[0].replace('_roll', '')
          const paibanWayStr = this.activePaibanWay[0].includes('roll')
            ? this.paibanWayList.find((e) => e.interface === str).name +
              '_少翻板'
            : this.paibanWayList.find((e) => e.interface === str).name
          // 重新排版使用的余料ID
          this.useSurplusId = this.paibanData
            .map(
              (item) => !item.surplusInfo?.isNotSurplus && item.surplusInfo?.id
            )
            .filter((id) => id)
          if (
            this.$store.state.preferencesSetting.setting.surplus_lock &&
            this.useSurplusId.length
          ) {
            // 锁定使用的余料 -存在重新排版后又使用了新的余料或者余料管理又去手动解锁了使用的余料
            const lockParams = {
              surplus: filterSurList
                .filter((item) => this.useSurplusId.includes(item.id))
                .map((item) => ({
                  ...item,
                  lock_status: 1,
                  lock_order: this.orderInfo?.order_address?.replace(
                    /\(.*?\)|历史记录/g,
                    ''
                  ),
                  lock_num: this.useSurplusId.filter((id) => id == item.id)
                    .length,
                })),
              release_all: false,
            }
            await surplusLock(lockParams)
            // 解锁本订单之前用了的余料 但重新排版未使用的余料
            const beforeUseId = oldUseSurplusId.filter(
              (id) => !this.useSurplusId.includes(id)
            )
            const unLockParams = {
              surplus: this.useSurplusList
                .filter(
                  (item) =>
                    beforeUseId.includes(item.id) &&
                    item.lock_order ==
                      this.orderInfo?.order_address?.replace(
                        /\(.*?\)|历史记录/g,
                        ''
                      )
                )
                .map((item) => ({
                  ...item,
                  lock_status: 0,
                  lock_num: beforeUseId.filter((id) => id == item.id).length,
                })),
              release_all: false,
            }
            await surplusLock(unLockParams)
          }
          // 重新排版后，夹手位置避让
          this.handleCheckClampHandPosition()
          updateLocalPreference({
            surplusAutoTailor:
              this.finalState.surplusAutoTailor ?? this.surplusAutoTailor,
            surplus_no_roll: this.finalState.isSurplusNoRoll,
            shortSideRect: this.finalState.shortSideRect || 250,
            longSideRect: this.finalState.longSideRect || 300,
            surplusTailorWay: this.finalState.surplusTailorWay,
            isLessReverse: this.isLessReverse,
            isSpecialShape: this.isSpecialShape,
            paibanWay: this.activePaibanWay[0],
            // paibanWay:
            //   this.selectedPaibanWay?.replace('_roll', '') ?? 'paiban_v2',
            layoutMethod: this.isSpecialShape
              ? paibanWayStr + '_计算异形'
              : paibanWayStr,
            nesting_version: this.nestWay === 'SENIOR' ? 2 : 1,
          })
          // 新增蓝色余料
          if (
            this.ncSetting.sawSetting.firstCutSurplus &&
            this.ncSetting.sawSetting.surplusStoreAndLabeling &&
            this.selectedPaibanWay == 'paiban' &&
            this.ncSetting.sawSetting.mentaoji_enable &&
            this.ncSetting.sawSetting.processType === 'weldingPlank'
          ) {
            cutBlueSurplus(this.drawData, true)
            // 蓝色余料生成后用 surplusPath 重算入库状态，避免沿用排版前的错误标记
            this.setHasSavedSurplus()
          }
          this.renderAll()
          this.$nextTick(() => {
            const count =
              this.$refs.moreAlignedPlanRef?.getDeepTabTipShowCount?.()
            if (count !== undefined) {
              this.hasDeepSearchPlan = count
            }
          })
        }
      )

      this.noReArrangeObj = {}
    },
    /**
     * @description 清理所有大板上的虚拟锁定标记
     * @returns {void}
     */
    clearVirtualLock() {
      this.paibanData.forEach((p) => {
        delete p._isVirtualLock
      })
      this.drawData.forEach((item) => {
        item.data.forEach((sub) => {
          delete sub._isVirtualLock
        })
      })
    },
    /**
     * @description 清除所有大板上的复用标记
     * @returns {void}
     */
    clearAllReuseMarks() {
      this.paibanData.forEach((p) => {
        delete p._isReused
        delete p._reuseParentId
      })
      this.drawData.forEach((item) => {
        item.data.forEach((sub) => {
          delete sub._isReused
          delete sub._reuseParentId
        })
      })
    },
    getBigPlankMaterialKey(bigPlank) {
      const firstPart = bigPlank?.parts?.[0]
      if (!firstPart) return ''
      // 与 drawData 的 title 生成规则保持一致（transformPaibanDataToFinalDrawData），
      // 品牌大板需要带上 brandName/supplierName，否则选中分组时 key 对不上会被全部虚拟锁定
      let key = `${firstPart.texture}:${firstPart.matCode}:${firstPart.thick}`
      if (firstPart.brandName && firstPart.supplierName) {
        key += `:${firstPart.brandName}:${firstPart.supplierName}`
      }
      if (bigPlank.otherPlate) {
        key += `:${bigPlank.otherPlate.width}:${bigPlank.otherPlate.height}`
      }
      return key
    },
    clearReuseMarksByMaterial(materialKeySet) {
      this.paibanData.forEach((p) => {
        if (!materialKeySet.has(this.getBigPlankMaterialKey(p))) return
        delete p._isReused
        delete p._reuseParentId
      })
      this.drawData.forEach((item) => {
        item.data.forEach((sub) => {
          if (!materialKeySet.has(this.getBigPlankMaterialKey(sub))) return
          delete sub._isReused
          delete sub._reuseParentId
        })
      })
    },
    /**
     * @description 清除指定父板所在复用组的所有复用信息
     * @param {IBigPlank} parentBoard - 父板
     * @returns {void}
     */
    clearReuseGroup(parentBoard) {
      clearReuseInfo(parentBoard, this.paibanData)
      // 同步清除 drawData 中的子板标记
      this.drawData.forEach((item) => {
        item.data.forEach((sub) => {
          if (sub._reuseParentId === parentBoard.bigPlankUniqueId) {
            delete sub._reuseParentId
          }
        })
      })
    },
    /**
     * @description 清除指定子板的复用信息
     * @param {IBigPlank} childBoard - 子板
     * @returns {void}
     */
    clearSingleReuseChild(childBoard) {
      const parentId = Array.isArray(childBoard._reuseParentId)
        ? childBoard._reuseParentId[0]
        : childBoard._reuseParentId
      clearReuseInfo(childBoard, this.paibanData)
      // 同步清除 drawData 中该子板的标记
      if (parentId) {
        this.drawData.forEach((item) => {
          item.data.forEach((sub) => {
            const subParentId = Array.isArray(sub._reuseParentId)
              ? sub._reuseParentId[0]
              : sub._reuseParentId
            if (
              subParentId === parentId &&
              sub.stockKey === childBoard.stockKey
            ) {
              delete sub._reuseParentId
            }
          })
        })
      }
    },
    /**
     * @description 检查大板是否需要清除复用信息，父板清除整组，子板清除自身
     * @param {IBigPlank} board - 大板对象
     * @returns {void}
     */
    clearReuseIfNeeded(board) {
      if (!board) return
      if (isReuseParent(board)) {
        this.clearReuseGroup(board)
      } else if (isReuseChild(board)) {
        this.clearSingleReuseChild(board)
      }
    },
    /**
     * @description 按指定材质分组重新排版，未选中的材质通过虚拟锁定跳过
     * @param {string[]} selectedTitles - 选中的材质分组 title 列表
     * @param {string} [displayText=''] - 选中材质的显示文本
     * @param {number[]} [selectedIndices=null] - 选中的 drawData 索引列表（来自弹窗）
     * @param {boolean} [isFromReuse=false] - 是否来自板件复用
     * @returns {void}
     */
    handleReLayoutByMaterial(
      selectedTitles,
      displayText = '',
      selectedIndices = null,
      isFromReuse = false
    ) {
      // 如果传入了 selectedIndices（来自弹窗），用索引构建选中 key 集合
      let selectedKeySet = null
      if (selectedIndices) {
        selectedKeySet = new Set(
          selectedIndices.map((i) => this.drawData[i].title)
        )
      }
      const relayoutMaterialKeySet = selectedKeySet ?? new Set(selectedTitles)
      // 给未选中材质的大板添加虚拟锁定标记，排版时跳过这些大板
      this.paibanData.forEach((p) => {
        // 已有虚拟锁，不覆盖
        if (p._isVirtualLock) return
        // 只有复用触发时才锁定复用板
        if (isFromReuse && (p._isReused || p._reuseParentId)) {
          p._isVirtualLock = true
          return
        }
        const key = this.getBigPlankMaterialKey(p)
        p._isVirtualLock = selectedKeySet
          ? !selectedKeySet.has(key)
          : !selectedTitles.includes(key)
      })
      // 只有用户手动触发时才记录操作
      if (!isFromReuse) {
        this.addDataToOperateArr({
          key: '指定材质重新排版',
          dataArr: [
            {
              type: 'form',
              current: {
                selectedMaterials: displayText || selectedTitles.join(', '),
              },
              ori: {
                selectedMaterials: '',
              },
              compareMsg: [
                {
                  title: '指定材质重新排版',
                  keys: ['selectedMaterials'],
                },
              ],
              formTextObj: {
                selectedMaterials: '选中材质',
              },
              formValueObj: {},
            },
          ],
        })
      }
      // 调用现有排版流程，传递 isFromReuse 参数
      this.handleChangePaibanWay(
        this.activePaibanWay[0],
        true,
        true,
        isFromReuse
          ? null
          : {
              reuseMaterialKeySet: relayoutMaterialKeySet,
            },
        isFromReuse
      )
    },
    /**
     * @description 处理布局复用结果，删除已使用的小板、添加虚拟锁定、触发重新排版
     * @param {Object} data - 复用结果数据
     * @param {IBigPlank[]} data.reusedBoards - 复用生成的子板列表
     * @param {PartType[]} data.usedParts - 已使用的小板列表
     * @param {PartType[]} data.unusedParts - 未使用的小板列表
     * @param {IBigPlank} data.parentBoard - 父板
     * @param {number} data.canvasKey - 父板所在的 drawData 索引
     * @returns {void}
     */
    async handleLayoutReuse({
      reusedBoards,
      usedParts,
      unusedParts,
      parentBoard,
    }) {
      // 1. 从 paibanData 中删除已使用的小板
      const usedIds = new Set(usedParts.map((p) => p.partUniqueId))
      let newPaibanData = this.paibanData.map((bigPlank) => ({
        ...bigPlank,
        parts: bigPlank.parts.filter(
          (part) => !usedIds.has(part.partUniqueId) && !isSurplusPlank(part)
        ),
      }))
      // 删除空大板（parts 为空的大板）
      newPaibanData = newPaibanData.filter(
        (bigPlank) => bigPlank.parts.length > 0
      )
      // 添加复用子板到 paibanData
      newPaibanData.push(...reusedBoards)
      // 触发重新排序
      newPaibanData.forEach((bigPlank) =>
        Reflect.deleteProperty(bigPlank, '_sortNum')
      )
      // 更新 paibanData
      this.setPaibanData(newPaibanData)
      // 判断是否需要重新排版
      if (unusedParts.length === 0) {
        // 全部用完，直接重建 drawData，不排版
        this.dealAllDrawData()
        // 重新计算余料
        await this.startTailorSurplus(false)
        // 未开启余料自动裁剪时，tailorSurplus 不会重算下刀点，需补充计算
        if (!this.surplusAutoTailor) {
          await this.calcCutPositionOrder()
        }
        this.setIsLockedRePaiban(true)
        this.renderAll()
      } else {
        // 有剩余，设置虚拟锁后重新排版
        // 虚拟锁：父板 + 子板
        this.paibanData.forEach((p) => {
          if (
            p.bigPlankUniqueId === parentBoard.bigPlankUniqueId ||
            reusedBoards.some((b) => b.bigPlankUniqueId === p.bigPlankUniqueId)
          ) {
            p._isVirtualLock = true
          }
        })
        // 找到所有同材质分组（考虑高光板）
        const materialKey = `${parentBoard.texture}:${parentBoard.matCode}:${parentBoard.thick}`
        const isHighGloss = parentBoard.parts.some((p) => p.is_high_gloss_plank)
        const selectedTitles = this.drawData
          .filter((group) => {
            const groupKey = `${group.texture}:${group.matCode}:${group.thick}`
            if (groupKey !== materialKey) return false
            const groupIsHighGloss = group.data.some((bigPlank) =>
              bigPlank.parts.some((p) => p.is_high_gloss_plank)
            )
            return groupIsHighGloss === isHighGloss
          })
          .map((group) => group.title)

        // 调用按材质重新排版，标记来自复用
        this.handleReLayoutByMaterial(selectedTitles, '', null, true)
      }
    },
    // 选择无纹理
    async handleNonTexture(e) {
      const checked = e?.target ? e.target.checked : !this.isNonTexture
      // 复选（Ctrl 多选）选中多块小板时，无纹理操作同样应用到全部选中小板
      if (this.batchActiveIdList.length) {
        return this.batchNonTexture(checked)
      }
      // 单板回显跟随勾选状态
      this.isNonTexture = checked
      if (isTextureAlignmentPlank(this.activePlank)) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          getSameGroupParts(this.activePlank, this.activeBigpart.parts),
          () => {
            this.isNonTexture = !this.isNonTexture
          }
        )
        if (!confirmed) return
      }
      buryPointApi('layout', 'plate_without_texture')
      this.isNeedUpdateBatch = true
      this.activePlank.texDir = this.isNonTexture
        ? 'notcare'
        : this.activePlank.srcTexDir
      this.activePlank.mark_notcare = true // 操作过板件无纹理
      this.setPlankArr(
        this.plankArr.map((plank) => {
          if (isSamePart(plank, this.activePlank)) {
            return { ...plank, isNonTexture: this.isNonTexture }
          } else {
            return plank
          }
        })
      )
      this.setBatchTaggingList([])
    },
    /**
     * @description 复选（Ctrl 多选）批量设置无纹理，与单板设置无纹理保持一致
     * @param {boolean} checked - 是否设置为无纹理
     * @returns {Promise<void>}
     */
    async batchNonTexture(checked) {
      const targets = this.getBatchActiveTargetsForAction('设置无纹理')
      if (!targets.length) return
      // 半选状态点击时按"全部设为无纹理"处理
      const nextChecked =
        checked === undefined ? !this.nonTextureChecked : checked
      // 与单板一致：对纹板件统一确认一次（回显由数据推导，取消时无需回滚）
      const textureParts = this.getBatchMatchParts(
        targets,
        isTextureAlignmentPlank
      )
      if (textureParts.length) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          textureParts
        )
        if (!confirmed) return
      }
      buryPointApi('layout', 'plate_without_texture')
      this.isNeedUpdateBatch = true
      targets.forEach((item) => {
        item.part.texDir = nextChecked ? 'notcare' : item.part.srcTexDir
        item.part.mark_notcare = true // 操作过板件无纹理
      })
      this.setPlankArr(
        this.plankArr.map((plank) => {
          const target = targets.find((item) => isSamePart(plank, item.part))
          return target ? { ...plank, isNonTexture: nextChecked } : plank
        })
      )
      // 同步单板回显标记，退出复选后状态一致
      this.isNonTexture = nextChecked
      this.setBatchTaggingList([])
    },

    // 异形板件选择分层切割
    handleLayerCut(e) {
      const checked = e?.target ? e.target.checked : !this.layerCutChecked
      // 复选（Ctrl 多选）选中多块小板时，分层切割同样应用到全部选中小板
      if (this.batchActiveIdList.length) {
        // 半选状态点击时按「全部开启分层切割」处理
        const nextChecked =
          checked === undefined ? !this.layerCutChecked : checked
        return this.batchLayerCut(nextChecked)
      }
      this.isLayerCut = checked
      // 开启分层切割，需要打开分层切割深度弹窗
      if (checked) {
        this.isShowLayerCutDepthModal = true
      }
      this.activePlank.curve_layered_cutting = checked

      // 修改原始数据
      this.setPlankArr(
        this.plankArr.map((plank) => {
          if (isSamePart(plank, this.activePlank)) {
            return {
              ...plank,
              curve_layered_cutting: checked,
            }
          }
          return plank
        })
      )
      this.setBatchTaggingList([])
      // 数据变化后清除当前大板的复用信息
      this.clearReuseIfNeeded(this.bigPart)
    },
    // 深度输入限制
    handleLayerCutDepthInput() {
      this.layerCutDepth = regReplaceCuttingParamsInputDepth(this.layerCutDepth)
    },
    // 确定修改分层切割深度
    handleConfirmLayerCutDepth() {
      // 只能输入数字且支持小数
      if (!/^\d*\.?\d*$/.test(this.layerCutDepth) || this.layerCutDepth < 0) {
        this.$message.warning(
          this.$translateLang('分层切割深度只能输入大于0的数字')
        )
        return
      }
      const deep = Number(this.layerCutDepth)
      // 复选时按选中的全部小板中最薄的板件校验
      const curThick = this.batchActiveIdList.length
        ? Math.min(
            ...this.getBatchActiveTargets().map((item) => item.part.thick)
          )
        : this.activePlank.thick
      if (deep >= curThick) {
        this.$message.warning(
          this.$translateLang('分层切割深度必须小于板件厚度')
        )
        return
      }

      this.isShowLayerCutDepthModal = false
      if (this.batchActiveIdList.length) {
        return this.batchLayerCutDepth(deep)
      }
      this.activePlank.curve_layered_cutting_deep = deep
      // TODO: 更新原始数据
      this.setPlankArr(
        this.plankArr.map((plank) => {
          if (isSamePart(plank, this.activePlank)) {
            return {
              ...plank,
              curve_layered_cutting_deep: deep,
            }
          }
          return plank
        })
      )
      this.isNeedUpdateBatch = true
    },
    // 取消修改分层切割深度
    handleCancelLayerCutDepth() {
      this.isShowLayerCutDepthModal = false
      // 复选时取消全部选中小板的分层切割
      if (this.batchActiveIdList.length) {
        const targets = this.getBatchActiveTargets()
        targets.forEach((item) => {
          item.part.curve_layered_cutting = false
        })
        this.setPlankArr(
          this.plankArr.map((plank) => {
            const target = targets.find((item) => isSamePart(plank, item.part))
            return target ? { ...plank, curve_layered_cutting: false } : plank
          })
        )
      } else {
        this.activePlank.curve_layered_cutting = false
        this.setPlankArr(
          this.plankArr.map((plank) => {
            if (isSamePart(plank, this.activePlank)) {
              return { ...plank, curve_layered_cutting: false }
            }
            return plank
          })
        )
      }
      this.isLayerCut = false
    },
    /**
     * @description 复选（Ctrl 多选）批量设置分层切割，与单板设置分层切割保持一致
     * @param {boolean} checked - 是否开启分层切割
     * @returns {void}
     */
    batchLayerCut(checked) {
      const targets = this.getBatchActiveTargetsForAction('设置分层切割')
      if (!targets.length) return
      // 开启分层切割，需要打开分层切割深度弹窗
      if (checked) {
        this.isShowLayerCutDepthModal = true
      }
      targets.forEach((item) => {
        item.part.curve_layered_cutting = checked
      })
      // 修改原始数据
      this.setPlankArr(
        this.plankArr.map((plank) => {
          const target = targets.find((item) => isSamePart(plank, item.part))
          return target ? { ...plank, curve_layered_cutting: checked } : plank
        })
      )
      // 同步单板回显标记，退出复选后状态一致
      this.isLayerCut = checked
      this.setBatchTaggingList([])
      // 数据变化后清除涉及大板的复用信息
      new Set(targets.map((item) => item.bigpart)).forEach((bigpart) =>
        this.clearReuseIfNeeded(bigpart)
      )
    },
    /**
     * @description 复选（Ctrl 多选）批量设置分层切割深度
     * @param {number} deep - 分层切割深度
     * @returns {void}
     */
    batchLayerCutDepth(deep) {
      const targets = this.getBatchActiveTargets()
      targets.forEach((item) => {
        item.part.curve_layered_cutting_deep = deep
      })
      // TODO: 更新原始数据
      this.setPlankArr(
        this.plankArr.map((plank) => {
          const target = targets.find((item) => isSamePart(plank, item.part))
          return target ? { ...plank, curve_layered_cutting_deep: deep } : plank
        })
      )
      this.isNeedUpdateBatch = true
    },

    // 旋转板件
    /**
     * @description 旋转小板
     * @param {number} angle - 旋转角度，支持 90、180、270
     * @returns {void}
     */
    async rotatePlank(angle = 90) {
      // 复选（Ctrl 多选）选中多块小板时，旋转操作同样应用到全部选中小板
      if (this.batchActiveIdList.length) {
        return this.batchRotatePlank(angle)
      }
      if (this.activePlank) {
        if (isTextureAlignmentPlank(this.activePlank)) {
          const confirmed = await showTextureConfirmModal(
            this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
            getSameGroupParts(this.activePlank, this.activeBigpart.parts)
          )
          if (!confirmed) return
        }
        if (
          this.activePlank.isUseSaw &&
          this.activePlank.path &&
          this.activePlank.path.length &&
          !judgeRectangle(this.activePlank.path[0])
        ) {
          const confirmed = await showTextureConfirmModal(
            this.$translateLang(
              '当前操作会影响板件间隙，导致加工问题，请确认是否继续？'
            ),
            getSameGroupParts(this.activePlank, this.activeBigpart.parts)
          )
          if (!confirmed) return
        }
        this.$nextTick(() => {
          let bigpart
          for (let i = 0; i < this.drawData[this.canvasKey].data.length; i++) {
            if (
              this.drawData[this.canvasKey].data[i].stockKey ===
              this.activePlank.stockKey
            ) {
              bigpart = this.drawData[this.canvasKey].data[i]
            }
          }
          const oriActivePlank = JSON.parse(JSON.stringify(this.activePlank))
          this.$refs[`drawpart${this.canvasKey}`][0].rotatePlank(angle)
          buryPointApi('layout', `rotate_${angle}`)
          this.isNeedUpdateBatch = true
          this.addDataToOperateArr({
            key: '旋转小板',
            dataArr: [
              {
                type: 'form',
                current: {
                  oRectWidth: this.activePlank.oRect.width,
                  angle,
                }, // 当前表单数据
                ori: {
                  oRectWidth: oriActivePlank.oRect.width,
                  angle: 0,
                }, // 原始表单数据
                compareMsg: [
                  {
                    title: `${this.activePlank.partName}-大板序号: ${bigpart.canvasIndex}`,
                    keys: ['oRectWidth'],
                  },
                  {
                    title: `${this.activePlank.partName}-大板序号: ${bigpart.canvasIndex}`,
                    keys: ['angle'],
                  },
                ], // 要比较的内容
                formTextObj: {
                  oRectWidth: '成品宽度',
                  angle: '小板旋转角度',
                }, // key对应的意思
                formValueObj: {}, // value对应的意思
              },
            ],
          })
          this.setBatchTaggingList([])
        })
      } else {
        this.$message({
          message: '请先选中板件再进行此操作!',
          type: 'info',
        })
      }
    },
    // 重新计算下刀点和下刀顺序
    async calcCutPositionOrder(
      onlyCalCutPoint = false,
      data = this.paibanData
    ) {
      buryPointApi('layout', 'recalculate ')
      this.isNeedUpdateBatch = true
      for (let i = 0; i < data.length; ++i) {
        for (let k = 0; k < data[i].parts.length; ++k) {
          if (data[i].parts[k].isMerge) {
            this.$message({
              type: 'error',
              message:
                '重新计算下刀点失败！请检查是否有板件重叠或板件在大板外!',
            })
            return
          }
        }
      }
      let newData = JSON.parse(JSON.stringify(data))
      newData = newData.filter((item) => {
        return !item.isLocked
      })
      // 将newData数组对象中的蓝色余料筛掉
      for (let i = 0; i < newData.length; ++i) {
        newData[i].parts = newData[i].parts.filter(
          (part) => !part.blueAreaSurplus
        )
      }
      let {
        startPosition,
        xyReverse,
        cutDirection,
        drawPlankWidth,
        drawPlankHeight,
        surplusPosition,
      } = this.ncSetting
      const isFromHistory = this.$route.query.from === 'history_paiabn'
      const pHeight = drawPlankHeight ?? this.selectStandardPlank.plankHeight
      const pWidth = drawPlankWidth ?? this.selectStandardPlank.plankWidth
      let plankWidth = xyReverse && isFromHistory ? pHeight : pWidth
      let plankHeight = xyReverse && isFromHistory ? pWidth : pHeight

      let rectMap = {}
      // 未使用的变量不知道作用暂时注释
      // let plankOffset = Math.abs(
      //   this.ncSetting.knife.diameter / 2 -
      //     this.ncSetting.panelSize.plankEdgeOff
      // )
      let cutKnifeR = this.ncSetting.knife.diameter / 2
      const realSurplusPosition = calcSurplusPositionByStartPosition(
        startPosition,
        surplusPosition,
        xyReverse
      )
      for (let i = 0; i < newData.length; ++i) {
        let title = `${newData[i].texture}:${newData[i].matCode}:${newData[i].thick}`
        if (newData[i]['brandName'] && newData[i]['supplierName']) {
          title += `:${newData[i].brandName}:${newData[i].supplierName}`
        }
        checkPlankDataIsCorrect(newData[i])
        filterNestedParts(newData[i].parts)
        for (let k = 0; k < newData[i].parts.length; ++k) {
          const part = newData[i].parts[k]
          const { startX, startY } = calcSurplusPosition(
            realSurplusPosition,
            part,
            cutKnifeR,
            { plankWidth, plankHeight }
          )
          let partRectWidth = 0
          let partRectHeight = 0
          partRectWidth = part.rect.width
          partRectHeight = part.rect.height
          let partInfo = {
            width: partRectWidth,
            height: partRectHeight,
            // startX: part.startX + cutKnifeR,
            // startY: plankHeight - partRectHeight - part.startY + cutKnifeR,
            startX: Number(startX),
            startY: Number(startY),
            isRotated: part.isRotated ? part.isRotated : false,
            partIndex: part.index,
            stockNum: part.stockNum,
            inPlankStockNum: part.inPlankStockNum,
            priority: part.priority,
          }
          if (part.surplusInfo) {
            partInfo.surplusInfo = part.surplusInfo
          }
          if (rectMap[title]) {
            rectMap[title].push(partInfo)
          } else {
            rectMap[title] = [partInfo]
          }
        }
      }
      const isDoorFrame =
        this.ncSetting.sawSetting?.mentaoji_enable &&
        this.ncSetting.sawSetting?.processType === 'doorFrame' &&
        isSawPaiban(this.$store)
      let obj = {
        ncConfig: {
          plankWidth: plankWidth ?? this.ncSetting.panelSize.plankWidth,
          plankHeight: plankHeight ?? this.ncSetting.panelSize.plankHeight,
          startPosition: calcStartPositionBySurplus(realSurplusPosition),
          // 后端要求不传该字段
          // xyReverse: xyReverse,
          cutDirection: cutDirection ?? '逆时针',
          gap: isDoorFrame ? 0 : this.ncSetting.panelSize.layoutGap,
          surplus_position: realSurplusPosition,
          new_cut_sequence: !!this.ncSetting.movePlankSetting
            ?.strong_suction_zones.length
            ? Boolean(this.ncSetting.movePlankSetting?.newCutSequence)
            : false,
          safe_length: this.ncSetting.movePlankSetting?.safe_length,
          strong_suction_zones:
            this.ncSetting.movePlankSetting?.strong_suction_zones,
          scattered_layout: this.ncSetting.movePlankSetting?.scattered_layout,
          OnlyCalCutPoint: onlyCalCutPoint,
        },
        layoutRectMap: rectMap,
        uid: this.userInfo.id,
      }
      this.showLoading = true
      if (sessionStorage.getItem('thinkerx_material')) {
        obj['from'] = '门窗erp'
      }

      const callBack = (res) => {
        if (res.status == 1) {
          let data = res.result.data
          for (let key in data) {
            for (let i = 0; i < data[key].length; ++i) {
              let newPosition = data[key][i]
              this.changePartPosition(key, newPosition, realSurplusPosition)
            }
          }
          applyLastCutPoint(this.paibanData, this.ncSetting.movePlankSetting)
          this.isRefresh = false
          this.showLoading = false
          for (let i = 0; i < this.drawData.length; ++i) {
            this.$nextTick(() => {
              this.$refs[`drawpart${i}`][0].renderAll()
            })
          }
          this.$message({
            type: 'success',
            message: this.$t('arrangedPage.recalcIndexSuccess'),
          })
          this.setBatchTaggingList([])
        }
      }

      const isWebQT =
        window.webToQt && Reflect.has(window.webToQt, 'calcPriority')

      const offlineCallBack = (res) => {
        const resObj = JSON.parse(res)
        callBack({
          status: resObj.code,
          result: resObj,
        })
        window.webToQt.calcPriorityFinished.disconnect(offlineCallBack)
      }

      if (isWebQT) {
        window.webToQt.calcPriorityFinished.connect(offlineCallBack)
        window.webToQt.calcPriority(obj)
      } else {
        await this.$token('/get_cal_priority', obj, callBack)
      }
    },
    handleChangeRemarks() {
      // 复选（Ctrl 多选）选中多块小板时，备注同样写入全部选中小板
      if (this.batchActiveIdList.length) {
        return this.batchChangeRemarks()
      }
      if (this.activePlank) {
        this.ableRewriteRemarks = false
        this.setPlankRemarksByCanvas(
          this.canvasKey,
          this.activePlank.stockKey,
          this.activePlank.oriPlankNum,
          this.activePlank.priority
        )
        this.$set(this.activePlank, 'plank_remarks', this.plankRemarks)
        buryPointApi('layout', 'edit_plank_remarks')
        this.isNeedUpdateBatch = true
        this.plankRemarks = ''
        this.setBatchTaggingList([])
      }
    },
    /**
     * @description 写入小板备注（原始料单数据 + 同大板下相同原始板号、相同切割顺序的小板），与单板编辑备注逻辑一致
     * @param {number} canvasKey - 画布下标
     * @param {string} stockKey - 大板标识
     * @param {number} oriPlankNum - 原始板号
     * @param {number} priority - 切割顺序
     * @returns {void}
     */
    setPlankRemarksByCanvas(canvasKey, stockKey, oriPlankNum, priority) {
      this.preLayoutData.forEach((nowPlank) => {
        if (oriPlankNum == nowPlank.oriPlankNum) {
          nowPlank.plank_remarks = this.plankRemarks
        }
      })
      const canvasData = this.drawData[canvasKey]?.data || []
      for (let i = 0; i < canvasData.length; i++) {
        if (canvasData[i].stockKey === stockKey) {
          canvasData[i].parts.forEach((nowPlank) => {
            if (
              oriPlankNum == nowPlank.oriPlankNum &&
              priority == nowPlank.priority
            ) {
              nowPlank.plank_remarks = this.plankRemarks
            }
          })
        }
      }
    },
    /**
     * @description 复选（Ctrl 多选）批量编辑备注，把同一备注写入全部选中小板
     * @returns {void}
     */
    batchChangeRemarks() {
      const targets = this.getBatchActiveTargets()
      this.ableRewriteRemarks = false
      if (!targets.length) return
      targets.forEach((item) => {
        this.setPlankRemarksByCanvas(
          item.canvasKey,
          item.bigpart.stockKey,
          item.part.oriPlankNum,
          item.part.priority
        )
        this.$set(item.part, 'plank_remarks', this.plankRemarks)
      })
      buryPointApi('layout', 'edit_plank_remarks')
      this.isNeedUpdateBatch = true
      this.plankRemarks = ''
      this.setBatchTaggingList([])
    },
    handleChangeRemarksAble(val) {
      this.ableRewriteRemarks = val
      this.plankRemarks = ''
      if (!this.plankRemarks) {
        this.plankRemarks = this.activePlank?.plank_remarks
      }
    },
    handleRewriteRemarks() {
      if (!this.plankRemarks) {
        // 复选时优先取激活小板备注，其次取任意一块已填写备注的选中小板
        const target = this.getBatchActiveTargets().find(
          (item) => item.part.plank_remarks
        )
        this.plankRemarks =
          this.activePlank?.plank_remarks || target?.part.plank_remarks || ''
      }
      this.ableRewriteRemarks = true
    },
    renderAll(isInitial) {
      this.drawData = this.finalDrawData
      if (this.drawData.length) {
        for (let i = 0; i < this.drawData.length; ++i) {
          this.$nextTick(() => {
            const drawpart = this.$refs[`drawpart${i}`][0]
            if (drawpart) {
              drawpart.startDraw()
              drawpart.renderAll()
            }
          })
        }
      }
    },
    changePartPosition(key, newPosition, realSurplusPosition) {
      const {
        xyReverse,
        drawPlankWidth,
        drawPlankHeight,
        knife,
        surplusPosition,
      } = this.ncSetting
      const isFromHistory = this.$route.query.from === 'history_paiabn'
      const pHeight = drawPlankHeight ?? this.selectStandardPlank.plankHeight
      const pWidth = drawPlankWidth ?? this.selectStandardPlank.plankWidth
      let plankHeight = xyReverse && isFromHistory ? pWidth : pHeight
      let plankWidth = xyReverse && isFromHistory ? pHeight : pWidth
      let cutKnifeR = knife.diameter / 2
      for (let i = 0; i < this.paibanData.length; ++i) {
        let title = `${this.paibanData[i].texture}:${this.paibanData[i].matCode}:${this.paibanData[i].thick}`
        if (this.paibanData[i].brandName && this.paibanData[i].supplierName) {
          title += `:${this.paibanData[i].brandName}:${this.paibanData[i].supplierName}`
        }
        if (title == key) {
          for (let k = 0; k < this.paibanData[i].parts.length; ++k) {
            let part = this.paibanData[i].parts[k]
            if (
              part.index == newPosition.index &&
              part.rect.width == newPosition.weight &&
              part.rect.height == newPosition.height &&
              part.stockNum == newPosition.stockNum
            ) {
              const { startX, startY } = calcSurplusPosition(
                realSurplusPosition,
                {
                  ...newPosition,
                  rect: {
                    width: newPosition.weight,
                    height: newPosition.height,
                  },
                },
                cutKnifeR,
                { plankWidth, plankHeight },
                true
              )
              part.startX = startX
              part.startY = startY
              // part.startX = newPosition.startX - cutKnifeR
              // part.startY =
              //   plankHeight + cutKnifeR - part.rect.height - newPosition.startY
              part.priority = newPosition.priority
              part.cutOrigin = newPosition.cutOrigin
            }
          }
        }
      }
    },
    // 删除板件
    async deletePlank() {
      // 复选（Ctrl 多选）选中多块小板时，删除操作同样应用到全部选中小板
      if (this.batchActiveIdList.length) {
        const targets = this.getBatchActiveTargetsForAction('删除')
        if (!targets.length) return
        const textureParts = this.getBatchMatchParts(
          targets,
          isTextureAlignmentPlank
        )
        if (textureParts.length) {
          if (this.isTextureConfirming) return
          this.isTextureConfirming = true
          const confirmed = await showTextureConfirmModal(
            this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
            textureParts
          )
          this.isTextureConfirming = false
          if (!confirmed) return
        }
        this.isVisible = true
        return
      }
      if (this.activePlank && isTextureAlignmentPlank(this.activePlank)) {
        if (this.isTextureConfirming) return
        this.isTextureConfirming = true
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          getSameGroupParts(this.activePlank, this.activeBigpart.parts)
        )
        this.isTextureConfirming = false
        if (!confirmed) return
      }
      if (this.activePlank) {
        this.isVisible = true
      } else {
        this.$message({
          message: '请先选中板件再进行此操作!',
          type: 'info',
        })
      }
    },
    // 确认删除板件
    async handleConfirmDeletePlank() {
      // 复选（Ctrl 多选）时批量删除全部选中小板
      if (this.batchActiveIdList.length) {
        return this.batchDeletePlank()
      }
      buryPointApi('layout', 'delete_plate')
      this.isNeedUpdateBatch = true
      let part = null
      for (let i = 0; i < this.drawData[this.canvasKey].data.length; ++i) {
        const oriBigpart = JSON.parse(
          JSON.stringify(this.drawData[this.canvasKey].data[i])
        )
        let bigpart = this.drawData[this.canvasKey].data[i]

        if (bigpart.stockKey == this.activePlank.stockKey) {
          // 找到对应的数据；普通待排版库板件删除后回到待排版库，补件只从大板移除。
          part = bigpart.parts.find(
            (item) => item.index == this.activePlank.index
          )
          if (!part?._isBujian) {
            const imgUrl = getPlankImage(part, false, {
              defaultScale,
              scale: 3,
              plankLineWidth: 1,
            })
            const data = await genAwaitStoreData(
              part,
              this.preLayoutData,
              imgUrl
            )
            this.$store.commit('awaitPaibanStore/setPlankToStore', data)
          }
          bigpart.parts.splice(
            bigpart.parts.findIndex(
              (item) => item.index == this.activePlank.index
            ),
            1
          )

          this.addDataToOperateArr({
            key: '删除小板',
            dataArr: [
              {
                type: 'form',
                current: {
                  partsNum: bigpart.parts.length,
                }, // 当前表单数据
                ori: {
                  partsNum: oriBigpart.parts.length,
                }, // 原始表单数据
                compareMsg: [
                  {
                    title: `${this.activePlank.partName}-大板序号：${bigpart.canvasIndex}`,
                    keys: ['partsNum'],
                  },
                ], // 要比较的内容
                formTextObj: {
                  partsNum: '小板数量',
                }, // key对应的意思
                formValueObj: {}, // value对应的意思
              },
            ],
          })
          calcBigpartArea(bigpart, this.ncSetting, this.isUnuseSurplus)
          this.dealOptimizeArea(this.drawData)
          updateBlueAreaSurplusPart(bigpart, this.ncSetting, [], this.drawData)
          this.$message.success(translate('common.deleteSuccess'))
          this.handleJudgeAbleFanban(bigpart, this.canvasKey)
          // 如果删除板件是待排版服务器上的数据则需要将板件再显示出来
          this.$store.commit(
            'awaitPaibanStore/showPlank',
            this.activePlank.partUniqueId
          )
          this.setBatchTaggingList([])
          break
        }
      }

      this.activePlank = null
      this.$nextTick(() => {
        // 调用渲染方法
        this.$refs[`drawpart${this.canvasKey}`][0].renderAll()
      })
      this.isVisible = false
      this.calcFanbanCount()
      this.onPartChange('delete', { partType: 'plank', data: part })
      // 删除板件后，检查是否影响复用关系
      const bigpart = this.drawData[this.canvasKey]?.data?.find(
        (b) => b.stockKey === part?.stockKey
      )
      this.clearReuseIfNeeded(bigpart)
    },
    /**
     * @description 复选（Ctrl 多选）批量删除小板，与单板删除保持一致的入库、统计与操作记录
     * @returns {Promise<void>}
     */
    async batchDeletePlank() {
      const targets = this.getBatchActiveTargets()
      this.isVisible = false
      if (!targets.length) {
        this.activePlank = null
        if (this.batchActiveIdList.length) {
          this.batchActiveIdList = []
          this.syncBatchActiveHighlight()
        }
        return
      }
      buryPointApi('layout', 'delete_plate')
      this.isNeedUpdateBatch = true
      // 按大板分组，删除后统一更新大板用料、余料与操作记录
      const bigpartMap = new Map()
      targets.forEach((item) => {
        if (!bigpartMap.has(item.bigpart)) {
          bigpartMap.set(item.bigpart, {
            bigpart: item.bigpart,
            canvasKey: item.canvasKey,
            partName: item.part.partName,
            oriPartsNum: item.bigpart.parts.length,
          })
        }
      })
      const deletedParts = []
      for (const item of targets) {
        const { bigpart, part } = item
        const partIndex = bigpart.parts.indexOf(part)
        if (partIndex === -1) continue
        // 普通待排版库板件删除后回到待排版库，补件只从大板移除
        if (!part?._isBujian) {
          const imgUrl = getPlankImage(part, false, {
            defaultScale,
            scale: 3,
            plankLineWidth: 1,
          })
          const data = await genAwaitStoreData(part, this.preLayoutData, imgUrl)
          this.$store.commit('awaitPaibanStore/setPlankToStore', data)
        }
        bigpart.parts.splice(partIndex, 1)
        deletedParts.push(part)
        // 待排版服务器上的数据删除后需要将板件再显示出来
        this.$store.commit('awaitPaibanStore/showPlank', part.partUniqueId)
      }
      if (deletedParts.length) {
        bigpartMap.forEach(({ bigpart, canvasKey, partName, oriPartsNum }) => {
          this.addDataToOperateArr({
            key: '删除小板',
            dataArr: [
              {
                type: 'form',
                current: {
                  partsNum: bigpart.parts.length,
                }, // 当前表单数据
                ori: {
                  partsNum: oriPartsNum,
                }, // 原始表单数据
                compareMsg: [
                  {
                    title: `${partName}-大板序号：${bigpart.canvasIndex}`,
                    keys: ['partsNum'],
                  },
                ], // 要比较的内容
                formTextObj: {
                  partsNum: '小板数量',
                }, // key对应的意思
                formValueObj: {}, // value对应的意思
              },
            ],
          })
          calcBigpartArea(bigpart, this.ncSetting, this.isUnuseSurplus)
          updateBlueAreaSurplusPart(bigpart, this.ncSetting, [], this.drawData)
          this.handleJudgeAbleFanban(bigpart, canvasKey)
          // 删除板件后，检查是否影响复用关系
          this.clearReuseIfNeeded(bigpart)
        })
        this.dealOptimizeArea(this.drawData)
        this.$message.success(translate('common.deleteSuccess'))
      }
      // 清空复选与激活状态后统一重绘
      this.activePlank = null
      this.batchActiveIdList = []
      this.syncBatchActiveHighlight()
      this.setBatchTaggingList([])
      this.calcFanbanCount()
      this.onPartChange('delete', {
        partType: 'plank',
        data: deletedParts.find((part) => part?._isBujian) || deletedParts[0],
      })
    },
    // 从暂存区拖拽出来时
    dragImg(e, item, index) {
      this.changeDragingPlank(true)
      this.$nextTick(() => {
        e.preventDefault()
        let imgDom = this.$refs[`tempImg${index}`][0]
        let imgBox = imgDom.getBoundingClientRect()
        // 计算点击的图片位置, 相对于图片的位置, 并用于后续拖动板件到大板时的位置判断
        this.imgPosition = {
          x: e.offsetX / imgBox.width,
          y: e.offsetY / imgBox.height,
        }
        this.setTempImgPos(this.imgPosition)
        this.setOffsetPointbetweenCacheImage({
          x: e.offsetX,
          y: e.offsetY,
        })
        // 记录现在鼠标相对于浏览器的位置
        let screenPos = {
          x: e.clientX,
          y: e.clientY,
        }
        // 点击的时候, 在鼠标位置生成原始大小的板件图片
        let img = null
        if (this.tempImg) {
          img = this.tempImg
        } else {
          img = new Image()
        }
        img.src = item.imgUrl
        new Promise((resolve) => {
          img.onload = function () {
            resolve({
              x: this.width,
              y: this.height,
            })
          }
        }).then((res) => {
          // 计算原始图片大小, 相当于从鼠标位置进行缩放
          let x = this.imgPosition.x * res.x
          let y = this.imgPosition.y * res.y
          this.imgRealSize = res
          let left = screenPos.x - x
          let top = screenPos.y - y
          // 记录图片缩放后鼠标相对于图片的偏移值
          this.setOffsetPointbetweenCacheImage({
            x: e.x - left,
            y: e.y - top,
          })
          // 设置其位置
          img.style.position = 'fixed'
          img.style.opacity = '0.7'
          img.style.left = left + 'px'
          img.style.top = top + 'px'
          img.style.display = 'block'
          img.style.zIndex = 1000
          // 挂载在页面上
          if (!this.tempImg) {
            document.body.appendChild(img)
          }
          this.tempImg = img
          this.mouseMoveEvent = this.mouseMoveFunc()
          window.addEventListener('mousemove', this.mouseMoveEvent)
          let that = this
          this.tempImg.onmouseup = function () {
            that.tempImg.style.display = 'none'
            window.removeEventListener('mousemove', that.mouseMoveEvent)
          }
        })

        this.recordBeDraggedPlank(item)
      })
    },
    mouseMoveFunc() {
      return (e) => {
        if (this.tempImg) {
          e.preventDefault()

          let x = this.imgPosition.x * this.imgRealSize.x
          let y = this.imgPosition.y * this.imgRealSize.y
          let left = e.clientX - x
          let top = e.clientY - y

          this.tempImg.style.left = left + 'px'
          this.tempImg.style.top = top + 'px'
        }
      }
    },
    async showSavePaiban() {
      if (await this.beforeCommonCheck()) {
        return
      }
      _hmt.push(['_trackEvent', '保存排版方案', 'click'])
      buryPointApi('layout', 'save_history')
      this.showSaveDialog = true
      this.dealHistoryName()
    },

    // 显示保存排版的弹窗, 传入一个参数作为保存的名称的后缀名
    dealHistoryName(suffix = '') {
      let date = new Date()
      let second = ('0' + date.getSeconds()).substr(-2, 2)
      let minute = ('0' + date.getMinutes()).substr(-2, 2)
      let hour = ('0' + date.getHours()).substr(-2, 2)
      let day = ('0' + date.getDate()).substr(-2, 2)
      let month = ('0' + (date.getMonth() + 1)).substr(-2, 2)
      let year = date.getFullYear()
      let name = `历史方案 ${year}-${month}-${day} ${hour}:${minute}:${second}`
      const noArr = dealGuimenFGNo(this.preLayoutData)
      let orderName = noArr.join(',')
      this.paibanWayName = `${orderName ?? name}${suffix ? '_' + suffix : ''}`
    },

    handleShowMoreResult() {
      // 暂时屏蔽功能显示升级中的弹窗
      this.alignedPlanDialog = !this.alignedPlanDialog
      buryPointApi('layout', 'more_paiban_result')
    },
    getMoreResultTipPopupContainer(triggerNode) {
      return triggerNode?.parentNode || document.body
    },
    handleMoreResultTipVisibleChange(visible) {
      // 受控：关闭只走右上角 x，忽略 hover 自动关闭；已关闭不因 hover 再开
      if (!visible || !this.moreResultTipVisible) {
        return
      }
    },
    handleCloseMoreResultTip() {
      this.moreResultTipVisible = false
    },
    handleOpenMoreResultTip() {
      this.moreResultTipVisible = true
    },
    // 前往排版图
    async gotoPaibanImg() {
      if (this.ncSetting.isPreLayout) {
        this.checkSettingChange()
        return
      }
      if (await this.beforeCommonCheck()) return
      if (this.checkIsEmptyPlank()) return
      this.isDownloadingNc = false
      this.$router.push({
        name: 'paibanImg',
      })
    },
    // 前往标签
    async gotoTagLabel(bigpart = null, isSubPrintTag = false, isLoadAllTag) {
      if (this.ncSetting.isPreLayout) {
        this.checkSettingChange()
        return
      }
      if (await this.beforeCommonCheck()) {
        return
      }
      this.currentOperate = 'tag'
      if (isSubPrintTag) {
        this.drawDataArr = [bigpart]
      }
      this.isSubtle = isSubPrintTag //精细排版的打印标签
      this.setIsPrintTag(true)
      _hmt.push(['_trackEvent', '打印标签', 'click'])
      buryPointApi('layout', 'to_tag')
      this.setIsSubPrintTag(isSubPrintTag)
      if (this.checkIsEmptyPlank()) return
      // if (this.isOnlyShowSurplus) {
      //   this.isOnlyShowSurplus = false
      //   this.handleShowSurplus()
      // }
      try {
        if (needApartPackUser.includes(this.userInfo.phone)) {
          this.loadingText = '正在加载预分包信息,请稍等...'
          this.isDownloadingNc = true
          const paibanData = await dealLblApartPackageCount(
            this.$store.state.preLayoutData,
            this.$store.state.paibanData,
            this.factoryId
          ).catch((err) => {
            this.$message.error(err)
          })
          if (paibanData) {
            this.setPaibanData(paibanData)
          }
        }
      } catch (err) {
        this.$message.error(err)
      } finally {
        this.setHasPrintTag(true)
        this.surplusBigpart = bigpart
        this.isDownloadingNc = false
        this.isTimeOut = false
        this.loadingText = '正在努力加载中......'
        this.$router.push({
          name: 'printTag',
          params: {
            bigpart,
            stockKey: bigpart?.stockKey,
            isLoadAllTag:
              isLoadAllTag && this.batchTaggingList.length ? true : false,
          },
        })
        // 排版页头部 打印标签按钮是加载全部标签 即需清空补标签数据
        if (isLoadAllTag) {
          this.setBatchTaggingList([])
        }
      }
    },

    // 部分操作公用的预检查预检查
    async beforeCommonCheck() {
      const ok = await this.checkAwaitLocalStore()
      return !ok
    },
    gotoTagLabelNew() {
      _hmt.push(['_trackEvent', '打印标签', 'click'])
      this.$router.push('/printTagNew')
    },
    checkIsEmptyPlank(msg = '标签打印') {
      const panbanDataArr = this.paibanData
      const arr = this.isSubtle ? this.drawDataArr : this.paibanData
      const emptyPlanks = arr.filter((item) => !item.parts.length)
      if (emptyPlanks.length) {
        const str = [...new Set(emptyPlanks.map((item) => item.stockKey))].join(
          '---'
        )
        this.$message.error(
          `存在${emptyPlanks.length}块空板<${str}>,请处理后再进行${msg}!`
        )
        return !!emptyPlanks.length
      }
      if (!panbanDataArr.length) {
        this.$message.error(`${translate('arrangedPage.noPaibanData')}${msg}!`)
        return !panbanDataArr.length
      }
    },
    /**
     * isNcFile: 是否为下载nc时自动保存的数据
     * （另外两个我不知道）
     * isFeedback: 是否是通过反馈的方式保存历史记录
     */

    savePaiban(
      isNcFile = false,
      isNCSave = false,
      src = '',
      isFeedback = false
    ) {
      if (!isNcFile && !isNCSave) {
        this.isSavePaiBanLoading = true
      }
      if (this.paibanWayName == '' && !isNcFile && !isNCSave) {
        if (!isNcFile && !isNCSave) {
          this.isSavePaiBanLoading = false
        }
        this.$message({
          message: translate('arrangedPage.historyNameErr'),
          offset: 60,
          duration: 1500,
          type: 'error',
        })
      } else {
        this.paibanData.forEach((item) => {
          item.parts.forEach((part) => {
            // 任意数据不相等则标识改变 板子位置数据 下刀点 切割顺序
            // 操作过板件旋转 板件翻面 板件无纹理
            if (part.oriMarkBoards) {
              // 如果没有oriMarkBoards，说明是历史数据
              // 还是用0.001来做容差比较
              if (
                Math.abs(part.startX - part.oriMarkBoards.startX) >= 0.001 ||
                Math.abs(part.startY - part.oriMarkBoards.startY) >= 0.001 ||
                part.cutOrigin !== part.oriMarkBoards.cutOrigin ||
                part.priority !== part.oriMarkBoards.priority ||
                part.mark_notcare ||
                part.mark_rotation ||
                part.reverePlank
              ) {
                part.modified = true
              } else {
                part.modified = false
              }
            }
          })
        })
        // 重绘当前内容
        this.renderAll()
        const recordData = {
          key: '订单: ' + this.paibanWayName, // 操作记录最外层的名字，比如：雕刻机
          operateArr: this.operateArr,
        }

        const time = new Date()
        const jsonFileName = `/bluenMaterialData/${
          this.$store.state.userInfo.id
        }/${time.getTime()}_${nanoid()}.json.gz`

        this.$getByToken('/get_oss_token', {}, async (res) => {
          if (res.status == 1) {
            let client = new OSS({
              region: 'oss-cn-hangzhou',
              accessKeyId: res.data.AccessKeyId,
              accessKeySecret: res.data.AccessKeySecret,
              stsToken: res.data.SecurityToken,
              bucket: 'eggrj',
            })
            // 处理保存历史的json文件数据
            const { jsonFile } = await this.dealJsonFile(jsonFileName, true)

            // 上传保存历史的json文件
            // 如果路径包含 /bluenMaterialData，设置 Content-Encoding: gzip 头
            const uploadOptions = jsonFileName.includes('/bluenMaterialData')
              ? {
                  headers: {
                    'Content-Type': 'application/json',
                    'Content-Encoding': 'gzip',
                  },
                }
              : {}
            const response = await client.multipartUpload(
              jsonFileName,
              jsonFile,
              uploadOptions
            )
            // 成功后拼接保存历史的json文件url
            if (response.res.status == 200) {
              let url =
                'https://eggrj.oss-cn-hangzhou.aliyuncs.com' + jsonFileName
              // 这里去处理获取排版批次
              if (this.fromWhtchBtn === 'saveHistory') {
                await this.getBatch()
                this.$store.commit('setHasDownloadedNC', true)
              }
              this.fromWhtchBtn = 'saveHistory'
              // 保存历史接口调用
              this.saveMaterialPaiban(
                url,
                isNcFile,
                isNCSave,
                src,
                null,
                isFeedback
              )
              genFinalRecord(recordData, `paiban`)
              if (!isNcFile && !isNCSave) {
                this.isSavePaiBanLoading = false
              }

              // 如果是反馈操作，则需要将文件压缩，然后上传至oss， 为什么呢 ，因为后端不愿意新增字段，需要使用v-html注入，a标签又无法直接下载json文件
              if (this.isFeedback) {
                this.isFeedback = false
                const { phone, name, id } = this.$store.state.userInfo
                const addFeedData = {
                  relatedModel: '云排版-排版反馈',
                  content: '',
                  appType: 3,
                  uid: id,
                  version: '',
                  feedbackPhone: phone,
                  feedbackName: name,
                }
                await Vue.prototype.$get('/latest_bluen_version', {}, (res) => {
                  if (res.status == 1) {
                    addFeedData.version = res.data.version
                  }
                })
                addFeedData.content = `<div class="mb-2 flex"><div class="w-20">保存历史:</div><div>${this.paibanWayName}</div><a class="ml-4" href="${url}" download="${this.paibanWayName}.json">下载</a></div><div class="mb-2 flex"><div class="w-20">${this.feedbackContent.key}:</div><div>${this.feedbackContent.content}</div></div>`
                addFeedback(addFeedData)
                  .then((res) => {
                    if (res.status === 1) {
                      this.$message.success(this.$translateLang('反馈成功!'))
                    } else {
                      this.$message.error(this.$translateLang('反馈失败!'))
                    }
                  })
                  .catch(() => {
                    this.$message.error(this.$translateLang('反馈失败!'))
                  })
              }
            } else {
              if (!isNcFile && !isNCSave) {
                this.isSavePaiBanLoading = false
              }
              this.$message({
                type: 'error',
                meesage: '上传失败!',
                duration: 1500,
                offset: 60,
              })
            }
          } else {
            if (!isNcFile && !isNCSave) {
              this.isSavePaiBanLoading = false
            }
          }
        })
      }
    },
    async saveMaterialPaiban(
      url,
      isNcFile,
      isNCSave = false,
      src = '',
      otherData = null,
      isFeedback = false
    ) {
      let plankList = this.bigPartsInfo
      // let plankList = this.bigPartsInfo.map((item) => {
      //   return {
      //     ...item,
      //     roomIds: [...new Set(item.roomIds.flat())],
      //     orderIds: [...new Set(item.orderIds.flat())],
      //   }
      // })
      let usedRate = this.paibanExtraInfo.total_used_rate
      let oids = this.orderInfo.order_ids
        ? this.orderInfo.order_ids.split(',').map(Number)
        : []
      const str = this.activePaibanWay[0].replace('_roll', '')
      const paibanWayStr = this.activePaibanWay[0].includes('roll')
        ? this.paibanWayList.find((e) => e.interface === str).name + '_少翻板'
        : this.paibanWayList.find((e) => e.interface === str).name
      const highgloss_direction = this.getHighgloss_direction
      /** 时间戳加在 filterObj 文件名 */
      const fileName = `filterObj_${new Date().getTime()}`
      const path = 'cloud_paiban/filterObj'
      const filterObjUrl = await saveDataToOSS(
        this.filterObject,
        fileName,
        path
      )
      const plankInfo = {
        historyUrl: url,
        plankTypeList: plankList,
        used_rate: usedRate,
        used_area: this.totalUsedArea,
        hasSaveSurplus: this.hasSaveSurplus,
        process_setting_name: this.ncSetting
          ? this.ncSetting.process_setting_name
          : '',
        order_codes: this.orderInfo.order_codes,
        isLessReverse: this.isLessReverse,
        isSpecialShape: this.isSpecialShape,
        paibanWay: this.activePaibanWay[0],
        layoutMethod: this.isSpecialShape
          ? paibanWayStr + '_计算异形'
          : paibanWayStr,
        paibanKey: this.paibanKey,
        filterObj: filterObjUrl,
        highgloss_direction,
        process_setting_id: this.ncSetting.process_setting_id ?? -2,
        process_setting_name:
          this.ncSetting.process_setting_name ??
          this.$store.state.recodrProductionLineChoose ??
          this.$t('preLayoutSetting.preWayEmpty'),
        preLayoutSettingUrl:
          otherData && otherData.preLayoutSettingUrl
            ? otherData.preLayoutSettingUrl
            : undefined,
        batch: this.orderInfo.batch
          ? Object.keys(this.orderInfo.batch).every((key) => {
              return this.orderInfo.batch[key] > 0
            })
          : false,
        is_des_material_no_cut: this.currentLine?.data?.is_des_material_no_cut,
        material_keywords_list: this.currentLine?.data?.material_keywords_list,
        hasMixPaibanPlans:
          !!this.$store.state.materialListStore?.selectedMixPaibanPlans?.length,
      }
      let obj = {
        name: this.paibanWayName,
        from: this.$route.query.from,
        plank_info: plankInfo,
        process_setting_id: this.ncSetting.process_setting_id ?? -2,
        order_list: oids,
        file_type: 'paiban',
        save_node: !this.showSaveDialog && this.isFollowExportTag ? 3 : 2,
        generate_batch: this.orderInfo.batch
          ? Object.keys(this.orderInfo.batch).every((key) => {
              return this.orderInfo.batch[key] > 0
            })
          : false,
        trimSide: this.ncSetting.trimSide,
        generate_batch_num: this.$store.state.typesettingBatch,
      }
      if (isNcFile) {
        let addressArr = []
        this.$store.state.preLayoutData.forEach((part) => {
          const str = part.groupNo ?? part.address
          if (!addressArr.includes(str)) {
            addressArr.push(str)
          }
        })
        obj.plank_info.isNcFile = src

        // 历史方案名称
        let name =
          this.isAutoPassData && isNCSave
            ? `${this.paibanWayName}_FromWebPage_生产线(${
                this.ncSetting?.process_setting_name ?? ''
              })`
            : `${addressArr.join('+')}_FromWebPage_生产线(${
                this.ncSetting?.process_setting_name ?? ''
              })`
        obj.name = isFeedback ? this.paibanWayName : name
      }

      if (
        this.orderInfo.needPaibanRoomIds &&
        this.orderInfo.needPaibanRoomIds.length > 0
      ) {
        obj.room_ids = this.orderInfo.needPaibanRoomIds
      }
      if (!isNCSave && !isNcFile) {
        obj.auto_save = 0
      } else {
        obj.auto_save = 1
      }
      const paibanListForHistory = this.paibanData ?? []
      obj.plank_info.hasSpecialBigPlank = paibanListForHistory.some((plank) =>
        isSpecialBigPlank(plank)
      )
      obj.plank_info.hasSurplusBigPlank = paibanListForHistory.some((plank) =>
        isSurplusBigPlank(plank)
      )
      //  TODO: 为了兼容后面如果想要手动关闭任务栏
      if (this.taskFn) {
        this.taskFn.delTask()
      }

      this.taskFn = createTask(
        {
          taskTitle: this.$translateLang('正在保存历史文件'),
          successMsg: this.$translateLang('保存历史文件成功'),
          errorMsg: this.$translateLang('保存历史文件失败'),
          isAutoClose: true,
        },
        1
      )
      const { task, switchTaskStatus } = this.taskFn
      try {
        const res = await saveHistory(obj)
        if (res.status == 1) {
          if (!obj.auto_save) {
            this.$message({
              type: 'success',
              message: translate('common.saveSuccess') + '!',
            })
          }
          let precessNum = 0
          let clearInervalTimer = setInterval(() => {
            if (precessNum >= 1 && clearInervalTimer) {
              window.clearInterval(clearInervalTimer)
            } else {
              precessNum += 0.2
              task(precessNum)
            }
          }, 200)
        } else {
          this.$message({
            type: 'error',
            message: res.message,
          })
          switchTaskStatus(TaskStatus.rejected)
        }
      } catch (err) {
        this.$message({
          type: 'error',
          message: err,
        })
        switchTaskStatus(TaskStatus.rejected)
      } finally {
        this.showSaveDialog = false
      }
    },
    // 跳转至柜柜云仓
    handlePlankShopinglist() {
      buryPointApi('layout', 'plate_purchase')
      const shoppingList = this.drawData.map((e) => {
        return {
          matCode: e.data[0].matCode,
          count: e.data.length,
          color: e.texture,
        }
      })
      this.genPaibanKey().then(() => {
        window.open(
          process.env.VUE_APP_ENV === 'production'
            ? `https://mensvsp.thinkerx.com/purchase?paiban_key=${this.paibanKey}&uid=${this.userInfo.id}&register_id=${this.factoryId}&source=ypb`
            : `https://mensvsp-dev.thinkerx.com/purchase?paiban_key=${this.paibanKey}&uid=${this.userInfo.id}&register_id=${this.factoryId}&source=ypb`
        )
      })
    },
    // 批量补标签
    handleBatchTagging() {
      this.isBatchTagging = true
      this.currentBatchTaggingList = []
      this.plankKeyWord = ''
      this.searchPlank('')
      this.clearAllActive()
      buryPointApi('layout', 'isBatchTagging')
    },
    handleCloseBatchTagging() {
      this.isBatchTagging = false
      this.currentBatchTaggingList = []
      this.clearAllActive()
      this.renderAll()
    },
    handleConfirmBatchTagging() {
      this.setBatchTaggingList(this.currentBatchTaggingList)
      this.gotoTagLabel()
    },

    drawParts(ctx, part, startX, startY, scale, way) {
      ctx.strokeStyle = '#0008'
      ctx.lineWidth = 1
      let rect = {
        x: startX + part.startX / scale,
        y: startY + part.startY / scale,
        width: part.rect.width / scale,
        height: part.rect.height / scale,
      }
      if (part.path) {
        for (let i = 0; i < part.path.length; ++i) {
          ctx.beginPath()
          for (let k = 0; k < part.path[i].length; ++k) {
            let x = rect.x + part.path[i][k].x / scale
            let y = rect.y + part.path[i][k].y / scale
            if (k == 0) {
              ctx.moveTo(x, y)
            } else {
              ctx.lineTo(x, y)
            }
          }
          ctx.closePath()
          ctx.stroke()
        }
      } else {
        ctx.strokeRect(rect.x, rect.y, rect.width, rect.height)
      }
      // 绘制孔、槽、牛角拉手、异型孔(只有排版图3才画)
      if (way == 3) {
        if (part.holes?.length > 0) {
          part.holes.forEach((hole) => {
            ctx.beginPath()
            ctx.arc(
              startX + (part.startX + hole.center.x) / scale,
              startY + (part.startY + hole.center.y) / scale,
              hole.diameter / 2 / scale,
              0,
              Math.PI * 2
            )
            ctx.closePath()
            ctx.stroke()
          })
        }
        if (part.slots?.length > 0) {
          part.slots.forEach((slot) => {
            const { x, y, width, height } = getSlotBasicInfo(slot, 'pt')
            ctx.beginPath()
            ctx.strokeRect(
              startX + (part.startX + x) / scale,
              startY + (part.startY + y) / scale,
              width / scale,
              height / scale
            )
            ctx.closePath()
          })
        }
        if (part.curveHoles?.length > 0) {
          part.curveHoles.forEach((curveHole) => {
            ctx.beginPath()
            for (let index = 0; index < curveHole.path.length; index++) {
              const curve = curveHole.path[index]
              let x, y
              x = startX + (part.startX + curve.x) / scale
              y = startY + (part.startY + curve.y) / scale
              if (index == 0) {
                ctx.moveTo(x, y)
              } else {
                ctx.lineTo(x, y)
              }
            }
            ctx.stroke()
            ctx.closePath()
          })
        }
        if (part.path?.length > 1) {
          part.path.forEach((path) => {
            ctx.beginPath()
            for (let index = 0; index < path.length; index++) {
              const curPath = path[index]
              let x, y
              x = startX + (part.startX + curPath.x) / scale
              y = startY + (part.startY + curPath.y) / scale
              if (index == 0) {
                ctx.moveTo(x, y)
              } else {
                ctx.lineTo(x, y)
              }
            }
            ctx.stroke()
            ctx.closePath()
          })
        }
        if (part.millInfo?.length > 0) {
          part.millInfo.forEach((mill) => {
            ctx.beginPath()
            for (let index = 0; index < mill.shape.length; index++) {
              const curMill = mill.shape[index]
              let x, y
              x = startX + (part.startX + curMill.x) / scale
              y = startY + (part.startY + curMill.y) / scale
              if (index == 0) {
                ctx.moveTo(x, y)
              } else {
                ctx.lineTo(x, y)
              }
            }
            ctx.stroke()
            ctx.closePath()
          })
        }
      }
    },
    drawText(ctx, part, startX, startY, scale) {
      let fontSize = 13
      ctx.fillStyle = '#333'
      ctx.font = `${fontSize}px 'PingFangSC-Regular, PingFang SC'`
      let lineHeight = 13
      let rect = {
        x: startX + part.startX / scale,
        y: startY + part.startY / scale,
        width: part.rect.width / scale,
        height: part.rect.height / scale,
      }
      let partInfo = `${part.realRect.height.toFixed(
        2
      )}*${part.realRect.width.toFixed(2)}*${part.thick}`

      const partName = part.partName ? part.partName : part.name
      let { y: partNameHeight, isFull } = this.wrapText(
        ctx,
        partName,
        rect.y + lineHeight,
        lineHeight,
        rect
      )
      if (!isFull) {
        this.wrapText(
          ctx,
          partInfo,
          lineHeight + partNameHeight,
          lineHeight,
          rect,
          'partInfo'
        )
      }
    },
    wrapText(ctx, text, y, lineHeight, rect, partInfo) {
      let { x, y: rectY, width: maxWidth, height: maxHeight } = rect
      let words = text.split('')
      let line = ''
      let isFull = false
      let textStartY = y
      let partNameHeight = partInfo ? y - rectY - lineHeight : 0
      for (let n = 0; n < words.length; n++) {
        let testLine = line + words[n]
        let metrics = ctx.measureText(testLine)
        let testWidth = metrics.width
        if (testWidth > maxWidth && n > 0) {
          if (y - textStartY + lineHeight + partNameHeight < maxHeight) {
            ctx.fillText(line, x, y)
            line = words[n] + ' '
            y += lineHeight
          } else {
            isFull = true
            line = ''
            break
          }
        } else {
          line = testLine
        }
      }
      ctx.fillText(line, x, y)
      return { y, isFull }
    },
    async getLabelPaibanImg() {
      let imgArr = {}
      if (this.ncSetting.labelingMachine) {
        let imgExportArr = []
        for (
          let i = 0;
          i < this.ncSetting.layoutImageSetting.layoutImage.length;
          ++i
        ) {
          let imgSetting = this.ncSetting.layoutImageSetting.layoutImage[i]
          let obj = {
            type: imgSetting.imageFormat,
            prefix: imgSetting.imageNamePrefix,
            direction: imgSetting.imageDirection == 'horiz' ? true : false, // 判断是横向图片还是竖向图片
            way: imgSetting.way,
            enable: imgSetting.enable,
          }
          if (obj.direction) {
            obj.width = imgSetting.imageSize[1]
            obj.height = imgSetting.imageSize[0]
          } else {
            obj.width = imgSetting.imageSize[0]
            obj.height = imgSetting.imageSize[1]
          }
          obj.index = i + 1
          imgExportArr.push(obj)
        }
        // 循环输出两种排版图
        for (let j = 0; j < imgExportArr.length; ++j) {
          if (!imgExportArr[j].enable) continue
          imgArr[j + 1] = []
          let direction = imgExportArr[j].direction
          // 创建canvas标签
          let oCanvas = document.createElement('canvas')

          // 设置canvas长宽
          oCanvas.width = Number(imgExportArr[j].width)
          oCanvas.height = Number(imgExportArr[j].height)
          let ctx = oCanvas.getContext('2d')
          let fontSize = 14
          // 如果是横向, 则需要切换旋转canvas, 切换canvas的长宽
          if (direction) {
            var temp = oCanvas.width
            oCanvas.width = oCanvas.height
            oCanvas.height = temp
          }
          // 循环绘制每一块大板 判断是否是精细排版，精细排版下载当前大板的排版图
          let subtleTypographyList = this.isSubtle
            ? this.drawDataArr
            : this.paibanData
          // 过滤出排版了但是仅加工孔槽的板件
          subtleTypographyList = subtleTypographyList.filter(
            (v) => !v.isDesMaterialNoCut
          )
          for (let i = 0; i < subtleTypographyList.length; ++i) {
            ctx.clearRect(0, 0, oCanvas.width, oCanvas.height)
            let center = {
              x: 0,
              y: 0,
            }
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, oCanvas.width, oCanvas.height)

            // 如果是横向, 则以中心点位置旋转, 并重新计算原点坐标
            if (direction) {
              center = {
                x: Math.round(oCanvas.width / 2),
                y: Math.round(oCanvas.height / 2),
              }
              ctx.translate(center.x, center.y)
              ctx.rotate(Math.PI / 2)
              ctx.translate(-center.y, -center.x)
            }

            // 设置绘制的属性
            ctx.fillStyle = '#fff'
            let finalScale = 0
            let startX = 0
            let startY = 0
            const bigPlankPath = subtleTypographyList[i].path
            const [minx, miny, maxx, maxy] = getPathMinMaxPoint(bigPlankPath)
            const plankWidth = maxx - minx
            const plankHeight = maxy - miny

            let scaleX = Number(plankWidth) / Number(imgExportArr[j].width - 64)
            let scaleY =
              Number(plankHeight) / Number(imgExportArr[j].height - 64)
            finalScale = scaleX > scaleY ? scaleX : scaleY
            startX =
              Math.abs(plankWidth / finalScale - imgExportArr[j].width) / 2
            startY =
              Math.abs(plankHeight / finalScale - imgExportArr[j].height) / 2
            ctx.beginPath()
            bigPlankPath.forEach((point, idx) => {
              const x = startX + point.x / finalScale
              const y = startY + point.y / finalScale
              if (idx === 0) {
                ctx.moveTo(x, y)
              } else {
                ctx.lineTo(x, y)
              }
            })
            ctx.closePath()
            ctx.stroke()

            // 将图片进行居中
            for (let k = 0; k < subtleTypographyList[i].parts.length; ++k) {
              let part = subtleTypographyList[i].parts[k]
              this.drawParts(
                ctx,
                part,
                startX,
                startY,
                finalScale,
                imgExportArr[j].way,
                direction,
                center
              )
            }

            if (direction) {
              ctx.translate(center.y, center.x)
              ctx.rotate(-Math.PI / 2)
              ctx.translate(-center.x, -center.y)
            }
            const size = getChildrenFolderFileSize(
              subtleTypographyList[i],
              this.ncSetting
            )
            ctx.fillStyle = '#333'
            ctx.font = `${fontSize}px 'PingFangSC-Regular, PingFang SC'`
            let str = `${subtleTypographyList[i].thick}${subtleTypographyList[i].matCode}${subtleTypographyList[i].texture}`
            let usedRate = subtleTypographyList[i].usedRate
              ? subtleTypographyList[i].usedRate >= 1
                ? `${(100).toFixed(2)}%`
                : `${(subtleTypographyList[i].usedRate * 100).toFixed(2)}%`
              : '0%'
            let textWidth = this.calcTextSize(str, fontSize)
            let textStartX = (oCanvas.width - textWidth) / 2
            let textStartY = direction ? startX : startY
            //排版图3单独处理
            if (imgExportArr[j].way == 3) {
              str = `第${i + 1}/${
                subtleTypographyList.length
              }张大板   利用率：${usedRate}`
              let strSecond = `材质:${subtleTypographyList[i].matCode}   颜色:${subtleTypographyList[i].texture}   规格：${size}`
              textWidth = this.calcTextSize(strSecond, fontSize)
              textStartX = (oCanvas.width - textWidth) / 2
              ctx.fillText(str, textStartX, textStartY - 20)
              ctx.fillText(strSecond, textStartX, textStartY - 4)
              for (let k = 0; k < subtleTypographyList[i].parts.length; ++k) {
                let part = subtleTypographyList[i].parts[k]
                this.drawText(ctx, part, startX, startY, finalScale)
              }
            } else {
              ctx.fillText(str, textStartX, textStartY - 4)
            }
            // 规定生成图片的文件格式
            const format = `image/${this.ncSetting.labelImageFormatNew}`
            let imgUrl = oCanvas.toDataURL(format)
            const num_auto_offset =
              this.ncSetting.layoutImageSetting.num_auto_offset
            const formatOrder = this.formatNumber(i + 1, num_auto_offset)
            let imgName = `${imgExportArr[j].prefix}${formatOrder}.${imgExportArr[j].type}`
            let index = imgExportArr[j].index

            if (imgExportArr[j].type === 'bmp') {
              const newBase64 = await convertJpegToBmp.convertJpegToBmp(imgUrl)
              imgUrl = newBase64.split(',')[1]
            }

            imgArr[j + 1].push({
              plankUniqueId: subtleTypographyList[i].bigPlankUniqueId,
              url: imgUrl,
              name: imgName,
              index: index,
              stock_key: subtleTypographyList[i].stockKey,
              // 将原始数据的长宽存储进去
              size,
              ext: `.${imgExportArr[j].type}`,
            })
          }
          if (document.body.contains(oCanvas)) {
            document.body.removeChild(oCanvas)
          }
        }
      }
      return imgArr
    },
    // 获取自定义排版图
    async getCustomPaibanImg() {
      let imgArr = {}
      let pdfArr = {}
      let paibanImgType = !this.confirmSendToFactory
        ? this.currentPaibanImgType
        : this.tagSetting.paibanImgType
      const modelRes = await fetchModelList()
      for (let item of modelRes?.data) {
        if (item.status === 1) {
          imgArr[item.name] = []
          // 循环绘制每一块大板 判断是否是精细排版，精细排版下载当前大板的排版图
          let subtleTypographyList = this.isSubtle
            ? this.drawDataArr
            : this.paibanData
          // 过滤出排版了但是仅加工孔槽的板件
          subtleTypographyList = subtleTypographyList.filter(
            (v) => !v.isDesMaterialNoCut
          )
          const modelDataRes = await fetchModelData(item.id)
          let templateData =
            modelDataRes.status === 1
              ? modelDataRes.data.data ?? defaultPaibanImgTemplate
              : defaultPaibanImgTemplate
          pdfArr[item.name] = {
            name: item.name,
            templateData,
            type: 'pdf',
            svg: [],
          }
          let createRes
          let chunkPaibanData = chunkArray(
            subtleTypographyList,
            this.$store.state.preferencesSetting.setting?.onePageNum
          )
          for (let [i, plank] of chunkPaibanData.entries()) {
            createRes = await createPaibanImg(templateData, plank, {
              total: subtleTypographyList.length,
            })

            if (paibanImgType.includes('picture')) {
              let { size } = getGraghEdge(plank[0])
              // 大板有L形和矩形两种情况
              const sizeList = size.split('*').splice(0, 2)
              size = `${sizeList[1]}*${sizeList[0]}`
              const num_auto_offset =
                this.$store.state.preferencesSetting.setting?.numAutoOffset
              const formatOrder = this.formatNumber(i + 1, num_auto_offset)
              let imgName = `${templateData.imageNamePrefix}${formatOrder}.${templateData.imageFormat}`
              if (templateData.bigPlank.isCustomName) {
                imgName = `${createRes.customNameText}${formatOrder}.${templateData.imageFormat}`
                // 添加大板序号数据源后 默认排版图序号就不需要生成
                if (
                  Object.values(
                    templateData.bigPlank.customName.label_keys
                  ).includes('canvasIndex')
                ) {
                  imgName = `${createRes.customNameText}.${templateData.imageFormat}`
                }
              }
              let url = createRes.base64
              if (templateData.imageFormat === 'bmp') {
                const newBase64 = await convertJpegToBmp.convertJpegToBmp(
                  createRes.base64
                )
                url = newBase64.split(',')[1]
              }
              imgArr[item.name].push({
                plankUniqueId: plank[0].bigPlankUniqueId,
                url: url,
                name: imgName,
                index: i,
                stock_key: plank[0].stockKey,
                // 将原始数据的长宽存储进去
                size,
                ext: `.${templateData.imageFormat}`,
              })
            }
            if (paibanImgType.includes('pdf')) {
              pdfArr[item.name].svg.push(createRes.svg)
            }
          }
        }
      }
      return { imgArr, pdfArr }
    },
    formatNumber(input, paddingValue) {
      // 获取输入的数字
      let number = parseInt(input, 10)
      // 获取补偿值
      let padding = parseInt(paddingValue, 10)
      // 计算最终补偿后的数字
      let formattedNumber = String(number).padStart(padding, '0')
      // 返回补偿后的结果
      return formattedNumber
    },
    calcTextSize(text, fontSize) {
      let span = document.createElement('span')
      let result = {}
      result.width = span.offsetWidth
      result.height = span.offsetHeight
      span.style.visibility = 'hidden'
      span.style.fontSize = `${fontSize}px`
      span.style.fontFamily = 'PingFangSC-Regular, PingFang SC'
      span.style.display = 'inline-block'
      document.body.appendChild(span)
      if (typeof span.textContent != 'undefined') {
        span.textContent = text
      } else {
        span.innerText = text
      }
      result.width =
        parseFloat(window.getComputedStyle(span).width) - result.width
      document.body.removeChild(span)
      let width = result.width
      return width
    },
    // 下载nc前的预检查
    async beforDownloadCheck(surplusPlank, isContinue, isSubtle) {
      let isReturn = false
      // 确保 ncSetting 数据是最新的
      if (this.ncSetting?.process_setting_id) {
        // 非预排版：从服务器获取最新设置
        try {
          const params = {
            setting_id: this.ncSetting.process_setting_id,
          }
          if (this.paibanTaskObj && !this.ncSetting.glass_setting) {
            const settingData = dealPreLayoutSettingFromNCSetting(
              this.paibanTaskObj.ncSetting
            )
            const hasSettingChanged = await comparePreLayoutSetting({
              setting_value: settingData,
              process_setting_id: this.ncSetting.process_setting_id,
              using_layout_task: true,
            })
            if (
              hasSettingChanged &&
              hasSettingChanged.status === 1 &&
              hasSettingChanged.data.total > 0
            ) {
              this.isSendToFactoryLoading = false
              this.hasConflict = true
              this.confilict = hasSettingChanged.data.data
              this.productionLineName = this.ncSetting.process_setting_name
              return true
            }
          }
          const res = await fetchGetProductionNcSetting(params)
          if (res.status === 1 && res.data) {
            const ncSetting = Object.assign(initProductionNcSetting(res.data), {
              process_setting_id: this.ncSetting.process_setting_id,
              process_setting_name: this.ncSetting.process_setting_name,
            })
            this.setNcSetting(ncSetting)
          }
        } catch (error) {
          console.error('获取最新 ncSetting 失败:', error)
        }
      }

      const {
        dock6FDrill,
        dock5FDrill,
        dock6FDrill_fileType,
        dock5FDrill_fileType,
        process_setting_id,
        process_setting_name,
        door_wall_aio,
      } = this.ncSetting
      // 检查五六钻模板是否存在
      // 检查五六钻模板是否存在 暂时校验不了模板下线情况（后端有做）
      let isTemplate56Error = false
      if (dock6FDrill || dock5FDrill) {
        let id = dock6FDrill
          ? dock6FDrill_fileType
          : dock5FDrill
          ? dock5FDrill_fileType
          : null
        if (!['xml2', 'mpr', 'ban', 'dxf', 'nc'].includes(id) && id) {
          const res = await getLoadDock56FModel({
            id: id,
          })
          if (!res.status) {
            // 五六钻模板不存在
            isTemplate56Error = true
          }
        }
      }
      // 检查门墙柜一体机模板
      let isTemplateDoorWallAioError = false
      if (door_wall_aio?.enable) {
        if (!door_wall_aio.model_id) {
          isTemplateDoorWallAioError = true
        } else {
          const res = await getLoadDoorWallAioModel({
            id: door_wall_aio.model_id,
          })
          if (!res.status) {
            isTemplateDoorWallAioError = true
          }
        }
      }
      if (
        (dock6FDrill && !dock6FDrill_fileType) ||
        (dock5FDrill && !dock5FDrill_fileType) ||
        isTemplate56Error ||
        isTemplateDoorWallAioError
      ) {
        isReturn = true
        let msg = ''
        let path = ''
        if (isTemplateDoorWallAioError) {
          msg = translate('doorWallCabinet.tempErrTip')
          path = `/integrateDoorWallCabinet?setting_id=${process_setting_id}&line=${process_setting_name}`
        } else {
          msg = translate('arrangedPage.tempErrTip')
          path = `/dockFiveSix?setting_id=${process_setting_id}&line=${process_setting_name}&equipType=fiveSix`
        }

        modalMsg(
          msg,
          'warning',
          translate('common.tip'),
          () => {
            this.isSendToFactoryLoading = false
            this.isNCBtnLoading = false
            this.$router.push(path)
          },
          {
            okText: translate('materialPage.goAdd'),
            cancelButtonProps: null,
            //ssss
            onCancel: () => {
              this.isSendToFactoryLoading = false
              this.isNCBtnLoading = false
            },
          }
        )
      }

      // 待排版库进行检查
      if (!(await this.checkAwaitLocalStore())) {
        isReturn = true
      }
      // // 开启标签按大板分不同文件夹 标签导出图片 检查
      // let nc_setting
      // if (this.ncSetting?.process_setting_id) {
      //   const nc_setting_res = await fetchGetProductionNcSetting({
      //     setting_id: this.ncSetting?.process_setting_id,
      //   })
      //   if (nc_setting_res.data) nc_setting = nc_setting_res.data
      let nc_setting = this.ncSetting
      if (nc_setting.laser_enable) {
        // 开料刀库
        const cutDockDataKnives = Object.values(nc_setting.knives)

        // 选择开料刀切换为激光刀取消勾选开料且置灰 再切换成其他刀
        if (
          cutDockDataKnives.length &&
          cutDockDataKnives.every((item) => item.cutable === false)
        ) {
          return message.warning(
            this.$translateLang('开料对接') +
              this.$translateLang(
                '刀库中请勾选“开料”选项的刀具，不然无法加工内部未切透异形'
              )
          )
        }
        // 所有小板数据(非余料的)
        const allParts = this.paibanData
          .map((bigpart) => bigpart.parts)
          .flat(1)
          .filter((part) => part.curveHoles?.length)
        // 所有未打穿内部异形数据
        const curveHoles =
          allParts
            .map((part) => {
              return part.curveHoles?.filter((hole) => hole.deep < part.thick)
            })
            .flat(1) || []
        if (curveHoles.length) {
          let diameter = curveHoles[0].diameter || 0
          let currentDiameter =
            cutDockDataKnives.find((knife) => knife.cutable).diameter || 0
          if (Number(diameter) !== Number(currentDiameter)) {
            return message.warning(
              this.$translateLang('设备对接参数已修改，请重新排版')
            )
          }
        }
        // 激光反面刀库
        const laserKnives = Object.values(nc_setting.back_knives)
        if (
          laserKnives.length &&
          laserKnives.every((key) => key.cutable === false)
        ) {
          return message.warning(
            this.$translateLang('激光一体机') +
              this.$translateLang(
                '刀库中请勾选“开料”选项的刀具，不然无法加工内部未切透异形'
              )
          )
        }
        const backKnives = Object.values(nc_setting.back_knives).find(
          (item) => item.type === 'laser'
        )
        const knives = Object.values(nc_setting.knives).find(
          (item) => item.type === 'laser'
        )
        if (backKnives && knives) {
          // 确保有刀再做刀径判断
          if (
            Number(backKnives.diameter) !== Number(knives.diameter) ||
            !backKnives.diameter ||
            !knives.diameter
          ) {
            isReturn = true
            message.warning(
              this.$translateLang(
                '开料刀库激光刀径和激光一体机激光刀径不一致，请检查'
              )
            )
          }
        }
        const cutableMillKnife = Object.values(nc_setting.knives).find(
          (item) => item.cutable === true
        )
        const cutableMillKnifeForLaser = Object.values(
          nc_setting.back_knives
        ).find((item) => item.cutable === true)
        if (cutableMillKnife && cutableMillKnifeForLaser) {
          if (
            Number(cutableMillKnife.diameter) !==
              Number(cutableMillKnifeForLaser.diameter) ||
            !cutableMillKnife.diameter ||
            !cutableMillKnifeForLaser.diameter
          ) {
            isReturn = true
            message.warning(
              this.$translateLang(
                '开料刀库下料刀径和激光一体机下料刀径不一致，请检查'
              )
            )
          }
        }
      }
      // }
      const { label_img_big_plank_folder } = nc_setting || this.ncSetting
      // 没勾选 小板标签
      const genSmallPlankLabel =
        !this.$store.state.preferencesSetting.setting.genSmallPlankLabel
      // 没勾选小板余料标签
      const genSmallPlankLabelForSur =
        !this.$store.state.preferencesSetting.setting
          .genSmallPlankLoaelForSurplus
      // 勾选了余料大板文件夹
      const isGenSurplusFolder =
        this.ncSetting.customizeFolder.is_gen_surplus_folder
      // 下载nc
      this.isNeedOpenModal =
        this.currentOperate === 'nc' &&
        !this.isWebToQt &&
        this.isFollowExportTag &&
        (genSmallPlankLabel || genSmallPlankLabelForSur) &&
        label_img_big_plank_folder &&
        this.isCanExportPic()

      this.isNeedOpenModalForSurFolder =
        this.currentOperate === 'nc' &&
        !this.isWebToQt &&
        this.isFollowExportTag &&
        isGenSurplusFolder &&
        label_img_big_plank_folder &&
        this.isCanExportPic()
      // 发送至车间
      this.isFactoryFlag =
        this.currentOperate === 'factory' &&
        this.isCanExportPic(this.tagSetting.tagDocType) &&
        (genSmallPlankLabel ||
          genSmallPlankLabelForSur ||
          isGenSurplusFolder) &&
        label_img_big_plank_folder
      if (
        this.isNeedOpenModal ||
        this.isNeedOpenModalForSurFolder ||
        this.isFactoryFlag
      ) {
        if (this.isNeedOpenModalForSurFolder)
          this.isShowConfirmForSurFolder = true
        if (this.isNeedOpenModal) this.isShowConfirmNoSmallTag = true
        if (this.isFactoryFlag) {
          if (genSmallPlankLabel || genSmallPlankLabelForSur) {
            this.isShowConfirmNoSmallTag = true
          }
          if (isGenSurplusFolder) {
            this.isShowConfirmForSurFolder = true
          }
        }

        this.confirmSendToFactory = false
        this.isSendToFactoryLoading = false
        isReturn = true
      }
      // 开启余料锁定 存在余料大板 下载NC判断使用余料是否被其它订单锁定
      if (
        this.$store.state.preferencesSetting.setting.surplus_lock &&
        surplusPlank &&
        Object.keys(surplusPlank) &&
        !isContinue
      ) {
        const order_address = this.orderInfo?.order_address?.replace(
          /\(.*?\)|历史记录/g,
          ''
        )
        if (
          this.useSurplusList.some(
            (item) => item.lock_status == 1 && item.lock_order != order_address
          ) &&
          !isSubtle
        ) {
          if (this.isShowConfirmNoSmallTag || this.isShowConfirmForSurFolder) {
            this.handleExportImg()
          }
          this.isShowSurplusLock = true
          isReturn = true
        } else {
          this.isShowSurplusLock = false
        }
        if (isSubtle) {
          this.handleExportImg()
          const newSurplus = this.useSurplusList.find(
            (item) => item.id == surplusPlank.surplusInfo.id
          )
          this.isShowSurplusLock = false
          if (
            newSurplus?.lock_status == 1 &&
            newSurplus?.lock_order != order_address
          ) {
            this.isShowSurplusLockNewSub = true
            isReturn = true
          } else {
            this.isShowSurplusLockNewSub = false
            isReturn = false
          }
        }
      }

      // 检查是否开启异形选刀的功能， 同时老数据无法兼容这个新功能
      if (this.$store.state.preferencesSetting.setting.inner_shape_tool_match) {
        const hasNativePath = this.paibanData
          .flatMap((data) => data.parts)
          .filter((part) => part.curveHoles?.length)
          .every((part) => part.curveHoles.find((hole) => hole.native_path))
        if (!hasNativePath) {
          message.error(
            '开启了异形自动选择刀具，排版数据异常，请从开料清单重新排版，或者关闭异形自动选刀功能'
          )
          return true
        }
      }

      return isReturn
    },
    /** 获取当前下载 NC 将使用的标签模板详情 */
    async fetchCurrentNcTagTemplateData() {
      try {
        if (this.confirmSendToFactory && this.tagSetting?.currentTagTemp) {
          const factoryTemp = this.tagSetting.currentTagTemp
          if (factoryTemp.data) {
            return typeof factoryTemp.data === 'string'
              ? JSON.parse(factoryTemp.data)
              : factoryTemp.data
          }
          if (factoryTemp.id != null) {
            const res = await fetchTagTemplate({
              id: factoryTemp.id,
              process_line_id: this.ncSetting.process_setting_id,
            })
            if (res.status) {
              return res.data?.data ?? res.data
            }
          }
          return null
        }
        const tempId =
          this.currentTagTempID ?? this.ncSetting?.tag_template_id ?? 0
        const listTemp = this.tagTempList?.find((temp) => temp.id === tempId)
        if (listTemp?.data) {
          const data =
            typeof listTemp.data === 'string'
              ? JSON.parse(listTemp.data)
              : listTemp.data
          if (data?.enable_sub != null) {
            return data
          }
        }
        const res = await fetchTagTemplate({
          id: tempId,
          process_line_id: this.ncSetting.process_setting_id,
        })
        if (res.status) {
          return res.data?.data ?? res.data
        }
      } catch (e) {
        console.error(e)
      }
      return null
    },
    /**
     * 自动贴标 + 副标模板时确认是否继续输出
     * @returns {Promise<boolean>} true 继续 / false 取消
     */
    async confirmLabelingSubTagTemplate() {
      // 同一次下载流程已确认过（如孔槽冲突忽略后重入），不再重复弹窗
      if (this.skipSubTagOnNcExport) {
        return true
      }
      // 未勾选顺带导出标签时不提示
      if (!this.isFollowExportTag) {
        return true
      }
      if (!this.ncSetting?.labelingMachine) {
        return true
      }
      const templateData = await this.fetchCurrentNcTagTemplateData()
      if (!templateData?.enable_sub) {
        return true
      }
      return new Promise((resolve) => {
        Vue.prototype.$antdConfirm({
          title: this.$translateLang('温馨提示'),
          content: this.$translateLang(
            '导出的标签带副标，自动贴标生产线暂时无法生成副标，是否继续输出？'
          ),
          okText: this.$translateLang('继续'),
          cancelText: this.$translateLang('取消'),
          centered: true,
          closable: true,
          onOk: () => {
            this.skipSubTagOnNcExport = true
            resolve(true)
          },
          onCancel: (close) => {
            if (typeof close === 'function') {
              close()
            }
            this.skipSubTagOnNcExport = false
            resolve(false)
          },
        })
      })
    },
    async handleDownloadNC(isSendToFactory = false, isContinue) {
      // 无深度计算权限时，当前使用方案若含深度结果则禁止下载
      if (
        this.checkUserPermissions([USER_PERMISSION_KEY.DEEP_SEARCH]) !== true
      ) {
        if (this.isUseDeepSearchPlan) {
          this.$message({
            type: 'error',
            message: this.$translateLang(
              '当前暂无深度计算排版权限，请联系销售购买后使用。'
            ),
            duration: 4000,
          })
          return
        }
      }

      this.progressTitle = isSendToFactory
        ? this.$translateLang('发至车间')
        : this.$translateLang('下载NC')
      // 全新下载时重置副标确认状态；忽略冲突后重入则保留
      if (!isContinue && !this.isContinue) {
        this.skipSubTagOnNcExport = false
      }
      // 记录点击的btn去区分是否需要排版批次
      this.fromWhtchBtn = isSendToFactory ? 'sendToFactory' : 'downloadNC'
      // 检查是否存在板件冲突
      const isConflict = this.isNotPlankConflict(this.paibanData)
      if (isConflict) return
      this.isSubtle = false
      // 未点击忽略
      if (this.notIgnore && !this.isContinue) {
        // 检查夹手处是否有孔槽
        const noClampHandConfilit = this.handleCheckClampHandPosition(
          'downloadNC',
          true
        )
        if (!noClampHandConfilit) return
      }
      this.notIgnore = true

      if (this.ncSetting.isPreLayout) {
        this.checkSettingChange()
        return
      }
      if (await this.beforeCommonCheck()) {
        return
      }
      // 检查本地所使用的目录是否存在
      if (
        !isSendToFactory &&
        !this.continueDownloadFlag &&
        !this.isContinue &&
        !(await this.$refs.folderChooseModalRef?.verify())
      ) {
        return
      }
      if (isSendToFactory) {
        this.currentOperate = 'factory'
      } else {
        this.currentOperate = 'nc'
      }
      this.currentDownloadType = 'paiban'
      let flag = this.judgeCutOrder()
      // 如果是精细排版，将数据传递给精细排版
      if (flag) {
        this.handleSeriesManipulate()
        return
      }
      if (this.isOnlyShowSurplus) {
        this.isOnlyShowSurplus = false
        this.handleShowSurplus()
      }
      const surplusPlank = this.paibanData.find(
        (item) =>
          item.surplusInfo &&
          Object.keys(item.surplusInfo).length &&
          !item.surplusInfo.isNotSurplus
      )
      if (surplusPlank) {
        this.useSurplusId = this.paibanData
          .map(
            (item) => !item.surplusInfo?.isNotSurplus && item.surplusInfo?.id
          )
          .filter((id) => id)
        const surplusRes = await getSurplusList({ page: 1, limit: 999 })
        const allSurplusList = surplusRes.status ? surplusRes.data.data : []
        this.useSurplusList = allSurplusList.filter((item) =>
          this.useSurplusId.includes(item.id)
        )
      }
      // 初始化下载nc的任务状态
      this.updateNcLifeObj()
      const { checkData, loadSetting } = this.ncLifeFuncObj
      checkData('start')
      const isReturn = await this.beforDownloadCheck(surplusPlank, isContinue)
      if (isReturn) {
        this.isNCBtnLoading = false
        return
      }
      const templateData = await this.fetchCurrentNcTagTemplateData()
      if (!(await validateSubTagPerForExport(templateData))) {
        this.isNCBtnLoading = false
        this.isSendToFactoryLoading = false
        this.isDownloadingNc = false
        return
      }
      const canContinueWithSubTag = await this.confirmLabelingSubTagTemplate()
      if (!canContinueWithSubTag) {
        this.isNCBtnLoading = false
        this.isSendToFactoryLoading = false
        this.isDownloadingNc = false
        return
      }
      checkData('end')
      loadSetting('start')
      this.isOutputCheck = true
      const isShowTrialDialog =
        await this.$refs.trialRef.checkUserSettingStatus(
          this.ncSetting.process_setting_id
        )
      // 如要弹出模态框则返回，走模态框逻辑
      this.isSendToFactoryLoading = false
      if (isShowTrialDialog) {
        this.isDownloadingNc = false
        this.isOutputCheck = false
        return
      }
      this.isNCBtnLoading = true
      this.subtleBigPart = null
      await this.beforeDownloadNC()
    },
    // 下载NC文件
    async beforeDownloadNC(subtleArr = [], isSubtle = false) {
      // 如果当前选中的操作是导出图片
      // 发送车间currentTagType 下载NCtagDocType
      const continueFlag =
        this.currentOperate == 'nc' &&
        this.isCanExportPic() &&
        this.print_color_tag &&
        this.ncSetting.labelImageFormatNew == 'bmp' &&
        this.ncSetting.bmp_color_style == 1 &&
        this.isFollowExportTag
      const res = await checkPlankEdgeHasChanged(this.baseMaterialData)
      const desMaterialNoCutRes = await checkDesMaterialNoCut()
      if (this.$refs.subtleRef) {
        this.$refs.subtleRef.changeLoading(false)
      }
      this.isOutputCheck = false

      if (!res || continueFlag || !desMaterialNoCutRes) {
        this.isShowTask = false
        this.isDownloadingNc = false
        this.showLoading = false
        this.isNCBtnLoading = false
        this.isRefresh = false
        if (continueFlag) {
          this.$message({
            type: 'error',
            message: translate('common.hoverTip'),
          })
        }
        return
      }
      this.isNCBtnLoading = true
      // 强制更新paibanData使其与finalDrawData中的data顺序保持一致
      this.handleSetNewPaibanData()
      this.isSubtle = isSubtle
      // 深拷贝后再改 texDir，避免污染内存中的 paibanData（余料入库会误显示无纹理）
      const drawDataArr = (this.drawDataArr = lodash.cloneDeep(
        isSubtle ? subtleArr : this.paibanData
      ))
      drawDataArr.forEach((e) => {
        e.parts.forEach((part) => {
          let partInPlankarr = this.plankArr.find(
            (plank) =>
              part.plankID === plank.plankID && part.index === plank.index
          )
          if (partInPlankarr && partInPlankarr.isNonTexture) {
            part.texDir = 'notcare'
          } else {
            part.texDir = part.srcTexDir || part.texDir
          }
        })
      })
      // 存在空的大板时， 结束执行函数，重置下载nc按钮状态
      if (this.checkIsEmptyPlank('文件下载')) {
        this.isNCBtnLoading = false
        return
      }
      if (
        (this.$store.state.userInfo.edition_id == 7 ||
          this.$store.state.userInfo.edition_id == 4) &&
        !sessionStorage.getItem('thinkerx_material')
      ) {
        let edition =
          this.$store.state.userInfo.edition_id == 7 ? '木工版' : '设计版'
        const h = this.$createElement
        this.$msgbox({
          title: translate('common.warning'),
          message: h('p', null, [
            h('i', { style: 'color: red' }, `抱歉，${edition}暂无此权限`),
            h('span', null, translate('arrangedPage.upgradeTip')),
          ]),
          showCancelButton: true,
          confirmButtonText: translate('arrangedPage.upgrade'),
          cancelButtonText: translate('common.cancel'),
          beforeClose(action, instance, done) {
            if (action == 'confirm') {
              window.open('https://www.eggrj.com/purchase.html')
            } else {
              done()
            }
          },
        }).catch((e) => {
          console.error(e)
        })
        return
      }
      const { labelCheck, colorRes: newColorRes } =
        this.judgeLimit(this.paibanData) ?? {}
      // 是否开启骨骼门加工时生成提示弹窗，且是否存在合并的骨骼门
      let isFrameDoorTip =
        this.$store.state.preferencesSetting.setting.isFrameDoorTip ?? true
      const frameDoorCheckData = isSubtle ? drawDataArr : this.paibanData
      if (
        !this.isFrameDoorConfirmed &&
        isFrameDoorTip &&
        frameDoorCheckData.some((item) =>
          item.parts.some((part) => judgeIsMergeFrameDoor(part))
        )
      ) {
        this.isShowFrameDoorModal = true
        this.isNCBtnLoading = false
        this.isSendToFactoryLoading = false
        return
      }
      // 当前排版结果存在孔槽冲突或孔槽深度异常
      if (
        ((this.isShowConflictPrompts || this.isDepthError()) &&
          !this.isContinue &&
          !this.isSubtle) ||
        ((this.judgmentConflicts(drawDataArr) ||
          this.isDepthError(drawDataArr)) &&
          this.isSubtle &&
          !this.isContinue)
      ) {
        this.isShowConflictModal = true
        this.isNCBtnLoading = false
        this.isSendToFactoryLoading = false
        return
      }
      let ncFlag =
        this.currentOperate == 'nc' &&
        !this.isWebToQt &&
        this.isFollowExportTag &&
        this.print_color_tag &&
        !this.continueDownloadFlag
      let factoryFlag =
        this.currentOperate == 'factory' &&
        this.print_color_tag &&
        !this.continueDownloadFlag
      // 如果开启了彩色标签，需要进行数据源限制数量检查
      if (ncFlag || factoryFlag) {
        this.limitTwelveList = []
        for (let key in labelCheck) {
          if (labelCheck[key].length > 12) {
            // 弹出提示弹窗
            this.limitTwelveList.push(key)
          }
        }
        if (this.limitTwelveList.length) {
          this.isShowConfirmColorTag = true
          this.isNCBtnLoading = false
          this.isSendToFactoryLoading = false
          return
        }
      }
      // 如果开启了彩色标签，需要判断是否需要重新生成新的颜色
      // TODO 生成颜色
      if (this.print_color_tag) {
        this.generateColor(labelCheck, newColorRes)
      }
      // 检查开启大板分不同文件夹 下载nc是否能导出图片
      if (this.isNeedOpenModal || this.isNeedOpenModalForSurFolder) {
        if (this.isNeedOpenModal) this.isShowConfirmNoSmallTag = true
        if (this.isNeedOpenModalForSurFolder)
          this.isShowConfirmForSurFolder = true
        this.isNCBtnLoading = false
        this.isSendToFactoryLoading = false
        return
      }
      // 检查扣减的状态，决定是否需要弹出扣减框
      this.checkDeductionStatus()
      if (this.isShowDeduction) {
        return
      }
      // 没有扣减项则继续下载nc
      this.handleContinueDownloadNc()
    },
    /** 获取需要扣减的余料数据 */
    getNeedDeductionSurplus(drawDataArr) {
      const surplusArr = []
      for (let i = 0; i < drawDataArr.length; ++i) {
        if (
          drawDataArr[i].surplusInfo &&
          Object.keys(drawDataArr[i].surplusInfo.length > 0) &&
          !drawDataArr[i].surplusInfo.isNotSurplus
        ) {
          surplusArr.push(drawDataArr[i].surplusInfo)
        }
      }
      return surplusArr
    },
    /** 检查是否需求扣减 */
    checkDeductionStatus() {
      this.deductionData.surplus = this.getNeedDeductionSurplus(
        this.drawDataArr
      )
      this.deductionData.awaitStore = []
      this.deductionData.bujian = []
      const { servePlankStore = [] } = this.$store.state.awaitPaibanStore
      this.drawDataArr.forEach((bigPlank) => {
        bigPlank.parts.forEach((plank) => {
          if (plank._isAwaitStorePlank && plank._awaitStoreId) {
            // 获取到数据前还需要检查一下，待排版库是否真的存在这个数据,避免用户删除再回来下载
            if (!servePlankStore.some((it) => it.id === plank._awaitStoreId))
              return
            this.deductionData.awaitStore.push({
              id: plank._awaitStoreId,
              type: 'awaitStore',
              new: true,
              plank,
            })
          }
          if (plank._isBujian && plank._bujianStoreId) {
            if (
              !store.state.bujianStore.queryCacheMap[
                this.bujianQueryKey
              ]?.data?.some((it) => it.id === plank._bujianStoreId)
            )
              return
            this.deductionData.bujian.push({
              id: plank._bujianStoreId,
              type: 'bujianStore',
              new: plank._isNewTableBujian,
              plank,
            })
          }
        })
      })
      // TODO: 需要新增是否展示扣减原片的项
      // 判断是否显示对应的选框
      this.deductionShowState.isShowSurplusDeduction =
        !!this.deductionData.surplus.length
      this.deductionShowState.isShowBujianDeduction =
        !!this.deductionData.bujian.length
      this.deductionShowState.isShowAwaitDeduction =
        !!this.deductionData.awaitStore.length
      // TODO: 暂时对所有人关闭此功能
      this.deductionShowState.isShowBaseMaterialDeduction = false
      // !!this.userInfo.userPlatform
      // 是否显示扣减的弹窗
      this.isShowDeduction =
        this.deductionShowState.isShowSurplusDeduction ||
        this.deductionShowState.isShowBujianDeduction ||
        this.deductionShowState.isShowAwaitDeduction ||
        this.deductionShowState.isShowBaseMaterialDeduction
    },
    /** 扣减补件和待排版库的板件 */
    deductionBujianAndAwaitStorePlank() {
      const { awaitStore, bujian } = this.deductionData
      const { isDeductionBujian, isDeductionPaibanStore } =
        this.$store.state.preferencesSetting.setting
      // 根据显示与选中情况决定是否执行
      if (!isDeductionBujian) {
        bujian.length = 0
      }
      if (!isDeductionPaibanStore) {
        awaitStore.length = 0
      }
      // 不存在任何 扣减项则不再执行
      if (!awaitStore?.length && !bujian?.length) return
      const [ids, news, planks] = [...awaitStore, ...bujian].reduce(
        (pre, next) => {
          pre[0].push(next.id)
          pre[1].push(next.new)
          pre[2].push(next.plank)
          return pre
        },
        [[], [], []]
      )
      if (!ids.length || !news.length) {
        return
      }
      deleteStoreData({
        ids: ids.join(),
        new: news.map((it) => (it ? 1 : 0)).join(),
      }).then(() => {
        // 补件或者待排版库扣减完成后重新获取补件库数据
        this.$store.dispatch('awaitPaibanStore/getServePlankData')
        // 扣减完成后将板件有关补件和待排版库的标识删除避免二次扣减
        planks.forEach((plank) => {
          plank._isAwaitStorePlank = false
          plank._isBujian = false
          // 删除预排版数据中的标识
          const target = this.preLayoutData.find(
            (it) => it.partUniqueId === plank.partUniqueId
          )
          if (target) {
            target._isAwaitStorePlank = false
            target._isBujian = false
          }
        })
      })
    },
    /** 扣减 余料/补件/待排版库的板件, 扣减lbl仓库原片*/
    async handleDeductionPlank() {
      this.closeDeductionModal()
      let surplusArr = this.getNeedDeductionSurplus(this.drawDataArr)
      // 被其它订单锁定余料id
      const otherOrderLock = this.useSurplusList
        .filter(
          (item) =>
            this.useSurplusId.includes(item.id) &&
            item.lock_status == 1 &&
            item.lock_order !=
              this.orderInfo.order_address.replace(/\(.*?\)|历史记录/g, '')
        )
        .map((item) => item.id)
      surplusArr = surplusArr.filter(
        (item) => !otherOrderLock.includes(item.id)
      )
      const arr = []
      const { isDeductionSurplus, surplus_lock, maintain_paiban_plank_lock } =
        this.$store.state.preferencesSetting.setting
      // 余料选择框显示且选择才进行处理
      if (
        this.deductionShowState.isShowSurplusDeduction &&
        isDeductionSurplus
      ) {
        for (let i = 0; i < surplusArr.length; ++i) {
          if (arr.length == 0) {
            arr.push({
              id: surplusArr[i].id,
              ggid: surplusArr[i].ggid,
              use_num: 1,
            })
          } else {
            let flag = true
            for (let k = 0; k < arr.length; ++k) {
              if (
                surplusArr[i].id === arr[k].id &&
                surplusArr[i].ggid === arr[k].ggid
              ) {
                arr[k].use_num++
                flag = false
                break
              }
            }
            if (flag) {
              arr.push({
                id: surplusArr[i].id,
                ggid: surplusArr[i].ggid,
                use_num: 1,
              })
            }
          }
        }
      } else if (surplus_lock && !isDeductionSurplus) {
        let currentOrderLockList
        if (!maintain_paiban_plank_lock) {
          // 解除当前订单锁定的余料
          currentOrderLockList = this.useSurplusList
            .filter(
              (item) =>
                this.useSurplusId.includes(item.id) &&
                item.lock_status == 1 &&
                item.lock_order ==
                  this.orderInfo.order_address.replace(/\(.*?\)|历史记录/g, '')
            )
            .map((item) => ({
              ...item,
              lock_status: 0,
              lock_num: this.useSurplusId.filter((id) => id == item.id).length,
            }))
        } else {
          // 选择维持锁定 解锁的余料被锁定
          currentOrderLockList = this.useSurplusList
            .filter(
              (item) =>
                this.useSurplusId.includes(item.id) && item.lock_status == 0
            )
            .map((item) => ({
              ...item,
              lock_status: 1,
              lock_order: this.orderInfo.order_address.replace(
                /\(.*?\)|历史记录/g,
                ''
              ),
              lock_num: this.useSurplusId.filter((id) => id == item.id).length,
            }))
        }
        const lockParams = {
          surplus: currentOrderLockList,
          release_all: false,
        }
        await surplusLock(lockParams)
      }
      await this.handleShowOrderMark(arr)
      if (!this.isShowOrderMark) {
        arr.length && (await useSurplusApi(arr))
        /** 扣减补件和待排版库的板件 */
        this.deductionBujianAndAwaitStorePlank()
        this.downloadNC(this.drawDataArr, this.isSubtle)
      }
    },
    /** 检查并下载nc文件 */
    async handleContinueDownloadNc() {
      await this.handleShowOrderMark()
      if (!this.isShowOrderMark) {
        this.downloadNC(this.drawDataArr, this.isSubtle)
      }
    },
    closeDeductionModal() {
      this.isShowDeduction = false
    },
    //定位问题板件,调用组件函数
    genLocationOfErrorPlank() {
      this.setActivePlank(0)
      this.searchPlankList = []
    },
    generateLabelNo(data) {
      const start = this.$store.state.ncSetting?.front_labeling_start_num || '0'
      const _no = Number(start) - 1
      if (data && data.length) {
        data.forEach((item) => {
          item.parts.forEach((it) => {
            it.auto_index = this.generateId(start, _no + it.priority)
          })
        })
      }
    },
    generateId(initStart, id) {
      let _id = id + ''
      if (_id.length < initStart.length) {
        _id = _id.padStart(initStart.length, 0)
      }
      return _id
    },
    // 下载NC文件
    async downloadNC(drawData = this.paibanData, isSubtle = false) {
      // 更新偏好设置
      // todo delete
      // await this.$store.dispatch('preferencesSetting/getSetting')
      // this.$store.dispatch('preferencesSetting/updateSetting')
      const { dealNCData, genPicFile, genPdfFile, loadSetting } =
        this.ncLifeFuncObj
      dealNCData('start')
      _hmt.push(['_trackEvent', '下载nc', 'click'])
      buryPointApi('layout', 'download_nc')
      // 重置参数
      this.imgZip = null
      this.labelImgList = []
      if (drawData.length == 0) {
        this.$message({
          message: translate('arrangedPage.noDataExport'),
          type: 'error',
        })
        return
      }

      let isBlank = drawData.every((v) => v.parts.length == 0)
      if (isBlank) {
        this.$message({
          message: translate('arrangedPage.noPlankExport'),
          type: 'error',
        })
        this.isNCBtnLoading = false
        return
      }

      // 关闭弹窗
      this.isSendToFactoryLoading = false
      // 发送车间不展示加载图片，下载NC时需要
      this.isDownloadingNc = true
      setTimeout(() => {
        this.isTimeOut = true
      }, 20000)
      let arr = []
      for (let i = 0; i < drawData.length; ++i) {
        if (drawData[i].parts.length == 0) continue
        let address = drawData[i].parts[0].address
        if (arr.length == 0) {
          arr.push(address)
        } else {
          if (!arr.includes(address)) {
            arr.push(address)
          }
        }
      }
      let name = ''
      let obj = await genFirstLevelFileName(true)
      const {
        data: { labeling_folder, label_image_folder },
      } = obj
      this.label_image_folder = label_image_folder
      store.commit('setLabelingFolder', labeling_folder)
      name = obj.firstLevelFileName
      let process_setting = JSON.parse(JSON.stringify(this.ncSetting))

      let imgArr = await this.getLabelPaibanImg()
      let pdfArr = {}
      // 开启自定义排版图 并且 下载nc勾选了顺带导出排版图并且非内嵌或者是发送车间 生成自定义排版图数据
      if (this.$store.state.preferencesSetting.setting?.isCustomPaibanImg) {
        if (
          (!this.isFollowExportPaibanImg || this.isWebToQt) &&
          !this.confirmSendToFactory
        ) {
          imgArr = {}
          pdfArr = {}
        } else {
          const cusRes = await this.getCustomPaibanImg()
          imgArr = cusRes.imgArr
          pdfArr = cusRes.pdfArr
          // 下载nc 顺带导出自定义排版图 埋点
          buryPointApi('paibanImgManage', 'download_nc_paibanImg')
        }
      }
      const dealArr = JSON.parse(JSON.stringify(drawData))
      const ncDownData = viewDataToNCData(dealArr)

      loadSetting('end')
      // 生成对应id
      changeDataStartPoint(ncDownData)

      for (let i = 0; i < ncDownData.length; ++i) {
        filterNestedParts(ncDownData[i].parts)
        // 大板上添加是否使用锯切刀 字段
        ncDownData[i].isUseSaw = ncDownData[i].parts.every(
          (part) => part.isUseSaw
        )
          ? true
          : false
      }
      let isNeedRecordSize = false
      for (let i = 0; i < drawData.length; ++i) {
        if (
          ncDownData[i].surplusInfo &&
          Object.keys(ncDownData[i].surplusInfo).length > 0 &&
          ncDownData[i].surplusInfo.isNotSurplus
        ) {
          isNeedRecordSize = true
          break
        }
      }
      // 处理所有异形路径点的顺序
      for (let i = 0; i < drawData.length; ++i) {
        // break
        // if (isNeedRecordSize) {
        if (!ncDownData[i].hasEdited) {
          if (
            ncDownData[i].surplusInfo &&
            Object.keys(ncDownData[i].surplusInfo).length > 0 &&
            ncDownData[i].surplusInfo.isNotSurplus
          ) {
            ncDownData[i].big_plank_size = {
              width: ncDownData[i].surplusInfo.width,
              height: ncDownData[i].surplusInfo.height,
              otherPlate: true,
            }
          } else {
            ncDownData[i].big_plank_size = {
              width: this.standardPlank.plankWidth,
              height: this.standardPlank.plankHeight,
              otherPlate: false,
            }
          }
        }

        // }
        for (let j = 0; j < ncDownData[i].parts.length; ++j) {
          let plank = ncDownData[i].parts[j]
          // oriCurveHoles
          ncDownData[i].parts[j].oriCurveHoles = ncDownData[i].parts[j]
            .oriCurveHoles
            ? JSON.parse(JSON.stringify(ncDownData[i].parts[j].oriCurveHoles))
            : []
          // realCurve
          if (plank.realCurve) {
            let realCurveArea = ClipperLib.JS.AreaOfPolygon(plank.realCurve)
            if (realCurveArea > 0) {
              let arr = plank.realCurve
              let cutCurve_1 = arr[0].b
              let flag = arr[1] && arr[1].b
              let len = arr.length
              for (let k = 0; k < len; ++k) {
                if (k == len - 1) {
                  if (arr[0].hasOwnProperty('b') && cutCurve_1) {
                    arr[k].b = -cutCurve_1
                    if (!flag) {
                      delete arr[0].b
                    }
                  }
                } else {
                  if (arr[k + 1].hasOwnProperty('b')) {
                    arr[k].b = -arr[k + 1].b
                    delete arr[k + 1].b
                  }
                }
              }
              plank.realCurve.reverse()
            }
          }
          // realCurveEx
          if (plank.realCurveEx) {
            for (let k = 0; k < plank.realCurveEx.length; ++k) {
              let realCurveExArea = ClipperLib.JS.AreaOfPolygon(
                plank.realCurveEx[k]
              )
              if (realCurveExArea > 0) {
                let arr = plank.realCurveEx[k]
                let cutCurve_1 = arr[0].b
                let flag = arr[1] && arr[1].b
                let len = arr.length
                for (let k = 0; k < len; ++k) {
                  if (k == len - 1) {
                    if (arr[0].hasOwnProperty('b') && cutCurve_1) {
                      arr[k].b = -cutCurve_1
                      if (!flag) {
                        delete arr[0].b
                      }
                    }
                  } else {
                    if (arr[k + 1].hasOwnProperty('b')) {
                      arr[k].b = -arr[k + 1].b
                      delete arr[k + 1].b
                    }
                  }
                }
                plank.realCurveEx[k].reverse()
              }
            }
          }
          // cutCurve
          if (plank.cutCurve) {
            let cutCurveArea = ClipperLib.JS.AreaOfPolygon(plank.cutCurve)
            if (cutCurveArea > 0) {
              let arr = plank.cutCurve
              let cutCurve_1 = arr[0].b
              let flag = arr[1] && arr[1].b
              let len = arr.length
              for (let k = 0; k < len; ++k) {
                if (k == len - 1) {
                  if (arr[0].hasOwnProperty('b') && cutCurve_1) {
                    arr[k].b = -cutCurve_1
                    if (!flag) {
                      delete arr[0].b
                    }
                  }
                } else {
                  if (arr[k + 1].hasOwnProperty('b')) {
                    arr[k].b = -arr[k + 1].b
                    delete arr[k + 1].b
                  }
                }
              }
              plank.cutCurve.reverse()
            }
          }
          // curCurveEx
          if (plank.cutCurveEx) {
            for (let k = 0; k < plank.cutCurveEx.length; ++k) {
              let cutCurveExArea = ClipperLib.JS.AreaOfPolygon(
                plank.cutCurveEx[k]
              )
              if (cutCurveExArea > 0) {
                let arr = plank.cutCurveEx[k]
                let cutCurve_1 = arr[0].b
                let flag = arr[1] && arr[1].b
                let len = arr.length
                for (let k = 0; k < len; ++k) {
                  if (k == len - 1) {
                    if (arr[0].hasOwnProperty('b') && cutCurve_1) {
                      arr[k].b = -cutCurve_1
                      if (!flag) {
                        delete arr[0].b
                      }
                    }
                  } else {
                    if (arr[k + 1].hasOwnProperty('b')) {
                      arr[k].b = -arr[k + 1].b
                      delete arr[k + 1].b
                    }
                  }
                }
                plank.cutCurveEx[k].reverse()
              }
            }
          }
          // opath
          if (plank.oPath) {
            for (let k = 0; k < plank.oPath.length; ++k) {
              let oPathArea = ClipperLib.JS.AreaOfPolygon(plank.oPath[k])
              if (oPathArea > 0) {
                plank.oPath[k].reverse()
              }
            }
          }
          // path
          if (plank.path) {
            for (let k = 0; k < plank.path.length; ++k) {
              let pathArea = ClipperLib.JS.AreaOfPolygon(plank.path[k])
              if (pathArea > 0) {
                plank.path[k].reverse()
              }
            }
          }
          // 孔槽处理
          const { thick, slots, holes } = plank
          const curveHoles = plank.curveHoles ?? []
          const handleSlopes = plank.handleSlopes ?? []
          const holeAllPenetrate = holes.every(
            (it) => it.deep * 1 + 0.001 >= thick && !it.isFixedSide
          )
          const curveHolesAllPenetrate = curveHoles.every(
            (it) => it.deep * 1 + 0.001 >= thick
          )
          const slotAllPenetrate = slots.every(
            (it) => it.deep * 1 + 0.001 >= thick
          )
          if (holeAllPenetrate && slotAllPenetrate && curveHolesAllPenetrate) {
            const { xyReverse } = this.ncSetting
            holes.forEach((hole) => {
              // 有此标志的孔槽不受（只存在通孔通槽默认在大阪正面）规则的影响
              if (xyReverse && !hole?.specialRuleFlag) {
                hole.side = -1
              }
            })
            slots.forEach((slot) => {
              // 有此标志的孔槽不受（只存在通孔通槽默认在大阪正面）规则的影响
              if (xyReverse && !slot?.specialRuleFlag) {
                slot.side = -1
              }
            })
            handleSlopes.forEach((slope) => {
              // 判断symbol是不是haitang_corner
              if (xyReverse && slope.symbol !== 'haitang_corner') {
                slope.side = -1
              }
            })
            curveHoles.forEach((cHole) => {
              if (xyReverse) {
                cHole.side = -1
              }
            })
          }
        }
      }
      if (this.userInfo.edition_id == 4) {
        for (let i = 0; i < ncDownData.length; ++i) {
          for (let k = 0; k < ncDownData[i].parts.length; ++k) {
            let plank = ncDownData[i].parts[k]
            plank.holes = []
            plank.sholes = []
            plank.sslots = []
            plank.slots = []
          }
        }
      }

      // 门窗ERP跳转需要给他们传一些数据
      const userFactoryId = this.userInfo.factory_id
      const userPlatform = this.userInfo.platform
      if (
        sessionStorage.getItem('thinkerx_material') ||
        userFactoryId ||
        userPlatform == 7
      ) {
        //大板信息
        let partPlanks = this.$store.state.preLayoutData
        let mcData = {
          factory_id: userFactoryId ? userFactoryId : partPlanks[0].factoryId,
          order_ids: '',
          fog_ids: '',
          result_data: [],
        }
        partPlanks.forEach((item) => {
          if (mcData.order_ids) {
            if (mcData.order_ids.indexOf(item.orderId) == -1) {
              mcData.order_ids += `,${item.orderId}`
            }
          } else {
            mcData.order_ids += item.orderId
          }
          if (mcData.fog_ids) {
            if (mcData.fog_ids.indexOf(item.groupId) == -1) {
              mcData.fog_ids += `,${item.groupId}`
            }
          } else {
            mcData.fog_ids += item.groupId
          }
        })
        drawData.forEach((item) => {
          let plankObj = {
            order_ids: '',
            fog_ids: '',
            count: item.parts.length,
            thing_id: item.parts[0].thingId ? item.parts[0].thingId : '',
            content: item.parts,
          }
          item.parts.forEach((e) => {
            if (plankObj.order_ids) {
              if (plankObj.order_ids.indexOf(e.orderId) == -1) {
                plankObj.order_ids += `,${e.orderId}`
              }
            } else {
              plankObj.order_ids += e.orderId
            }
            if (plankObj.fog_ids) {
              if (plankObj.fog_ids.indexOf(e.groupId) == -1) {
                plankObj.fog_ids += `,${e.groupId}`
              }
            } else {
              plankObj.fog_ids += e.groupId
            }
          })
          mcData.result_data.push(plankObj)
        })
        const dealAfterData = this.thinkerxMaterialSkip()
        this.$post(
          '/window_save_optimization',
          { ...dealAfterData },
          (res) => {}
        )
      }

      // 如果是下载nc每一次都需要调用 await this.getBatch()
      // 如果是发送至车间，需要判断1、是否存在排版批次，不存在则调用，同时需要满足，如果有下载过NC的话需要再次调用一次await this.getBatch()
      if (this.fromWhtchBtn == 'downloadNC') {
        this.$store.commit('setHasDownloadedNC', true)
      }

      // 判断是否需要执行 getBatch
      const shouldGetBatch =
        this.fromWhtchBtn == 'downloadNC' ||
        (!this.$store.state.typesettingBatch &&
          this.fromWhtchBtn == 'sendToFactory') ||
        (this.fromWhtchBtn == 'sendToFactory' &&
          this.$store.state.hasDownloadedNC) ||
        (this.fromWhtchBtn == 'sendToFactory' && this.isNeedUpdateBatch)

      if (shouldGetBatch) {
        await this.getBatch()
      }
      if (this.fromWhtchBtn == 'sendToFactory') {
        this.$store.commit('setHasDownloadedNC', false)
        this.fromWhtchBtn = 'saveHistory'
        this.isNeedUpdateBatch = false
      }
      if (isSubtle) {
        name =
          handleGenFileNameStr([this.subtleBigPart], {
            ...this.$store.state.ncSetting?.customizeFolder,
            max_file_name:
              this.$store.state.ncSetting?.customizeFolder.max_file_name -
              `(大板${this.currentIndex})`.length,
          }) + `(大板${this.currentIndex})`
      }
      if (process_setting.glass_setting) {
        // 给每一个大板添加修边尺寸数据
        const data = JSON.parse(JSON.stringify(ncDownData)).map((item) => {
          return {
            ...item,
            trim_size: this.standardPlank.plankEdgeOff,
          }
        })
        collector.setOriginNcData(data)
        collector.setNcSetting(window.$copy(this.ncSetting ?? {}))
        const glassFileFunc = async () => {
          const { data: res } = await axios({
            url: process.env.VUE_APP_BASE_URL + '/glass',
            method: 'POST',
            data: {
              setting_id: process_setting.process_setting_id,
              data,
            },
            headers: {
              token: window.sessionStorage.getItem('token'),
            },
          })
          if (res.status === 1) {
            const files = await this.genFileUrls(res.data)
            if (files && files.length) {
              this.downloadFile(
                files,
                name,
                imgArr,
                pdfArr,
                isNeedRecordSize,
                isSubtle
              )
              this.isNCBtnLoading = false
            }
          }
        }
        // 玻璃切割机下载NC
        await glassFileFunc()
        dealNCData('end')
        if (this.proucePopupState.mark_action) {
          const data = {
            order_ids: [...new Set(this.orderIds)],
            mark_action: this.proucePopupState.mark_action,
          }
          await updateProduceStatus(data)
        }
      } else {
        const newNCFileLoadFunc = async (isSendToFactory = false) => {
          const embedded = sessionStorage.getItem('embedded') ? 1 : 0
          const guigui_version = sessionStorage.getItem('guigui_version')
          let plate_knife_map = this.ncSetting.plate_knife_map
          ncDownData.forEach((nc) => {
            let p = 0
            for (const key in plate_knife_map) {
              const current = plate_knife_map[key]
              const matchResult = matchOriginalPlankknife(current, nc, p)
              if (matchResult.result) {
                p = matchResult.priority
                nc.plankKnife = current.knife
                if (this.ncSetting.laser_enable) {
                  nc.plankKnife = this.ncSetting.knife.desc
                }
              }
            }
          })
          this.generateLabelNo(ncDownData)
          const copyData = JSON.parse(JSON.stringify(ncDownData))
          const payloadData = copyData.map((plank) => {
            return {
              ...plank,
              parts: plank.parts.map((part) => {
                const { texture, oriTexture } = part
                return {
                  ...part,
                  texDir: part.texDir == 'reverse' ? 'normal' : part.texDir,
                  form_data: {
                    width:
                      part.srcTexDir != 'reverse'
                        ? Number(this.showPartSize('oRect', 'width', part))
                        : Number(this.showPartSize('oRect', 'height', part)),
                    height:
                      part.srcTexDir != 'reverse'
                        ? Number(this.showPartSize('oRect', 'height', part))
                        : Number(this.showPartSize('oRect', 'width', part)),
                  },
                  // 用于混排字段处理， 后端要求texture和oriTexture一致都表示原始值，newTexture表示新的值
                  texture: oriTexture,
                  newTexture: texture,
                }
              }),
              // xy互换大板的四边修边已经转了，传给nc要转回去
              margin: fourTrimEdge(
                String(
                  plank.surplusInfo && plank.surplusInfo.is_plus
                    ? plank.isUseSaw
                      ? plank.margin
                      : store.state.selectStandardPlank.plankEdgeOff
                    : plank.margin
                ),
                this.ncSetting
              ),
            }
          })
          // parts按切割顺序进行升序排序
          payloadData.forEach((item) => {
            item.parts.sort((a, b) => a.priority - b.priority)
          })
          // 锯片切割增加longPlankFlag参数 长板加工生效的板件(门板和厚度超过xx的常规板)
          // 判断是否开启长板二次加工
          let {
            longPlankMinLength: longSide,
            longPlankShortMinLength: shortSide,
            longPlankExpandedSize: lpes,
            longPlankShortExpandedSize: lpses,
            longPlankCuttingEnable,
            cutSingleDoor,
            cutGeneralPlank,
            generalPlankThick,
            single_door_thick,
            specified_board_secondary_cutting,
            secondary_cutting_board_list,
          } = this.ncSetting.longPlankCuttingSetting
          payloadData.forEach((item) => {
            // 给大板上传递焊接板的标识
            if (item.parts.some((part) => part.isWeldingPlank)) {
              item.isWeldingPlank = true
            }
            const surplusInfo = item.surplusInfo
            if (
              surplusInfo &&
              surplusInfo.is_plus &&
              surplusInfo.shape == 'lshape' &&
              surplusInfo.path &&
              surplusInfo.path.length
            ) {
              Object.assign(surplusInfo, dealLshapeTurnPoints(surplusInfo.path))
            }
          })
          if (longPlankCuttingEnable) {
            payloadData.forEach((item) => {
              item.parts.forEach((it) => {
                // // 判断板子是否是门板或者厚度超过xx的常规板或者指定板件名称二次切割开关开启后，小板名称包含指定的板件名称
                // const rectWH = [it.rect.width, it.rect.height]
                // const partLongSide = Math.max(...Object.values(rectWH))
                // const partShortSide = Math.min(...Object.values(rectWH))
                // const partName = it.partName || it.name || ''
                // if (
                //   ((it.type == 'SingleDoor' &&
                //     cutSingleDoor &&
                //     it.thick >= Number(single_door_thick)) ||
                //     (it.type == 'Plank' &&
                //       cutGeneralPlank &&
                //       it.thick > generalPlankThick) ||
                //     (specified_board_secondary_cutting &&
                //       secondary_cutting_board_list.some((item) =>
                //         partName.includes(item)
                //       ))) &&
                //   partLongSide > longSide &&
                //   partShortSide > shortSide
                // ) {
                //   it.longPlankFlag = true
                // } else {
                //   it.longPlankFlag = false
                // }
                if (isLongPlateProcessing(it, this.ncSetting)) {
                  it.longPlankFlag = true
                } else {
                  it.longPlankFlag = false
                }
              })
            })
          } else {
            payloadData.forEach((item) => {
              item.parts.forEach((it) => {
                it.longPlankFlag = false
              })
            })
          }

          // 需要删除payloadData数组对象中parts数组中的带有blueAreaSurplus字段的板件
          const payloadDataCopy = JSON.parse(JSON.stringify(payloadData))
          payloadDataCopy.forEach((item) => {
            item.parts = item.parts.filter((it) => !it.blueAreaSurplus)
            // 添加封边描述信息
            item.parts.forEach((part) => {
              part.edgeInfo_desc_LW = getEdgeTypeWithRect(
                part.edgeInfo,
                part.rect
              )
            })
          })
          payloadDataCopy.forEach((item) => {
            item.parts.forEach((part) => {
              if (judgeIsMergeFrameDoor(part)) {
                // 清掉合并骨骼门 为绘制所构造的线槽数据（如果不删除 后端会去加工）
                part.lineSlots = []
              }
            })
          })
          // 仅保留 /new_nc 需要的小板字段，去掉无用字段减小请求体积
          payloadDataCopy.forEach((item) => {
            item.parts = item.parts.map((part) => pickNcPartFields(part))
          })
          const ncData = JSON.stringify(payloadDataCopy)
          const ncDataObj = JSON.parse(ncData)
          collector.setOriginNcData(ncDataObj)
          collector.setNcSetting(window.$copy(this.ncSetting ?? {}))

          //-------------------------------------------------------------------
          const { waste_setting } = this.ncSetting
          const { data: res } = await axios({
            url: process.env.VUE_APP_BASE_URL + '/new_nc',
            method: 'POST',
            data: {
              uid: this.userInfo.id,
              data: ncData,
              id:
                process_setting.process_setting_name == '默认生产线'
                  ? -1
                  : process_setting.process_setting_id,
              keepKnifeOrigin: true,
              from: 'web',
              embedded,
              guigui_version,
              version: 'v1',
              longPlankCuttingSetting: this.ncSetting.longPlankCuttingSetting,
              waste_setting,
              generate_batch_num: this.$store.state.typesettingBatch,
            },
            headers: {
              token: window.sessionStorage.getItem('token'),
            },
          })

          const { subfolderNameStr } =
            this.$store.state.mergeFolderSetting ??
            this.ncSetting.customizeFolder
          const needSizeArr = ['板件长宽', '文件数自增']
          if (!isSendToFactory)
            await genMergeSubFolderData(
              this.paibanData,
              needSizeArr.some((item) => subfolderNameStr.includes(item))
                ? true
                : false,
              this.$store.state.ncSetting,
              'paibanData'
            )
          this.isNCBtnLoading = false
          if (res?.status == 1) {
            // 检查是否有仅加工孔槽的错误，有则验证并弹窗
            if (
              !(await this.isContinueDownloadWithNoCutError(
                res.data,
                this.confirmSendToFactory
              ))
            ) {
              this.confirmSendToFactory = false
              this.isDownloadingNc = false
              this.isTimeOut = false
              this.isShowTask = false
              return
            }
            dealNCData('end')
            this.setNewNCRes(res)
            // 存储nc记录到试生产
            let isIconfontDownLoad = false
            this.lackKnivesList = []

            // TODO: 完成后续接口处理
            // 执行完毕后，根据是否是单订单，同步用料量
            const { orderIds, roomIds } = this.getOrderIdAndRoomId()
            if (orderIds.length === 1) {
              const boardList = this.dealDataToQianliyan(this.useMaterialData)
              const params = {
                order_id: orderIds[0],
                room_ids: roomIds,
                board_list: boardList,
              }
              fetchSendUseMaterialData(params)
                .then((res) => {
                  if (res.status === 1) {
                    message.success(res.msg)
                  } else {
                    message.error(res.msg)
                  }
                })
                .catch((err) => {
                  console.log('同步失败', err)
                })
            }

            const { isDeductionBaseMaterial } =
              this.$store.state.preferencesSetting.setting
            // 扣减原片显示，且勾选了才扣减原片
            if (
              this.deductionShowState.isShowBaseMaterialDeduction &&
              isDeductionBaseMaterial
            ) {
              try {
                const res = await fetchDeductBaseMaterial({
                  summary_plank_data: this.useMaterialData,
                })
                if (res.status === 1) {
                  message.success(res.data?.lbl_result?.data.export_msg)
                } else {
                  message.error(res.data?.msg)
                }
              } catch (error) {
                console.log(error)
              }
            }

            res.data.forEach((item) => {
              if (item.filetype === 'label' && item.specifications) {
                this.setOpenSingleFile(true)
              }
              if (
                item.hole_slot_unable_process &&
                Object.keys(item.hole_slot_unable_process).length > 0
              ) {
                this.lackKnivesList.push(item.hole_slot_unable_process)
                this.isShowLackKnivesDialog = true
                isIconfontDownLoad = true
              }
            })

            this.lackKnivesKeysList = Array.from(
              new Set(this.lackKnivesList.map((obj) => Object.keys(obj)[0]))
            )

            this.lackKnivesValueString = Array.from(
              new Set(
                this.lackKnivesList
                  .map((obj) => Object.values(obj)[0])
                  .flatMap((subArr) => subArr)
              )
            ).join(';')

            if (isIconfontDownLoad) {
              this.isDownloadingNc = false
              this.isTimeOut = false
              return
            }
            if (this.isTrialProduct) {
              sendTrialRecord(res.data, this.ncSetting)
            }
            if (genPicFile) {
              genPicFile('start')
            }
            if (genPdfFile) {
              genPdfFile('start')
            }
            const files = await this.genFileUrls(
              res.data,
              JSON.stringify(payloadData)
            )
            // 体验优化
            if (files && files.length) {
              this.downloadFile(
                files,
                name,
                imgArr,
                pdfArr,
                isNeedRecordSize,
                isSubtle
              )
            } else {
              this.isDownloadingNc = false
              this.isTimeOut = false
              return
            }
          } else {
            this.isDownloadingNc = false
            this.isTimeOut = false
            if (res.data?.error === 'annual_fee_expire') {
              this.expirseMsg = res.msg
              this.isVisiblExpire = true
              return
            }
            let regError = /过长工位无法加工/gi
            if (regError.test(res.msg)) {
              this.$confirm(`${res.msg}`, '提示', {
                confirmButtonText: '前往修改',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  this.$router.push('/baseMaterial')
                })
                .catch(() => {})
              return
            }
            if (res.msg === '找不到刀') {
              // 处理数据
              this.handleDealNotFoundKnivesData(res.data.data)
              return
            }
            this.$confirm(`${res.msg}`, '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'error',
              customClass: 'nc-confirm',
            })
              .then(() => {})
              .catch(() => {})
          }
          return res
        }

        // 普通NC下载
        const nc_data = await newNCFileLoadFunc()
        if (nc_data && Array.isArray(nc_data.data)) {
          this.labelInfoList = nc_data.data.filter(
            (i) => i.filetype === 'label'
          )
        }
        const data = {
          order_ids: [...new Set(this.orderIds)],
          mark_action: this.proucePopupState.mark_action,
        }
        await updateProduceStatus(data)
      }
    },
    async dealJsonFile(jsonFileName, isSave = false) {
      // 深拷贝后再改 texDir，避免浅拷贝污染内存中的 paibanData（余料入库会误显示无纹理）
      const paibanData = lodash.cloneDeep(this.paibanData)
      paibanData.forEach((e, index) => {
        if (this.isSubtle && isSave) {
          if (e.canvasIndex === this.drawDataArr[0].canvasIndex) {
            // 如果是精细排版的自动保存历史，需要替换掉精细排版那块大板的数据 通过canvasIndex对应
            paibanData[index].parts = lodash.cloneDeep(
              this.drawDataArr[0].parts
            )
          }
        }
        e.parts.forEach((part) => {
          const partInPlankarr = this.plankArr.find(
            (plank) =>
              part.plankID === plank.plankID && part.index === plank.index
          )
          if (partInPlankarr && partInPlankarr.isNonTexture) {
            part.texDir = 'notcare'
          } else {
            part.texDir = part.srcTexDir ?? part.texDir
          }
        })
      })
      let defaultStandardPlank = await dealStandardPlank(
        this.selectStandardPlank,
        {
          uid: this.userInfo.id,
          from: sessionStorage.getItem('thinkerx_material')
            ? 'guimen'
            : undefined,
        }
      )
      const jsonObj = {
        layoutData: this.preLayoutData,
        paibanData,
        process_setting_id: this.ncSetting.process_setting_id ?? -2,
        process_setting_name:
          this.ncSetting.process_setting_name ??
          this.$store.state.recodrProductionLineChoose ??
          this.$t('preLayoutSetting.preWayEmpty'),
        recodeSelectPart: this.$store.state.recodeSelectPart,
        recodeSelectSurplus: this.$store.state.recodeSelectSurplus,
        thinkerxMaterialKeys: this.$store.state.thinkerxMaterialKeys,
        paibanInfo: {
          paibanWay: this.selectedPaibanWay,
          isLessReverse: this.isLessReverse,
          isSpecialShape: this.isSpecialShape,
          isCuttingOrder: this.isCuttingOrder,
          isAutoPassData: this.isAutoPassData,
          hasSaveSurplus: this.hasSaveSurplus,
          paibanKey: this.paibanKey,
          isUnuseSurplus: this.isUnuseSurplus,
          isDataDefaultCollapsed: this.isDataDefaultCollapsed,
          isMarkModifiedSmallBoards: this.isMarkModifiedSmallBoards,
          // 嵌套方式
          nestWay: this.nestWay,
          historyPlankEdgeOff: this.historyPlankEdgeOff,
          historySecondTrimValue: this.ncSetting.secondTrimValue,
          selectedStandardPlank: defaultStandardPlank,
          customPlankOrder: store.state.customPlankOrder,
          plankOrderList: store.state.plankOrderList,
          batch: this.orderInfo.batch
            ? Object.keys(this.orderInfo.batch).every((key) => {
                return this.orderInfo.batch[key] > 0
              })
            : false,
          morePaibanPlanks: this.$store.state.paibanStore?.paibanDataCollect,
          prePaibanData: this.$store.state.paibanStore?.prePaibanData,
          currentUsingSpecialId:
            this.$store.state.paibanStore?.currentUsingSpecialId,
          batchTaggingList: this.batchTaggingList,
          mixPaibanPlans:
            this.$store.state.materialListStore?.selectedMixPaibanPlans ?? [],
          is_des_material_no_cut:
            this.currentLine?.data?.is_des_material_no_cut,
          material_keywords_list:
            this.currentLine?.data?.material_keywords_list,
          influenceOptions: buildInfluenceSnapshot({
            ncSetting: this.ncSetting,
            preLayoutSetting: this.$store.state.preLayoutSetting,
            preferencesSetting: this.$store.state.preferencesSetting,
            materialListStore: this.$store.state.materialListStore,
            paibanInfo: this.$store.state.paibanInfo,
            paibanData,
            isLessReverse: this.isLessReverse,
            isSpecialShape: this.isSpecialShape,
            isSurplusNoRoll: this.$store.state.isSurplusNoRoll,
            activePaibanWay: this.activePaibanWay,
            selectedPaibanWay: this.selectedPaibanWay,
            currentLine: this.currentLine,
          }),
        },
        // 保存历史需要记录未入库的板件
        localPlankStore: this.$store.state.awaitPaibanStore.localPlankStore,
        preLayoutSetting: this.ncSetting.isPreLayout
          ? this.oriLayoutSetting
          : undefined,
        trimSide: this.ncSetting.trimSide,
        /** 记录 finaldrawdata当前的title顺序 */
        beforeTitleSorts: this.beforeTitleSorts,
      }
      if (this.isShowSample) {
        jsonObj.sampleFormData = this.sampleTableData
      }
      // 下载 NC / 导出 json 时写入用户 IP
      jsonObj.ip = await fetchUserIp()
      let jsonBlob = new Blob([JSON.stringify(jsonObj)], { type: '' })
      jsonBlob = await appendIpToJsonBlob(jsonBlob)
      let jsonFile
      if (jsonFileName) {
        // 如果路径包含 /bluenMaterialData，则进行 gzip 压缩
        if (jsonFileName.includes('/bluenMaterialData')) {
          const compressedBlob = await compressGzip(jsonBlob)
          jsonFile = new File([compressedBlob], jsonFileName, {
            type: '',
            lastModified: Date.now(),
          })
        } else {
          jsonFile = new File([jsonBlob], jsonFileName, {
            type: '',
            lastModified: Date.now(),
          })
        }
      }
      return { jsonFile, jsonBlob, jsonObj }
    },

    thinkerxMaterialSkip() {
      // 获取到所有补件的id
      const bujianOrderIds = this.availableBujianList.map(
        (item) => item.partUniqueId
      )
      const drawData = JSON.parse(JSON.stringify(this.drawData))
      const dealAfterData = {
        factory_id:
          drawData[0].data[0].parts[0].factoryId ??
          this.userInfo.factory_id ??
          this.factoryId,
        order_ids: '',
        fog_ids: '',
        result_data: [],
        process_name:
          this.ncSetting.process_setting_name ??
          this.$store.state.recodrProductionLineChoose,
      }

      const newDrawData = drawData.map((ctx) => {
        return {
          surplusList: ctx.data.filter(
            (plank) => plank.surplusInfo && !plank.surplusInfo.isNotSurplus
          ),
          standPlankList: ctx.data.filter(
            (plank) =>
              (!plank.surplusInfo || plank.surplusInfo.isNotSurplus) &&
              !plank.otherPlate
          ),
          specialPlankList: ctx.data.filter(
            (plank) =>
              (!plank.surplusInfo || plank.surplusInfo.isNotSurplus) &&
              plank.otherPlate
          ),
          matCode: ctx.matCode,
          thick: ctx.thick,
          texture: ctx.texture,
        }
      })

      /** 所有的小板 */
      const parts = newDrawData
        .map((d) => [
          d.surplusList.map((s) => s.parts),
          d.standPlankList.map((s) => s.parts),
          d.specialPlankList.map((s) => s.parts),
        ])
        .flat(3)

      //面积统计
      const areaData = calcPartsArea(parts)

      const fog_ids = Array.from(
        new Set(parts.map((part) => part.groupId))
      ).join(',')
      const order_ids = Array.from(
        new Set(parts.map((part) => part.orderId))
      ).join(',')

      const payload = newDrawData
        .map((data) => {
          const surplusPlankList = data.surplusList.map((s) => {
            return {
              surplusPlank: true,
              color: data.texture,
              thick: data.thick,
              count: 1,
              content: s.parts.map((item) => ({
                ...item,
                isSupplement: bujianOrderIds.includes(item.partUniqueId),
              })),
              thing_id: '',
              fog_ids,
              order_ids,
              width: s.plankWidth,
              length: s.plankHeight,
            }
          })

          // 经过处理后的标准大板上的小板数据
          const clonedStandParts = this.handleAddFlagForSurplusListToLbl(
            data.standPlankList,
            bujianOrderIds
          )
          let standPlank
          if (data.standPlankList.length) {
            standPlank = {
              // name: '标准大板',
              name: data.matCode,
              surplusPlank: false,
              color: data.texture,
              thick: data.thick,
              count: data.standPlankList.length,
              content: clonedStandParts,
              fog_ids,
              order_ids,
              thing_id: '',
              width: data.standPlankList[0].plankWidth,
              length: data.standPlankList[0].plankHeight,
            }
          }
          // 经过处理后的特殊大板上的小板数据
          const clonedSpecialParts = this.handleAddFlagForSurplusListToLbl(
            data.specialPlankList,
            bujianOrderIds
          )
          let specialPlank
          if (data.specialPlankList.length) {
            specialPlank = {
              // name: '特殊板材',
              name: data.matCode,
              surplusPlank: false,
              color: data.texture,
              thick: data.thick,
              count: data.specialPlankList.length,
              content: clonedSpecialParts,
              fog_ids,
              order_ids,
              thing_id:
                data.specialPlankList[0].surplusInfo.window_plank_id ?? '',
              width: data.specialPlankList[0].plankWidth,
              length: data.specialPlankList[0].plankHeight,
            }
          }
          const res = [...surplusPlankList]
          if (standPlank) res.push(standPlank)
          if (specialPlank) res.push(specialPlank)
          return res
        })
        .flat(1)

      dealAfterData.order_ids = order_ids
      dealAfterData.fog_ids = fog_ids
      dealAfterData.result_data = payload
      dealAfterData.area_data = areaData
      // 生成玻璃切割机数据
      if (this.ncSetting?.glass_setting) {
        dealAfterData.result_detail_data =
          this.genThinkerxMaterialGlassPlankData()
      }
      return dealAfterData
    },
    genThinkerxMaterialGlassPlankData() {
      const planks = this.drawData.map((it) => it.data).flat(1)
      const addAmount = (isExist, data) => {
        if (isExist === 'exists') {
          data.amount += 1
        } else {
          data.amount = 1
        }
      }
      return planks.map((plank) => {
        const data = window.$copy(plank.parts)
        return dataClustering(data, 'orderId', 'outItemPanelId', addAmount)
      })
    },
    // 获取文件数据
    getFile(url) {
      return new Promise((resolve) => {
        axios({
          method: 'get',
          url,
          responseType: 'arraybuffer',
        })
          .then((data) => {
            resolve(data.data)
          })
          .catch((err) => {
            resolve(false)
          })
      })
    },
    // 处理采购单文件
    async dealWorkerShopFile() {
      const layout_batch = this.$store.state.typesettingBatch
      const url =
        process.env.VUE_APP_ENV === 'production'
          ? `https://lblsvsp.thinkerx.com/purchase/export?paiban_key=${this.paibanKey}&uid=${this.userInfo.id}&register_id=${this.factoryId}&source=ypb&layout_batch=${layout_batch}`
          : `https://test-lblsvsp.thinkerx.com/purchase/export?paiban_key=${this.paibanKey}&uid=${this.userInfo.id}&register_id=${this.factoryId}&source=ypb&layout_batch=${layout_batch}`
      try {
        const res = await httpRequest.get(url)
        if (res.status === 1) {
          const { data } = res
          const arrayBuffer = await this.getFile(data)
          const blob = new Blob([arrayBuffer])
          return blob
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    // 下载NC文件
    async downloadFile(
      arr,
      name,
      imgArr,
      pdfArr,
      isNeedRecordSize,
      isSubtle = false
    ) {
      try {
        this.$store.commit('setFolderContents', {})
        this.$store.commit('setRepeatFileName', [])
        this.$store.commit('setTempFileName', [])
        let workerShopBlob = null
        // 内嵌不支持顺带导出采购单/发送车间也不支持
        if (
          this.isFollowExportWorkerShop &&
          !this.isWebToQt &&
          !this.confirmSendToFactory
        ) {
          workerShopBlob = await this.dealWorkerShopFile()
        }
        const { genPicFile, genPdfFile, genZip } = this.ncLifeFuncObj
        const { jsonBlob, jsonObj } = await this.dealJsonFile()
        /** 是否需要试生产 */
        const isNeedTrialProduct =
          Object.keys(this.orderInfo).length && this.isTrialProduct
        /** 当次下载的 zip 源 */
        let zip
        // 自定义文件夹功能开启时，不走之前的逻辑
        if (this.$store.state.ncSetting.customizeFolder?.new_customize_folder) {
          genZip('start')
          const ncFiles = arr.filter(
            (v) =>
              // 非标签文件/非自定义识别类型文件/文件名不为空(后端 bug会返回空文件)
              v.fileType !== 'tag' && !v._customizeRecognitionType && v.filename
          )
          const tagFiles = arr.filter((v) => v.fileType === 'tag')
          // 额外的之前本地添加的直接下载文件
          const productionBatchExcel = arr.find(
            (v) => v._customizeRecognitionType === 'product_export_batch_excel'
          )
          // 添加额外的可以作为文件夹解析的数据
          collector.addExtraData({
            productionLineName: jsonObj.process_setting_name,
          })
          const { exporter, folderStructure } = await genNcZipByCustomFolder(
            this.$store.state.ncSetting,
            this.$store.state.ncSetting.customizeFolder
              ?.customize_folder_config,
            ncFiles,
            tagFiles,
            imgArr,
            pdfArr,
            {
              jsonBlob,
              productionBatchExcelData: productionBatchExcel?.fileData,
              workerShopBlob,
            },
            { isNeedTrialProduct }
          )
          // qt 直接将数据传输给柜柜/发送车间走正常流程发送
          if (this.isWebToQt && !this.confirmSendToFactory) {
            await exporter.exportToQtClient()
            exporter.clear()
            return
          }

          const {
            success,
            errorMsg,
            zip: resultZip,
          } = await exporter.exportZip(false, false)
          if (!success) {
            message.error(errorMsg?.join('\n') ?? '文件下载失败')
            return
          }
          zip = resultZip
          name = folderStructure.getNodeStructure().name ?? ''
          // 下载完成后清理下载库收集的所有信息。避免内存占用
          exporter.clear()
        } else {
          const result = await downloadNCFile(
            arr,
            name,
            imgArr,
            pdfArr,
            isNeedRecordSize,
            this.paibanWayName,
            this.mergeFolder,
            this.ncSetting,
            () => {
              this.isDownloadingNc = false
              this.isTimeOut = false
              this.paibanWayName = this.orderInfo.order_codes
              // !isSubtle && this.savePaiban(true, this.isAutoPassData)
              this.savePaiban(true, this.isAutoPassData)
            },
            jsonBlob,
            workerShopBlob,
            () => {
              this.isDownloadingNc = false
              this.isTimeOut = false
              this.isShowWarningModal = true
            },
            {
              // 发送车间时仅生成数据，不触发内嵌环境下的本地下载
              skipNativeDownload: this.confirmSendToFactory,
            }
          )
          if (genPicFile) {
            genPicFile('end')
          }
          if (genPdfFile) {
            genPdfFile('end')
          }
          genZip('start')
          if (result.isErr) {
            this.$confirm(result.errMsg, '警告', {
              type: 'error',
            })
            this.isDownloadingNc = false
            this.isTimeOut = false
            return
          }
          const {
            zip: resultZip,
            qtRepeat,
            repeatNameList,
            repeatZipFileNameList,
            repeatZipFolderNameList,
          } = result
          zip = resultZip
          // TODO 重名文件判断
          // 获取merge_folder_display_name
          if (qtRepeat) {
            this.repeatNameList = repeatNameList
            this.repeatFileNameList = repeatZipFileNameList
            this.repeatFolderNameList = repeatZipFolderNameList
            return
          }
          let repeatZipFolderNameList2 = []
          let repeatZipFileNameList2 = JSON.parse(
            JSON.stringify(this.$store.state.repeatFileName)
          )
          Object.keys(this.$store.state?.folderContents)?.forEach((item) => {
            if (
              !this.ncSetting.customizeFolder?.merge_folder_list.includes(
                fileNameSetObj[item] + '文件'
              ) &&
              this.ncSetting.customizeFolder?.merge_folder_list.length > 1
            ) {
              if (
                this.ncSetting?.customizeFolder?.merge_folder_display_name.trim() ===
                this.$store.state.folderContents[item].trim()
              ) {
                repeatZipFolderNameList2.push(fileNameSetObj[item])
              }
            }
          })
          this.repeatFileNameList = repeatZipFileNameList2
          this.repeatFolderNameList = repeatZipFolderNameList2
          this.repeatNameList = []
            .concat(repeatZipFolderNameList2)
            .concat(repeatZipFileNameList2)
          if (this.repeatNameList.length) {
            this.isDownloadingNc = false
            this.isTimeOut = false
            this.isShowWarningModal = true
            return
          }
          if (isNeedTrialProduct) {
            try {
              for (let index = 0; index < sampleCabinets.length; index++) {
                const file = sampleCabinets[index]
                const result = await fetch(file).then((res) => res.blob())
                const base64Url = await convertBlobToBase64(result)
                zip.file(
                  `试生产样品柜样例图/样品柜样例${index + 1}.png`,
                  base64Url,
                  {
                    base64: true,
                  }
                )
              }
            } catch (error) {
              console.error(error)
            }
          }

          this.isDownloadingNc = false
          this.isTimeOut = false
          // 贴标文件和大板的文件的对应关系
          const plankWidthLabel = {}
          // 处理贴标文件
          const { label_img_big_plank_folder, labeling_file_insert } =
            this.ncSetting
          const { label_image_in_nc_folder } = this.ncSetting.folderCategory
          const hasLabelImageInNcFolderPermission =
            this.$store.state.userPermissions['label_image_in_nc_folder'] &&
            label_image_in_nc_folder
          if (hasLabelImageInNcFolderPermission) {
            Object.keys(zip.files).forEach((item) => {
              if (item === this.label_image_folder + '/') {
                zip.remove(this.label_image_folder)
              }
            })
          }
          if (
            label_img_big_plank_folder &&
            labeling_file_insert &&
            this.imgZip &&
            this.isCanExportPic()
          ) {
            // 获取zip文件里面的贴标信息
            const zipLabelInfoList = {}
            Object.keys(zip.files).forEach((key) => {
              if (
                key.startsWith(`${this.labeling_folder}/`) &&
                key.length > 5
              ) {
                const k = key.split('/')[1]
                if (k) {
                  zipLabelInfoList[k] = zip.files[key]
                }
              }
            })
            const zipLableKeys = Object.keys(zipLabelInfoList)
            // 获取大板文件夹
            const bigpartDirList = []
            Object.keys(this.imgZip.files).forEach((key) => {
              if (key.endsWith('/')) {
                bigpartDirList.push(key.slice(0, -1))
              }
            })
            // 将贴标信息放到大板里面去
            this.labelInfoList.forEach((item, index2) => {
              // 当前的大板文件夹位置
              const index = item.stock_num - 1
              if (zipLableKeys[index2]) {
                // this.imgZip.files[
                //   `${bigpartDirList[index] + '/' + zipLableKeys[index]}`
                // ] = zipLabelInfoList[zipLableKeys[index]]
                if (!plankWidthLabel[index]) {
                  plankWidthLabel[index] = []
                }
                plankWidthLabel[index].push({
                  [`${bigpartDirList[index] + '/' + zipLableKeys[index2]}`]:
                    zipLabelInfoList[zipLableKeys[index2]],
                })
              }
            })
            zip.remove(this.labeling_folder)
          }

          // 将贴标信息放进最终生成的文件夹里面
          this.labelImgList.forEach((item, i) => {
            // 将贴标信息放到大板里面去
            if (
              item[0] &&
              Object.keys(plankWidthLabel).length &&
              labeling_file_insert &&
              label_img_big_plank_folder &&
              this.isCanExportPic()
            ) {
              plankWidthLabel[i].forEach((it) => {
                let labelName =
                  item[0].name.split('/').slice(0, -1).join('/') +
                  '/' +
                  Object.keys(it)[0].split('/').pop()
                zip.files[labelName] = it[Object.keys(it)[0]]
              })
            }
            if (this.isCanExportPic) {
              item.forEach(async (it) => {
                await zip.file(it.name, it.url, { base64: true })
              })
            }
          })
        }

        if (JSON.parse(sessionStorage.getItem('isImportOrder'))) {
          // 柜门需要导出nc的订单数据信息
          const orderPlankData = dealPlankDataForLbl()
          const allPaibanPlankList = this.paibanData.map((p) => p.parts).flat(1)
          const plankParams = {
            uid: this.userInfo.id,
            order_list: orderPlankData.map((data) => {
              const stockKeyList = Array.from(
                new Set(
                  data.map((part) => {
                    const paibanPart = allPaibanPlankList.find(
                      (p) => p.oriPartUniqueId == part.partUniqueId
                    )
                    const stockKey =
                      paibanPart?.stockKey ?? paibanPart?.stock_key
                    return stockKey
                  })
                )
              ).filter((key) => key)
              const oriPartUniqueIdList = data.map((part) => part.partUniqueId)
              const plankData = allPaibanPlankList.filter((plank) =>
                oriPartUniqueIdList.includes(plank.oriPartUniqueId)
              )
              return {
                buyer_address: data[0].address ?? '',
                customer: data[0].customer ?? data[0].customer_name ?? '',
                order_code: data[0].orderNo ?? '',
                room_name: data[0].roomName ?? '',
                remark: data[0].remark ?? '',
                plank_data: plankData.map((part) => {
                  const p = data.find(
                    (p) => p.partUniqueId === part.oriPartUniqueId
                  )
                  return {
                    ...p,
                    name: p.partName ?? '',
                    edgeInfo: p.edgeInfo ?? '',
                    number: p.plankID ?? '',
                    width: p.specWidth,
                    height: p.specHeight,
                    amount: 1,
                    plankNum: part.plankNum,
                  }
                }),
                big_plank_data: Object.values(
                  this.paibanData
                    .filter((item) => stockKeyList.includes(item.stockKey))
                    .reduce((acc, cur) => {
                      const stock_key = `${cur.plankHeight}-${cur.plankWidth}-${cur.texture}-${cur.thick}-${cur.matCode}}`
                      if (acc[stock_key]) {
                        acc[stock_key].count += 1
                      } else {
                        acc[stock_key] = {
                          count: 1,
                          name: cur.matCode,
                          length: cur.plankHeight,
                          width: cur.plankWidth,
                          color: cur.texture,
                          thick: cur.thick,
                        }
                      }
                      return acc
                    }, {})
                ),
              }
            }),
          }
          saveOrderInfoToLbl(plankParams)
        }
        if (this.isAutoPassData) {
          this.dealHistoryName()
          this.paibanWayName =
            this.paibanWayName.length > 900
              ? this.paibanWayName.slice(0, 900).concat('···')
              : this.paibanWayName
        }

        // 如果发送到车间则不再继续下载，而是将文件上传到 oss
        if (this.confirmSendToFactory) {
          removeTagImageZip(zip, this.imgZip, this.ncSetting)
          await this.sendNcFileToFactory(zip, name)
          return
        }
        const savePaibanFn = (url) => {
          if (!this.isAutoPassData) {
            this.savePaiban(true, false, url)
          } else {
            const shouldAutoPass = this.isHistoryStatus
              ? false
              : this.isAutoPassData
            this.savePaiban(true, shouldAutoPass, url)
          }
        }
        console.log(zip, 'zip')
        await promiseToZip(
          zip,
          null,
          name,
          (url) => {
            savePaibanFn(url)
          },
          () => {
            this.isDownloadingNc = false
            this.isTimeOut = false
          },
          this,
          this.ncSetting
        )
        this.isContinue = false
        this.isFrameDoorConfirmed = false
        this.continueDownloadFlag = false
        // 下载成功提示
        this.$message.success(this.$t('common.downloadDoneByType'))
      } catch (error) {
        throw error
      } finally {
        this.isDownloadingNc = false
        this.isTimeOut = false
        this.skipSubTagOnNcExport = false
      }
    },
    /** 如果下载出来的文件存在仅加工孔槽的错误则弹出弹窗，并返回是否继续下载 */
    async isContinueDownloadWithNoCutError(ncFiles, isSendToFactory) {
      return new Promise(async (resolve) => {
        // 检查是否有不下料错误信息
        const hasNoCutError = ncFiles.some((file) => file.no_cut_error_info)
        if (!hasNoCutError) return resolve(true)
        const isDesMaterialNoCutTip =
          this.$store.state.preferencesSetting?.setting
            ?.isDesMaterialNoCutTip ?? true
        if (!isDesMaterialNoCutTip) return resolve(true)
        if (isSendToFactory) {
          this.isShowTask = false
        } else {
          this.isDownloadingNc = false
          this.isTimeOut = false
        }
        const h = this.$createElement

        const confirm = Vue.prototype.$antdConfirm({
          title: this.$translateLang('温馨提示'),
          okText: this.$translateLang('继续下载'),
          cancelText: this.$translateLang('取消'),
          centered: true,
          closable: true,
          content: () => {
            return h('div', [
              h(
                'div',
                {
                  style: { marginBottom: '12px' },
                },
                this.$translateLang(
                  '指定小板材质不下料的板件中存在分配到雕刻机加工的孔槽/异形，本次下载孔槽/异形均分配到五六面钻加工，是否继续下载文件'
                )
              ),
              h('div', [
                h('a-checkbox', {
                  props: {
                    checked: this.noCutErroroNotShow,
                  },
                  on: {
                    change: (e) => {
                      this.noCutErroroNotShow = e.target.checked
                      updateLocalPreference({
                        isDesMaterialNoCutTip: !e.target.checked,
                      })
                      if (e.target.checked) {
                        const recordData = {
                          key: '订单：' + this.orderInfo.order_address,
                          operateArr: [
                            {
                              key: '指定小板材质不下料的板件中存在分配到雕刻机加工的孔槽提示弹窗',
                              dataArr: [
                                {
                                  type: 'form',
                                  current: {
                                    isDesMaterialNoCutTip: '勾选',
                                  },
                                  ori: {
                                    prisDesMaterialNoCutTip: '不勾选',
                                  },
                                  compareMsg: [
                                    {
                                      title: '',
                                      keys: ['isDesMaterialNoCutTip'],
                                    },
                                  ],
                                  formTextObj: {
                                    isDesMaterialNoCutTip: '不再提示',
                                  },
                                  formValueObj: {},
                                },
                              ],
                            },
                          ],
                        }
                        genFinalRecord(recordData, 'paiban')
                      }
                    },
                  },
                }),
                h(
                  'span',
                  {
                    style: { marginLeft: '8px' },
                  },
                  this.$translateLang('不再提示')
                ),
              ]),
            ])
          },
          onOk: () => {
            if (confirm) confirm.destroy()
            resolve(true)
            if (isSendToFactory) {
              this.isShowTask = true
            } else {
              this.isDownloadingNc = true
              this.isTimeOut = true
            }
            const recordData = {
              key: '订单：' + this.orderInfo.order_address,
              operateArr: [
                {
                  key: '指定小板材质不下料的板件中存在分配到雕刻机加工的孔槽提示弹窗',
                  dataArr: [
                    {
                      type: 'form',
                      current: {
                        continueDownload: '是',
                      },
                      ori: {
                        continueDownload: '否',
                      },
                      compareMsg: [{ title: '', keys: ['continueDownload'] }],
                      formTextObj: {
                        continueDownload: '继续下载',
                      },
                      formValueObj: {},
                    },
                  ],
                },
              ],
            }
            genFinalRecord(recordData, 'paiban')
          },
          onCancel: () => {
            if (confirm) confirm.destroy()
            resolve(false)
          },
        })
      })
    },
    /**
     * @description 保存生成好的 zip 文件到车间
     * @param zip jszip 对象
     * @param name 名称
     */
    async sendNcFileToFactory(zip, name) {
      try {
        /** 项目地址 */
        const address = Array.from(
          new Set(
            this.preLayoutData.map((data) =>
              data.address ? data.address : data.groupNo
            )
          ).values()
        ).join(',')
        /** 订单号 */
        const order_id = Array.from(
          new Set(this.preLayoutData.map((data) => data.orderNo)).values()
        ).join(',')
        /** 生产线 名称 */
        const product_line =
          this.ncSetting.process_setting_name ??
          this.$store.state.recodrProductionLineChoose
        const process_line_id =
          this.ncSetting.process_line_id ?? this.ncSetting.process_setting_id
        const { jsonObj } = await this.dealJsonFile()
        // 原始内容的板件
        const collectPartUniqueIdsForPlankFilter = (part) => {
          if (judgeIsMergeFrameDoor(part)) {
            return part.frame_door_children
              .map((c) => c.partUniqueId)
              .filter(Boolean)
          }
          return part.partUniqueId ? [part.partUniqueId] : []
        }
        const filterArr = this.prePaibanData.length
          ? this.prePaibanData.flatMap((data) =>
              collectPartUniqueIdsForPlankFilter(data)
            )
          : this.paibanData
              .map((data) => data.parts)
              .flat(1)
              .flatMap((part) => collectPartUniqueIdsForPlankFilter(part))
        const plank = [
          ...this.preLayoutData.filter((data) =>
            filterArr.includes(data.partUniqueId)
          ),
          ...this.availableBujianList,
        ].map((part) => ({ ...part, amount: 1 }))
        const result = await sendDataToWorkShop({
          address,
          order_id,
          zip,
          plank,
          jsonObj,
          process_line_id,
          product_line,
          layout_batch: this.$store.state.typesettingBatch,
        })
        if (result.status == 1) {
          this.$message.success(translate('materialPage.sendFactorySuccess'))
        } else {
          this.$confirm(
            translate('arrangedPage.sendErr'),
            translate('common.warning'),
            {
              type: 'error',
            }
          )
        }
        console.log(zip, name)
      } catch (error) {
        console.log(error, 'error')
      } finally {
        this.isDownloadingNc = false
        this.isTimeOut = false
        this.confirmSendToFactory = false
        this.isFrameDoorConfirmed = false
      }
    },

    mergeFolder() {
      this.mergeFolderList = this.folderSetting.merge_folder_list
      this.mergeFolderDisplayName = this.folderSetting.merge_folder_display_name
      // 如果有合并文件
      this.needMerge = this.folderSetting.merge_folder_list?.length > 1
      if (this.folderSetting.use_category_folder) {
        // 如果为true，那么就不使用合并文件
        this.needMerge = false
      }
    },

    // 读取老板良跳转过来的json数据
    dealJsonFromLbl(url) {
      axios.get(url).then((res) => {
        if (res.data.hasOwnProperty('employee')) {
          if (res.data.employee != 0) {
            this.changeLblAuth(false)
          }
        }
        this.isRefresh = false
        this.showLoading = false
        let lblJson = res.data
        let orderInfo = {
          order_address: res.data.order_address,
          order_list: res.data.order_list.join(','),
          room_ids: [],
          needPaibanRoomIds: [],
          order_codes: res.data.order_code,
        }
        this.setOrderInfo(orderInfo)
        // 区分柜柜和班鲁保存的数据
        // 柜柜
        if (
          lblJson.plank_info.dataFrom &&
          lblJson.plank_info.dataFrom == 'ggpc'
        ) {
          let zipUrl = lblJson.plank_info.historyUrl
          getZipJson(zipUrl).then((result) => {
            this.changeDataFrom('ggpc')
            for (let i = 0; i < result.length; ++i) {
              let data = JSON.parse(result[i])
              dealGuiguiJson(JSON.parse(data.layoutResult)).then(
                (finalData) => {
                  this.dealPaibanData()
                  this.setPreLayoutData(dealPreLayoutDataLabelID(finalData))
                }
              )
            }
          })
        } else {
          // 班鲁web
          getGzipData(lblJson.plank_info.historyUrl).then((finalData) => {
            this.setPaibanData(finalData.data.paibanData)
            this.setPreLayoutData(
              dealPreLayoutDataLabelID(finalData.data.layoutData)
            )
            let params = {
              setting_id: finalData.data.process_setting_id,
            }
            if (window.sessionStorage.getItem('thinkerx_material')) {
              params.production_from = 'guimen'
            }
            this.$getByToken('/get_production_nc_setting', params, (nc) => {
              nc.data.drawPlankWidth = nc.data.xyReverse
                ? nc.data.panelSize.plankHeight
                : nc.data.panelSize.plankWidth
              nc.data.drawPlankHeight = nc.data.xyReverse
                ? nc.data.panelSize.plankWidth
                : nc.data.panelSize.plankHeight
              let ncSetting = Object.assign(nc.data, {
                process_setting_id: finalData.data.process_setting_id,
                process_setting_name: finalData.data.process_setting_name,
              })
              this.setNcSetting(ncSetting)
              this.dealPaibanData()
            })
          })
        }
      })
    },
    // 进入多选：首次按下 Ctrl 时，把当前激活小板带进列表，避免高亮瞬间消失
    enterBatchSelectMode() {
      const wasBatchActive = this.isBatchActive
      this.isBatchActive = true
      if (wasBatchActive || this.batchActiveIdList.length) return
      if (!this.activePlank?.partUniqueId) return
      this.batchActiveIdList = [this.activePlank.partUniqueId]
      this.syncBatchActiveHighlight()
    },
    /** 退出 Ctrl 多选模式（不在此处清列表，松 Ctrl 后仍可看到已选高亮，下次单击再清） */
    exitBatchSelectMode() {
      this.isBatchActive = false
    },
    isControlKeyEvent(e) {
      return (
        e.key === 'Control' ||
        e.code === 'ControlLeft' ||
        e.code === 'ControlRight' ||
        e.keyCode === 17
      )
    },
    // 键盘删除事件
    keyDownFuncs() {
      return (e) => {
        if (e.ctrlKey || this.isControlKeyEvent(e)) {
          // 复制、粘贴仍走浏览器默认行为
          if (!(e.keyCode == 67 || e.keyCode == 86)) {
            e.preventDefault()
          }
          this.enterBatchSelectMode()
        }
        if (e.code == 'Delete') {
          e.preventDefault()
          if (this.bigPart && this.bigPart.isLocked) {
            return this.$message.error('板件被锁定，无法删除!')
          }
          this.deletePlank()
        }
      }
    },
    keyUpFuncs() {
      return (e) => {
        // webToQt / Qt WebEngine 松开 Ctrl 时 e.ctrlKey 可能仍为 true，不能只靠 ctrlKey 判断
        if (this.isControlKeyEvent(e) || !e.ctrlKey) {
          this.exitBatchSelectMode()
          return
        }
        this.isBatchActive = !!e.ctrlKey
      }
    },
    /** 窗口失焦时退出多选，避免 Qt 下 Ctrl 松开事件丢失导致一直停留多选 */
    onWindowBlurExitBatchSelect() {
      this.exitBatchSelectMode()
    },
    // Mac Chrome：Ctrl+左键会走 contextmenu，在捕获阶段取消系统菜单
    preventCtrlContextMenu(e) {
      if (e.ctrlKey) {
        e.preventDefault()
      }
    },
    dealOptimizeArea(drawData) {
      const data = drawData
        .filter((data) => !data.isDesMaterialNoCut)
        .map((item) => item.data)
        .flat(2)
      // 计算优化率
      drawData.forEach((item) => {
        let usedRate = item.data.reduce(
          (prev, cur) => (prev += cur.usedRate),
          0
        )
        item.usedRate = usedRate / item.data.length
        let usedArea = item.data.reduce(
          (prev, cur) => (prev += cur.usedArea),
          0
        )
        item.usedArea = usedArea
      })
      let totalUsedRate = data.reduce((prev, cur) => (prev += cur.usedRate), 0)
      this.totalUsedRate = totalUsedRate / this.oriPlankLen
      this.totalUsedArea = data.reduce((prev, cur) => (prev += cur.usedArea), 0)
      this.setPaibanExtraInfo({
        total_used_rate: this.totalUsedRate,
        total_used_area: this.totalUsedArea,
        total_fanban: this.totalBigpartFanban,
        total_big_planks: this.totalBigpartCounts,
      })
    },
    // 应用方案
    useApply(specialId, paibanResult, loadingInstance) {
      this.alignedPlanDialog = false
      // 切方案前清掉激活小板：数量>1 时 plankID 常相同，drawPart 按 index 复用，
      // 残留 activePlank/isMovingPlank 会在新方案上画出错位选中态甚至误触发移板。
      try {
        this.clearAllActive()
      } catch (e) {}
      this.activePlank = null
      this.activePlankID = 0
      this.activePlankIndex = 0
      this.activeBigpart = null
      try {
        for (let i = 0; i < (this.drawData || []).length; ++i) {
          const ref = this.$refs[`drawpart${i}`]?.[0]
          ref?.resetPlankStatus?.()
          if (ref) {
            ref.activePlank = null
            ref.activePartUniqueId = ''
          }
        }
      } catch (e) {}
      this.dealAllDrawData()
      // 更新余料数据
      if (
        this.ncSetting.sawSetting.firstCutSurplus &&
        this.ncSetting.sawSetting.surplusStoreAndLabeling &&
        this.selectedPaibanWay == 'paiban' &&
        this.ncSetting.sawSetting.mentaoji_enable &&
        this.ncSetting.sawSetting.processType === 'weldingPlank'
      ) {
        cutBlueSurplus(this.drawData)
      }
      this.renderAll(true)
      // 激活后写入翻板数，列表展示与页头保持同一结果
      const cacheValue = {
        paibanData: this.paibanData,
        specialId,
        rawPlanData:
          (paibanResult && paibanResult.rawPlanData) ||
          this.$store.state.paibanStore?.currentRawPlanData,
        fanbanCount: this.totalBigpartFanban,
      }
      this.$store.commit('paibanStore/setAlreadyDealDrawData', {
        specialId,
        value: JSON.parse(JSON.stringify(cacheValue)),
      })
      // 关闭loading
      this.startTailorSurplus()
      this.handleResetPlankArea(true)
      loadingInstance.close()
      // 应用更多排版方案 批量补标签数据置为空
      this.setBatchTaggingList([])
    },
    async startTailorSurplus(isRenader = true) {
      const res = await tailorSurplus(this.drawData)
      if (res) {
        this.dealOptimizeArea(this.drawData)
        this.onPartChange('update', { partType: 'bigPlank' })
        isRenader && this.renderAll()
      }
    },
    async updateTaskStatus() {
      this.loadingPrompts = 'arrangedPage.updateTaskStatus'
      this.isUpdatingTask = true
      const taskDetail = showCardDetail(this.preLayoutData)

      const jsonData = {
        layoutData: this.preLayoutData,
        paibanData: this.paibanData,
        process_setting_id: this.ncSetting.process_setting_id,
        process_setting_name: this.ncSetting.process_setting_name,
        recodeSelectPart: this.$store.state.recodeSelectPart,
        recodeSelectSurplus: this.$store.state.recodeSelectSurplus,
        thinkerxMaterialKeys: this.$store.state.thinkerxMaterialKeys,
        paibanInfo: {
          paibanWay: this.selectedPaibanWay,
          isLessReverse: this.isLessReverse,
          isSpecialShape: this.isSpecialShape,
          filterPlankList: this.filterPlankList,
          historyPlankEdgeOff: this.historyPlankEdgeOff,
          historySecondTrimValue: this.ncSetting.secondTrimValue,
          batchTaggingList: this.batchTaggingList,
          is_des_material_no_cut:
            this.currentLine?.data?.is_des_material_no_cut,
          material_keywords_list:
            this.currentLine?.data?.material_keywords_list,
        },
        matCode: taskDetail?.matCode ? taskDetail?.matCode : '',
        texDir: taskDetail?.texDir ? taskDetail?.texDir : '',
        texture: taskDetail?.texture ? taskDetail?.texture : '',
        /** 记录 finaldrawdata当前的title顺序 */
        beforeTitleSorts: this.beforeTitleSorts,
      }
      if (this.isBatch) {
        Object.assign(jsonData, {
          batchNo: this.batchPaiban
            ? this.batchPaiban.batchNo
            : this.batchNo
            ? this.batchNo
            : `${getDate()}-${Number(this.produceTime) + 1}`,
        })
      }
      if (this.ncSetting.isPreLayout) {
        Object.assign(jsonData, {
          isPreLayout: true,
          preLayoutSetting: this.oriLayoutSetting,
        })
      }
      const paibanJson = new File(
        [new Blob([JSON.stringify(jsonData)], { type: '' })],
        `taskData_${new Date().getTime()}.json`,
        {
          type: '',
          lastModified: Date.now(),
        }
      )
      // 对 bluenMaterialData 目录下的 json 文件进行 gzip 压缩
      const compressedBlob = await compressGzip(paibanJson)
      const compressedFile = new File(
        [compressedBlob],
        `taskData_${new Date().getTime()}.json.gz`,
        {
          type: '',
          lastModified: Date.now(),
        }
      )
      // 使用封装好的 uploadCompressedFile 函数上传
      const res = await uploadCompressedFile(compressedFile)
      if (!this.isBatch) {
        this.materialTask.forEach(async (task) => {
          let payload = {
            platform: task.platform,
            task_ids: [task.id],
            paiban_json: res,
            process_id:
              this.ncSetting.process_line_id ??
              this.ncSetting.process_setting_id ??
              -2,
            task_batch: `${getDate()}-${Number(this.produceTime) + 1}`,
          }
          if (task.current_step) {
            Object.assign(payload, { current_step: task.current_step })
          }
          this.setProduceTime(Number(this.produceTime) + 1)
          await updateToHasPaiban(payload)
        })
      } else {
        const payload = {
          platform: this.materialTask[0].platform,
          task_ids: this.materialTask.map((task) => task.id),
          process_id:
            this.ncSetting.process_line_id ??
            this.ncSetting.process_setting_id ??
            -2,
          paiban_json: res,
        }

        if (!this.batchPaiban) {
          Object.assign(payload, {
            task_batch: this.batchNo
              ? this.batchNo
              : `${getDate()}-${Number(this.produceTime) + 1}`,
          })
        }

        await updateToHasPaiban(payload)
        this.setBatchPaiban({
          ...jsonData,
          batchNo: this.batchPaiban
            ? this.batchPaiban.batchNo
            : this.batchNo
            ? this.batchNo
            : `${getDate()}-${Number(this.produceTime) + 1}`,
        })
        if (!this.batchPaiban) {
          this.setProduceTime(Number(this.produceTime) + 1)
        }
      }
      this.setIsNewPaiban(false)
      this.isUpdatingTask = false
    },
    handleChangeImageTempMousedownFlag(val) {
      this.imageTempMousedownFlag = val
    },
    showPartSize(field, needShowField, part) {
      const plank = part ?? this.activePlank
      const rect = getOriginRect(plank, field)
      return (rect?.[needShowField] ?? 0).toFixed(2)
    },

    handleSurplusSave(event, isSaveStorage) {
      buryPointApi('layout', 'sup_once_warehousing')
      const allBigparts = this.paibanData
      const allSurplus = allBigparts
        .map((bigpart) => bigpart.parts)
        .flat(1)
        .filter((part) => part.surplusPath && !part.hasSaved)

      console.log(allSurplus, 'allSurplus')
      this.$getByToken('/get_user_plank_setting', {}, (res) => {
        if (res.status == 1) {
          let surplusPayload = []
          try {
            surplusPayload = buildCutSurplusDepotPayloadItems(
              allSurplus,
              this.ncSetting
            )
          } catch (error) {
            this.isShowSurplusSizeErrModal = true
            return
          }
          assignSequentialSurplusNames(
            surplusPayload,
            res.data.next_surplus_name
          )
          postProcessSurplusPayloadItems(surplusPayload, this.ncSetting)
          if (
            this.$store.state.preferencesSetting.setting.isSecondConfirm ??
            true
          ) {
            this.isShowSecondConfirm = true
            this.surplusConfirmList = surplusPayload.map((item) => ({
              ...item,
              isHighPlank: item.type.includes('高光_')
                ? this.$translateLang('高光板')
                : this.$translateLang('非高光板'),
              highlight_surface: item.highlight_surface,
              position: 'systemAllocation',
            }))
            this.otherSurplusData = { allSurplus, allBigparts }
            return
          }

          applySpecialShapeMinZeroForUpload(surplusPayload)
          this.handleCallStorageInf(surplusPayload, isSaveStorage, {
            allSurplus,
            allBigparts,
          })
        }
      })
    },

    // 调用入库接口
    handleCallStorageInf(data, isSaveStorage, otherData) {
      this.$token(
        '/create_surplus_depot',
        { surplus_data: data, designated: isSaveStorage ? true : false },
        (res) => {
          if (res.status == 1) {
            // 成功之后检查余料中是否有异形余料，有则进行埋点
            const hasSpecialShape = data.some((item) => item.shape == 2)
            if (hasSpecialShape) {
              buryPointApi('supplus_storage', 'special_shape_surplus')
            }
            const savedPlankNumList = data.map((sur) => sur.plankNum)
            otherData.allBigparts.forEach((bigpart) => {
              bigpart.parts.forEach((part) => {
                if (savedPlankNumList.includes(part.plankNum)) {
                  part.hasSaved = true
                }
              })
            })
            if (res.data.length) {
              otherData.allSurplus.forEach((surplus, index) => {
                // surplus.hasSaved = true
                surplus.branch_name =
                  res.data[index]?.branch_name ?? res.data[0]?.branch_name
                surplus.branch_no =
                  res.data[index]?.branch_no ?? res.data[0]?.branch_no
                surplus.branch_id = res.data[index]?.id ?? res.data[0]?.id
              })
            }
            if (
              (otherData?.isSecondConfirm &&
                data.length == otherData.allSurplus.length) ||
              !otherData?.isSecondConfirm
            ) {
              this.hasSaveSurplus = true
            }
            this.$message({
              message: '入库成功!',
              type: 'success',
            })
            if (isSaveStorage) {
              this.showSurStoreTip = false
            }
            this.isShowSecondConfirm = false
          } else {
            this.hasSaveSurplus = false
            if (!otherData?.isSecondConfirm) {
              const errStrArr = Object.values(res.data.err_surplus).flat(2)
              if (errStrArr.includes('余料条码已存在')) {
                this.$message({
                  message:
                    this.$translateLang('部分余料板件已经在库中，此次操作失败'),
                  type: 'error',
                })
                return
              }
              if (res.data?.error_code == '0') {
                this.showSurStoreTip = true
                return
              }
              this.$message({
                message: res.msg,
                type: 'error',
              })
              if (isSaveStorage) {
                this.showSurStoreTip = false
              }
            } else {
              if (data.length) {
                this.$message({
                  message: this.$translateLang(
                    '入库失败，存在余料名称重复或余料仓存放达到上限或不满足入库规则'
                  ),
                  type: 'error',
                })
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                })
              }
              if (res.data?.err_surplus) {
                let errSurplus = res.data?.err_surplus
                Object.keys(errSurplus).forEach((key) => {
                  this.surplusConfirmList.forEach((item) => {
                    if (item.name === key) {
                      if (errSurplus[key].includes('余料名称已重复')) {
                        Vue.set(item, 'isNameRepeat', true)
                      }
                      if (
                        errSurplus[key].includes(
                          '余料仓容量不足或存在余料不满足入库规则，无法存入仓库'
                        )
                      ) {
                        Vue.set(item, 'isPositionLimit', true)
                      }
                      if (errSurplus[key].includes('余料条码已存在')) {
                        Vue.set(item, 'isSurplusExist', true)
                      }
                    }
                  })
                })
              }
            }
          }
        }
      )
    },

    // 删除 余料入库二次确认数据
    handleDelSecCon(index) {
      this.surplusConfirmList.splice(index, 1)
    },

    // 关闭入库确认弹窗
    handleCloseSecCon() {
      this.isShowSecondConfirm = false
    },

    // 入库确认
    handleOKSecCon(data) {
      this.surplusConfirmList = data.map((item) => {
        delete item.isNameRepeat
        delete item.isPositionLimit
        delete item.isSurplusExist
        return item
      })

      const surplusData = this.surplusConfirmList.map((item) => {
        let result = JSON.parse(JSON.stringify(item))
        result.color_id = item.colorId || item.color_id
        delete result.colorId
        delete result.isHighPlank
        if (
          !['systemAllocation', 'surplusMaterialList'].includes(item.position)
        ) {
          result.branch_no = item.position
          result.position = 'surplusStore'
        } else {
          result.branch_no = 0
        }
        return result
      })
      this.otherSurplusData.isSecondConfirm = true
      surplusData.forEach((item) => {
        if (item.shape == 2) {
          item.min_long = 0
          item.min_width = 0
        }
      })
      this.handleCallStorageInf(surplusData, true, this.otherSurplusData)
    },

    genStockKey(plank) {
      return genSurplusStockKey(plank)
    },

    groupBy(arr, property) {
      return arr.reduce((acc, obj) => {
        const key = obj[property]
        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(obj)
        return acc
      }, {})
    },

    isNewContent(key) {
      return (
        this.newPaibanTags &&
        Boolean(this.newPaibanTags.find((tag) => tag.web_property === key))
      )
    },
    setHasSavedSurplus() {
      this.$nextTick(() => {
        const allSurplus = this.paibanData
          .map((bigpart) => bigpart.parts)
          .flat(1)
          .filter((part) => part.surplusPath && !part.hasSaved)
        this.hasSaveSurplus = !allSurplus.length
        const addSurplus = this.paibanData
          .map((bigpart) => bigpart.parts)
          .flat(1)
          .filter((part) => part.surplusPath)
        this.hasCut = addSurplus.length
      })
    },
    async subtleDownloadNC(bigpart, isContinue) {
      // 检测板件是否存在冲突
      const isConflict = this.isNotPlankConflict([bigpart])
      if (isConflict) return
      this.currentDownloadType = 'jingxi'
      this.currentOperate = 'nc'
      this.fromWhtchBtn = 'downloadNC'
      // 必须在最开始就赋值，后面会使用
      this.subtleBigPart = bigpart
      // 全新下载时重置副标确认状态；忽略冲突后重入则保留
      if (!isContinue && !this.isContinue) {
        this.skipSubTagOnNcExport = false
      }
      // 检查本地所使用的目录是否存在
      if (
        !this.continueDownloadFlag &&
        !this.isContinue &&
        !(await this.$refs.folderChooseModalRef?.verify())
      ) {
        return
      }
      this.isSubtle = true

      // 未点击忽略(夹手位置避让检测)
      if (this.notIgnore && !this.isContinue) {
        const targetData = [
          {
            data: [bigpart],
          },
        ]
        // 检查夹手处是否有孔槽
        const noClampHandConfilit = this.handleCheckClampHandPosition(
          'downloadNC',
          true,
          targetData
        )
        if (!noClampHandConfilit) return
      }
      this.notIgnore = true

      if (this.judgeCutOrder([bigpart])) {
        this.handleSeriesManipulate()
        return
      }
      // 自定义文件夹记录下载环境
      collector.addExtraData({ downloadEnv: 'single' })
      this.$refs.subtleRef.changeLoading(true)
      this.isNCBtnLoading = true
      this.currentIndex = bigpart.orderIndex
      this.subtleBigPart = bigpart
      let surplusPlank
      if (
        bigpart.surplusInfo &&
        Object.keys(bigpart.surplusInfo).length &&
        !bigpart.surplusInfo.isNotSurplus
      ) {
        surplusPlank = bigpart
        this.useSurplusId = [bigpart.surplusInfo.id]
        const surplusRes = await getSurplusList({ page: 1, limit: 999 })
        const allSurplusList = surplusRes.status ? surplusRes.data.data : []
        this.useSurplusList = allSurplusList.filter((item) =>
          this.useSurplusId.includes(item.id)
        )
      }
      // 初始化下载nc的任务状态
      this.updateNcLifeObj()
      const { checkData } = this.ncLifeFuncObj
      checkData('start')
      const isReturn = await this.beforDownloadCheck(
        surplusPlank,
        isContinue,
        true
      )
      if (isReturn) {
        this.isNCBtnLoading = false
        return
      }
      const templateData = await this.fetchCurrentNcTagTemplateData()
      if (!(await validateSubTagPerForExport(templateData))) {
        this.isNCBtnLoading = false
        this.isDownloadingNc = false
        this.$refs.subtleRef?.changeLoading?.(false)
        return
      }
      const canContinueWithSubTag = await this.confirmLabelingSubTagTemplate()
      if (!canContinueWithSubTag) {
        this.isNCBtnLoading = false
        this.isDownloadingNc = false
        this.$refs.subtleRef?.changeLoading?.(false)
        return
      }
      checkData('end')
      // 传递精细排版的数据
      this.beforeDownloadNC([this.subtleBigPart], true)
    },
    subtlePrintTag(bigpart) {
      this.currentIndex = bigpart.orderIndex
      // 精细排版单独生成颜色
      const { labelCheck, colorRes: newColorRes } =
        this.judgeLimit(this.paibanData) ?? {}
      this.$nextTick(() => {
        if (this.print_color_tag) {
          this.generateColor(labelCheck, newColorRes, bigpart)
        }
      })
      this.gotoTagLabel(bigpart, true)
    },
    //生成排版key
    async genPaibanKey() {
      // 全局数据 开料清单的数据this.preLayoutData和this.paibanData的并集
      const paibanPartData = this.paibanData.flatMap((d) => d.parts) // 展开paibanData的小板数据
      // 根据partUniqueId求并集并去重
      const allPartDataMap = new Map()
      this.preLayoutData.concat(paibanPartData).forEach((d) => {
        if (
          this.currentLine?.data?.is_des_material_no_cut &&
          this.currentLine?.data?.material_keywords_list?.some((item) =>
            d.matCode.includes(item)
          )
        ) {
          return
        }
        allPartDataMap.set(d.partUniqueId, d) // 使用Map自动去重
      })
      // 转换为数组
      const allPartDataUnique = Array.from(allPartDataMap.values())
      const statisticData = await dealPlankType(
        this.paibanData,
        allPartDataUnique
      )
      function getMaxPartNameCountByRoom(arr) {
        // 使用 reduce 按 roomID 分组并统计
        const roomGroups = arr.reduce((groups, item) => {
          const roomId = item.roomID
          if (!groups[roomId]) groups[roomId] = []
          groups[roomId].push(item)
          return groups
        }, {})
        // 计算每个房间的最大 partName 数量
        return Object.entries(roomGroups).reduce((result, [roomId, items]) => {
          const partNameCount = items.reduce((count, item) => {
            count[item.partName] = (count[item.partName] || 0) + 1
            return count
          }, {})
          result[roomId] = Math.max(...Object.values(partNameCount))
          return result
        }, {})
      }
      const plankData = statisticData.plankData
      let obj = {}
      obj.uid = this.userInfo.id
      // 统计的排版的数据
      obj.addon_data = statisticData.addonData
      obj['supplement_addon_data'] = statisticData.supplementAddonData
      obj.all_edge_data = statisticData.allEdgeData
      obj.edge_data = statisticData.edgeData
      // 根据allPartDataUnique以roomID分组，统计每个roomID中partName相同的数量，取最大的数量，只统计partName相同的个数。
      const withoutBujianAndAwaitStoreData = allPartDataUnique.filter(
        (item) =>
          !item._isBujian &&
          !item._isAwaitStorePlank &&
          !item.isDesMaterialNoCut
      )
      const roomNameMap = getMaxPartNameCountByRoom(
        withoutBujianAndAwaitStoreData
      )
      const order_ids =
        Array.from(
          new Set(
            paibanPartData
              .filter((item) => !item.isDesMaterialNoCut)
              .map((part) => part.orderId)
          )
        ).join(',') || ''
      const roomIdGroup = allPartDataUnique.reduce((acc, item) => {
        const roomId = item.roomID
        if (!acc[roomId]) {
          acc[roomId] = []
        }
        acc[roomId].push(item)
        return acc
      }, {})
      let supplementRoomList = []
      let roomList = []
      Object.keys(roomIdGroup).forEach((roomId) => {
        if (!roomId || roomId === 'undefined') return

        const roomData = roomIdGroup[roomId]
        const roomItem = {
          room_id: Number(roomId),
          product_num: roomNameMap[roomId] || 0,
        }

        // 检查roomData中是否每一项都包含_isBujian字段或者_isAwaitStorePlank字段
        const hasBujianOrAwaitStorePlank = roomData.every(
          (item) => item._isBujian || item._isAwaitStorePlank
        )
        if (hasBujianOrAwaitStorePlank) {
          supplementRoomList.push(roomItem)
          return
        }

        // 检查roomData中是否每一项都不包含_isBujian字段或者_isAwaitStorePlank字段
        const hasNoBujianOrAwaitStorePlank = roomData.every(
          (item) => !item._isBujian || !item._isAwaitStorePlank
        )
        if (hasNoBujianOrAwaitStorePlank) {
          roomList.push(roomItem)
        }
      })
      obj.filter_data = [
        {
          order_id: this.orderInfo.order_ids || order_ids,
          room_list: roomList,
          supplement_room_list: supplementRoomList,
          order_code: this.orderInfo.order_codes || '',
          buyer_address: statisticData.addressData,
        },
      ]
      obj.plank_data = plankData.map(
        ({
          matCode,
          count,
          texture,
          thick,
          width,
          height,
          plankType,
          branch_name,
          plankOrderNumber,
          plankNum,
          colorId,
          brandName,
          supplierName,
        }) => {
          return {
            material: matCode,
            color: texture,
            thick,
            spec: `${width}*${height}`,
            count: String(count),
            plankType,
            branch_name,
            plankOrderNumber: String(plankOrderNumber),
            plankNum,
            color_id: colorId,
            brand_name: brandName,
            supplier_name: supplierName,
          }
        }
      )
      const res = await fetchSendPurchaseData(obj)
      if (res.status && res.status > 0) {
        this.setPaibanKey(res.data)
        this.setFactoryId(
          res.factory_id
            ? res.factory_id
            : sessionStorage.getItem('thinkerx_material_factory_id')
        )
      }
    },
    async handleSendToFactory() {
      // 检查板件是否冲突
      const isConflict = this.isNotPlankConflict(this.paibanData)
      if (isConflict) return
      if (this.ncSetting.isPreLayout) {
        this.checkSettingChange()
        return
      }
      if (await this.beforeCommonCheck()) {
        return
      }
      // 打开发给车间生产页面
      this.isSendToFactoryLoading = true
      this.sendToFactoryDialog = true
      this.confirmSendToFactory = false
    },
    // 显示大板用料清单弹窗
    handleShowMatList() {
      this.showMaterialList = true
    },
    handleCloseSend() {
      this.sendToFactoryDialog = false
      this.confirmSendToFactory = false
      this.isSendToFactoryLoading = false
    },
    // 确认发送给车间生产
    async handleConfirmSend({ tagDocType, currentTagTemp, paibanImgType }) {
      buryPointApi('layout', 'send_factory')

      if (this.isOnlyShowSurplus) {
        this.isOnlyShowSurplus = false
        this.handleShowSurplus()
      }
      this.sendToFactoryDialog = false
      this.confirmSendToFactory = true
      this.tagSetting = {
        currentTagTemp: {
          ...currentTagTemp,
          render_url: currentTagTemp.render_url
            ? currentTagTemp.render_url?.replace(/http:/g, 'https:')
            : '',
        },
        paibanImgType,
      }
      this.$set(this.tagSetting, 'tagDocType', tagDocType)
      this.fromWhtchBtn = 'sendToFactory'
      this.handleDownloadNC(true)
    },
    async generateTagsFile(
      template,
      exportType,
      isNeedLoading = true,
      isFileOnly = false
    ) {
      this.isShowTask = isNeedLoading
      // const exportFlag = exportType === '导出PDF'
      // 非pdf导出都导出图片
      const isCanExportPic = this.isCanExportPic(exportType)
      const isCanExportPdf = this.isCanExportPdf(exportType)
      if (!isCanExportPic && !isCanExportPdf) return []
      const exportObj = {
        isTag: isCanExportPic,
        isPdf: isCanExportPdf,
      }
      // 生成pdf blob对象或标签tag base64数组
      this.generateLabelNo(
        this.subtleBigPart ? [this.subtleBigPart] : this.paibanData
      )
      let data = this.subtleBigPart ? [this.subtleBigPart] : this.paibanData
      // 如果未勾选生成不下料板件标签则不传入对应数据
      if (!this.$store.state.preferencesSetting.setting.genNoCutTag) {
        data = data.filter((item) => !item.isDesMaterialNoCut)
      }
      if (!data.length) {
        return []
      }
      const preferencesSetting = this.$store.state.preferencesSetting?.setting
      const tagSetting = {
        isGenPartTag: preferencesSetting.genSmallPlankLabel,
        isGenPartTagS: preferencesSetting.genSmallPlankLoaelForSurplus,
        isGenSurplusTag: preferencesSetting.cutNeedLave,
        isGenSurplusTagS: preferencesSetting.cutNeedLaveForSur,
        isGenRestTag: preferencesSetting.surplusLabel,
        isGenRestTagS: preferencesSetting.surplusLabelForSur,
        isGenRestTagEnd: preferencesSetting.cutLaveEnd,
        isGenRestTagEndS: preferencesSetting.cutLaveEndForSur,
        isGenBigPartTag: preferencesSetting.bigPlankLabel,
        isGenBigPartTagS: preferencesSetting.bigPlankLabelForSur,
        positionX: preferencesSetting.labelCoord.xCoordinate,
        positionY: preferencesSetting.labelCoord.yCoordinate,
        isGenBigPartFileSuffix: preferencesSetting.isGenNcSuffix,
        isTagMirror: preferencesSetting.mirrorLabel,
        isGenFiveSixDir: preferencesSetting.boardBenchmark,
        isGenColorful: preferencesSetting.printColorTag,
        tagOrder: preferencesSetting.labelSortWay,
        opacity: preferencesSetting.opacity,
        size: preferencesSetting.size,
        sizeAuto: preferencesSetting.sizeAuto,
        isReverseColor: preferencesSetting.genPartColorRevert,
        roomCabinetPanelNameDisplay:
          preferencesSetting.roomCabinetPanelNameDisplay,
      }

      // const currentTagTemp = this.tagTempList.find(
      //   (temp) => temp.id === this.currentTagTempID
      // )
      // const temp = {
      //   data: JSON.stringify(template ?? ''),
      //   name: currentTagTemp?.name ?? '默认模板',
      //   id: currentTagTemp?.id ?? 0,
      // }
      const file = this.isNewTagDraw
        ? await generateTagFile(
            window.$copy(data),
            template,
            this.$store,
            exportObj,
            {},
            this.ncLifeFuncObj,
            {
              isNewGen: true,
              tagSetting,
              isSendToFactory: this.confirmSendToFactory,
              isFollowExportTag: true,
              skipSubTag: this.skipSubTagOnNcExport,
            }
          )
        : await generateTagFile(
            data,
            template,
            this.$store,
            exportObj,
            {},
            this.ncLifeFuncObj,
            {
              skipSubTag: this.skipSubTagOnNcExport,
            }
          )
      // 未能正常生成直接返回
      if (!file) {
        return []
      }
      // 是否需要压缩，只有图片需要压缩
      let zipFile = null
      if (file.tagData && isCanExportPic) {
        const {
          data,
          zip: imgZip,
          labelImgList,
        } = await createTagImageZip(
          file.tagData,
          this.$store,
          template.name,
          this.subtleBigPart
            ? window.$copy([this.subtleBigPart])
            : JSON.parse(JSON.stringify(this.paibanData)),
          true
        )
        zipFile = data
        this.imgZip = imgZip
        this.labelImgList = labelImgList
      }
      /** @description 最终返回的结果， */
      const result = []
      /** @description 生成最终结果，用数组方式存储 */
      const genResult = async (data, type = 'pdf') => {
        const ext = type === 'pdf' ? '.pdf' : '.zip'
        const uploadFile = new File([data], template.name + ext, {
          type: data.type,
        })
        result.push({
          type,
          data: {
            uploadFile,
            tagfileData: file.tagData?.collect,
            isOnlySurplus: file.pdfData?.isOnlySurplus,
          },
        })
      }
      if (isCanExportPdf || isCanExportPic) {
        if (isCanExportPdf) await genResult(file.pdfData.data, 'pdf')
        if (isCanExportPic) await genResult(zipFile, 'picture')
      }
      return result
    },
    // 试生产模态框已上传图片后确认下载nc
    async handleTrialProductConfirm() {
      await this.beforeDownloadNC()
    },
    // 试生产模态框关闭
    handleTrialProductCancel() {
      // 切换nc下载按钮loading状态
      this.isNCBtnLoading = false
    },
    // 窗口点击事件
    onMoreSetting(e) {
      let isMoreSetting = false //是不是更多设置
      let isBody = false // 是不是已经找到了body元素了
      let target = e.target
      const bodyElement = document.getElementsByTagName('body')[0] //body元素
      while (!isMoreSetting && !isBody) {
        // 点击弹框中的内容说明是更多设置
        if (
          (target.id && target.id === 'paiban_export_setting_menu') ||
          target.id === 'paiban_export_setting_dropdown' ||
          target.id.includes('paiban_tag_template_select')
        ) {
          isMoreSetting = true
          this.isChangeTagTemp = false
          updateLocalPreference({
            isChangeTagTemp: false,
          })
        } else if (target === bodyElement) {
          isBody = true
          this.isMoreSetting = false
        } else {
          target = target.parentNode
        }
      }
    },

    handleClickMoreSetting() {
      this.isMoreSetting = !this.isMoreSetting
      if (this.isMoreSetting) {
        document.body.addEventListener('mousedown', this.onMoreSetting)
        this.isChangeTagTemp = false
        updateLocalPreference({
          isChangeTagTemp: false,
        })
      } else {
        document.body.removeEventListener('mousedown', this.onMoreSetting)
      }
      this.currentTagTempID = this.initTagTempID()
    },
    // 生成需要下载的文件URL数组
    async genFileUrls(data, ncPayloadData = '') {
      let flag = this.judgeCutOrder()
      if (flag) {
        // this.$message.warning(translate('arrangedPage.cutOrderErr'))
        this.handleSeriesManipulate()
        return []
      }
      const files = [...data]
      const { tagDocType, currentTagTemp: factoryTagTemp } =
        this?.tagSetting ?? {}
      // 是否生成标签文件-发送车间时判断，需要发送车间且只是选择了一中标签生成方式
      const isFactoryGenTag = this.confirmSendToFactory && tagDocType?.length

      //  todo web 和发送车间都可以正常根据逻辑生成标签，但内嵌点击下载 NC 按钮暂时不可以下载
      const isEmbeddedTag = !window.webToQt || this.confirmSendToFactory
      if (isEmbeddedTag) {
        if (this.isFollowExportTag || isFactoryGenTag) {
          let currentTagTemp = this.tagTempList.find(
            (temp) => temp.id === this.currentTagTempID
          )
          let exportTagType = this.currentTagType
          if (this.confirmSendToFactory) {
            exportTagType = tagDocType
            currentTagTemp = factoryTagTemp
          }
          const tagResults = await this.generateTagsFile(
            currentTagTemp,
            exportTagType,
            false,
            this.isFollowExportTag
          )
          const isNeedPDFFile = this.isCanExportPdf(exportTagType)
          const isNeedPictureFile = this.isCanExportPic(exportTagType)

          tagResults?.forEach((v) => {
            const { type, data } = v
            const { url, isOnlySurplus, tagfileData, uploadFile } = data
            files.push({
              fileType: 'tag',
              url,
              exportType: type === 'pdf' ? 'pdf' : 'zip',
              file_display_name: this.orderInfo.order_address,
              fileData: isNeedPDFFile ? uploadFile : false,
              tagData: isNeedPictureFile ? tagfileData : null,
              isOnlySurplus,
            })
          })
        }
      }

      if (
        this.ncSetting.automation &&
        this.ncSetting.cuttingEquipment == 'engraving' &&
        (this.ncSetting.dock5FDrill || this.ncSetting.dock6FDrill)
      ) {
        const res = await getExcelData({
          process_line_id:
            this.ncSetting.process_line_id ?? this.ncSetting.process_setting_id,
          big_planks: ncPayloadData,
          factory_id: this.factoryId ?? 13195,
        })
        if (res.status) {
          if (!this.isWebToQt) {
            const excelFile = exportExcel(res.data)
            files.push({
              fileType: 'excel',
              url: excelFile,
              exportType: 'xlsx',
              file_display_name: '生产进度跟踪批次导入表格',
              fileData: excelFile,
              // 自定义文件夹识别类型
              _customizeRecognitionType: 'product_export_batch_excel',
            })
          }
        } else {
          this.$message.error(res.msg)
        }
      }

      try {
        files.forEach((url) => {
          // 利用异常抛出错误
          if (url.error_info) {
            throw new Error(url.error_info)
          }
        })
      } catch (e) {
        this.$confirm(e.message, translate('common.warning'), {
          type: 'error',
        })
        return
      }

      return files
    },
    // 初始化标签选中模板ID
    initTagTempID() {
      const tempIDArr = this.tagTempList.map((temp) => temp.id)
      const defaultTemp = this.tagTempList.find((temp) => temp.is_default)
      const proLineTagTempId =
        this.currentTagTempID ?? this.ncSetting.tag_template_id
      const defualtTempID = defaultTemp ? defaultTemp.id : 0
      const finalTempId =
        proLineTagTempId !== -1 ? proLineTagTempId : this.currentTagTempID
      if (tempIDArr.length == 1) {
        return tempIDArr[0]
      } else {
        return tempIDArr.includes(finalTempId) ? finalTempId : defualtTempID
      }
    },
    handlePlankRollPoly() {
      this.drawData = this.drawData.map((plankData) => {
        plankData.data.forEach((item) => {
          item.parts.forEach((val) => {
            if (val.is_high_gloss_plank) {
              rolloverPlank(val)
              dealPlankPoly(val)
            }
          })
        })
        return plankData
      })
      this.setHasRollPoly(true)
    },
    // 初始化高光翻面
    async handleInitAllHighGlossSide() {
      // 本次排版是正面且不是历史订单进行高光翻面
      if (
        this.highgloss_direction === 'front' &&
        !this.isHistoryStatus &&
        !this.hasRollPoly
      ) {
        const { from } = this.$route.query
        if (from == 'history_paiabn') {
          return
        } else {
          this.handlePlankRollPoly()
        }
      }
    },
    // 检测切割顺序
    judgeCutOrder(bigpart = null) {
      // 切割顺序有问题的板子数组
      this.errorCutOrders = []
      this.errorBigPlankCutOrders = []
      this.errorBigPlankLockedCutOrders = []
      const paibanData = bigpart
        ? bigpart
        : this.drawDataArr && this.drawDataArr.length && this.isSubtle
        ? this.drawDataArr
        : this.paibanData
      for (let index = 0; index < paibanData.length; index++) {
        let flag = false
        const plank = paibanData[index]
        // 是否存在重复切割顺序
        // 是否是连续的切割顺序
        // 不能用原数组进行sort排序处理，修改原数组会触发监听，调用当前方法，无限循环
        let parts = deepCopy(
          plank.parts.filter((item) => !item.blueAreaSurplus)
        )
        // 切割顺序错误的几种情况 a.1 1 2 3 提示板件1  b.1 2 4 5 提示板件4、5  c.1 2 2 5 6 提示板件2、5、6
        // 重复数据
        const prioritys = []
        for (let i = 0; i < plank.parts.length; i++) {
          if (prioritys.includes(plank.parts[i].priority)) {
            // 放入错误数据
            this.errorCutOrders.push(plank.parts[i])
            // 将重复数据变成null方便后期筛选
            parts[i] = null
            // 修改判断大板顺序是否有错误
            flag = true
          } else {
            prioritys.push(plank.parts[i].priority)
          }
        }
        parts = parts.filter((item) => item)
        parts.sort((a, b) => a.priority - b.priority)
        for (let i = 0; i < parts.length; i++) {
          // 切割顺序不连续数据
          if (parts[i].priority != i + 1) {
            this.errorCutOrders.push(parts[i])
            flag = true
          }
        }
        if (flag) {
          this.errorBigPlankCutOrders.push(plank.canvasIndex)
          if (plank.isLocked) {
            this.errorBigPlankLockedCutOrders.push(plank.canvasIndex)
          }
        }
      }
      this.errorBigPlankCutOrders.sort((a, b) => a - b)
      this.errorBigPlankLockedCutOrders.sort((a, b) => a - b)
      return this.errorCutOrders.length
    },
    clearConflict() {
      this.isExistsActivePlank = !!this.getAllActive().filter((it) => it).length
    },

    judgmentConflicts(drawDataArr = this.paibanData) {
      this.isShowConflictPrompts = false
      drawDataArr.forEach((item) => {
        item.parts.forEach((val) => {
          try {
            // 添加一个冲突可能性，重新再检测一次是否有冲突
            checkPlankHoleSlot(val)
          } catch (err) {
            // 冲突检测异常错误
            console.error(err)
          }
          if (val?.holeSlotMerge) {
            this.isShowConflictPrompts = true
          }
        })
      })
      return this.isShowConflictPrompts
    },
    // 收集冲突板件数据
    handleCollectConflicts() {
      const list = []
      store.state.finalDrawData.forEach((item) => {
        item.data.forEach((v) => {
          // 过滤掉不包含孔槽冲突的板件并且按照小板切割顺序
          const nParts = [...v.parts]
            .filter((i) => i.holeSlotMerge)
            .sort((a, b) => a.priority - b.priority)
          nParts.forEach((it) => {
            list.push(it)
          })
        })
      })
      this.conflictPlankList = Object.freeze(list)
    },
    handleClickLock() {
      this.jundgeAllPlankLocked()
    },
    // 判断所有的大板是否锁定
    jundgeAllPlankLocked() {
      const lockedPlank = []
      this.drawData.forEach((planks) => {
        const lockedPlankList = planks.data
          .slice()
          .filter((item) => item.isLocked)
        lockedPlank.push(...lockedPlankList)
      })
      this.isBanRelayout = lockedPlank.length === this.paibanData.length
    },
    // 前往料单前的统一处理
    goToBeforeMaterialDeal(data, item) {
      data.sampleFormData
        ? this.setIsShowSample(true)
        : this.setIsShowSample(false)
      data.paibanData.forEach((plank) => {
        checkPlankDataIsCorrect(plank)
        plank.parts.forEach((part) => {
          generateSimplePlankNum(part)
        })
      })
      this.setPreLayoutData(dealPreLayoutDataLabelID(data.layoutData))
      if (data.thinkerxMaterialKeys) {
        this.setThinkerxMaterialKeys(data.thinkerxMaterialKeys)
      }
      let orderInfo = {
        order_address: `${translate('common.history')}-${item.name}`,
        order_ids: item.order_list ? item.order_list.join(',') : '',
        order_codes: item.plank_info.order_codes,
        needPaibanRoomIds: item.room_ids ? item.room_ids : [],
        room_ids: [],
      }

      this.setOrderInfo(orderInfo)
      const sampleData =
        data.sampleFormData ?? clearObjAttr(this.sampleTableData)
      this.setSampleTableData(sampleData)
      // 当是第三方直接进入，并且没有样表信息的不显示样表头
      if (this.isLinkLogin && !data.sampleFormData) {
        this.setIsShowSample(false)
      }
    },
    // 优化率排序
    // rateSort() {
    //   let arr = []
    //   // 对数据进行修改赋值
    //   for (let item of this.drawData) {
    //     arr.push(...item.data)
    //   }
    //   arr.sort((a, b) => {
    //     return b.usedRate - a.usedRate
    //   })
    //   // 将不同的材质拆分出来再组合
    //   const surplusDataList = []
    //   const normalDataList = []
    //   for (const plank of arr) {
    //     if (plank.surplusInfo) {
    //       surplusDataList.push(plank)
    //     } else {
    //       normalDataList.push(plank)
    //     }
    //   }
    //   const sort = (data) => {
    //     const single = []
    //     const double = []
    //     for (const item of data) {
    //       if (item.ableToggle) {
    //         double.push(item)
    //       } else {
    //         single.push(item)
    //       }
    //     }
    //     // 按照双先单后顺序返回数据
    //     return [double, single].flat()
    //   }

    //   const surplus = sort(surplusDataList)
    //   const normal = sort(normalDataList)

    //   arr = [].concat(surplus).concat(normal)
    //   for (let i = 0; i < arr.length; i++) {
    //     arr[i]._sortNum = i + 1
    //   }
    //   this.drawData.forEach((d) => {
    //     d.data
    //       .sort((a, b) => {
    //         return a._sortNum - b._sortNum
    //       })
    //       ?.map((item, index) => {
    //         item.canvasIndex = index + 1
    //       })
    //   })

    //   this.resetNeedData()
    //   this.dealPaibanData()
    //   // 再次赋值
    //   this.resetNeedData()
    // },
    resetNeedData() {
      this.setFinalDrawData(this.drawData)
      this.handleSetNewPaibanData()
    },
    handleJudgeAbleFanban(bigpart, index) {
      this.$refs[`drawpart${index}`][0].judgeAbleFanban(bigpart)
    },
    // 查看深度异常详情
    handleSeeDepthError() {
      this.isShowDepthTip = true
    },
    // TODO收集深度异常数据allDepthErrorData
    handleCollectDepthErrorData(data) {
      const partsList = data
        .flatMap((item) => item.data)
        .flatMap((item) => item.parts)
      this.allDepthErrorData = partsList.filter((item) => item.depthError)
    },
    handleDepthTipBtnClick(type) {
      switch (type) {
        case 'next':
          this.depthErrorIndex++
          if (this.depthErrorIndex === this.allDepthErrorData.length) {
            this.depthErrorIndex = 0
          }
          break

        case 'prev':
          this.depthErrorIndex--
          if (this.depthErrorIndex < 0) {
            this.depthErrorIndex = this.allDepthErrorData.length - 1
          }
          break
      }
    },
    handleSetNewPaibanData() {
      let newPaibanArr = []
      this.finalDrawData.forEach((item) => {
        newPaibanArr = [...newPaibanArr, ...item.data]
      })
      this.setPaibanData(newPaibanArr)
    },

    async handleOrderMarkOk() {
      // 继续导出nc并关闭弹窗
      this.isShowOrderMark = false
      this.isCancontinue = true
      if (this.surplusUseArr.length) {
        await useSurplusApi(this.surplusUseArr)
      }
      await this.downloadNC(this.drawDataArr, this.isSubtle)
      if (!this.orderIds.length) {
        return
      }
      // 更新标记状态
      const data = {
        order_ids: [...new Set(this.orderIds)],
        mark_action: this.proucePopupState.mark_action,
      }
      await updateProduceStatus(data)
    },
    handleOrderMarkCancel() {
      // 中断导出nc并关闭弹窗
      this.isNCBtnLoading = false
      this.isShowOrderMark = false
      this.confirmSendToFactory = false
    },
    async handleShowOrderMark(surplusUseArr = []) {
      const hasOrderIds = JSON.parse(JSON.stringify(this.paibanData))
        .flatMap((item) => item.parts)
        .some((item) => (item._isBujian ? item._bujianOid : item.orderId))
      if (hasOrderIds) {
        // 当前订单所有的orderIds
        this.orderIds = JSON.parse(JSON.stringify(this.paibanData))
          .flatMap((item) => item.parts)
          .map((item) => (item._isBujian ? item._bujianOid : item.orderId))
      } else {
        return
      }
      const fliterGGIds = JSON.parse(localStorage.getItem('ggOrderIds')) || []
      // 计算 fliterGGIds 中每个值的重复次数
      const countMap = fliterGGIds.reduce((map, value) => {
        map.set(value, (map.get(value) || 0) + 1)
        return map
      }, new Map())
      // 过滤 this.orderIds 中包含在 fliterGGIds 中的值，并确保输出数组中每个值的重复次数不超过 fliterGGIds 中的重复次数
      this.orderIds = this.orderIds.filter((value) => {
        if (countMap.has(value) && countMap.get(value) > 0) {
          countMap.set(value, countMap.get(value) - 1)
          return true
        }
        return false
      })
      // 所有的原始数据补件orderIds
      // const allPreBujianOrderIds = JSON.parse(
      //   JSON.stringify(this.preLayoutData)
      // )
      //   .filter((item) => item._isBujian)
      //   .map((item) => item.orderId)
      // const allBujianOrderIds = JSON.parse(
      //   JSON.stringify(allPreBujianOrderIds)
      // ).filter((orderId) => this.orderIds.includes(orderId))
      // 所有的板件都是补件也不显示任何弹窗
      // const isAllBujian = allBujianOrderIds.length === this.orderIds.length
      if (!this.orderIds.length) {
        return
      }
      const data = {
        order_ids: [...new Set(this.orderIds)], //真实ids
      }
      const proucePopupState = await getProucePopupState(data)
      if (proucePopupState.status) {
        const { data } = proucePopupState
        Object.assign(this.proucePopupState, data)
      }
      if (
        proucePopupState.data.is_display_mark ||
        proucePopupState.data.is_produced_orders
      ) {
        this.isShowOrderMark = true
        if (surplusUseArr.length) {
          this.surplusUseArr = surplusUseArr
        }
      } else {
        this.isShowOrderMark = false
      }
    },
    // 勾选只看余料的时候执行
    handleShowSurplus() {
      if (this.isShowDepthTip) this.isShowDepthTip = false
      if (this.isShowConflictDiagram) this.isShowConflictDiagram = false
      // 需要保存原始数据，取消数据的赋值回原数据，在每次勾选前保存一次
      this.$nextTick(() => {
        this.drawData.map((item, index) => {
          this.$refs[`drawpart${index}`][0].startDraw()
        })
      })
    },
    handleBury() {
      if (this.isOnlyShowSurplus) {
        buryPointApi('layout', 'only_show_surplus')
      }
      if (this.isLessReverse) {
        buryPointApi('layout', 'is_less_reverse')
      }
    },
    handleUnuseSurplus() {
      updateLocalPreference({
        isUnuseSurplus: this.isUnuseSurplus,
      })
      // 计算
      this.handleResetPlankArea(true)
      this.renderAll()
    },
    handleUsePlankAdsorption() {
      updateLocalPreference({
        isUsePlankAdsorption: this.isUsePlankAdsorption,
      })
      if (this.isUsePlankAdsorption) {
        buryPointApi('layout', 'plank_adsorption')
      }
    },
    // 数据默认收起
    handleDataDefaultCollapsed() {
      // 将数据修改后的数据存到偏好设置里面
      updateLocalPreference(
        {
          isDataDefaultCollapsed: this.isDataDefaultCollapsed,
        },
        ({ isErr }) => {
          if (isErr) {
            this.$message.error(res.msg ?? this.$t('common.checkNetwork'))
            // 是否需要阻止修改勾选框
            this.isDataDefaultCollapsed = !this.isDataDefaultCollapsed
          } else {
            this.controlCollapsed()
            this.renderAll()
          }
        }
      )
      if (this.isDataDefaultCollapsed) {
        buryPointApi('layout', 'data_default_collapsed')
      }
    },
    /** 标识修改过的小板 */
    handleMarkModifiedSmallBoards() {
      updateLocalPreference({
        isMarkModifiedSmallBoards: this.isMarkModifiedSmallBoards,
      })
    },
    /** 显示键盘移动步长 */
    handleShowMoveStep() {
      updateLocalPreference({
        isShowMoveStep: this.isShowMoveStep,
      })
      if (this.isShowMoveStep) {
        buryPointApi('layout', 'isShowMoveStep')
      }
    },
    onSubtleActivePlankChange(hasActive) {
      this.subtleHasActivePlank = Boolean(hasActive)
    },
    handleInputMoveStep(value) {
      this.moveStep = Number(value.target.value.replace(/\D/g, ''))
    },
    /** 回车保存步长；0 或无效时不保存，恢复为上次有效值 */
    handleUpdateMoveStep() {
      const step = Number(this.moveStep)
      if (!step || step <= 0) {
        this.moveStep = this.lastValidMoveStep
        return
      }
      this.lastValidMoveStep = step
      this.moveStep = step
      updateLocalPreference({
        moveStep: this.lastValidMoveStep,
      })
    },
    /** 失焦未回车：不保存，恢复为上次有效步长 */
    handleBlurMoveStep() {
      this.moveStep = this.lastValidMoveStep
    },
    // 导出孔槽图 默认为样式二
    async handleExportHoleSlotPdf() {
      buryPointApi('layout', 'export_hole_slot_pdf')
      // 加载字体
      await jsPdfTool.loadFont('msyh', 'zh', 'normal')
      // 创建一个用于绘制三视图的实例
      const drawView = new DrawPartView()
      let data = deepCopy(this.paibanData)
        .map((item) => item.parts)
        .flat(1)
      // 过滤余料板件
      data = data.filter((item) => item.name !== '余料板件')
      data.forEach((part, idx) => {
        let plankNum = part.oriPlankNum
        if (this.ncSetting.genSimpleLabelBarcode) {
          plankNum = part.simplePlankNum ?? ''
        }
        const tableInfo = {
          date: ' ',
          version: ' ',
          modifiedCount: '',
          designer: ' ',
          size: `${Number(part.oRect.width).toFixed(1)}*${Number(
            part.oRect.height
          ).toFixed(1)}*${Number(part.thick).toFixed(1)}`,
          pic: ' ',
          matCode: part.matCode,
          check: ' ',
          color: part.texture,
          count: part.amount ? part.amount.toString() : '1',
          percent: ' ',
          approval: ' ',
          index: idx + 1,
          total: data.length,
          plankNum,
          orderNo: part.orderNo,
          partName: part.partName,
          proCount: ' ',
        }
        let newPart = part
        if (part.oRect.width < part.oRect.height) {
          // FIXE: 旋转板件，需要修改原方法，不应该直接修改原数据
          rotatePart(newPart)
        }
        drawView.drawThreeView(newPart, () => {
          drawView.drawInfoTable(tableInfo)
        })
        drawView.pdf.addPage()
      })
      // 删除尾页
      drawView.pdf.deletePage(drawView.pdf.getNumberOfPages())
      drawView.save(`${this.orderInfo.order_address}-三视图`)
    },
    async handleExportHoleSlotDxf() {
      const hasPermission = checkUserPermissionWithToast(
        USER_PERMISSION_KEY.EXPORT_THE_STYLE_TWO_HOLE_SLOT_DIAGRAM_DXF,
        this.$translateLang('该功能为付费功能，请联系销售开通后使用~')
      )
      if (!hasPermission) {
        return
      }

      buryPointApi('layout', 'export_hole_slot_dxf')
      let data = deepCopy(this.paibanData)
        .map((item) => item.parts)
        .flat(1)
      data = data.filter((item) => item.name !== '余料板件')
      exportThreeViewDxf(
        data,
        !!this.ncSetting.genSimpleLabelBarcode,
        `${this.orderInfo.order_address}-三视图DXF`
      )
    },
    /** 重新计算排版页面板件利用率 */
    handleResetPlankArea(isFoucedReset = false) {
      if (isFoucedReset) {
        // 如需要强制重新切换顺序则删除 paibanData上的_sortNum 字段让后续方法重新进行排序
        this.paibanData.forEach((bigPlank) =>
          Reflect.deleteProperty(bigPlank, '_sortNum')
        )
        this.dealAllDrawData()
        return
      }
    },
    // 点击料单跳往开料清单
    handleToMaterialList() {
      buryPointApi('layout', 'material_list')
      this.$router.push('/materialList')
    },
    // 切换排版设置
    handleToggleSettings() {
      // 点击打开或者关闭弹窗
      this.isShowProgram = !this.isShowProgram
    },
    // 判断鼠标所在区域，关闭弹窗（点击除弹窗的部分触发）
    onToggleSettings(e) {
      //获取当前点击区域
      let target = e.target
      // 利用includes判断
      if (!this.$refs.paibanProgramRef?.contains(target)) {
        this.isShowProgram = false
      }
    },
    // 标记TODO
    async handleChangeSetting() {
      // 当设置发生变更时
      this.isShowProgram = false
      // 判断设置的初始数据，以及开启余料自动裁剪后的情况
      if (
        JSON.stringify(this.initState) !== JSON.stringify(this.finalState) ||
        JSON.stringify(this.initTableList) !==
          JSON.stringify(this.finalTableList) ||
        JSON.stringify(this.initSurplusSelectList) !==
          JSON.stringify(this.finalSurplusSelectList)
      ) {
        if (this.finalState.surplusAutoTailor) {
          this.hasSaveSurplus = false
        } else {
          this.hasSaveSurplus = true
          this.hasCut = false
        }
        this.selectedPaibanWay =
          this.finalState.paibanWay?.replace('_roll', '') ?? 'paiban_v2'
        this.isLessReverse = this.finalState.isLessReverse
        this.nestWay =
          this.finalState.nestWay === 'SENIOR' &&
          !this.hasAdvancedNestPermission
            ? 'PRIMARY'
            : this.finalState.nestWay
        this.isSpecialShape = this.finalState.isSpecialShape
        this.setSurplusAutoTailor(this.finalState.surplusAutoTailor)
        if (this.finalState.surplusAutoTailor) {
          this.setSurplusTailorWay(this.finalState.surplusTailorWay)
          this.setRecodeIsTailor(this.finalState.surplusAutoTailor)
          this.setLongSideRect(this.finalState.longSideRect)
          this.setShortSideRect(this.finalState.shortSideRect)
        }
        this.handleChangePaibanWay(this.selectedPaibanWay)
      }
    },
    handleGetInitData(state) {
      this.initState = state
    },
    handleGetFinalData(state) {
      this.finalState = state
    },
    handleGetInitTableData(state) {
      this.initTableList = state
    },
    handleGetFinalTableData(state) {
      this.finalTableList = state
    },
    handleGetInitSurplusSelectData(state) {
      this.initSurplusSelectList = state
    },
    handleGetFinalSurplusSelectData(state) {
      this.finalSurplusSelectList = state
    },
    handleCloseTagTemp() {
      this.isChangeTagTemp = false
      updateLocalPreference({
        isChangeTagTemp: false,
      })
    },
    // 修改下刀位置
    changeCutOrigin(type) {
      this.selectedCutorigin = type
    },

    handleConfirmChangeCutOrigin() {
      this.$confirm(
        `${this.$translateLang(
          '当前操作为批量修改下刀点，修改后将应用到全部小板，下刀点在同一个方向可能会出现跑板，请确认是否操作！'
        )}`,
        this.$translateLang('温馨提示'),
        {
          confirmButtonText: this.$translateLang('确定'),
          cancelButtonText: this.$translateLang('取消'),
          type: 'warning',
          customClass: 'nc-confirm',
        }
      ).then(() => {
        this.confirmChangeCutOrigin()
      })
    },

    confirmChangeCutOrigin() {
      this.drawData.forEach((draw) =>
        draw.data.forEach((plank) => {
          if (!plank.isLocked) {
            plank.parts.forEach(
              (part) => (part.cutOrigin = this.selectedCutorigin)
            )
          }
        })
      )

      this.showPositionChange = false
      this.paibanData.forEach((plank) => {
        if (!plank.isLocked) {
          plank.parts.forEach(
            (part) => (part.cutOrigin = this.selectedCutorigin)
          )
        }
      })
      this.setFinalDrawData(this.drawData)
      this.renderAll()
      // 这里操作记录
      const payload = [
        {
          key: '排版页',
          value: [
            {
              key: '批量修改下刀点',
              oldValue: '',
              value: this.selectedCutorigin,
            },
          ],
        },
      ]
      saveDataJsonToOssForRecord(
        payload,
        // `排版页-${this.orderInfo.order_address ?? ''}`
        'paiban'
      )
      this.selectedCutorigin = ''
      buryPointApi('layout', 'batch_set_cutOrigin')
      this.isNeedUpdateBatch = true
      this.setBatchTaggingList([])
    },
    /** 重新计算总翻板数 */
    calcFanbanCount() {
      // 统计大板件翻板数
      this.totalBigpartFanban = 0
      this.drawData.forEach((series) => {
        // 重置大板片翻板数
        series.fanbanCount = 0
        series.data.forEach((bigpart) => {
          if (bigpart.ableToggle) {
            series.fanbanCount += 1
          }
        })

        const stockKey = `${series.matCode}-${series.texture}-${series.thick}`
        const bigPlank = this.bigPartsInfo.find(
          (item) => stockKey === `${item.matCode}-${item.texture}-${item.thick}`
        )
        if (bigPlank) {
          bigPlank.toggleCount = series.fanbanCount
        }
        this.totalBigpartFanban += series.fanbanCount
      })
    },
    clearAllTimer() {
      clearTimeout(this.scaleTimer)
      clearInterval(this.scaleInterv)
    },
    /** 清除所有监听,避免泄漏 */
    clearAllListener() {
      window.removeEventListener('keydown', this.keyDownEvent)
      window.removeEventListener('keyup', this.keyUpEvent)
      window.removeEventListener('blur', this.onWindowBlurExitBatchSelect)
      window.removeEventListener(
        'contextmenu',
        this.preventCtrlContextMenu,
        true
      )
      window.removeEventListener('resize', this.resizeEvent)
      window.removeEventListener('mouseup', this.clearAllTimer)
      window.removeEventListener('mousedown', this.onMoreSetting)
      window.removeEventListener('mousemove', this.mouseMoveEvent)
    },
    //不改变传入的小板数据,老板良那边要求，需要给补件的每块小板增加标识，用于区分是补件，该字段和值由前端定义
    handleAddFlagForSurplusListToLbl(plankList, bujianOrderIds) {
      const clonedPlankList = lodash.cloneDeep(plankList)
      const tempData = clonedPlankList.flatMap((item) =>
        item.parts.map((part) => ({
          ...part,
          isSupplement: bujianOrderIds.includes(part.partUniqueId) || false,
        }))
      )
      return tempData
    },
    // 存入余料清单
    handleSaveSurStorage() {
      this.handleSurplusSave({}, true)
    },
    /** 子画布缩放值改变 */
    handlePartScaleChange({ defaultScale, scale }) {
      this.defaultScale = defaultScale ?? 6
      this.scalePercent = scale ?? 1
    },
    /** 设置激活大板 */
    handleSetActiveBigpart(val) {
      this.activeBigpart = val
    },
    /** 检查进行下载或标签相关操作前需要先检查待排版库是否存在板件 */
    async checkAwaitLocalStore() {
      if (this.storeType !== 'awaitStore') return true
      const result = this.$refs['storeRef']?.checkLocalPlankStore?.()
      if (result == null) return true
      return await Promise.resolve(result)
    },
    translateLang(key, val) {
      return translate(key, val)
    },
    handleProLineSwitchIconClick() {
      if (this.isProLineSwitchIconDisabled) {
        return
      }
      this.handleSelectProLine()
    },
    // 打开生产线选择框
    handleSelectProLine() {
      if (this.checkBigPlankIsRotate(this.paibanData)) {
        return
      }
      buryPointApi('layout', 'select_proLine')
      if (this.ncSetting.isPreLayout) {
        this.checkSettingChange()
      } else {
        this.isSelectProLine = true
      }
    },
    //关闭生产线选择框
    handleChangeVisible(val) {
      this.isSelectProLine = val
    },
    // 生产线确认按钮及重新排版按钮
    async handleConfirmLineSelect(lineId = null, isReLayout = false) {
      this.isSelectProLine = false
      if (!lineId) return
      this.oriNcSetting = deepCopy(store.state.ncSetting)
      const res = await fetchGetProductionNcSetting({ setting_id: lineId })
      store.commit('setNcSetting', {
        ...res.data,
        process_setting_id: lineId,
      })
      this.preSaveNcSetting = {
        ...res.data,
        process_setting_id: lineId,
      }
      // 切换的生产线有冲突时 才放出更多更多排版方案
      if (isReLayout) {
        this.setIsLockedRePaiban(false)
      }
      if (lineId && isReLayout) {
        const currentLine = this.proLineList.find((item) => item.id === lineId)
        // 判断异形嵌套和五六面钻
        if (currentLine) {
          try {
            if (
              this.isSpecialShape &&
              currentLine.data.dock56FDrill &&
              !currentLine.data.hole_slot_engraving_process
                .engraving_process_setting.non_hole_slot_of_special_shape &&
              currentLine.data.ncHoleSlot !== 'doubleHoleSlot'
            ) {
              this.currentSpecailType = 'prePaiban'
              this.isShowSpecialAndFiveSix = true
              this.currentLineId = lineId
              return
            }
          } catch (error) {
            console.log('检测异形嵌套且开启五六面钻设置失败', error)
          }
        }
        this.reLayout(lineId)
      } else if (lineId) {
        this.showLoading = true
        store.commit(
          'setRecodrProductionLineChoose',
          this.proLineList.find((item) => item.id === lineId).name
        )
        this.showLoading = false
      }
      // 画布的展开收起变化
      this.controlCollapsed()
    },
    async reLayout(lineId) {
      // const hasPart = this.finalDrawData.every((item) => {
      //   const data = item.data
      //   return data.every(
      //     (plank) =>
      //       plank.parts.length && !plank.parts.every((part) => part.surplusPath)
      //   )
      // })
      if (this.checkBigPlankIsRotate(this.paibanData)) {
        return
      }
      const allParts = this.finalDrawData
        .map((item) => item.data.map((plank) => plank.parts))
        .flat(Infinity)
      const noPart = allParts.every((part) => part.surplusPath)
      if (noPart) {
        Vue.prototype.$antdConfirm({
          title: translate('common.tip'),
          content: translate('arrangedPage.uselessPart'),
          okText: translate('common.confirm'),
          cancelText: translate('common.cancel'),
          centered: true,
        })
        this.showLoading = false
        this.isRefresh = false
        this.resetNCSetting()
        return new Promise((resolve) => resolve(false))
      }
      // 请求待排版库数据
      const result = await fetchStoreData({
        library_type: LibraryType.bujianStore,
      })
      const bujianPlankList = result.data?.data ?? []
      this.showLoading = true
      // 真正进入排版流程，清除所有复用标记
      this.clearAllReuseMarks()
      this.setIsResetPaibanAllocation(true)
      const paibanPlankResNested = await Promise.all(
        this.paibanData
          .map((item) => item.parts)
          .flat(1) // 平铺所有的part
          .filter((item) => !item.surplusPath) //筛选出非余料板
          .map(async (part) => {
            // 合并骨骼门：需要开料清单合并前的 5 块原始板参与重新排版
            if (judgeIsMergeFrameDoor(part)) {
              const rawList = this.preLayoutData.filter(
                (item) =>
                  item.frame_door !== undefined &&
                  item.frame_door !== null &&
                  item.frame_door !== '' &&
                  item.frame_door === part.frame_door
              )
              return rawList.map((child) => ({
                ...deepCopy(child),
                amount: 1,
              }))
            }
            let p = this.preLayoutData.find(
              (item) => item.partUniqueId === part.oriPartUniqueId
            )
            let plank
            if (part._isAwaitStorePlank) {
              const awaitPart =
                store.state.awaitPaibanStore.servePlankStore.find(
                  (i) => i.id == part._awaitStoreId
                )
              if (awaitPart) {
                plank = await parseAwaitStoreRenderUrl(
                  awaitPart.render_url,
                  awaitPart.from
                )
                plankAddAwaitStoreFeature(plank, awaitPart)
              }
            } else if (part._isBujian) {
              const bujianPart = bujianPlankList.find(
                (i) => i.id == part._bujianStoreId
              )
              if (bujianPart) {
                const bujianRes = await axios.get(bujianPart.render_url)
                if (bujianRes.status) {
                  plank = Array.isArray(bujianRes.data.plank)
                    ? bujianRes.data.plank.find(
                        (p) => p.plankID == part.plankID
                      )
                    : bujianRes.data.plank
                }
                plankAddBujianStoreFeature(plank, bujianPart)
              }
            }

            if (p) {
              return { ...p, amount: 1 }
            }
            if (plank) {
              return { ...plank, amount: 1 }
            }
            return false
          })
      )
      const paibanPlankResList = paibanPlankResNested.flatMap((item) => {
        if (Array.isArray(item)) {
          return item
        }
        return item ? [item] : []
      })
      const paibanPlankList = paibanPlankResList.every((item) => !item)
        ? this.preLayoutData.filter((item) => item.isSelected)
        : paibanPlankResList.filter((item) => item)

      // if (
      //   this.ncSetting.hs_on_front_aft_shunt ||
      //   this.ncSetting.cal_turn_num_aft_shunt
      // ) {
      // 这里注释是因为，通槽找刀逻辑放在了孔槽分流接口里面，这个条件需要放开
      // 对纹板件分离处理
      const textureParts = paibanPlankList.filter((p) =>
        isTextureAlignmentPlank(p)
      )
      const layoutGap = this.ncSetting?.panelSize?.layoutGap ?? 0
      const compositedParts = compositeTexturePlanks(
        paibanPlankList,
        layoutGap,
        false,
        false,
        this.ncSetting?.decimal ?? 2,
        true
      )
      const virtualPlanks = compositedParts.filter((p) =>
        isVirtualCompositePlank(p)
      )
      const shuntParts = [...compositedParts, ...textureParts]
      const newAllPart = dealAllParts(shuntParts, this.ncSetting)
      // 获取孔槽分流相关设置 更新板件数据
      const shuntPreData = await dealHoleSlotShunt({
        process_line_id:
          this.ncSetting.process_line_id ?? this.ncSetting.process_setting_id,
        planks: newAllPart,
      })
      if (shuntPreData.status === 1) {
        const newParts = compShapeData(shuntPreData.data.planks, shuntParts)
        paibanPlankList.forEach((part) => {
          const newPart = newParts.find(
            (p) => p.partUniqueId == part.partUniqueId
          )
          if (newPart) {
            Object.assign(part, newPart)
          }
        })
        // 用对纹虚拟板的分流信息，代替内部小板的分流信息
        for (const vp of virtualPlanks) {
          const {
            process_in_engraving_to_curve,
            engraving_cut_curve,
            engraving_cut_curve_to_turn,
          } = vp
          const planks = decompositeTexturePlanks([vp])
          for (const cp of planks ?? []) {
            cp.process_in_engraving_to_curve = process_in_engraving_to_curve
            cp.engraving_cut_curve = engraving_cut_curve
            cp.engraving_cut_curve_to_turn = engraving_cut_curve_to_turn
          }
        }
      }
      // }

      const surObj = setSurplusObj(this.paibanData, this.selectedPaibanWay)
      const surplusRes = await getSurplusList({ page: 1, limit: 999 })
      const allSurplusList = surplusRes.status ? surplusRes.data.data : []
      // 如果xy互换设置不同的情况下，需要对匹配的余料、大板的长宽对调

      for (const key in surObj) {
        surObj[key] = surObj[key]
          .map((p) => {
            const sur = allSurplusList.find((s) => s.id === p.id)
            return sur ? { ...sur, isSelected: true } : false
          })
          .filter((p) => p)
      }
      // 处理余料参数数据
      // = genSurplusParams(Object.values(surObj).flat(1))
      let surplusParams
      // =====余料锁定-排版接口余料参数相关处理=====
      let filterSurList = allSurplusList
      let oldUseSurplusId = JSON.parse(JSON.stringify(this.useSurplusId))
      const surplusPlank = this.paibanData.find(
        (item) =>
          item.surplusInfo &&
          Object.keys(item.surplusInfo).length &&
          !item.surplusInfo.isNotSurplus
      )
      this.useSurplusList = allSurplusList.filter((item) =>
        this.useSurplusId.includes(item.id)
      )
      let notOrderLockList = []
      // 开启余料锁定 且使用了余料时 处理重新排版的余料参数
      if (
        this.$store.state.preferencesSetting.setting.surplus_lock &&
        surplusPlank
      ) {
        // 获取被其它订单锁定的余料id
        notOrderLockList = this.useSurplusList
          .filter(
            (item) =>
              item.lock_status == 1 &&
              item.lock_order !=
                this.orderInfo?.order_address?.replace(/\(.*?\)|历史记录/g, '')
          )
          .map((item) => item.id)
      }
      // 历史记录 直接剔除被其它订单锁定的余料
      if (notOrderLockList.length && this.isHistoryStatus) {
        surplusParams = setSurplusObj(
          this.paibanData.filter(
            (item) =>
              !item.isLocked &&
              !item.customSurplus &&
              !notOrderLockList.includes(item?.surplusInfo?.id)
          ),
          this.selectedPaibanWay
        )
      } else if (notOrderLockList.length) {
        let selectSurplusList = []
        if (this.selectSurplusList.length) {
          selectSurplusList = this.selectSurplusList
        } else {
          selectSurplusList = allSurplusList
            .filter((item) => this.useSurplusId.includes(item.id))
            .map((item) => ({ ...item, isSelected: true }))
        }
        // 开料清单 从所选余料中剔除被其它订单锁定的余料
        filterSurList = selectSurplusList.filter(
          (item) =>
            !notOrderLockList.includes(item.id) &&
            !this.delSurplusId.includes(item.id)
        )
        // 更新所选余料 （拆分的情况）
        filterSurList = filterSurList.map((item) => ({
          ...item,
          amount: allSurplusList.find((useItem) => useItem.id == item.id)
            ?.amount,
        }))
        this.setSelectSurplusList(filterSurList)
        // 过滤掉与仅加工孔槽板件匹配的余料
        filterSurList = filterSurplusByNoCutPlanks(
          filterSurList,
          paibanPlankList,
          this.currentLine
        )
        surplusParams = genSurplusParams(filterSurList)
      } else {
        // 过滤掉与仅加工孔槽板件匹配的余料
        const filteredSurList = filterSurplusByNoCutPlanks(
          Object.values(surObj).flat(1),
          paibanPlankList,
          this.currentLine
        )
        surplusParams = genSurplusParams(filteredSurList)
      }

      store.commit('setOriLayoutSetting', this.preLayoutSetting) // 保存排版用预排版设置
      let isErrRes = false
      const res = await calcBaseMaterial(
        paibanPlankList,
        store.state.selectStandardPlank,
        lineId,
        (errType, errText = '') => {
          this.showLoading = false
          this.isRefresh = false
          if (errType === 'plank') {
            this.knifeErrCallback(lineId, errText)
          } else {
            this.$confirm(errText, this.$t('common.tip'), {
              confirmButtonText: this.$t('common.confirm'),
              cancelButtonText: this.$t('common.cancel'),
              type: 'error',
            })
          }
          isErrRes = true
          this.resetNCSetting()
        }
      )
      if (isErrRes) {
        this.showLoading = false
        this.isRefresh = false
        this.resetNCSetting()
        return
      }
      if (!res) {
        this.showLoading = false
        this.isRefresh = false
        this.resetNCSetting()
        return
      }

      const needBaseMaterials = res ? res.needBaseMaterials : []
      // 将仅加工孔槽板件生成的特殊原片追加到 needBaseMaterials
      const currentLine = this.proLineList.find((item) => item.id === lineId)
      if (currentLine) {
        const notCutMaterials = genBaseMaterialsForNotCutParts(
          paibanPlankList,
          currentLine
        )
        needBaseMaterials.unshift(...notCutMaterials)
      }
      const data = dealDataForPaiban(paibanPlankList, store.state.ncSetting, {
        isSpecialShape: this.isSpecialShape,
        isNewLayout: true,
        baseMaterialList: needBaseMaterials,
        surplusObj: surplusParams,
        isOnlyLayoutTooBig: res.materialRes
          ? res.materialRes.only_layout_too_big
          : false,
      })
      if (!data) {
        this.showLoading = false
        this.isRefresh = false
        this.resetNCSetting()
        // this.knifeErrCallback(lineId)
        return
      }
      let paibanWay = this.activePaibanWay[0]
      if (this.isLessReverse) {
        switch (paibanWay) {
          case 'paiban':
            paibanWay = 'paiban_roll'
            break
          case 'paiban_v2':
            paibanWay = 'paiban_roll_v2'
            break
          default:
            break
        }
      }
      const paibanRes = await dealPaibanData(
        data,
        store.state.prePaibanData,
        paibanWay,
        true,
        true,
        true
      )
      if (!paibanRes) {
        this.isRefresh = false
        this.showLoading = false
        this.resetNCSetting()
        store.commit(
          'setRecodrProductionLineChoose',
          this.oriNcSetting.isPreLayout
            ? this.$t('preLayoutSetting.preWayEmpty')
            : this.proLineList.find(
                (item) => item.id === this.oriNcSetting.process_setting_id
              ).name
        )
        return
      }
      if (paibanRes.isOverSize && paibanRes.text) {
        this.isRefresh = false
        this.showLoading = false
        this.resetNCSetting()
        this.$message({
          message: paibanRes.text,
          type: 'error',
          duration: 3000,
        })
        return
      }
      // 开启自定义大板顺序 剔除被其它订单锁定的余料后 排版失败的处理
      if (this.customPlankOrder && paibanRes?.text == '大板数量不够或超尺') {
        // '余料大板被其他订单占用，可用大板不足，请到开料清单重新排版'
        this.$message.warning(translate('arrangedPage.rePaibanWarn'))
        return
      }

      this.activePlank = null
      this.showLoading = false
      this.isRefresh = false
      // 处理板件
      this.dealPaibanData()
      const standardPlank = this.paibanData.find((plank) => {
        return (
          Object.hasOwnProperty.call(plank, 'standardPlankId') &&
          !plank.otherPlate
        )
      })
      if (standardPlank) {
        this.standardPlank = {
          ...this.standardPlank,
          plankEdgeOff: standardPlank.margin,
          plankWidth: standardPlank.plankWidth,
          plankHeight: standardPlank.plankHeight,
        }
      }
      if (lineId) {
        const line = this.proLineList.find((item) => item.id === lineId)
        store.commit(
          'setRecodrProductionLineChoose',
          line ? line.name : this.$t('preLayoutSetting.preWayEmpty')
        )
      }

      // 余料裁剪
      if (this.surplusAutoTailor) {
        await this.startTailorSurplus()
        this.setRecodeIsTailor(false)
        this.handleResetPlankArea(true)
        this.isUpdatingTask = false
      }

      this.$nextTick(() => {
        this.drawData.map((item, index) => {
          this.$refs[`drawpart${index}`][0].startDraw()
        })
        // 检测，绘制夹手
        this.handleCheckClampHandPosition()
        this.renderAll()
      })
      if (!lineId) {
        // 预排版设置修改
        const { setting_value: setting } = this.preLayoutSetting
        const ncSetting = dealPreLayoutSetting(setting)
        store.commit('setOriLayoutSetting', this.preLayoutSetting) // 保存排版用预排版设置
        store.commit('setNcSetting', ncSetting)
      }
      // 重新排版使用的余料ID
      this.useSurplusId = this.paibanData
        .map((item) => !item.surplusInfo?.isNotSurplus && item.surplusInfo?.id)
        .filter((id) => id)
      if (
        this.$store.state.preferencesSetting.setting.surplus_lock &&
        this.useSurplusId.length
      ) {
        // 锁定使用的余料 -存在重新排版后又使用了新的余料或者余料管理又去手动解锁了使用的余料
        const lockParams = {
          surplus: filterSurList
            .filter((item) => this.useSurplusId.includes(item.id))
            .map((item) => ({
              ...item,
              lock_status: 1,
              lock_order: this.orderInfo?.order_address?.replace(
                /\(.*?\)|历史记录/g,
                ''
              ),
              lock_num: this.useSurplusId.filter((id) => id == item.id).length,
            })),
          release_all: false,
        }
        await surplusLock(lockParams)
        // 解锁本订单之前用了的余料 但重新排版未使用的余料
        const beforeUseId = oldUseSurplusId.filter(
          (id) => !this.useSurplusId.includes(id)
        )
        const unLockParams = {
          surplus: this.useSurplusList
            .filter(
              (item) =>
                beforeUseId.includes(item.id) &&
                item.lock_order ==
                  this.orderInfo?.order_address?.replace(
                    /\(.*?\)|历史记录/g,
                    ''
                  )
            )
            .map((item) => ({
              ...item,
              lock_status: 0,
              lock_num: beforeUseId.filter((id) => id == item.id).length,
            })),
          release_all: false,
        }
        await surplusLock(unLockParams)
      }
    },

    resetNCSetting() {
      this.setNcSetting(this.oriNcSetting)
    },

    async checkSettingChange(isMounted = false) {
      const newSetting = await getPrelayoutSetting()
      this.setPreLayoutSetting(newSetting.data)
      // 检测预排版设置是否改变 对象对比法
      const hasPreLayoutSettingChanged = checkPrelayoutSettingChanged(
        this.oriLayoutSetting.setting_value,
        this.preLayoutSetting.setting_value
      )
      // 保存时间对比法 有问题
      // const hasPreLayoutSettingChanged =
      //   this.oriLayoutSetting.update_time != this.preLayoutSetting.update_time

      this.isPreLayoutSettingChenged = hasPreLayoutSettingChanged
      if (hasPreLayoutSettingChanged) {
        this.$antdConfirm({
          title: '提示',
          content: '系统检测预排版设置发生改变，是否重新排版？',
          okText: '重新排版',
          cancelText: '前往修改',
          closable: true,
          centered: true,
          onCancel: (e) => {
            if (typeof e === 'function') {
              e()
              this.$router.push({
                path: '/preLayoutSetting',
                query: {
                  from: 'paiban',
                },
              })
            }
          },
          onOk: () => {
            const { setting_value: setting } = this.preLayoutSetting
            const ncSetting = dealPreLayoutSetting(setting)
            store.commit('setNcSetting', ncSetting)
            this.oriNcSetting = deepCopy(ncSetting)
            this.reLayout()
          },
        })
      } else if (!isMounted) {
        this.isSelectProLine = true
      }
    },
    onGotoSubtleErr() {
      this.checkSettingChange()
    },
    /** 验证目录是否还在使用后的nc下载回调  只区分排版页和精细排版页的下载 */
    ncDownloadCallBack() {
      if (this.currentDownloadType === 'jingxi') {
        this.subtleDownloadNC(this.subtleBigPart)
      } else {
        this.handleDownloadNC()
      }
    },
    /** 刀具错误提示 */
    knifeErrCallback(lineId, errText = '') {
      this.showLoading = false
      this.isRefresh = false
      let errStr = errText
      if (this.ncSetting.plate_knife_map) {
        for (const key in this.ncSetting.plate_knife_map) {
          errStr = this.ncSetting.plate_knife_map[key].error
          if (errStr) break
        }
      }
      this.$confirm(errStr, this.$t('common.tip'), {
        confirmButtonText: this.$t('materialPage.goAdd'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
      }).then(() => {
        const line = this.proLineList.find((item) => item.id === lineId)
        const setting_id = lineId,
          equipType = 'engraving'
        this.$router.push({
          path: `/${equipType}`,
          query: {
            setting_id,
            line: line.name,
            equipType,
          },
        })
      })
    },
    // 查看未找到的刀具信息
    handleOpenNotFoundKnifeInfoModal() {
      this.isShowNotFoundKnivesInfoModal = true
      this.isShowNotFoundKnivesInfoDrawer = false
    },
    // 查看详细信息
    handleOpenErrDetailInfoDrawer() {
      // 关闭modal
      this.isShowNotFoundKnivesInfoModal = false
      // 打开抽屉
      this.isShowNotFoundKnivesInfoDrawer = true
    },
    // 处理找不到刀的数据
    handleDealNotFoundKnivesData(data, isSendToFactory = false) {
      this.notFoundKnivesInfo = data
      // // 统计出所有的错误信息
      this.allKnivesErrInfos = data
        .map((errObj) => {
          return errObj.errorInfo
        })
        .flat(1)
      // 对相同的错误信息进行去重
      this.allKnivesErrInfos = Array.from(new Set(this.allKnivesErrInfos))
      // 打开刀错误信息弹窗
      this.handleOpenNotFoundKnifeInfoModal()
      if (isSendToFactory) {
        // 关闭下载nc弹窗
        this.isDownloadingNc = false
        this.isShowTask = false
        this.isNCBtnLoading = false
      }
    },
    // 其余刀错误信息处理
    handleDealOtherNotFoundKnivesData(msg) {
      // 关闭下载nc弹窗
      this.isDownloadingNc = false
      this.isShowTask = false
      this.isNCBtnLoading = false
      let regError = /过长工位无法加工/gi
      if (regError.test(msg)) {
        this.$confirm(`${res.msg}`, '提示', {
          confirmButtonText: '前往修改',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$router.push('/baseMaterial')
          })
          .catch(() => {})
        return
      }
      this.$confirm(`${msg}`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error',
      })
        .then(() => {})
        .catch(() => {})
    },
    // 关闭弹窗
    handleCloseConflictModal() {
      this.isShowConflictModal = false
      // 去检查即中断本次下载，清空副标确认，下次下载重新提示
      this.skipSubTagOnNcExport = false
    },
    handleIgnoreConflict(type) {
      // 关闭弹窗
      this.isShowConflictModal = false
      // 继续下载NC
      if (type.cancelType == 'button') {
        this.isContinue = true
        if (this.isSubtle) {
          this.subtleDownloadNC(this.subtleBigPart)
        } else {
          this.handleDownloadNC(this.currentOperate == 'nc' ? false : true)
        }
      }
    },
    handleConfirmFrameDoor() {
      this.isShowFrameDoorModal = false
      this.isFrameDoorConfirmed = true
      // 继续下载NC（保留副标确认状态，避免重复弹窗）
      if (this.isSubtle) {
        this.subtleDownloadNC(this.subtleBigPart)
      } else {
        this.handleDownloadNC(this.currentOperate == 'nc' ? false : true)
      }
    },
    handleChangeFrameDoorTip(e) {
      updateLocalPreference({
        isFrameDoorTip: !e?.target?.checked,
      })
    },
    // 复制用料信息
    handleCopyData() {
      const successMsg = '已经复制大板用量为文本，可以复制到其他软件'
      copyText(this.materialData.join('\n'), successMsg)
    },
    // 后端返回的用料数据处理
    dealUseMaterialData(data) {
      const result = []
      const { xyReverse } = this.ncSetting
      try {
        const standardMap = new Map()
        const surpluMap = new Map()
        const specialMap = new Map()
        data?.data.detailed_info.forEach((item) => {
          const matCode = item?.plank_kind.split(':').slice(0, 3).join(' ')
          item.special_stock.forEach((stock) => {
            const { plank_type: plankType, stock_num: stockNum } = stock
            // 标准大板
            if (plankType === 'standard') {
              const [height, width] = stock.size.split('*')
              const size = `${width}*${height}`
              const mapKey = `${matCode}-${size}`
              if (!standardMap.get(mapKey)) standardMap.set(mapKey, stockNum)
            }
            // 余料数据
            else if (plankType === 'surplus') {
              const { size: size2 } = stock
              let [height, width] = size2.split('*')
              if (xyReverse) {
                ;[width, height] = [height, width]
              }
              let size = `${width}*${height}`
              // L形余料
              if (stock.shape === 'lshape') {
                const { x3, y5 } = stock
                // const longWidth = xyReverse ? y5 : x3
                // const lognHeight = xyReverse ? x3 : y5
                const longWidth = x3
                const lognHeight = y5
                size = `${width} (${longWidth}) * ${height} (${lognHeight})`
              }
              const mapKey = `${matCode}-${size}`
              if (!surpluMap.get(mapKey)) surpluMap.set(mapKey, stockNum)
            }
            // 特殊大板
            else if (plankType === 'special') {
              const [height, width] = stock.size.split('*')
              const size = `${width}*${height}`
              const mapKey = `${matCode}-${size}`
              if (!specialMap.get(mapKey)) specialMap.set(mapKey, stockNum)
            }
          })
        })
        standardMap.forEach((value, key) => {
          const [matCode, size] = key?.split('-')
          result.push(`${matCode} ${size} ${value}块`)
        })
        specialMap.forEach((value, key) => {
          const [matCode, size] = key?.split('-')
          result.push(`${matCode} ${size} ${value}块`)
        })
        surpluMap.forEach((value, key) => {
          const [matCode, size] = key?.split('-')
          result.push(`${matCode} ${size} ${value}块 (余料)`)
        })
      } catch (error) {
        console.log('数据出错啦，请重试', error)
      }
      return result
    },
    // 将drawData处理成目标数据结构
    dealDrawDataToTargetData(data) {
      const map = new Map()
      const useMaterialData = {
        data: {
          kind_count: 0,
          detailed_info: [],
        },
      }

      data?.forEach((data) => {
        const { matCode, texture, thick, type } = data
        const dataPlanks = data.data
        const { otherPlate } = dataPlanks[0] || {}
        const standardMap = new Map()
        const specialMap = new Map()
        const plankKind = `${matCode}:${texture}:${thick}`
        let specialStockItem = {}

        // 特殊大板
        if (otherPlate) {
          dataPlanks.forEach((plank) => {
            const { plankWidth, plankHeight } = plank
            const specialSize = `${plankWidth}*${plankHeight}`
            if (!specialMap.get(specialSize)) {
              specialMap.set(specialSize, [])
            }
            const specials = specialMap.get(specialSize)
            specialStockItem = {
              plank_type: 'special',
              size: `${plankHeight}*${plankWidth}`,
            }
            specials.push(specialStockItem)
          })
          specialMap.forEach((value) => {
            let specialsArr = []

            specialStockItem = {
              ...value[0],
              stock_num: value.length,
            }
            specialsArr.push(specialStockItem)
            const newPlankKind = plankKind + `:${value[0].size}`
            map.set(newPlankKind, specialsArr)
          })
        } else {
          if (!map.get(plankKind)) map.set(plankKind, [])
          const arr = map.get(plankKind)
          const surplusMap = new Map()
          // 余料
          dataPlanks.forEach((plank) => {
            const { surplusInfo } = plank
            if (surplusInfo) {
              const { width, height, shape, x3, y3, x4, y4, x5, y5 } =
                surplusInfo
              const size = `${width} (${x3}) * ${height} (${y5})`
              if (!surplusMap.get(size)) surplusMap.set(size, [])
              const surplus = surplusMap.get(size)
              const specialStockItem = {
                plank_type: 'surplus',
                shape,
                size: `${height}*${width}`,
                x3,
                y3,
                x4,
                y4,
                x5,
                y5,
              }
              surplus.push(specialStockItem)
            } else {
              // 解决，余料板添加大板时，添加的是标准大板，但是这个标准大板出现在了预料板的分类里面。需要单独统计
              const { plankWidth, plankHeight } = plank
              const standardSize = `${plankWidth}*${plankHeight}`
              if (!standardMap.get(standardSize)) {
                standardMap.set(standardSize, [])
              }
              const standards = standardMap.get(standardSize)
              // 标准大板
              specialStockItem = {
                plank_type: 'standard',
                size: `${plankHeight}*${plankWidth}`,
              }
              standards.push(specialStockItem)
            }
          })
          surplusMap.forEach((value) => {
            specialStockItem = {
              ...value[0],
              stock_num: value.length,
            }
            arr.push(specialStockItem)
            map.set(plankKind, arr)
          })
          let standarsArr = []
          standardMap.forEach((value) => {
            specialStockItem = {
              ...value[0],
              stock_num: value.length,
            }
            standarsArr.push(specialStockItem)
            map.set(`${plankKind}-standard`, standarsArr)
          })
        }
      })
      map.forEach((value, key) => {
        if (key.includes('-standard')) {
          key = key.replace('-standard', '')
        }
        useMaterialData.data.detailed_info.push({
          plank_kind: key,
          special_stock: value,
          stock_count: value.length,
        })
      })
      const kindCount = useMaterialData.data.detailed_info.length
      useMaterialData.data.kind_count = kindCount
      this.useMaterialData = useMaterialData
      return useMaterialData
    },
    // 将tooltip挂载到当前组件
    getContainer(node) {
      return node
    },
    // 统计板件订单id和房间id
    getOrderIdAndRoomId() {
      const orderIdset = new Set()
      const roomIdset = new Set()
      for (let i = 0; i < this.drawData.length; i++) {
        this.drawData[i].data.forEach((data) => {
          data.parts.forEach((part) => {
            // 排除待排版库和补件
            if (part._isAwaitStorePlank || part._isBujian) return
            if (part.orderId) {
              orderIdset.add(part.orderId)
            }
            if (part.roomID) {
              roomIdset.add(part.roomID)
            }
          })
        })
      }
      return {
        orderIds: Array.from(orderIdset),
        roomIds: Array.from(roomIdset),
      }
    },
    // 处理成千里眼适用数据
    dealDataToQianliyan(data) {
      const plankTypeMap = new Map([
        ['standard', 1],
        ['special', 2],
        ['surplus', 3],
      ])
      const result = []
      data?.data.detailed_info.forEach((item) => {
        const { plank_kind, special_stock } = item
        const [substrate, color, thick] = plank_kind?.split(':')
        special_stock.forEach((stock) => {
          const { plank_type, stock_num, size, shape } = stock
          let [height, width] = size.split('*')
          if (plank_type === 'surplus') {
            if (this.ncSetting.xyReverse) {
              ;[width, height] = [height, width]
            }
            if (shape === 'lshape') {
              const { x3, y5 } = stock
              // L形余料
              const longWidth = x3
              const lognHeight = y5
              width = `${width} (${longWidth})`
              height = `${height} (${lognHeight})`
            }
          }
          result.push({
            substrate,
            thick,
            color,
            spec: `${width}*${height}`,
            num: stock_num,
            board_type: plankTypeMap.get(plank_type),
          })
        })
      })
      return result
    },
    handleCancelDownloadNC() {
      // 关闭弹窗
      this.isShowConfirmColorTag = false
      this.isNCBtnLoading = false
      // 去掉参数影响
      this.confirmSendToFactory = false
    },
    handleConfirmContinue() {
      // 选择是，继续下载NC，关闭弹窗
      this.isShowConfirmColorTag = false
      this.continueDownloadFlag = true
      // 调用NC下载的方法
      if (this.isSubtle) {
        this.subtleDownloadNC(this.subtleBigPart)
      } else {
        this.handleDownloadNC(this.currentOperate == 'nc' ? false : true)
      }
    },
    judgeLimit(arr) {
      const labelCheck = {}
      const colorRes = {}
      // 精细排版时还是判断全局数据 需要剔除余料板的数据
      for (let i = 0; i < arr.length; ++i) {
        for (let k = 0; k < arr[i].parts.length; ++k) {
          const part = arr[i].parts[k]
          // 彩色标签数据源数量限制判断
          // 如果当前板件是余料板，不需要进行检测，直接进入下一循环
          if (part?.surplusPath) continue
          for (let v of labelSources) {
            // 判断目标对象里面是否已经存在数据源，不存在时给默认值[]
            if (!labelCheck[v]) {
              labelCheck[v] = []
            }
            // 收集之前颜色数据，待排版库的板子颜色数据生成来源之一
            if (!colorRes[v]) {
              colorRes[v] = {}
            }
            if (part.colorRes && part.colorRes[v] && !colorRes[v][part[v]]) {
              colorRes[v][part[v]] = part.colorRes[v]
            }
            if (!labelCheck[v].includes(part[v]) && part[v] !== undefined) {
              // 目标对象属性里面是否已经存在小板上的数据源信息，不存在时push进去
              labelCheck[v].push(part[v])
            }
          }
        }
      }
      return { labelCheck, colorRes }
    },
    // 添加颜色的方法
    formPlankColor(arr, colorRes, newColorRes) {
      for (let i = 0; i < arr.length; ++i) {
        for (let k = 0; k < arr[i].parts.length; ++k) {
          const part = arr[i].parts[k]
          // 余料板不走下面的逻辑
          if (part.surplusPath) continue
          // 重新给每块板子添加上新的颜色数据
          if (
            !part.colorRes ||
            (part._isAwaitStorePlank && !part._isGenColor)
          ) {
            part.colorRes = {}
            if (part._isAwaitStorePlank) {
              part._isGenColor = true
            }
            // 添加对应数据
            for (let item of labelSources) {
              if (
                newColorRes[item] &&
                newColorRes[item][(part[item] ?? '')?.toString()]
              ) {
                part.colorRes[item] =
                  newColorRes[item][(part[item] ?? '')?.toString()]
              } else if (colorRes[item]) {
                part.colorRes[item] =
                  colorRes[item][(part[item] ?? '')?.toString()]
              } else {
                part.colorRes[item] = 'rgb(255, 255, 255)'
              }
            }
          }
        }
      }
    },
    // 需要重新生成颜色
    // 判断小板的colorRes数据是否为null，如果为null就需要重新生成，待排版库已入库的小板都需要重新生成
    generateColor(labelCheck, newColorRes, bigpart = null) {
      let checkTag = false
      const limitOvers = []
      for (let key in labelCheck) {
        if (labelCheck[key].length > 12) {
          // 弹出提示弹窗
          checkTag = true
          limitOvers.push(key)
        }
      }
      if (checkTag) {
        this.$store.commit('setLimitOvers', limitOvers)
        return
      } else {
        this.$store.commit('setLimitOvers', [])
      }
      // 此时颜色不超过12个
      // 给板子添加colorRes
      const colorRes = genColorRes(labelCheck)
      // 给保存历史添加历史数据
      this.formPlankColor(this.paibanData, colorRes, newColorRes)
      // 当前绘制数据添加颜色
      this.formPlankColor(this.drawDataArr, colorRes, newColorRes)
      if (bigpart) {
        this.formPlankColor([bigpart], colorRes, newColorRes)
      }
    },
    // 关闭余料锁定提示弹窗
    handleCloseSurLock() {
      this.isShowSurplusLock = false
    },
    // 关闭余料锁定提示弹窗
    handleCloseSurLockNewSub() {
      this.isShowSurplusLockNewSub = false
    },
    // 解锁处理
    async handleUnlock(allSurplusList) {
      const lockParams = {
        surplus: [],
        release_all: false,
      }
      allSurplusList.forEach((item) => {
        // 使用的余料数量
        const useSurNum = this.useSurplusId.filter((id) => id == item.id).length
        // 开料清单所选余料未使用
        if (!this.useSurplusId.includes(item.id)) {
          lockParams.surplus.push({
            ...item,
            lock_status: 0, // 0代表未锁定，也就相当于解锁
            lock_num: item.amount,
          })
          // 开料清单所选余料虽使用了但没有使用完
        } else if (
          this.useSurplusId.includes(item.id) &&
          item.amount != useSurNum
        ) {
          lockParams.surplus.push({
            ...item,
            lock_status: 0,
            lock_num: item.amount - useSurNum,
          })
        }
      })
      if (lockParams.surplus.length) {
        // 解锁本次排版未使用余料
        await surplusLock(lockParams)
      }
    },
    setAlignedPlanDialog(val) {
      this.alignedPlanDialog = val
    },
    /** 自动调整不正确的切割顺序 */
    async handleAutoAdjust() {
      // 调用排版页重新计算下刀点和切割顺序的方法
      if (!this.hasLblAuth || this.handleIslocked)
        return this.$message.error(
          this.translateLang('common.autoAdjustWarning')
        )
      await this.calcCutPositionOrder()
      this.$nextTick(() => {
        // 关闭弹窗
        this.isShowInspectCutOrder = false
        // 重新调用下载NC的方法继续下载NC操作
        this.isContinue = true
        if (this.currentOperate == 'nc') {
          this.handleDownloadNC(false)
        } else if (this.currentOperate == 'factory') {
          this.handleDownloadNC(true)
        }
      })
    },
    /** 查看详情 */
    handleShowConflictDetail(type) {
      this.isShowInspectCutOrder = false
      // 清除加载的各种状态
      this.isSendToFactoryLoading = false
      this.isNCBtnLoading = false
      // 去掉参数影响
      this.confirmSendToFactory = false
      if (type.cancelType == 'button') {
        // 打开冲突的板件详情弹窗
        this.isShowConflictDetail = true
        // 打开详情默认展示第一个数据
        this.setActivePlank(this.currentCutOrderIndex - 1, this.errorCutOrders)
      }
    },
    // 查看上一个/下一个
    handleOperate(operate) {
      if (operate === 'last') {
        this.currentCutOrderIndex--
        if (this.currentCutOrderIndex <= 0) {
          this.currentCutOrderIndex = this.errorCutOrders.length
        }
      } else {
        this.currentCutOrderIndex++
        if (this.currentCutOrderIndex >= this.errorCutOrders.length + 1) {
          this.currentCutOrderIndex = 1
        }
      }
      // 需要兼容余料板的名字
      this.currentCutOrderName =
        this.errorCutOrders[this.currentCutOrderIndex - 1]?.partName ??
        this.errorCutOrders[this.currentCutOrderIndex - 1]?.name
      // 设置激活板件
      this.setActivePlank(this.currentCutOrderIndex - 1, this.errorCutOrders)
    },
    // 返回上一个页面
    handleGoBack() {
      // 关闭详情弹窗
      this.isShowConflictDetail = false
      this.isShowInspectCutOrder = true
    },
    // 打开切割顺序弹窗的一系列操作
    handleSeriesManipulate() {
      if (!this.isSubtle) {
        this.isShowInspectCutOrder = true
        // 默认展示第一个数据
        this.currentCutOrderName =
          this.errorCutOrders[0]?.partName ?? this.errorCutOrders[0]?.name
        // 恢复初始展示index
        this.currentCutOrderIndex = 1
        this.cutOrderOkDisable = this.errorBigPlankLockedCutOrders.length != 0
      } else {
        this.isShowSubtleInspectCutOrder = true
        this.currentSubtleCutOrderName =
          this.errorCutOrders[0]?.partName ?? this.errorCutOrders[0]?.name
        // 恢复初始展示index
        this.currentSubtleCutOrderIndex = 1
      }
    },
    //关闭夹手冲突的弹窗
    handleCloseClamHandConfictModal() {
      this.isShowHoleSlotOnClampHandModal = false
    },
    //关闭夹手冲突的弹窗(下载)
    handleCloseClamHandConfictModalForDownloadNC(payload) {
      const { cancelType } = payload
      this.isShowHoleSlotOnClampHandModalForDownloadNC = false
      this.notIgnore = true
      // 通过点击按钮关闭
      if (cancelType === 'button') {
        this.notIgnore = false
        if (this.isSubtle) {
          this.subtleDownloadNC(this.subtleBigPart)
        } else {
          this.handleDownloadNC(this.currentOperate == 'nc' ? false : true)
        }
      }
    },

    // 夹手冲突查看详情
    handleViewDetail() {
      this.showConflictPartDetail = true
      this.$nextTick(() => {
        this.isShowHoleSlotOnClampHandModal = false
        this.isShowHoleSlotOnClampHandModalForDownloadNC = false
      })
    },
    // 切换夹手板件冲突的板件
    handleSearchClampHandPart(payload) {
      const { part, type } = payload
      this.searchPlank(part.partUniqueId, 0, type)
    },
    // 夹手位置检测
    handleCheckClampHandPosition(
      type,
      onlyCheck = false,
      targetData = this.drawData
    ) {
      const {
        aio_fixture_setting,
        xyReverse,
        startPosition,
        enable_integration_device: enableIntegrationDevice,
        knife,
      } = this.ncSetting
      const {
        aio_avoid_fixture,
        aio_first_fixture_height,
        aio_fixture_direction,
        aio_fixture_length,
        aio_fixture_width,
        aio_second_fixture_height,
      } = aio_fixture_setting
      const data = {
        clampHandHeight: aio_fixture_length,
        clampHandWidth: aio_fixture_width,
        clampHandMargin1: aio_first_fixture_height,
        clampHandMargin2: aio_second_fixture_height,
        clampHandDirection: aio_fixture_direction,
      }
      const setting = {
        isXyReverse: xyReverse,
        startPosition,
      }
      const options = {
        onlyCheck,
        diameter: Number(knife?.diameter || 0),
      }
      const payload = {
        data,
        setting,
        options,
        drawData: targetData,
      }
      // 开启了夹具避让且开启了使用一体机
      if (aio_avoid_fixture && enableIntegrationDevice) {
        const conflictParts = dealClampHandHasPart(payload)
        if (conflictParts.length) {
          if (type === 'downloadNC') {
            this.isShowHoleSlotOnClampHandModalForDownloadNC = true
          } else {
            this.isShowHoleSlotOnClampHandModal = true
          }
          this.conflictParts = conflictParts
          return false
        }
      }
      return true
    },
    // 处理单块板添加补件
    handleAddBujian() {
      const flag = getOriPartByLayout(this.activePlank.oriPartUniqueId)
      if (!flag) {
        return message.error(translate('arrangedPage.batchBujianErrTip'))
      } else if (
        this.activePlank.specialType &&
        this.activePlank.specialType === 'supplus'
      ) {
        return message.error(translate('arrangedPage.selectErrTip'))
      }
      this.batchBujianList = getSameGroupParts(
        this.activePlank,
        this.activeBigpart.parts
      )

      this.handleConfirmBatchBujian()
      // 拖到补件库后，检查是否影响复用关系
      this.clearReuseIfNeeded(this.activeBigpart)
    },
    // 修改大板的切割顺序
    handleChangePriority(type) {
      const currentPart = this.activePlank
      const currentPlank = this.activeBigpart
      const currentPriority = currentPart.priority

      let findPart = null
      let targetPart = null
      const findPlank = this.findPlankByStockKey(currentPlank.stockKey)
      if (!findPlank) return
      switch (type) {
        case 'first':
          findPlank?.parts?.forEach((part) => {
            if (part.partUniqueId === currentPart.partUniqueId) {
              part.priority = 1
            } else {
              if (currentPriority > part.priority) {
                part.priority += 1
              }
            }
          })
          break
        case 'last':
          findPlank?.parts?.forEach((part) => {
            if (part.partUniqueId === currentPart.partUniqueId) {
              part.priority = findPlank.parts.length
            } else {
              if (currentPriority < part.priority) {
                part.priority -= 1
              }
            }
          })
          break
        case 'prev':
          findPart = findPlank?.parts.find(
            (part) => part.partUniqueId === currentPart.partUniqueId
          )
          targetPart = findPlank?.parts.find(
            (part) => part.priority + 1 === currentPriority
          )
          if (findPart?.priority === 1) return
          if (targetPart) {
            findPart.priority = targetPart.priority
            targetPart.priority = currentPriority
          }
          break
        case 'next':
          findPart = findPlank?.parts.find(
            (part) => part.partUniqueId === currentPart.partUniqueId
          )
          targetPart = findPlank?.parts.find(
            (part) => part.priority - 1 === currentPriority
          )
          if (findPart?.priority === findPlank.length) return

          if (targetPart) {
            findPart.priority = targetPart.priority
            targetPart.priority = currentPriority
          }
          break
      }
      this.setDrawData([...this.drawData])

      // 重新计算下刀点
      this.calcCutPositionOrder(true, [currentPlank])
    },

    // 提取查找findPlank的公共方法
    findPlankByStockKey(stockKey) {
      return this.drawData
        .find((drawItem) =>
          drawItem.data?.find((plank) => plank.stockKey === stockKey)
        )
        ?.data?.find((plank) => plank.stockKey === stockKey)
    },

    // 更新drawData
    setDrawData(data) {
      this.drawData = data
    },

    // 点击鼠标右键
    handleClickRight({ clickType, position, canvasKey }) {
      // 当点击小板是第一个时，需要隐藏的选项
      const needHideItemHead = ['first', 'prev']
      // 当点击小板是最后一个时，需要隐藏的选项
      const needHideItemTail = ['last', 'next']
      this.$refs['mMenuRef'].closeMenu()
      if (!clickType) return
      this.pointPosition = position
      this.canvasKey = canvasKey
      // 选中了小板
      if (clickType === 'part') {
        // 当一个大板上的小板只有一块时， 就移除修改切割顺序的选项
        if (this.activeBigpart.parts.length === 1) {
          const item = partMenuList.find(
            (item) => item.type === 'changePriority'
          )
          if (item) {
            item['isShow'] = false
          }
        } else {
          partMenuList.forEach((item) => {
            item.isShow = true
          })
          // 检测当前选中的小板的顺序，再决定修改切割顺序中的选项
          if (this.activeBigpart.parts.length === this.activePlank.priority) {
            partMenuList
              .find((item) => item.type === 'changePriority')
              ?.children.forEach((item) => {
                if (needHideItemTail.includes(item.type)) {
                  item.isShow = false
                } else {
                  item.isShow = true
                }
              })
          } else if (this.activePlank.priority === 1) {
            partMenuList
              .find((item) => item.type === 'changePriority')
              ?.children.forEach((item) => {
                if (needHideItemHead.includes(item.type)) {
                  item.isShow = false
                } else {
                  item.isShow = true
                }
              })
          } else {
            partMenuList
              .find((item) => item.type === 'changePriority')
              ?.children.forEach((item) => {
                item.isShow = true
              })
          }
        }
        this.menuList = [...partMenuList]
      } else if (clickType === 'plank') {
        // 选中了大板
        this.menuList = [...bigPlankMenuList]
      } else if (clickType === 'other') {
        this.menuList = [...otherMenuList]
      }
      this.$refs['mMenuRef'].openMenu()
    },
    // 点击鼠标左键
    handleClickLeft() {
      this.$refs['mMenuRef'].closeMenu()
    },
    handleSelectMenuItem(menuItem) {
      const { type, label, key } = menuItem
      const group = key.split('-')[1]
      const canvasIndex = this.canvasKey
      // 大板序号
      const bigpartIndex = this.activeBigpart?.canvasIndex || 0
      // 小板序号
      const partOrder = this.activePlank?.priority || 0
      switch (type) {
        case 'useSurplus':
          this.$refs[`drawpart${canvasIndex}`][0].useSurplus()
          break
        case 'subTle':
          this.$refs[`drawpart${canvasIndex}`][0].gotoSubtleByBtn()
          break
        case 'addPlank':
          this.$refs[`drawpart${canvasIndex}`][0].addNewBigpart()
          break
        case 'deletePlank':
          this.$refs[`drawpart${canvasIndex}`][0].deleteBigpart()
          break
        case 'rotate-90':
          this.rotatePlank(90)
          break
        case 'rotate-180':
          this.rotatePlank(180)
          break
        case 'rotate-270':
          this.rotatePlank(270)
          break
        case 'flip':
          this.reversePlank()
          break
        case 'addBujian':
          this.handleAddBujian()
          break
        case 'deletePart':
          this.deletePlank()
          break
        case 'changePriority':
        case 'first':
        case 'last':
        case 'prev':
        case 'next':
          this.handleChangePriority(type)
          break
        case 'runningBoard':
        case 'lowUtilizationRate':
        case 'unreasonableLayout':
          // TODO: 手动保存历史记录
          // TODO: 调用接口将反馈上传到柜柜后台
          this.isFeedback = true
          // 反馈整个排版
          if (group === 'other') {
            this.feedbackContent = {
              key: label,
              content: '整个排版',
            }
          } else if (group === 'part') {
            this.feedbackContent = {
              key: label,
              content: `第${bigpartIndex}张大板上的第${partOrder}块小板`,
            }
          } else if (group === 'bigPlank') {
            this.feedbackContent = {
              key: label,
              content: `第${bigpartIndex}张大板`,
            }
          }
          // 反馈排版
          this.dealHistoryName(label)
          this.savePaiban(true, false, '', true)
          buryPoint({
            function_module: 'layout',
            function_point: 'paibanFeedback',
          })
          break
      }
    },
    /** 进入/退出精细排板对路径上的处理（增加一个标记,在路径上记录是否是精细排板页面） */
    dealJinxiEnterPath(isEnter = true) {
      const query = { ...this.$route.query, is_jinxi_paiban: 1 }
      if (!isEnter) Reflect.deleteProperty(query, 'is_jinxi_paiban')
      this.$router.replace({ path: this.$route.path, query })
    },
    // 控制drawPart画布的关闭收起
    controlCollapsed() {
      this.drawData.forEach((item, index) => {
        const ref = this.$refs[`drawpart${index}`]
        if (ref && ref[0]) {
          try {
            this.isDrawPartCollapsed = this.isDataDefaultCollapsed
            ref[0].collapseCanvas(this.isDrawPartCollapsed)
          } catch (error) {
            console.error(`Error collapsing:`, error)
          }
        }
      })
    },

    updatePreference({ data, isErr }) {
      if (isErr) return
      data = data || store.state.preferencesSetting.setting

      this.print_color_tag = data.printColorTag
      // 获取偏好设置
      this.setActivePaibanWay([data.paibanWay])
      this.setSurplusNoRoll(data.surplus_no_roll)
      this.isLessReverse = data.isLessReverse
      this.isSpecialShape = data.isSpecialShape
      this.isShowPartSize = data.isShowPartSize
      this.isUnuseSurplus = data.isUnuseSurplus
      this.isSendToEzSort = data.isSendToEzSort ?? false
      this.selectedPaibanWay = this.activePaibanWay[0]
        ? this.activePaibanWay[0].replace('_roll', '')
        : 'paiban_v2'
      this.isAutoPassData = data.isAutoPassData
      this.isCuttingOrder = data.isCuttingOrder ?? true
      this.isFollowExportTag = data.isFollowExportTag
      this.nestWay =
        data.nesting_version === 2 && this.hasAdvancedNestPermission
          ? 'SENIOR'
          : 'PRIMARY'
      this.print_color_tag = data.printColorTag
      this.isUsePlankAdsorption = Boolean(data.isUsePlankAdsorption)
      this.currentTagType = data.currentTagType
      this.currentPaibanImgType = data.currentPaibanImgType ?? ['picture']
      this.isFollowExportPaibanImg = data.isFollowExportPaibanImg ?? true
      this.isFollowExportWorkerShop = data.isFollowExportWorkerShop ?? false
      this.suitText = this.paibanWayList.find(
        (e) => e.interface === this.selectedPaibanWay
      ).desc
      this.$store.commit('setIsFollowExportTag', data.isFollowExportTag)
      this.isDataDefaultCollapsed = data.isDataDefaultCollapsed ?? false
      this.isDrawPartCollapsed = this.isDataDefaultCollapsed
      this.isMarkModifiedSmallBoards = data.isMarkModifiedSmallBoards
      this.isChangeTagTemp = data.isChangeTagTemp ?? false
      this.isShowMoveStep = data.isShowMoveStep ?? false
      const savedMoveStep = Number(data.moveStep) || 20
      this.lastValidMoveStep = savedMoveStep > 0 ? savedMoveStep : 20
      this.moveStep = this.lastValidMoveStep
    },
    /**
     * @description 添加事件监听
     */
    addBusEvent() {
      EventBus.$on(EventBusKey.KNIVES_ERR, this.handleDealNotFoundKnivesData)
      EventBus.$on(
        EventBusKey.OTHER_KNIVES_ERR,
        this.handleDealOtherNotFoundKnivesData
      )
    },
    /**
     * @description 取消事件监听
     */
    removeBusEvent() {
      EventBus.$off(EventBusKey.KNIVES_ERR, this.handleDealNotFoundKnivesData)
      EventBus.$off(
        EventBusKey.OTHER_KNIVES_ERR,
        this.handleDealOtherNotFoundKnivesData
      )
    },
    /** 检查传入的大板组内部的板件是否存在冲突 */
    isNotPlankConflict(bigPlanks) {
      // 小板重叠检测
      const elLoading = Loading.service({
        text: this.$translateLang('正在检测板件状态'),
      })
      for (let i = 0; i < bigPlanks.length; ++i) {
        const bigPlank = bigPlanks[i]
        for (let k = 0; k < bigPlank.parts.length; ++k) {
          const plank = bigPlank.parts[k]
          let isConflict = plank.plankMerge
          // 如果板件没有冲突则再检测一次(因为一些特殊操作可能之前的代码不能正常检测到冲突)
          if (!isConflict) {
            isConflict = !checkOnePlank(plank, bigPlank)
          }
          if (isConflict) {
            this.plankKeyWord = ''
            this.searchPlankList = []
            this.searchPlankList.push(plank)
            this.genLocationOfErrorPlank(i, k)
            this.$message({
              type: 'error',
              message: translate('arrangedPage.plankOverEdge'),
            })
            elLoading.close()
            return true
          }
        }
      }
      // 关闭小板检测提示弹窗
      elLoading.close()
    },

    handleConfirmContinuePaiban(type = this.currentSpecailType) {
      this.isShowSpecialAndFiveSix = false
      if (this.currentLineId) {
        if (type === 'prePaiban') {
          this.$nextTick(() => {
            this.reLayout(this.currentLineId)
          })
        } else if (type === 'special') {
          this.$nextTick(() => {
            this.handleChangePaibanWay('specialShape')
          })
        } else {
          console.error('出现未知的方法')
        }
      } else {
        console.error('currentLineId is not exist')
      }
    },
    handleCancelContinuePaiban(type, specialType = this.currentSpecailType) {
      this.isShowSpecialAndFiveSix = false
      if (specialType === 'prePaiban') {
        this.showLoading = false
        this.isRefresh = false
        this.resetNCSetting()
      } else if (specialType === 'special') {
        this.isSpecialShape = false
      } else {
        console.error('出现未知的方法')
      }
      return
    },
    /**
     * @description 当板件或板件数据发生变化时调用
     * @param {('add' | 'delete' | 'move' | 'update')} action 操作类型
     * @param {Object} payload 操作相关数据
     * @param {('plank' | 'bigPlank')} payload.partType 板件类型
     * @param {Object} [payload.data] 附加数据（可选）
     */
    async onPartChange(action, payload) {
      // 将之前 watch 监听 drawData而触发的部分事件迁移此处，目前 action 并无用处
      if (payload?.data?._isBujian && ['add', 'delete'].includes(action)) {
        this.$nextTick(() => {
          const currentPaibanData = this.drawData.flatMap(
            (item) => item.data ?? []
          )
          this.$store.commit(
            'bujianStore/syncParticipationBujianPlankIds',
            getBujianParticipationIdsFromPaibanData(currentPaibanData)
          )
        })
      }
      const lockedPlank = []
      this.drawData.forEach((planks) => {
        planks.data.forEach((item) => {
          if (item.isLocked) {
            lockedPlank.push(item)
          }
        })
      })
      this.isBanRelayout = lockedPlank.length === this.paibanData.length // 是否全部大板都是被锁定状态
      if (this.paibanData.every((item) => item.isLocked)) {
        this.isBanRelayout = true
      }
      this.handleCollectDepthErrorData(this.drawData) // 检查板件深度异常
      let surplusCount = 0 // 统计余料数量
      this.recordDrawPlankDataLength = 0
      for (let item of this.drawData) {
        item.data.forEach((bigPlank) => {
          this.recordDrawPlankDataLength +=
            bigPlank.parts.filter(isNormalPlankPart).length
        })
        surplusCount =
          surplusCount +
          item?.data?.filter((it) => {
            return it.surplusInfo && !it.surplusInfo.isNotSurplus
          }).length
      }
      this.surplusCount = surplusCount
      // 一改变数据就会重新收集切割顺序错误的数据
      this.setIsCanPrintTag(!this.judgeCutOrder())
      if (!this.judgeCutOrder()) this.isShowConflictDetail = false
    },

    /** 设置plankArr 数据，同时冻结数组，防止响应式，此数据并不会用在页面上 */
    setPlankArr(val) {
      this.plankArr = Object.freeze(val)
    },
    /** 检查大板是否旋转，此处代码待异形余料上线后需根据新需求排版 异形余料上了后删除此逻辑*/
    checkBigPlankIsRotate(arr) {
      const bigPlankRotateRes = checkBigPlankIsRotate(arr)
      if (bigPlankRotateRes.isRotate) {
        this.$message.error(
          `${this.$translateLang(
            '部分大板已旋转，暂不支持重新排版，已旋转大板序号：'
          )}${bigPlankRotateRes.rotateArr.map((v) => v.canvasIndex).join()}`
        )
        return true
      }
    },
    /** @description 按照单一类型中大板数量进行降序排序 */
    handleSortByPlankNum(isSortByPlankCountDesc) {
      const diff = (data) => {
        return data.map((item) => ({
          key: item.title,
          planks: item.data.map((v) => v.canvasIndex),
        }))
      }
      const beforeSort = JSON.stringify(diff(this.drawData))
      if (isSortByPlankCountDesc) {
        this.setDrawData(changeFinalDataByPlankNum(this.drawData))
        this.processInitDrawData(this.drawData)
      } else {
        // false 的情况下重新进行整个排序，恢复成刚进入排版页的样子
        this.paibanData.forEach((v) => {
          Reflect.deleteProperty(v, '_sortNum')
        })
        this.setBeforeTitleSorts([])
        this.dealAllDrawData()
      }
      const currentSort = JSON.stringify(diff(this.drawData))
      this.setBeforeTitleSorts(genBeforeTitleSorts(this.drawData))
      this.renderAll()
      updateLocalPreference({})
      if (beforeSort !== currentSort) {
        this.addDataToOperateArr({
          key: `板件分类/大板顺序改变`,
          dataArr: [
            {
              type: 'form',
              current: { order: currentSort },
              ori: { order: beforeSort },
              compareMsg: [{ title: '', keys: ['order'] }],
              formTextObj: { order: '按照大板数量调整顺序' },
              formValueObj: {},
            },
          ],
        })
      }
    },
    handleAutoScrollRightOperationZone({
      draggableTarget,
      isInCompositionZone,
    }) {
      const leftOperationZoneRect =
        this.$refs.leftOperationZoneRef?.getBoundingClientRect()
      const draggableTargetRect = draggableTarget?.getBoundingClientRect()
      if (!leftOperationZoneRect || !draggableTargetRect) {
        this.activeTempStorage = false
        return
      }
      const isApproachedFringe =
        draggableTargetRect.right > leftOperationZoneRect.right
      this.activeTempStorage = isInCompositionZone
      if (!isApproachedFringe) return
      this.$refs['storeRef']?.autoScrollToWaitedCompositionZone()
    },
    async getBatch() {
      const res = await getPaibanBatch()
      this.$store.commit('setTypesettingBatch', res.data.layout_batch)
    },
    dealHighlightMatCode(matcode) {
      return dealHighlightMatCode(matcode)
    },
    async fetchRawMaterialPlankInfo(payLoad) {
      const currentReqId = ++this.rawMaterialReqId
      try {
        const { uid, production_from } = payLoad
        const res = await loadFullPlankManageData({
          uid,
          ...(production_from ? { production_from } : {}),
        })
        if (
          this.isComponentDestroyed ||
          currentReqId !== this.rawMaterialReqId
        ) {
          return
        }
        if (res.status == 1) {
          const data = res.data
          this.baseMaterialData = {
            ...data,
            brandPlankLoad: res.brandPlankLoad,
          }
          if (Array.isArray(data.defaultPlankInfo)) {
            this.defaultPlankList = data.defaultPlankInfo
          } else {
            this.defaultPlankList = [data.defaultPlankInfo]
          }
          if (
            !this.defaultPlankList.some(
              (item) =>
                item.plankWidth == this.standardPlank.plankWidth &&
                item.plankHeight == this.standardPlank.plankHeight &&
                item.plankEdgeOff == this.standardPlank.plankEdgeOff
            )
          ) {
            this.standardPlank = this.ncSetting.panelSize
          }
        }
      } catch (e) {
        // 原片管理信息失败不影响排版主流程，避免阻塞/白屏
      }
    },

    // 获取补件数据
    /**
     * @description 获取补件数据
     * @param {string} 订单号
     */
    async handleGetBujianStoreData(oid = '', force = false) {
      try {
        this.bujianKeyword = oid
        const params = {
          colorTextureThickStr: this.currentDrawPlankKeyStr,
          filterWord: oid,
        }
        // if (!params.colorTextureThickStr) return
        await this.$store.dispatch('bujianStore/fetchBujianListByQuery', {
          queryKey: buildBujianQueryKey({
            ...params,
            pageScope: 'paiban',
          }),
          pageScope: 'paiban',
          params,
          force,
        })
      } catch (error) {
        console.error(error)
      }
    },
    /** @description 下载 NC 时是否可以顺带导出图片 */
    isCanExportPic(originData) {
      originData = originData ?? this.currentTagType
      return originData?.includes('picture')
    },
    /** @description 下载 NC 时是否可以顺带导出PDF */
    isCanExportPdf(originData) {
      originData = originData ?? this.currentTagType
      return originData?.includes('pdf')
    },
    /** @description 更新 NC 生命对象，根据当前标签类型和是否发送到工厂进行选择 */
    updateNcLifeObj() {
      this.taskList = []
      this.ncLifeFuncObj = {}
      this.ncLifeFuncObj = initNcLifeObj(
        this,
        this.confirmSendToFactory
          ? this.tagSetting.tagDocType
          : this.currentTagType,
        (!window.webToQt && this.isFollowExportTag) || this.confirmSendToFactory
      )
      return this.ncLifeFuncObj
    },
  },

  async mounted() {
    this.$nextTick(() => {
      const count = this.$refs.moreAlignedPlanRef?.getDeepTabTipShowCount?.()
      if (count !== undefined) {
        this.hasDeepSearchPlan = count
      }
    })

    this.storeType =
      this.$store.state.preferencesSetting?.setting?.layoutStoreType ??
      'awaitStore'
    this.$store.commit('paibanTaskStore/setIsLoading', false)
    this.currentLine = this.proLineList.find(
      (item) => item.id === this.ncSetting.process_setting_id
    )
    this.layout_batch = sessionStorage.getItem('layout_batch') ?? ''
    this.preSaveNcSetting = deepCopy(this.ncSetting)
    if (this.isHistoryStatus) {
      this.setIsLockedRePaiban(false)
      if (this.paibanData.some((item) => isPaibanLock(item))) {
        this.setIsLockedRePaiban(true)
      }
    }
    this.$preference.init(this.updatePreference, this.$route.path)
    this.addBusEvent()
    // 本次排版使用的余料ID
    this.useSurplusId = this.paibanData
      .map((item) => !item.surplusInfo?.isNotSurplus && item.surplusInfo?.id)
      .filter((id) => id)
    const routeQuery = this.$route.query
    // 代表从开始清单-开始排版跳转过来 且 开启余料锁定
    if (
      (routeQuery?.from == 'material_paiban' ||
        routeQuery?.from == 'lbl' ||
        routeQuery?.isSpecialShape) &&
      this.$store.state.preferencesSetting.setting.surplus_lock
    ) {
      this.handleUnlock(this.selectSurplusList)
    }
    this.standardPlank =
      this.selectStandardPlank && Object.keys(this.selectStandardPlank).length
        ? this.selectStandardPlank
        : {
            ...this.paibanData.find(
              (item) => !item.otherPlate && !item.surplusInfo
            ),
            plankEdgeOff: this.historyPlankEdgeOff,
          }
    let payLoad = {
      uid: this.userInfo.id,
      data: {},
    }
    if (window.sessionStorage.getItem('thinkerx_material')) {
      payLoad.production_from = 'guimen'
    }
    // 不阻塞首屏初始化，避免页面白屏闪烁：后台拉取原片管理数据
    this.fetchRawMaterialPlankInfo(payLoad)
    this.surplusUseArr = []
    if (this.recodeIsTailor) {
      this.isUpdatingTask = true
    }
    // 判断当前排版是否存在冲突
    this.judgmentConflicts()

    // 收集冲突板件数组
    this.handleCollectConflicts()
    this.canvasMaxWidth =
      document.body.offsetWidth - 650 < 988
        ? 988
        : document.body.offsetWidth - 650
    this.canvasMaxHeight = document.body.offsetHeight - 80
    window.onresize = () => {
      this.canvasMaxWidth = document.body.offsetWidth - 650
      this.canvasMaxHeight = document.body.offsetHeight - 80
    }
    window.addEventListener('mouseup', this.clearAllTimer)
    let params = {}
    if (window.sessionStorage.getItem('thinkerx_material')) {
      params.production_from = 'guimen'
    }
    let hasCheckedClampHand = false
    // 好帮手跳转排版方案处理
    const querys = this.$route.query
    if (querys?.from && querys?.from === 'lblerp') {
      const item = JSON.parse(querys.item)
      this.$store.commit(
        'setRecodrProductionLineChoose',
        item.plank_info.process_setting_name
      )
      this.setFilterMaterialList(null)
      this.setBeforeSearchMaterialList(null)
      this.setBeforeSizeFilterList(null)
      const filterData = item.plank_info.filterObj
      // 如果是 oss 链接，则获取数据
      if (filterData) {
        if (filterData.startsWith('https://')) {
          const filterObj = await getJsonUrlData(filterData)
          this.setFilterObject(filterObj)
        } else {
          this.setFilterObject(filterData)
        }
      }
      // 清空收集的多排版方案
      this.$store.commit('paibanStore/setPaibanDataCollect', [])
      this.$store.commit('paibanStore/setResultPlansObj', null)
      this.$store.commit('paibanStore/setCurrentRawPlanData', null)
      this.$store.commit('paibanStore/clearAlreadyDealDrawData')
      // 非试生产
      this.setIsTrialProduct(false)
      await getGzipData(item.plank_info.historyUrl).then(async (res) => {
        let params = {
          setting_id: item.process_setting_id,
        }
        if (res.data.filterPlankList) {
          const plankList = dealPlankListLabelID(res.data.filterPlankList)
          this.setFilterMaterialList(plankList)
          this.setBeforeSearchMaterialList(plankList)
          this.setBeforeSizeFilterList(plankList)
        }

        const result = await fetchGetProductionNcSetting(params)
        if (result.status === 1) {
          this.setHasSendToTask(false)
          if (res.data.paibanInfo) {
            this.setHistoryPlankEdgeOff(res.data.paibanInfo.historyPlankEdgeOff)
            this.setHistorySecondTrimValue(
              res.data.paibanInfo.historySecondTrimValue
            )
            this.setFilterMaterialList(
              res.data.paibanInfo.filterPlankList ?? null
            )
            this.setBatchTaggingList(
              res.data.paibanInfo?.batchTaggingList ?? []
            )
          } else {
            this.setFilterMaterialList(null)
          }
          this.setPaibanKey(res.data.paibanKey)
          this.setPreLayoutData(dealPreLayoutDataLabelID(res.data.layoutData))
          this.goToBeforeMaterialDeal(res.data, item)
          this.setPaibanInfo(res.data.paibanInfo ?? {})
          if (res.data.paibanData.length > 0) {
            this.setPaibanData(res.data.paibanData)
            this.setFinalDrawData([])
          }
          let obj = Object.assign(initProductionNcSetting(result.data), {
            process_setting_id: item.process_setting_id,
            process_setting_name: item.plank_info.process_setting_name,
          })
          this.setNcSetting(obj)
          this.isHbsHistoryStatus = true
        }
      })
      this.setHistoryOrder(item)
      this.setRecodeSelectPart({ selects: [], isHistory: true })
      this.setRecodeSelectSurplus({ selects: [], isHistory: true })
      if (item.save_node === 3) {
        this.setHasPrintTag(true)
      } else {
        this.setHasPrintTag(false)
      }
    }
    if (this.isHistoryStatus || this.isHbsHistoryStatus) {
      this.currentTagTempID = undefined
      this.currentTagTempID = this.initTagTempID()
      this.hasSaveSurplus = Boolean(this.paibanInfo.hasSaveSurplus)
      this.exNextTip = this.$store.state.preferencesSetting.setting.exNextTip
    } else {
      params.platform = this.userInfo.platform
      getPreferencesSetting(params)
        .then((res) => {
          if (res.status === 1) {
            // 获取偏好设置
            this.exNextTip = res.data.exNextTip
            this.setActivePaibanWay([res.data.paibanWay])
            this.setSurplusNoRoll(res.data.surplus_no_roll)
            this.isLessReverse = res.data.isLessReverse
            this.isSpecialShape = res.data.isSpecialShape
            this.isShowPartSize = res.data.isShowPartSize
            // this.isUnuseSurplus = res.data.isUnuseSurplus
            this.selectedPaibanWay = this.activePaibanWay[0]
              ? this.activePaibanWay[0].replace('_roll', '')
              : 'paiban_v2'
            this.isAutoPassData = res.data.isAutoPassData
            this.isCuttingOrder = res.data.isCuttingOrder ?? true
            this.isFollowExportTag = res.data.isFollowExportTag
            this.nestWay =
              res.data.nesting_version === 2 && this.hasAdvancedNestPermission
                ? 'SENIOR'
                : 'PRIMARY'
            this.print_color_tag = res.data.printColorTag
            this.isUsePlankAdsorption = Boolean(res.data.isUsePlankAdsorption)
            this.storeType = res.data.layoutStoreType ?? this.storeType
            this.isFollowExportPaibanImg =
              res.data.isFollowExportPaibanImg ?? true
            this.isFollowExportWorkerShop =
              res.data.isFollowExportWorkerShop ?? false
            this.suitText = this.paibanWayList.find(
              (e) => e.interface === this.selectedPaibanWay
            ).desc
            this.$store.commit(
              'setIsFollowExportTag',
              res.data.isFollowExportTag
            )
          } else {
            this.$message.error(res.status)
          }
        })
        .catch((error) => {
          this.$message.error(error)
        })
    }

    if (this.$route.query.json) {
      this.dealJsonFromLbl(this.$route.query.json)
      return
    }
    if (Object.keys(this.ncSetting).length == 0) {
      return
    }
    if (window.sessionStorage.getItem('isHistory')) {
      this.changeHistoryStatus(true)
    }
    // 处理板件
    this.dealPaibanData()

    this.keyDownEvent = this.keyDownFuncs()
    this.keyUpEvent = this.keyUpFuncs()
    window.addEventListener('keydown', this.keyDownEvent)
    window.addEventListener('keyup', this.keyUpEvent)
    window.addEventListener('blur', this.onWindowBlurExitBatchSelect)
    window.addEventListener('contextmenu', this.preventCtrlContextMenu, true)
    this.setPaibanTime(new Date().getTime())
    // 生成排版Key
    this.genPaibanKey()
    // 如果开启了焊接板的切断后的余料可入库和打印标签就执行则不执行余料自动裁剪。
    const {
      sawCutOnlyWeld,
      firstCutSurplus,
      surplusStoreAndLabeling,
      mentaoji_enable,
      sawToLayout,
      processType,
    } = this.ncSetting.sawSetting

    if (sawCutOnlyWeld && sawToLayout && processType === 'weldingPlank') {
      if (
        firstCutSurplus &&
        surplusStoreAndLabeling &&
        this.selectedPaibanWay == 'paiban' &&
        mentaoji_enable &&
        processType === 'weldingPlank'
      ) {
        await cutBlueSurplus(this.drawData, true)
      }
      if (this.recodeIsTailor) {
        // 余料裁剪
        await this.startTailorSurplus()
        this.setRecodeIsTailor(false)
        this.handleResetPlankArea(true)
        this.drawData.map((item, index) => {
          this.$refs[`drawpart${index}`][0].startDraw()
        })
      }
      this.isUpdatingTask = false
    } else {
      // 如果没开启sawCutOnlyWeld，则优先执行余料自动裁剪功能，反之执行蓝色余料cutBlueSurplus
      if (this.recodeIsTailor) {
        // 余料裁剪
        await this.startTailorSurplus()
        this.setRecodeIsTailor(false)
        this.handleResetPlankArea(true)
        this.drawData.map((item, index) => {
          this.$refs[`drawpart${index}`][0].startDraw()
        })
      } else if (
        firstCutSurplus &&
        surplusStoreAndLabeling &&
        this.selectedPaibanWay == 'paiban' &&
        mentaoji_enable &&
        processType === 'weldingPlank'
      ) {
        await cutBlueSurplus(this.drawData, this.ncSetting)
      }
      this.isUpdatingTask = false
    }

    // 获取勾选的数据
    if (this.isOnlyShowSurplus) {
      this.handleShowSurplus()
    }
    if (this.isNewPaiban) {
      this.updateTaskStatus()
    }
    this.setIsResetPaibanAllocation(false)
    this.setHasSavedSurplus()

    const parts = this.paibanData.map((i) => i.parts).flat(1)
    const hasAutoRollOver = this.paibanData.some((item) => item.hasAutoRollOver)
    if (
      parts
        .filter((item) => !item.blueAreaSurplus)
        .some((part) => !part.priority) ||
      hasAutoRollOver
    ) {
      this.calcCutPositionOrder()
    }
    getSpecialRemarks().then((res) => {
      if (res.status === 200) {
        this.$store.commit('setSpecialRemarks', res?.data?.data ?? {})
      }
    })
    if (this.ncSetting.isPreLayout) {
      this.checkSettingChange(true)
    }
    const { from } = this.$route.query
    // 从开料清单排版或者保存历史进入
    if (this.isFromMaterial || from === 'history_paiabn') {
      const { exNextTip } = store.state.preferencesSetting.setting
      if (!exNextTip) {
        this.handleCheckClampHandPosition()
        return
      }
      // 没有检测过夹手位置
      if (!hasCheckedClampHand) {
        this.handleCheckClampHandPosition()
      }
    }
  },
  beforeDestroy() {
    this.isComponentDestroyed = true
    this.removeBusEvent()
    this.clearAllListener()
    // 如果当前页面有任务，就将任务关闭
    // 离开页面时，删除当前页面的任务
    if (this.taskFn) this.taskFn.delTask()
  },
  // 前往标签页前，检查切割顺序是否正确
  beforeRouteLeave(to, from, next) {
    let flag = this.judgeCutOrder()
    this.surplusBigpart = null
    if (to.path == '/printTag' && !to.query.from) {
      if (flag) {
        this.handleSeriesManipulate()
        return false
      } else if (this.print_color_tag && !this.isSubtle) {
        // 生成颜色
        const { labelCheck, colorRes: newColorRes } =
          this.judgeLimit(this.paibanData) ?? {}
        // 在这里提示
        this.generateColor(labelCheck, newColorRes)
      }
    }
    // 试进入生产柜时排版方案选项无法选中（paibandata必须清空）-历史遗留BUG-
    !store.state.isTrialProduct && this.handleSetNewPaibanData()
    next()
  },
}
</script>

<style scoped lang="less">
#allPartsOrderMark {
  /deep/ .ant-modal {
    top: 30% !important;
  }
}

.draw-parts {
  height: 100%;

  .AI-paiban-btn {
    width: 100%;
    margin: 0 0 8px;

    &.activeWay {
      color: #18a8c7;
      border-color: #18a8c7;
    }
  }

  span {
    font-family: PingFangSC-Regular, PingFang SC;
  }

  &.forbid-select {
    span {
      user-select: none !important;
    }

    img {
      user-select: none !important;
    }
  }

  .loading-box {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10000000000000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-align: center;
    background: #0008;
  }

  .paiban-bread {
    height: 38px;
    padding: 0 16px;
    color: #999;
    font-size: 14px;
    line-height: 38px;
    background: #fafafa;
    cursor: default;

    .material-list {
      color: #333;
      cursor: pointer;
    }
  }

  .draw-parts-main {
    display: flex;
    align-items: flex-start;
    height: 98%;

    // justify-content: space-between;
    .left-operation {
      // overflow: auto;
      position: relative;
      display: flex;
      flex-direction: column;
      width: calc(100% - 350px);
      //width: 100%;
      height: 100%;
      margin-top: 16px;

      .paiban-top-container {
        background: #fafafa;
        padding: 0 16px;
        margin: 0 16px;
        // height: 150px;
        // min-height: 150px;
        overflow: auto;
      }

      .paiban-top {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .order-title {
          margin-right: 10px;
          max-width: 500px;
          overflow: hidden;
          color: #000;
          font-weight: 600;
          font-size: 21px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .more-title {
          max-width: 600px !important;
        }

        .paiban-info {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;

          flex: 1;
          min-width: 920px;

          &.order-address {
            display: inline-block;
            max-width: 300px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .paiban-info-label {
            margin-right: 35px;
            color: rgba(0, 0, 0, 0.4);
            font-size: 16px;
            display: inline-block;
            // min-width: 200px;
          }
          .cursor {
            cursor: pointer;
            color: #18a8c7;
          }

          .paiban-proline-icon--disabled {
            color: rgba(0, 0, 0, 0.25) !important;
            cursor: not-allowed !important;
          }

          .paiban-info-value {
            color: #fb4444;
          }
          .iconfont.icon-qiehuan {
            font-size: 20px;
          }
        }

        .paiban-actions {
          display: flex;
          align-items: center;
        }

        .current-tag-name {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: absolute;
          margin-left: 88px;
          color: rgba(0, 0, 0, 0.4);
          top: 92px;
          height: 30px;
          background-color: #fff;
          padding: 5px;

          .icon-close {
            font-size: 12px;
            transform: scale(0.8);
            margin-top: 2px;
            margin-left: 5px;
          }
        }

        .tag-nc {
          display: flex;

          #paiban_batch_bujian_btn,
          #paiban_batch_edit_size_btn {
            color: #000;
            background: #fafafa;
          }

          #paiban_more_setting_btn {
            color: #000;
          }
        }

        .action-btn,
        .disable-btn {
          // line-height: 40px;
          display: inline-block;
          box-sizing: border-box;
          // margin-left: 15px;
          color: #000;
          // width: 138px;
          // height: 40px;
          font-size: 14px;
          text-align: center;
          background: #fafafa;
          border-color: #dddddd;
          border-radius: 4px;
          user-select: none;

          &:hover {
            color: #18a8c7;
            border-color: #18a8c7;
          }

          /deep/ .ant-checkbox-wrapper {
            color: inherit;
          }
        }

        .disable-btn {
          color: #ccc !important;
          background: #f5f5f5 !important;
          cursor: not-allowed !important;

          &:hover {
            color: #ccc;
            border-color: #ccc;
          }
        }
        .deep-search-btn {
          color: #f4d086;
        }

        .down-nc {
          // line-height: 40px;
          display: inline-block;
          color: #fff;
          font-size: 14px;
          text-align: center;
          // width: 81px;
          // height: 40px;
          background: #18a8c7;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          user-select: none;
        }

        .more-setting {
          .more-icon {
            transform: rotate(180deg);
            transition: transform 0.5s;
          }
        }
      }

      .normal-top {
        margin-top: -20px;
      }

      .oneErr-top {
        margin-top: -15px;
      }

      .batch-bujian {
        height: 50px;
        background-color: #f9f9f9;

        .close-batch-bujian-btn {
          right: 10px;
          top: 0px;
        }
      }

      .all-parts {
        // flex-grow: 1;
        // width: calc(100vw - 316px);
        margin: 16px 9px 16px 16px;
        overflow: scroll;
        transition: all 0.3s;
        scroll-behavior: smooth;
        flex: 1;

        /* 改造滚动条样式 */

        &::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.05);
        }

        &:hover::-webkit-scrollbar-thumb {
          background-color: rgba(0, 0, 0, 0.2);
          border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb:hover {
          background-color: rgba(0, 0, 0, 0.4);
        }

        &::-webkit-scrollbar-track {
          background-color: #eee;
          border-radius: 10px;
        }

        &::-webkit-scrollbar-track:hover {
          background-color: #eee;
        }
        .no-cut-tag-tip {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          span {
            font-size: 18px;
            color: rgba(0, 0, 0, 0.4);
          }
        }
      }

      .move-step-box {
        position: fixed;
        right: 585px;
        bottom: 24px;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        background-color: #fff;
        border-radius: 3px;
        box-shadow: 1px 1px 5px #333;
        padding: 0 10px;
      }

      .operate-menu {
        position: fixed;
        right: 380px;
        bottom: 24px;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 200px;
        height: 35px;
        background-color: #fff;
        border-radius: 3px;
        box-shadow: 1px 1px 5px #333;
      }

      .operate-menu .operate-icon {
        color: #333;
        font-size: 16px;
        cursor: pointer;

        &.icon-hint01 {
          margin-right: 15px;
        }

        &:hover {
          color: #18a8c7;
        }
      }

      .zoom-percent-box {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 127px;
        cursor: default;
        user-select: none;
      }

      .zoom-percent {
        display: inline-block;
        width: 38px;
        text-align: center;
      }
    }

    .right-operation {
      position: relative;
      flex-shrink: 0;
      width: 350px;
      height: 100%;
      margin-top: 16px;
      padding: 16px;
      overflow: auto;
      background: #fff;

      /* 改造滚动条样式 */

      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.05);
      }

      &:hover::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: rgba(0, 0, 0, 0.4);
      }

      &::-webkit-scrollbar-track {
        background-color: #eee;
        border-radius: 10px;
      }

      &::-webkit-scrollbar-track:hover {
        background-color: #eee;
      }

      .empty-input {
        /deep/ .ant-input:focus {
          border-color: rgb(251, 70, 70);
          box-shadow: 0 0 0 2px rgba(251, 70, 70, 0.2);
        }
      }

      .paiban-way,
      .plank-operation {
        margin: 20px 0;

        /deep/ .ant-checkbox-wrapper {
          margin-left: 0;
        }
      }

      .change-plank {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        .el-button {
          width: 50%;
          height: 30px;
          padding: 0 15px;
        }
      }

      .active-plank-box {
        width: 100%;
        height: 234px;
        margin-top: 16px;
        border: 1px solid #d9d9d9;
      }

      .active-plank-info {
        position: relative;
        // display: flex;
        // align-items: flex-end;
        // justify-content: space-between;
        height: 100%;
        padding: 0 10px 0 8px;

        .left-info {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-around;
          height: 100%;
          color: #333;
          font-size: 12px;

          span {
            display: block;
            max-width: 300px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .info-eliplise {
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .plank-matCode-container {
          display: flex;
          width: 100%;
        }

        .right-qrcode {
          position: absolute;
          right: 10px;
          bottom: 0;
          margin-bottom: 10px;
          padding-top: 11px;
          user-select: none;

          img {
            display: none !important;
          }

          /deep/ canvas {
            display: block !important;
          }
        }
      }

      .no-active-plank {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 178px;
        color: #999;
        font-size: 14px;
        text-align: center;
      }

      .title-box {
        display: flex;
        align-items: center;
        margin: 8px 0;

        .circle {
          display: inline-block;
          width: 6px;
          height: 6px;
          margin-right: 8px;
          background: #999999;
          border-radius: 50%;
        }

        .title {
          color: #999999;
          font-size: 14px;
          user-select: none;
        }
      }

      .select-paiban {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;

        .paiban-way-item {
          display: inline-block;
          box-sizing: border-box;
          width: 138px;
          height: 32px;
          margin-bottom: 8px;
          font-size: 14px;
          line-height: 32px;
          text-align: center;
          border-radius: 2px;

          &.activeWay {
            color: #18a8c7;
            border-color: #18a8c7;
          }

          &:last-child {
            display: flex;
            justify-content: center;
            width: 100%;
            margin-bottom: 0;

            > div {
              display: flex;
              align-items: center;
            }

            .icon-save {
              margin-right: 4px;
            }
          }
        }
      }

      .plank-operation-btns {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .plank-control-rotate {
          width: 150px;
          height: 32px;
          margin-bottom: 8px;
        }

        .highGlossDisabled {
          color: #ccc;
          background: #f5f5f5;
          cursor: not-allowed;
        }

        .disable-btn {
          color: #ccc;
          background: #f5f5f5 !important;
          cursor: not-allowed;

          &:hover {
            color: #ccc;
            border-color: #ccc;
          }
        }

        .plank-control-del {
          width: 150px;
          height: 32px;
          margin-bottom: 8px;

          &:hover {
            .ant-checkbox-wrapper {
              color: #18a8c7;
            }
          }
        }

        .plank-control-calc {
          width: 100%;
          height: 32px;
          margin-bottom: 8px;
        }

        .plank-control-temp {
          width: 100%;
        }

        .origin-dialog-mask {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #0008;
          z-index: 1000;
        }

        .origin-dialog {
          position: fixed;
          top: 135px;
          right: 75px;
          width: 333px;
          height: 228px;
          margin: auto;
          background: #fff;

          .origin-dialog-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            width: 100%;
            height: 56px;
            padding: 0 24px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);

            span {
              color: #333;
              font-size: 16px;
              cursor: default;
            }

            .icon-close {
              cursor: pointer;
            }
          }

          .origin-btn {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            width: 100%;
            padding: 24px 24px 16px 24px;
            color: #333;
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);

            .ant-btn {
              width: 138px;
              height: 32px;
              margin-bottom: 8px;
              border-radius: 2px;
            }

            .ant-btn.active {
              color: #18a8c7;
              border-color: #18a8c7;
            }
          }

          .origin-dialog-btns {
            display: flex;
            justify-content: flex-end;
            box-sizing: border-box;
            padding: 10px;

            > div {
              .ant-btn {
                width: 65px;
                height: 32px;

                &:last-child {
                  color: #fff;
                  background: #18a8c7;
                  border: none;
                }
              }
            }
          }
        }
      }

      .temp-area {
        z-index: 2;
        box-sizing: border-box;
        height: calc(100% - 700px);
        min-height: 455px;
        margin-top: 8px;
        overflow: hidden;
        background: #eee;
        border: 1px solid #ddd;

        .temp-area-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 58px;
          padding: 0 24px;
          color: #333;
          font-weight: 600;
          font-size: 18px;
          border-bottom: 1px solid rgba(229, 229, 229, 1);

          .el-icon-close {
            cursor: pointer;
          }
        }

        .temp-area-content {
          height: calc(100% - 58px);
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
          }

          &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.05);
          }

          &:hover::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.2);
            border-radius: 10px;
          }

          &::-webkit-scrollbar-thumb:hover {
            background-color: rgba(0, 0, 0, 0.4);
          }

          &::-webkit-scrollbar-track {
            background-color: #fff;
            border-radius: 10px;
          }

          &::-webkit-scrollbar-track:hover {
            background-color: #fff;
          }
        }

        .temp-area-content .plank-item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          float: left;
          box-sizing: border-box;
          width: 50%;
          height: 180px;
          padding: 8px 0;
          text-align: center;
          border: 1px solid rgba(229, 229, 229, 1);
          border-top: none;

          &:first-child {
            border-top: 1px solid rgba(229, 229, 229, 1);
          }

          &:nth-child(2) {
            border-top: 1px solid rgba(229, 229, 229, 1);
          }

          &:nth-child(2n) {
            border-left: none;
          }

          img {
            display: block;
            margin: 0 auto;
          }
        }
      }

      .no-temp-storage {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;

        > div {
          display: flex;
          flex-direction: column;
          align-items: center;

          img {
            margin-bottom: 15px;
          }

          span {
            color: #999;
            font-size: 14px;
          }
        }
      }
    }
  }

  .save-paiban-box {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2003;
    width: 100%;
    height: 100%;
    background: #0008;

    .mask {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 400px;
      height: 228px;
      margin: auto;
      background: #fff;
    }

    .top-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 56px;
      padding: 0 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);

      .title {
        color: #333;
        font-size: 16px;
        line-height: 56px;
      }

      .icon-close {
        font-size: 14px;
        line-height: 56px;
      }
    }

    .paiban-way-name {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);

      > div {
        width: 95%;
        margin: 0 auto;

        .paiban-name {
          color: #333;
          font-size: 16px;
        }

        .ant-input {
          width: 240px;
        }
      }
    }

    .btns {
      display: flex;
      justify-content: flex-end;
      height: 52px;
      padding: 0 16px;

      > div {
        display: flex;
        align-items: center;
        cursor: pointer;

        span {
          display: inline-block;
          font-size: 14px;
        }

        .cancel {
          margin-right: 8px;
          color: #18a8c7;
        }

        .save {
          width: 80px;
          height: 28px;
          color: #fff;
          line-height: 28px;
          text-align: center;
          background: #18a8c7;
          border-radius: 4px;
        }
      }
    }
  }

  .surplus-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 10;
    .content {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 900px;
      height: 500px;
      margin: auto;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
        0px 6px 16px 0px rgba(0, 0, 0, 0.08),
        0px 3px 6px -4px rgba(0, 0, 0, 0.12);

      .title-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 58px;
        padding: 16px 24px;
        background: #fafafa;
        box-shadow: inset 0px -1px 0px 0px #e5e5e5;

        .title {
          color: #333;
          font-size: 18px;
        }

        .icon-close {
          cursor: pointer;
        }
      }

      .match-surplus-box {
        padding: 16px 24px 0 24px;
      }

      .top-operation {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        .ant-btn {
          width: 86px;
          height: 32px;
          color: #fff;
          background: #18a8c7;
          border: none;
        }

        .disable-use {
          color: rgba(0, 0, 0, 0.25);
          background: #f5f5f5;
          border: 1px solid #d9d9d9;
        }

        /deep/ .ant-input-search {
          width: 369px;
        }

        /deep/ .ant-input-wrapper {
          width: 369px;

          .ant-input-group-addon {
            .ant-select {
              width: 100px !important;
            }
          }
        }
      }

      .surplus-list {
        height: 378px;
        max-height: 378px;
        overflow: scroll;

        &::-webkit-scrollbar {
          display: none;
        }

        .surplus-item {
          display: flex;
          align-items: center;
          height: 98px;
          margin-bottom: 16px;
          border: 1px solid #e5e5e5;
          cursor: pointer;

          &:hover {
            border-color: #18a8c7;

            .title {
              color: #18a8c7;
            }
          }
        }

        .ant-radio-wrapper {
          margin: 0 24px;
          transform: scale(1.5);
          transform-origin: center;
        }

        .surplus-info {
          display: flex;
          align-items: center;

          .surplus-info-item {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;

            span {
              display: block;
              overflow: hidden;
              color: #999999;
              font-size: 14px;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .info {
              color: #333;
              font-size: 16px;
            }
          }

          .surplus-name {
            width: 210px;
            margin-right: 45px;

            .title {
              font-size: 16px;
            }
          }

          .surplus-amount {
            width: 30px;
            margin-right: 32px;
          }

          .surplus-thick {
            width: 70px;
            margin-right: 32px;
          }

          .surplus-long {
            width: 70px;
            margin-right: 32px;
          }

          .surplus-width {
            width: 70px;
            margin-right: 32px;
          }
        }

        .no-match-list {
          text-align: center;

          > div {
            margin-top: 131px;
          }

          img {
            display: block;
            width: 64px;
            margin: 0 auto;
            margin-bottom: 8px;
          }

          .no-match-text {
            color: #999;
            font-size: 14px;
            cursor: default;
          }

          .add-new-surplus {
            color: #18a8c7;
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }
  }
  .user-info {
    position: absolute;
    bottom: 25px;
    left: 15px;
    z-index: 2026;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.2);
  }
}

.prompts {
  color: red;
}
.titleTip {
  font-size: 12px;
  color: red;
  margin-bottom: 10px;
}
.see-details {
  width: 80px;
  height: 30px;
}

.display {
  min-width: 280px;
  align-items: center;
}

// .conflict-display {
//   line-height: 32px;
//   min-width: 335px;
// }

.tag-template-select {
  .ant-select {
    margin-left: 10px;
  }

  /deep/ .ant-select-selection--single {
    height: 25px;
  }

  /deep/ .ant-select-selection__rendered {
    line-height: 25px;
  }

  .temp-label {
    color: rgba(0, 0, 0, 0.65);
  }

  .temp-label_disabel {
    color: rgba(0, 0, 0, 0.25);
  }
}

.follow-export {
  text-align: left;
}

.drop-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  width: 100vw;
  height: 100vh;
  // background-color: rgba(0, 0, 0, 0.3);
}

/deep/ .material-list-modal {
  .ant-modal-close {
    width: 54px;
    height: 54px;
  }

  .ant-modal-header {
    border-bottom: none;
    padding: 16px;
    padding-bottom: 14px;

    .ant-modal-title {
      font-weight: bold;
      color: rgba(0, 0, 0, 0.9);
    }
  }

  .ant-modal-body {
    height: 298px;
    padding: 0 16px;
  }
}

/deep/ .material-list-table {
  .ant-table-thead > tr > th {
    height: 36px;
    background-color: #f3f3f3;
  }

  .ant-table-body > tr > td {
    height: 40px;
  }
}

.icon-warn {
  color: #18a8c7;
  font-size: 22px;
}
/deep/ .useMaterial-tooltip-card {
  .ant-tooltip-content {
    .ant-tooltip-arrow {
      display: none;
    }
    .ant-tooltip-inner {
      width: 350px;
      max-height: 30px;
      background-color: #fff;
      display: flex;
      align-items: center;
      color: #000;
      .tip {
        max-width: 230px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
/deep/ .influence-tip-card {
  max-width: 360px;
  .ant-tooltip-arrow {
    display: none;
  }
  .ant-tooltip-inner {
    padding: 16px 12px 16px 16px;
    background-color: #fff;
    color: rgba(0, 0, 0, 0.85);
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}
.paiban-influence-icon {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  &:hover {
    color: #18a8f6;
  }
}
.send-to-ezsort-head-checkbox {
  margin-top: 5px;
  .anticon {
    color: #999 !important;
  }
}
:deep(.paiban-export-hole-slot-tooltip-card) {
  .ant-tooltip-content {
    .ant-tooltip-arrow {
      display: none;
    }
    .ant-tooltip-inner {
      height: 140px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
}
</style>

<style lang="less">
.more-result-tip {
  display: flex;
  align-items: flex-start;
  min-width: 120px;
  max-width: 240px;
  line-height: 1.4;

  &__content {
    flex: 1;
    font-size: 12px;
    word-break: break-all;
  }

  &__close {
    flex-shrink: 0;
    margin-left: 8px;
    font-size: 12px;
    cursor: pointer;
    opacity: 0.85;

    &:hover {
      opacity: 1;
    }
  }
}

.customConfirm {
  .el-message-box__status {
    top: 20% !important;
  }
}
.paiban-operate-menu.ant-popover {
  opacity: 1;

  .ant-popover-content {
    width: 210px;

    .ant-popover-inner-content {
      padding: 0;
    }

    .operate-item {
      display: flex;
      justify-content: space-between;
      padding: 9px;
      border-bottom: 1px solid #e5e5e5;

      &.paiban-intro {
        align-items: center;
      }
    }

    .operate-item-more {
      text-align: right;
    }

    .ant-popover-title {
      padding: 5px 10px;
    }

    .rect-example {
      width: 36px;
      height: 12px;
      background: #eeeea1;
    }

    .holeslot-merge-example {
      width: 36px;
      height: 12px;
      background: #f808;
    }

    .rect-merge-example {
      width: 36px;
      height: 12px;
      background: #f008;
    }
    .rect-step-cutting {
      width: 36px;
      height: 12px;
      border: 3px solid skyblue;
    }
    .rect-cross-material {
      width: 36px;
      height: 12px;
      border: 1px dashed #0008;
    }

    .slot-example {
      width: 36px;
      height: 12px;

      &.face-slot {
        border: 1px solid #f00;
      }

      &.back-slot {
        border: 1px solid #00f;
      }
    }

    .hole-example {
      width: 12px;
      height: 12px;
      margin-left: 12px;
      border-radius: 50%;

      &.face-hole {
        border: 1px solid #f00;
      }

      &.back-hole {
        border: 1px solid #00f;
      }
    }
  }
}

.special-shape-modal {
  .ant-modal-confirm-btns {
    .ant-btn:first-child {
      display: none;
    }
  }
}

.highgloss-tips {
  border-radius: 4px;
  min-width: 335px;

  .font-style {
    color: red;
  }
}

.only-surplus-box {
  min-width: 120px;

  .only-show-surplus {
    color: red;
    margin-left: -20px;
  }
}

.paiban-program-box {
  .paiban-program-choose {
    width: 210px;
    height: 30px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;

    .span-box {
      margin-left: 10px;
      width: 180px;
      line-height: 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .anticon {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 100%;
      font-size: 12px;
      margin-right: 7px;
    }
  }

  .paiban-program-title {
    min-width: 70px;
  }
}

.disable-class {
  color: rgba(0, 0, 0, 0.25) !important;
}

.material-list-btn,
.surplus-in-storages {
  .disable-class {
    color: rgba(0, 0, 0, 0.25) !important;
  }

  .ant-btn-link {
    // color: #8322ff;
  }
}

.purchase-order {
  .purchase-btn {
    display: flex;
    align-items: center;
  }

  .ant-btn-link {
    color: rgba(0, 0, 0, 0.65);
  }
}

.layout-loc {
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
}
g-t-view .sur-store-modal {
  .ant-modal-header {
    border-bottom: none;
  }

  .ant-modal-footer {
    border-top: none;

    .ant-btn:first-child {
      display: none;
    }
  }
}
.deduction-modal {
  .deduction-label {
    display: inline-block;
    width: 112px;
    text-align: right;
  }
}
.paiban-export-hole-slot-tooltip-card {
  .ant-tooltip-content {
    .ant-tooltip-arrow {
      display: none;
    }
    .ant-tooltip-inner {
      height: 90px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
}
</style>
